// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/cortado.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ActivityLite, Note, Task, TaskLite } from "./actions_pb";
import { file_cortado_v1_actions } from "./actions_pb";
import type { AdminArchiveUserRequestSchema, AdminArchiveUserResponseSchema, AdminCreateUserRequestSchema, AdminCreateUserResponseSchema, AdminDisableFeatureForAllOrgsRequestSchema, AdminDisableFeatureForAllOrgsResponseSchema, AdminDisableFeatureRequestSchema, AdminDisableFeatureResponseSchema, AdminEnableFeatureRequestSchema, AdminEnableFeatureResponseSchema, AdminGetOrganizationFeaturesRequestSchema, AdminGetOrganizationFeaturesResponseSchema, AdminGetOrganizationLeaderboardRequestSchema, AdminGetOrganizationLeaderboardResponseSchema, AdminGetOrganizationRequestSchema, AdminGetOrganizationResponseSchema, AdminGetOrganizationStatsRequestSchema, AdminGetOrganizationStatsResponseSchema, AdminGetSystemStatsRequestSchema, AdminGetSystemStatsResponseSchema, AdminListFeatureCatalogRequestSchema, AdminListFeatureCatalogResponseSchema, AdminListOrganizationsRequestSchema, AdminListOrganizationsResponseSchema, AdminListUsersRequestSchema, AdminListUsersResponseSchema, AdminResendInviteRequestSchema, AdminResendInviteResponseSchema, AdminUnarchiveUserRequestSchema, AdminUnarchiveUserResponseSchema, AdminUpdateFeedbackStageRequestSchema, AdminUpdateFeedbackStageResponseSchema, ListMySupportSessionsRequestSchema, ListMySupportSessionsResponseSchema } from "./admin_pb";
import { file_cortado_v1_admin } from "./admin_pb";
import type { ListUnreadAnnouncementsRequestSchema, ListUnreadAnnouncementsResponseSchema, MarkAnnouncementReadRequestSchema, MarkAnnouncementReadResponseSchema } from "./announcements_pb";
import { file_cortado_v1_announcements } from "./announcements_pb";
import type { ApiKey } from "./api_keys_pb";
import { file_cortado_v1_api_keys } from "./api_keys_pb";
import type { Attachment, AttachmentFolder, AttachmentLite } from "./attachments_pb";
import { file_cortado_v1_attachments } from "./attachments_pb";
import type { CheckEventsCalendarExistsRequestSchema, CheckEventsCalendarExistsResponseSchema, DeleteGmailAccountRequestSchema, DeleteGmailAccountResponseSchema, GetGmailAuthURLRequestSchema, GetGmailAuthURLResponseSchema, IsGmailConnectedRequestSchema, IsGmailConnectedResponseSchema, ListGoogleCalendarsRequestSchema, ListGoogleCalendarsResponseSchema, RecheckGmailAccountHealthRequestSchema, RecheckGmailAccountHealthResponseSchema, SetGoogleCalendarRequestSchema, SetGoogleCalendarResponseSchema, UpdateGmailAccountRequestSchema, UpdateGmailAccountResponseSchema } from "./auth_pb";
import { file_cortado_v1_auth } from "./auth_pb";
import type { ArchiveCompanyRequestSchema, ArchiveCompanyResponseSchema, ArchiveContactRequestSchema, ArchiveContactResponseSchema, Company, CompanyContact, Contact, UnarchiveCompanyRequestSchema, UnarchiveCompanyResponseSchema, UnarchiveContactRequestSchema, UnarchiveContactResponseSchema } from "./contacts_pb";
import { file_cortado_v1_contacts } from "./contacts_pb";
import type { AcceptEmailThreadAddressSuggestionRequestSchema, AcceptEmailThreadAddressSuggestionResponseSchema, DismissEmailThreadAddressSuggestionRequestSchema, DismissEmailThreadAddressSuggestionResponseSchema, LinkEmailThreadRequestSchema, LinkEmailThreadResponseSchema, ListEmailThreadAddressSuggestionsRequestSchema, ListEmailThreadAddressSuggestionsResponseSchema, ListEmailThreadEntityCandidatesRequestSchema, ListEmailThreadEntityCandidatesResponseSchema, ListEmailThreadLinksRequestSchema, ListEmailThreadLinksResponseSchema, ListEmailThreadsByEntityRequestSchema, ListEmailThreadsByEntityResponseSchema, MarkEmailThreadReadRequestSchema, MarkEmailThreadReadResponseSchema, UnlinkEmailThreadRequestSchema, UnlinkEmailThreadResponseSchema } from "./email_conversations_pb";
import { file_cortado_v1_email_conversations } from "./email_conversations_pb";
import type { ConnectedMailbox, ConnectedMailboxProvider, DiscardDraftRequestSchema, DiscardDraftResponseSchema, Email, EmailCaptureExclusion, EmailCaptureSettings, EmailSenderSuggestion, EmailSenderSuggestionActionEnum, EmailSuppression, EmailSuppressionReason, EmailTemplate, EmailThread, GetEmailAttachmentDownloadUrlRequestSchema, GetEmailAttachmentDownloadUrlResponseSchema, GetEmailThreadRequestSchema, GetEmailThreadResponseSchema, GetSystemEmailTemplateRequestSchema, GetSystemEmailTemplateResponseSchema, ListEmailDraftsRequestSchema, ListEmailDraftsResponseSchema, ListEmailsRequestSchema, ListEmailsResponseSchema, ListEmailThreadsRequestSchema, ListEmailThreadsResponseSchema, ListSystemEmailTemplatesRequestSchema, ListSystemEmailTemplatesResponseSchema, MailboxSendAccess, PreviewSystemEmailTemplateRequestSchema, PreviewSystemEmailTemplateResponseSchema, ReplyToThreadRequestSchema, ReplyToThreadResponseSchema, ResetSystemEmailTemplateRequestSchema, ResetSystemEmailTemplateResponseSchema, RetryEmailBodyFetchRequestSchema, RetryEmailBodyFetchResponseSchema, RetryEmailSendRequestSchema, RetryEmailSendResponseSchema, SaveDraftRequestSchema, SaveDraftResponseSchema, UpdateEmailThreadRequestSchema, UpdateEmailThreadResponseSchema, UpdateSystemEmailTemplateRequestSchema, UpdateSystemEmailTemplateResponseSchema } from "./emails_pb";
import { file_cortado_v1_emails } from "./emails_pb";
import type { AddEventPackingItemRequestSchema, AddEventPackingItemResponseSchema, DeleteEventPackingItemRequestSchema, DeleteEventPackingItemResponseSchema, GetEventPackingListRequestSchema, GetEventPackingListResponseSchema, RegenerateEventPackingListRequestSchema, RegenerateEventPackingListResponseSchema, SetEventPackingItemPackedRequestSchema, SetEventPackingItemPackedResponseSchema, SetEventPackingItemQuantityRequestSchema, SetEventPackingItemQuantityResponseSchema } from "./event_packing_pb";
import { file_cortado_v1_event_packing } from "./event_packing_pb";
import type { ListEventAddonsRequestSchema, ListEventAddonsResponseSchema, PreviewEventInventoryRequestSchema, PreviewEventInventoryResponseSchema, PreviewEventTimelineRequestSchema, PreviewEventTimelineResponseSchema } from "./event_plan_pb";
import { file_cortado_v1_event_plan } from "./event_plan_pb";
import type { GetEventTimelineRequestSchema, GetEventTimelineResponseSchema, RegenerateEventTimelineRequestSchema, RegenerateEventTimelineResponseSchema, UpdateEventTimelineBlocksRequestSchema, UpdateEventTimelineBlocksResponseSchema } from "./event_timeline_pb";
import { file_cortado_v1_event_timeline } from "./event_timeline_pb";
import type { ListEventStaffAvailabilityRequestSchema, ListEventStaffAvailabilityResponseSchema } from "./event_staffing_pb";
import { file_cortado_v1_event_staffing } from "./event_staffing_pb";
import type { Feedback } from "./feedback_pb";
import { file_cortado_v1_feedback } from "./feedback_pb";
import type { ArchiveEventRequestSchema, ArchiveEventResponseSchema, ArchiveInquiryRequestSchema, ArchiveInquiryResponseSchema, Booking, CreateBookingRequestSchema, CreateBookingResponseSchema, CreateInquiryEventRequestSchema, CreateInquiryEventResponseSchema, DeleteInquiryEventRequestSchema, DeleteInquiryEventResponseSchema, Event, EventLite, GeneratePortalLinkRequestSchema, GeneratePortalLinkResponseSchema, GeneratePublicPortalLinkRequestSchema, GeneratePublicPortalLinkResponseSchema, GetInquiryOverlapsRequestSchema, GetInquiryOverlapsResponseSchema, Inquiry, InquiryLite, ListInquiryEventsRequestSchema, ListInquiryEventsResponseSchema, PublicBooking, PublicInquiry, PublicInvoice, PublicPaymentSchedule, PublicQuote, SharePublicInquiryByEmailRequestSchema, SharePublicInquiryByEmailResponseSchema, SharePublicInvoiceByEmailRequestSchema, SharePublicInvoiceByEmailResponseSchema, UnarchiveEventRequestSchema, UnarchiveEventResponseSchema, UnarchiveInquiryRequestSchema, UnarchiveInquiryResponseSchema, UpdateInquiryEventRequestSchema, UpdateInquiryEventResponseSchema, UserScheduling } from "./inquiries_pb";
import { file_cortado_v1_inquiries } from "./inquiries_pb";
import type { DisconnectOrganizationIntegrationRequestSchema, DisconnectOrganizationIntegrationResponseSchema, GetConnectedSlackChannelsRequestSchema, GetConnectedSlackChannelsResponseSchema, GetOrganizationIntegrationRequestSchema, GetOrganizationIntegrationResponseSchema, ListSlackChannelsRequestSchema, ListSlackChannelsResponseSchema, SetConnectedSlackChannelsRequestSchema, SetConnectedSlackChannelsResponseSchema, UpsertOrganizationIntegrationRequestSchema, UpsertOrganizationIntegrationResponseSchema } from "./integrations_pb";
import { file_cortado_v1_integrations } from "./integrations_pb";
import type { ContactQuoteInteraction, Discount, ExportInvoicePaymentsRequestSchema, ExportInvoicePaymentsResponseSchema, GenerateInvoicePortalLinkRequestSchema, GenerateInvoicePortalLinkResponseSchema, Invoice, InvoiceLite, Item, ItemImage, ListDisputesRequestSchema, ListDisputesResponseSchema, ListInvoicePaymentsRequestSchema, ListInvoicePaymentsResponseSchema, MarkInvoiceAsPaidRequestSchema, MarkInvoiceAsPaidResponseSchema, PaymentIntent, PaymentSchedule, PaymentScheduleLite, ProcessStripeRefundRequestSchema, ProcessStripeRefundResponseSchema, Quote, QuoteAddonOfferInput, QuoteItem, QuoteLineItemInput, QuoteLite, QuotePaymentScheduleInput, QuoteTemplate, QuoteTemplateItemScalingType, RecordBatchManualPaymentsRequestSchema, RecordBatchManualPaymentsResponseSchema, RecordManualPaymentRequestSchema, RecordManualPaymentResponseSchema, SendInvoiceRequestSchema, SendInvoiceResponseSchema, SendPaymentReminderRequestSchema, SendPaymentReminderResponseSchema, StripePayment, TaxRate, VoidInvoiceRequestSchema, VoidInvoiceResponseSchema, VoidManualPaymentRequestSchema, VoidManualPaymentResponseSchema } from "./invoices_pb";
import { file_cortado_v1_invoices } from "./invoices_pb";
import type { GetJobRequestSchema, GetJobResponseSchema, GetPipelineSummaryRequestSchema, GetPipelineSummaryResponseSchema, ListJobActivityRequestSchema, ListJobActivityResponseSchema, ListJobEventsRequestSchema, ListJobEventsResponseSchema, ListJobsRequestSchema, ListJobsResponseSchema, UpdateJobRequestSchema, UpdateJobResponseSchema } from "./jobs_pb";
import { file_cortado_v1_jobs } from "./jobs_pb";
import type { ArchiveNotificationsRequestSchema, ArchiveNotificationsResponseSchema, GetNotificationDigestRequestSchema, GetNotificationDigestResponseSchema, GetUnreadNotificationCountRequestSchema, GetUnreadNotificationCountResponseSchema, ListInAppNotificationsRequestSchema, ListInAppNotificationsResponseSchema, ListMyNotificationSettingsRequestSchema, ListMyNotificationSettingsResponseSchema, MarkNotificationsReadRequestSchema, MarkNotificationsReadResponseSchema, SendTestNotificationDigestRequestSchema, SendTestNotificationDigestResponseSchema, UpdateMyNotificationSettingRequestSchema, UpdateMyNotificationSettingResponseSchema, UpdateNotificationDigestRequestSchema, UpdateNotificationDigestResponseSchema } from "./notifications_pb";
import { file_cortado_v1_notifications } from "./notifications_pb";
import type { AddUserToOrganizationRequestSchema, AddUserToOrganizationResponseSchema, CheckSlugAvailabilityRequestSchema, CheckSlugAvailabilityResponseSchema, CreateAgreementClauseRequestSchema, CreateAgreementClauseResponseSchema, CreateAgreementRequestSchema, CreateAgreementResponseSchema, CreateOrganizationRequestSchema, CreateOrganizationResponseSchema, CreateUnavailableDateRequestSchema, CreateUnavailableDateResponseSchema, DeleteAgreementClauseRequestSchema, DeleteAgreementClauseResponseSchema, DeleteAgreementRequestSchema, DeleteAgreementResponseSchema, DeleteUnavailableDateRequestSchema, DeleteUnavailableDateResponseSchema, GenerateAgreementClausesRequestSchema, GenerateAgreementClausesResponseSchema, GetAgreementRequestSchema, GetAgreementResponseSchema, GetOrganizationOnboardingRequestSchema, GetOrganizationOnboardingResponseSchema, GetOrganizationRequestSchema, GetOrganizationResponseSchema, ListAgreementsRequestSchema, ListAgreementsResponseSchema, ListMyOrganizationsRequestSchema, ListMyOrganizationsResponseSchema, ListOrganizationUsersRequestSchema, ListOrganizationUsersResponseSchema, ListUnavailableDatesRequestSchema, ListUnavailableDatesResponseSchema, OrganizationGalleryImage, RemoveUserFromOrganizationRequestSchema, RemoveUserFromOrganizationResponseSchema, ReorderAgreementClausesRequestSchema, ReorderAgreementClausesResponseSchema, SkipOnboardingStepRequestSchema, SkipOnboardingStepResponseSchema, UpdateAgreementClauseRequestSchema, UpdateAgreementClauseResponseSchema, UpdateAgreementRequestSchema, UpdateAgreementResponseSchema, UpdateOnboardingStepRequestSchema, UpdateOnboardingStepResponseSchema, UpdateOrganizationRequestSchema, UpdateOrganizationResponseSchema, UpdateOrganizationUserRequestSchema, UpdateOrganizationUserResponseSchema, UpdateUnavailableDateRequestSchema, UpdateUnavailableDateResponseSchema, UploadOrganizationLogoRequestSchema, UploadOrganizationLogoResponseSchema } from "./organizations_pb";
import { file_cortado_v1_organizations } from "./organizations_pb";
import type { Questionnaire, QuestionnaireAnswerInput, QuestionnaireFile, QuestionnaireItem } from "./questionnaires_pb";
import { file_cortado_v1_questionnaires } from "./questionnaires_pb";
import type { DisconnectStripeAccountRequestSchema, DisconnectStripeAccountResponseSchema, GetStripeAccountLinkURLRequestSchema, GetStripeAccountLinkURLResponseSchema, GetStripeConnectionStatusRequestSchema, GetStripeConnectionStatusResponseSchema, ListFailedWebhooksRequestSchema, ListFailedWebhooksResponseSchema, ListStaleWebhooksRequestSchema, ListStaleWebhooksResponseSchema, ListWebhooksRequestSchema, ListWebhooksResponseSchema, ReplayFailedWebhooksRequestSchema, ReplayFailedWebhooksResponseSchema, ReplayStaleWebhooksRequestSchema, ReplayStaleWebhooksResponseSchema, ReplayWebhookRequestSchema, ReplayWebhookResponseSchema } from "./payments_pb";
import { file_cortado_v1_payments } from "./payments_pb";
import type { Role } from "./rbac_pb";
import { file_cortado_v1_rbac } from "./rbac_pb";
import type { AcceptLeadReferralRequestSchema, AcceptLeadReferralResponseSchema, CreateLeadReferralPartnerRequestSchema, CreateLeadReferralPartnerResponseSchema, DeleteLeadReferralPartnerRequestSchema, DeleteLeadReferralPartnerResponseSchema, GetLeadReferralSettingsRequestSchema, GetLeadReferralSettingsResponseSchema, ListIncomingLeadReferralsRequestSchema, ListIncomingLeadReferralsResponseSchema, ListLeadReferralPartnersRequestSchema, ListLeadReferralPartnersResponseSchema, ListLeadReferralsRequestSchema, ListLeadReferralsResponseSchema, LookupLeadReferralCodeRequestSchema, LookupLeadReferralCodeResponseSchema, RegenerateLeadReferralCodeRequestSchema, RegenerateLeadReferralCodeResponseSchema, RejectLeadReferralRequestSchema, RejectLeadReferralResponseSchema, SendLeadReferralRequestSchema, SendLeadReferralResponseSchema, UpdateLeadReferralSettingsRequestSchema, UpdateLeadReferralSettingsResponseSchema, WithdrawLeadReferralRequestSchema, WithdrawLeadReferralResponseSchema } from "./referrals_pb";
import { file_cortado_v1_referrals } from "./referrals_pb";
import type { GetRealtimeQueriesRequestSchema, GetRealtimeQueriesResponseSchema } from "./realtime_pb";
import { file_cortado_v1_realtime } from "./realtime_pb";
import type { GetReportingMetricsRequestSchema, GetReportingMetricsResponseSchema, GetSalesTaxReportRequestSchema, GetSalesTaxReportResponseSchema } from "./reporting_pb";
import { file_cortado_v1_reporting } from "./reporting_pb";
import type { ActivityTypeEnum, BookingStageEnum, CheckoutSessionStatusEnum, DiscountTypeEnum, EventListBucketEnum, EventStageEnum, EventTypeEnum, FeedbackStageEnum, FeedbackTypeEnum, GetSystemSettingsRequestSchema, GetSystemSettingsResponseSchema, InquiryRejectReasonEnum, InquiryStageEnum, InquiryTagEnum, InvoicePaymentScheduleAdjustmentStrategyEnum, InvoiceStatusEnum, ItemUnitEnum, OrganizationEventType, ParentTypeEnum, PaymentRiskLevelEnum, PaymentScheduleStatusEnum, PermissionEnum, PermissionInfo, PortalAttributionModeEnum, PortalLinkIssuanceChannelEnum, QuoteExpirationAnchorEnum, QuoteRejectionReasonEnum, QuoteStatusEnum, StripeCheckoutPaymentMethodEnum, StripePaymentStatusEnum, TaskStatusEnum, TipAllocationModeEnum, UserSchedulingRoleEnum, UserSchedulingStatusEnum } from "./settings_pb";
import { file_cortado_v1_settings } from "./settings_pb";
import type { CancelSubscriptionRequestSchema, CancelSubscriptionResponseSchema, ChangeSubscriptionPlanRequestSchema, ChangeSubscriptionPlanResponseSchema, CreateCheckoutSessionRequestSchema, CreateCheckoutSessionResponseSchema, GetCustomerPortalURLRequestSchema, GetCustomerPortalURLResponseSchema, GetOrganizationBillingStateRequestSchema, GetOrganizationBillingStateResponseSchema, GetOrganizationSubscriptionRequestSchema, GetOrganizationSubscriptionResponseSchema, GetPaymentHistoryRequestSchema, GetPaymentHistoryResponseSchema, GetSeatUsageRequestSchema, GetSeatUsageResponseSchema, GetSubscriptionProductRequestSchema, GetSubscriptionProductResponseSchema, ListPlanOptionsRequestSchema, ListPlanOptionsResponseSchema, PreviewPlanChangeRequestSchema, PreviewPlanChangeResponseSchema, ReconcileCheckoutSessionRequestSchema, ReconcileCheckoutSessionResponseSchema, ResumeSubscriptionRequestSchema, ResumeSubscriptionResponseSchema } from "./subscriptions_pb";
import { file_cortado_v1_subscriptions } from "./subscriptions_pb";
import type { GetMeRequestSchema, GetMeResponseSchema, UpdateMeRequestSchema, UpdateMeResponseSchema } from "./users_pb";
import { file_cortado_v1_users } from "./users_pb";
import type { SubmitWaitlistRequestSchema, SubmitWaitlistResponseSchema } from "./waitlist_pb";
import { file_cortado_v1_waitlist } from "./waitlist_pb";
import type { FieldMask, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/cortado.proto.
 */
export const file_cortado_v1_cortado: GenFile = /*@__PURE__*/
  fileDesc("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", [file_cortado_v1_actions, file_cortado_v1_admin, file_cortado_v1_announcements, file_cortado_v1_api_keys, file_cortado_v1_attachments, file_cortado_v1_auth, file_cortado_v1_contacts, file_cortado_v1_email_conversations, file_cortado_v1_emails, file_cortado_v1_event_packing, file_cortado_v1_event_plan, file_cortado_v1_event_timeline, file_cortado_v1_event_staffing, file_cortado_v1_feedback, file_cortado_v1_inquiries, file_cortado_v1_integrations, file_cortado_v1_invoices, file_cortado_v1_jobs, file_cortado_v1_notifications, file_cortado_v1_organizations, file_cortado_v1_questionnaires, file_cortado_v1_payments, file_cortado_v1_rbac, file_cortado_v1_referrals, file_cortado_v1_realtime, file_cortado_v1_reporting, file_cortado_v1_settings, file_cortado_v1_subscriptions, file_cortado_v1_users, file_cortado_v1_waitlist, file_google_protobuf_field_mask, file_google_protobuf_timestamp]);

/**
 * PingRequest is sent to check service health
 *
 * @generated from message cortado.v1.PingRequest
 */
export type PingRequest = Message<"cortado.v1.PingRequest"> & {
  /**
   * Optional message to echo back
   *
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.PingRequest.
 * Use `create(PingRequestSchema)` to create a new message.
 */
export const PingRequestSchema: GenMessage<PingRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 0);

/**
 * PingResponse is returned from the Ping RPC
 *
 * @generated from message cortado.v1.PingResponse
 */
export type PingResponse = Message<"cortado.v1.PingResponse"> & {
  /**
   * Echo of the request message if provided
   *
   * @generated from field: string message = 1;
   */
  message: string;

  /**
   * Server timestamp when ping was received
   *
   * @generated from field: int64 timestamp = 2;
   */
  timestamp: bigint;
};

/**
 * Describes the message cortado.v1.PingResponse.
 * Use `create(PingResponseSchema)` to create a new message.
 */
export const PingResponseSchema: GenMessage<PingResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 1);

/**
 * @generated from message cortado.v1.ListContactsRequest
 */
export type ListContactsRequest = Message<"cortado.v1.ListContactsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * absent/<=0 => all
   *
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: optional int32 offset = 3;
   */
  offset?: number;

  /**
   * Optional text search matching contact first/last name or company name (case-insensitive)
   *
   * @generated from field: optional string search = 4;
   */
  search?: string;

  /**
   * When true, archived contacts are included alongside active contacts.
   *
   * @generated from field: bool include_archived = 5;
   */
  includeArchived: boolean;
};

/**
 * Describes the message cortado.v1.ListContactsRequest.
 * Use `create(ListContactsRequestSchema)` to create a new message.
 */
export const ListContactsRequestSchema: GenMessage<ListContactsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 2);

/**
 * @generated from message cortado.v1.ListContactsResponse
 */
export type ListContactsResponse = Message<"cortado.v1.ListContactsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.Contact contacts = 1;
   */
  contacts: Contact[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListContactsResponse.
 * Use `create(ListContactsResponseSchema)` to create a new message.
 */
export const ListContactsResponseSchema: GenMessage<ListContactsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 3);

/**
 * @generated from message cortado.v1.CreateContactRequest
 */
export type CreateContactRequest = Message<"cortado.v1.CreateContactRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string first_name = 2;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 3;
   */
  lastName: string;

  /**
   * @generated from field: optional string email = 4;
   */
  email?: string;

  /**
   * @generated from field: optional string phone_number = 5;
   */
  phoneNumber?: string;

  /**
   * @generated from field: optional string custom_fields = 6;
   */
  customFields?: string;

  /**
   * Further addresses beyond email, saved as secondary addresses.
   *
   * @generated from field: repeated string additional_emails = 7;
   */
  additionalEmails: string[];
};

/**
 * Describes the message cortado.v1.CreateContactRequest.
 * Use `create(CreateContactRequestSchema)` to create a new message.
 */
export const CreateContactRequestSchema: GenMessage<CreateContactRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 4);

/**
 * @generated from message cortado.v1.CreateContactResponse
 */
export type CreateContactResponse = Message<"cortado.v1.CreateContactResponse"> & {
  /**
   * @generated from field: cortado.v1.Contact contact = 1;
   */
  contact?: Contact;
};

/**
 * Describes the message cortado.v1.CreateContactResponse.
 * Use `create(CreateContactResponseSchema)` to create a new message.
 */
export const CreateContactResponseSchema: GenMessage<CreateContactResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 5);

/**
 * @generated from message cortado.v1.GetContactRequest
 */
export type GetContactRequest = Message<"cortado.v1.GetContactRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetContactRequest.
 * Use `create(GetContactRequestSchema)` to create a new message.
 */
export const GetContactRequestSchema: GenMessage<GetContactRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 6);

/**
 * @generated from message cortado.v1.GetContactResponse
 */
export type GetContactResponse = Message<"cortado.v1.GetContactResponse"> & {
  /**
   * @generated from field: cortado.v1.Contact contact = 1;
   */
  contact?: Contact;
};

/**
 * Describes the message cortado.v1.GetContactResponse.
 * Use `create(GetContactResponseSchema)` to create a new message.
 */
export const GetContactResponseSchema: GenMessage<GetContactResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 7);

/**
 * @generated from message cortado.v1.UpdateContactRequest
 */
export type UpdateContactRequest = Message<"cortado.v1.UpdateContactRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string first_name = 2;
   */
  firstName?: string;

  /**
   * @generated from field: optional string last_name = 3;
   */
  lastName?: string;

  /**
   * @generated from field: optional string email = 4;
   */
  email?: string;

  /**
   * @generated from field: optional string phone_number = 5;
   */
  phoneNumber?: string;

  /**
   * @generated from field: optional string custom_fields = 6;
   */
  customFields?: string;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 7;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message cortado.v1.UpdateContactRequest.
 * Use `create(UpdateContactRequestSchema)` to create a new message.
 */
export const UpdateContactRequestSchema: GenMessage<UpdateContactRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 8);

/**
 * @generated from message cortado.v1.UpdateContactResponse
 */
export type UpdateContactResponse = Message<"cortado.v1.UpdateContactResponse"> & {
  /**
   * @generated from field: cortado.v1.Contact contact = 1;
   */
  contact?: Contact;
};

/**
 * Describes the message cortado.v1.UpdateContactResponse.
 * Use `create(UpdateContactResponseSchema)` to create a new message.
 */
export const UpdateContactResponseSchema: GenMessage<UpdateContactResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 9);

/**
 * @generated from message cortado.v1.DeleteContactRequest
 */
export type DeleteContactRequest = Message<"cortado.v1.DeleteContactRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteContactRequest.
 * Use `create(DeleteContactRequestSchema)` to create a new message.
 */
export const DeleteContactRequestSchema: GenMessage<DeleteContactRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 10);

/**
 * @generated from message cortado.v1.DeleteContactResponse
 */
export type DeleteContactResponse = Message<"cortado.v1.DeleteContactResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteContactResponse.
 * Use `create(DeleteContactResponseSchema)` to create a new message.
 */
export const DeleteContactResponseSchema: GenMessage<DeleteContactResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 11);

/**
 * @generated from message cortado.v1.GetContactByEmailRequest
 */
export type GetContactByEmailRequest = Message<"cortado.v1.GetContactByEmailRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;
};

/**
 * Describes the message cortado.v1.GetContactByEmailRequest.
 * Use `create(GetContactByEmailRequestSchema)` to create a new message.
 */
export const GetContactByEmailRequestSchema: GenMessage<GetContactByEmailRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 12);

/**
 * @generated from message cortado.v1.GetContactByEmailResponse
 */
export type GetContactByEmailResponse = Message<"cortado.v1.GetContactByEmailResponse"> & {
  /**
   * @generated from field: cortado.v1.Contact contact = 1;
   */
  contact?: Contact;
};

/**
 * Describes the message cortado.v1.GetContactByEmailResponse.
 * Use `create(GetContactByEmailResponseSchema)` to create a new message.
 */
export const GetContactByEmailResponseSchema: GenMessage<GetContactByEmailResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 13);

/**
 * @generated from message cortado.v1.AddContactEmailRequest
 */
export type AddContactEmailRequest = Message<"cortado.v1.AddContactEmailRequest"> & {
  /**
   * @generated from field: string contact_id = 1;
   */
  contactId: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: optional string label = 3;
   */
  label?: string;
};

/**
 * Describes the message cortado.v1.AddContactEmailRequest.
 * Use `create(AddContactEmailRequestSchema)` to create a new message.
 */
export const AddContactEmailRequestSchema: GenMessage<AddContactEmailRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 14);

/**
 * @generated from message cortado.v1.AddContactEmailResponse
 */
export type AddContactEmailResponse = Message<"cortado.v1.AddContactEmailResponse"> & {
  /**
   * The contact with its addresses.
   *
   * @generated from field: cortado.v1.Contact contact = 1;
   */
  contact?: Contact;
};

/**
 * Describes the message cortado.v1.AddContactEmailResponse.
 * Use `create(AddContactEmailResponseSchema)` to create a new message.
 */
export const AddContactEmailResponseSchema: GenMessage<AddContactEmailResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 15);

/**
 * @generated from message cortado.v1.RemoveContactEmailRequest
 */
export type RemoveContactEmailRequest = Message<"cortado.v1.RemoveContactEmailRequest"> & {
  /**
   * @generated from field: string contact_id = 1;
   */
  contactId: string;

  /**
   * @generated from field: string contact_email_id = 2;
   */
  contactEmailId: string;
};

/**
 * Describes the message cortado.v1.RemoveContactEmailRequest.
 * Use `create(RemoveContactEmailRequestSchema)` to create a new message.
 */
export const RemoveContactEmailRequestSchema: GenMessage<RemoveContactEmailRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 16);

/**
 * @generated from message cortado.v1.RemoveContactEmailResponse
 */
export type RemoveContactEmailResponse = Message<"cortado.v1.RemoveContactEmailResponse"> & {
  /**
   * @generated from field: cortado.v1.Contact contact = 1;
   */
  contact?: Contact;
};

/**
 * Describes the message cortado.v1.RemoveContactEmailResponse.
 * Use `create(RemoveContactEmailResponseSchema)` to create a new message.
 */
export const RemoveContactEmailResponseSchema: GenMessage<RemoveContactEmailResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 17);

/**
 * @generated from message cortado.v1.SetPrimaryContactEmailRequest
 */
export type SetPrimaryContactEmailRequest = Message<"cortado.v1.SetPrimaryContactEmailRequest"> & {
  /**
   * @generated from field: string contact_id = 1;
   */
  contactId: string;

  /**
   * @generated from field: string contact_email_id = 2;
   */
  contactEmailId: string;
};

/**
 * Describes the message cortado.v1.SetPrimaryContactEmailRequest.
 * Use `create(SetPrimaryContactEmailRequestSchema)` to create a new message.
 */
export const SetPrimaryContactEmailRequestSchema: GenMessage<SetPrimaryContactEmailRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 18);

/**
 * @generated from message cortado.v1.SetPrimaryContactEmailResponse
 */
export type SetPrimaryContactEmailResponse = Message<"cortado.v1.SetPrimaryContactEmailResponse"> & {
  /**
   * @generated from field: cortado.v1.Contact contact = 1;
   */
  contact?: Contact;
};

/**
 * Describes the message cortado.v1.SetPrimaryContactEmailResponse.
 * Use `create(SetPrimaryContactEmailResponseSchema)` to create a new message.
 */
export const SetPrimaryContactEmailResponseSchema: GenMessage<SetPrimaryContactEmailResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 19);

/**
 * @generated from message cortado.v1.ListCompaniesRequest
 */
export type ListCompaniesRequest = Message<"cortado.v1.ListCompaniesRequest"> & {
  /**
   * Organization ID to get companies for (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Optional limit on number of companies to return (default: 50)
   *
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * Optional offset for pagination (default: 0)
   *
   * @generated from field: optional int32 offset = 3;
   */
  offset?: number;

  /**
   * When true, archived companies are included alongside active companies.
   *
   * @generated from field: bool include_archived = 4;
   */
  includeArchived: boolean;
};

/**
 * Describes the message cortado.v1.ListCompaniesRequest.
 * Use `create(ListCompaniesRequestSchema)` to create a new message.
 */
export const ListCompaniesRequestSchema: GenMessage<ListCompaniesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 20);

/**
 * @generated from message cortado.v1.ListCompaniesResponse
 */
export type ListCompaniesResponse = Message<"cortado.v1.ListCompaniesResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.Company companies = 1;
   */
  companies: Company[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListCompaniesResponse.
 * Use `create(ListCompaniesResponseSchema)` to create a new message.
 */
export const ListCompaniesResponseSchema: GenMessage<ListCompaniesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 21);

/**
 * @generated from message cortado.v1.CreateCompanyRequest
 */
export type CreateCompanyRequest = Message<"cortado.v1.CreateCompanyRequest"> & {
  /**
   * Organization ID the company belongs to (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Name of the company (required)
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * Website URL of the company (optional)
   *
   * @generated from field: optional string website_url = 3;
   */
  websiteUrl?: string;

  /**
   * Mail domain, e.g. acme.com (optional). Public mail providers such as
   * gmail.com are refused, and a domain belongs to one company per org.
   *
   * @generated from field: optional string domain = 4;
   */
  domain?: string;
};

/**
 * Describes the message cortado.v1.CreateCompanyRequest.
 * Use `create(CreateCompanyRequestSchema)` to create a new message.
 */
export const CreateCompanyRequestSchema: GenMessage<CreateCompanyRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 22);

/**
 * @generated from message cortado.v1.CreateCompanyResponse
 */
export type CreateCompanyResponse = Message<"cortado.v1.CreateCompanyResponse"> & {
  /**
   * @generated from field: cortado.v1.Company company = 1;
   */
  company?: Company;
};

/**
 * Describes the message cortado.v1.CreateCompanyResponse.
 * Use `create(CreateCompanyResponseSchema)` to create a new message.
 */
export const CreateCompanyResponseSchema: GenMessage<CreateCompanyResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 23);

/**
 * @generated from message cortado.v1.GetCompanyRequest
 */
export type GetCompanyRequest = Message<"cortado.v1.GetCompanyRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetCompanyRequest.
 * Use `create(GetCompanyRequestSchema)` to create a new message.
 */
export const GetCompanyRequestSchema: GenMessage<GetCompanyRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 24);

/**
 * @generated from message cortado.v1.GetCompanyResponse
 */
export type GetCompanyResponse = Message<"cortado.v1.GetCompanyResponse"> & {
  /**
   * @generated from field: cortado.v1.Company company = 1;
   */
  company?: Company;

  /**
   * Contacts associated with this company
   *
   * @generated from field: repeated cortado.v1.CompanyContactWithDetails contacts = 2;
   */
  contacts: CompanyContactWithDetails[];
};

/**
 * Describes the message cortado.v1.GetCompanyResponse.
 * Use `create(GetCompanyResponseSchema)` to create a new message.
 */
export const GetCompanyResponseSchema: GenMessage<GetCompanyResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 25);

/**
 * CompanyContactWithDetails includes contact details with their title at the company
 *
 * @generated from message cortado.v1.CompanyContactWithDetails
 */
export type CompanyContactWithDetails = Message<"cortado.v1.CompanyContactWithDetails"> & {
  /**
   * @generated from field: cortado.v1.Contact contact = 1;
   */
  contact?: Contact;

  /**
   * @generated from field: string title = 2;
   */
  title: string;
};

/**
 * Describes the message cortado.v1.CompanyContactWithDetails.
 * Use `create(CompanyContactWithDetailsSchema)` to create a new message.
 */
export const CompanyContactWithDetailsSchema: GenMessage<CompanyContactWithDetails> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 26);

/**
 * @generated from message cortado.v1.UpdateCompanyRequest
 */
export type UpdateCompanyRequest = Message<"cortado.v1.UpdateCompanyRequest"> & {
  /**
   * Company ID (required)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Name of the company
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * Website URL of the company
   *
   * @generated from field: optional string website_url = 3;
   */
  websiteUrl?: string;

  /**
   * Mail domain; an empty string clears it
   *
   * @generated from field: optional string domain = 4;
   */
  domain?: string;

  /**
   * Field mask for partial updates
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 10;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message cortado.v1.UpdateCompanyRequest.
 * Use `create(UpdateCompanyRequestSchema)` to create a new message.
 */
export const UpdateCompanyRequestSchema: GenMessage<UpdateCompanyRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 27);

/**
 * @generated from message cortado.v1.UpdateCompanyResponse
 */
export type UpdateCompanyResponse = Message<"cortado.v1.UpdateCompanyResponse"> & {
  /**
   * @generated from field: cortado.v1.Company company = 1;
   */
  company?: Company;
};

/**
 * Describes the message cortado.v1.UpdateCompanyResponse.
 * Use `create(UpdateCompanyResponseSchema)` to create a new message.
 */
export const UpdateCompanyResponseSchema: GenMessage<UpdateCompanyResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 28);

/**
 * @generated from message cortado.v1.DeleteCompanyRequest
 */
export type DeleteCompanyRequest = Message<"cortado.v1.DeleteCompanyRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteCompanyRequest.
 * Use `create(DeleteCompanyRequestSchema)` to create a new message.
 */
export const DeleteCompanyRequestSchema: GenMessage<DeleteCompanyRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 29);

/**
 * @generated from message cortado.v1.DeleteCompanyResponse
 */
export type DeleteCompanyResponse = Message<"cortado.v1.DeleteCompanyResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteCompanyResponse.
 * Use `create(DeleteCompanyResponseSchema)` to create a new message.
 */
export const DeleteCompanyResponseSchema: GenMessage<DeleteCompanyResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 30);

/**
 * @generated from message cortado.v1.AddContactToCompanyRequest
 */
export type AddContactToCompanyRequest = Message<"cortado.v1.AddContactToCompanyRequest"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;

  /**
   * @generated from field: string contact_id = 2;
   */
  contactId: string;

  /**
   * Title/role at the company (optional)
   *
   * @generated from field: optional string title = 3;
   */
  title?: string;
};

/**
 * Describes the message cortado.v1.AddContactToCompanyRequest.
 * Use `create(AddContactToCompanyRequestSchema)` to create a new message.
 */
export const AddContactToCompanyRequestSchema: GenMessage<AddContactToCompanyRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 31);

/**
 * @generated from message cortado.v1.AddContactToCompanyResponse
 */
export type AddContactToCompanyResponse = Message<"cortado.v1.AddContactToCompanyResponse"> & {
  /**
   * @generated from field: cortado.v1.CompanyContact company_contact = 1;
   */
  companyContact?: CompanyContact;
};

/**
 * Describes the message cortado.v1.AddContactToCompanyResponse.
 * Use `create(AddContactToCompanyResponseSchema)` to create a new message.
 */
export const AddContactToCompanyResponseSchema: GenMessage<AddContactToCompanyResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 32);

/**
 * @generated from message cortado.v1.RemoveContactFromCompanyRequest
 */
export type RemoveContactFromCompanyRequest = Message<"cortado.v1.RemoveContactFromCompanyRequest"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;

  /**
   * @generated from field: string contact_id = 2;
   */
  contactId: string;
};

/**
 * Describes the message cortado.v1.RemoveContactFromCompanyRequest.
 * Use `create(RemoveContactFromCompanyRequestSchema)` to create a new message.
 */
export const RemoveContactFromCompanyRequestSchema: GenMessage<RemoveContactFromCompanyRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 33);

/**
 * @generated from message cortado.v1.RemoveContactFromCompanyResponse
 */
export type RemoveContactFromCompanyResponse = Message<"cortado.v1.RemoveContactFromCompanyResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.RemoveContactFromCompanyResponse.
 * Use `create(RemoveContactFromCompanyResponseSchema)` to create a new message.
 */
export const RemoveContactFromCompanyResponseSchema: GenMessage<RemoveContactFromCompanyResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 34);

/**
 * @generated from message cortado.v1.CreateInquiryRequest
 */
export type CreateInquiryRequest = Message<"cortado.v1.CreateInquiryRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string contact_id = 2;
   */
  contactId: string;

  /**
   * @generated from field: optional cortado.v1.EventTypeEnum event_type = 3 [deprecated = true];
   * @deprecated
   */
  eventType?: EventTypeEnum;

  /**
   * @generated from field: optional google.protobuf.Timestamp event_date = 4;
   */
  eventDate?: Timestamp;

  /**
   * @generated from field: optional int32 event_days = 5;
   */
  eventDays?: number;

  /**
   * @generated from field: optional double event_length = 6;
   */
  eventLength?: number;

  /**
   * @generated from field: optional string event_location = 7;
   */
  eventLocation?: string;

  /**
   * @generated from field: optional int32 event_guests = 8;
   */
  eventGuests?: number;

  /**
   * @generated from field: optional string event_timezone = 9;
   */
  eventTimezone?: string;

  /**
   * @generated from field: optional string referrer = 10;
   */
  referrer?: string;

  /**
   * @generated from field: optional cortado.v1.InquiryStageEnum stage = 11;
   */
  stage?: InquiryStageEnum;

  /**
   * Attribution source data (JSONB in DB, serialized as JSON string in proto)
   *
   * @generated from field: optional string source = 12;
   */
  source?: string;

  /**
   * @generated from field: optional string event_type_key = 13;
   */
  eventTypeKey?: string;

  /**
   * Whether bookings created from this lead get a questionnaire. Defaults to
   * true when absent.
   *
   * @generated from field: optional bool requires_questionnaire = 14;
   */
  requiresQuestionnaire?: boolean;
};

/**
 * Describes the message cortado.v1.CreateInquiryRequest.
 * Use `create(CreateInquiryRequestSchema)` to create a new message.
 */
export const CreateInquiryRequestSchema: GenMessage<CreateInquiryRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 35);

/**
 * @generated from message cortado.v1.CreateInquiryResponse
 */
export type CreateInquiryResponse = Message<"cortado.v1.CreateInquiryResponse"> & {
  /**
   * @generated from field: cortado.v1.Inquiry inquiry = 1;
   */
  inquiry?: Inquiry;
};

/**
 * Describes the message cortado.v1.CreateInquiryResponse.
 * Use `create(CreateInquiryResponseSchema)` to create a new message.
 */
export const CreateInquiryResponseSchema: GenMessage<CreateInquiryResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 36);

/**
 * @generated from message cortado.v1.GetInquiryRequest
 */
export type GetInquiryRequest = Message<"cortado.v1.GetInquiryRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetInquiryRequest.
 * Use `create(GetInquiryRequestSchema)` to create a new message.
 */
export const GetInquiryRequestSchema: GenMessage<GetInquiryRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 37);

/**
 * @generated from message cortado.v1.GetInquiryResponse
 */
export type GetInquiryResponse = Message<"cortado.v1.GetInquiryResponse"> & {
  /**
   * @generated from field: cortado.v1.Inquiry inquiry = 1;
   */
  inquiry?: Inquiry;
};

/**
 * Describes the message cortado.v1.GetInquiryResponse.
 * Use `create(GetInquiryResponseSchema)` to create a new message.
 */
export const GetInquiryResponseSchema: GenMessage<GetInquiryResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 38);

/**
 * @generated from message cortado.v1.UpdateInquiryRequest
 */
export type UpdateInquiryRequest = Message<"cortado.v1.UpdateInquiryRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string contact_id = 2;
   */
  contactId?: string;

  /**
   * @generated from field: optional cortado.v1.InquiryStageEnum stage = 3;
   */
  stage?: InquiryStageEnum;

  /**
   * @generated from field: optional cortado.v1.EventTypeEnum event_type = 4 [deprecated = true];
   * @deprecated
   */
  eventType?: EventTypeEnum;

  /**
   * @generated from field: optional google.protobuf.Timestamp event_date = 5;
   */
  eventDate?: Timestamp;

  /**
   * @generated from field: optional int32 event_days = 6;
   */
  eventDays?: number;

  /**
   * @generated from field: optional double event_length = 7;
   */
  eventLength?: number;

  /**
   * @generated from field: optional string event_location = 8;
   */
  eventLocation?: string;

  /**
   * @generated from field: optional int32 event_guests = 9;
   */
  eventGuests?: number;

  /**
   * @generated from field: optional string event_timezone = 10;
   */
  eventTimezone?: string;

  /**
   * @generated from field: optional string referrer = 11;
   */
  referrer?: string;

  /**
   * @generated from field: repeated string item_ids = 12;
   */
  itemIds: string[];

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 13;
   */
  updateMask?: FieldMask;

  /**
   * @generated from field: repeated cortado.v1.InquiryTagEnum tags = 14;
   */
  tags: InquiryTagEnum[];

  /**
   * @generated from field: optional cortado.v1.InquiryRejectReasonEnum reject_reason = 15;
   */
  rejectReason?: InquiryRejectReasonEnum;

  /**
   * @generated from field: optional string reject_notes = 16;
   */
  rejectNotes?: string;

  /**
   * @generated from field: optional string event_type_key = 17;
   */
  eventTypeKey?: string;

  /**
   * User ID to assign the lead to (optional). Set to empty string to unassign.
   * Only applied when in update_mask.
   *
   * @generated from field: optional string assigned_to = 18;
   */
  assignedTo?: string;

  /**
   * Whether bookings created from this lead get a questionnaire.
   * Only applied when in update_mask.
   *
   * @generated from field: optional bool requires_questionnaire = 19;
   */
  requiresQuestionnaire?: boolean;
};

/**
 * Describes the message cortado.v1.UpdateInquiryRequest.
 * Use `create(UpdateInquiryRequestSchema)` to create a new message.
 */
export const UpdateInquiryRequestSchema: GenMessage<UpdateInquiryRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 39);

/**
 * @generated from message cortado.v1.UpdateInquiryResponse
 */
export type UpdateInquiryResponse = Message<"cortado.v1.UpdateInquiryResponse"> & {
  /**
   * @generated from field: cortado.v1.Inquiry inquiry = 1;
   */
  inquiry?: Inquiry;
};

/**
 * Describes the message cortado.v1.UpdateInquiryResponse.
 * Use `create(UpdateInquiryResponseSchema)` to create a new message.
 */
export const UpdateInquiryResponseSchema: GenMessage<UpdateInquiryResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 40);

/**
 * @generated from message cortado.v1.GetPublicInquiryRequest
 */
export type GetPublicInquiryRequest = Message<"cortado.v1.GetPublicInquiryRequest"> & {
  /**
   * Token is extracted from Authorization header by backend
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetPublicInquiryRequest.
 * Use `create(GetPublicInquiryRequestSchema)` to create a new message.
 */
export const GetPublicInquiryRequestSchema: GenMessage<GetPublicInquiryRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 41);

/**
 * @generated from message cortado.v1.GetPublicInquiryResponse
 */
export type GetPublicInquiryResponse = Message<"cortado.v1.GetPublicInquiryResponse"> & {
  /**
   * @generated from field: cortado.v1.PublicInquiry inquiry = 1;
   */
  inquiry?: PublicInquiry;
};

/**
 * Describes the message cortado.v1.GetPublicInquiryResponse.
 * Use `create(GetPublicInquiryResponseSchema)` to create a new message.
 */
export const GetPublicInquiryResponseSchema: GenMessage<GetPublicInquiryResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 42);

/**
 * @generated from message cortado.v1.GetPublicQuoteRequest
 */
export type GetPublicQuoteRequest = Message<"cortado.v1.GetPublicQuoteRequest"> & {
  /**
   * Quote ID
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetPublicQuoteRequest.
 * Use `create(GetPublicQuoteRequestSchema)` to create a new message.
 */
export const GetPublicQuoteRequestSchema: GenMessage<GetPublicQuoteRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 43);

/**
 * @generated from message cortado.v1.GetPublicQuoteResponse
 */
export type GetPublicQuoteResponse = Message<"cortado.v1.GetPublicQuoteResponse"> & {
  /**
   * @generated from field: cortado.v1.PublicQuote quote = 1;
   */
  quote?: PublicQuote;

  /**
   * True when this view was attributed to the original tracked recipient token.
   *
   * @generated from field: bool is_access_attributed = 2;
   */
  isAccessAttributed: boolean;
};

/**
 * Describes the message cortado.v1.GetPublicQuoteResponse.
 * Use `create(GetPublicQuoteResponseSchema)` to create a new message.
 */
export const GetPublicQuoteResponseSchema: GenMessage<GetPublicQuoteResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 44);

/**
 * PublicQuoteAddonSelection represents a customer's opt-in for a single
 * add-on offer on a quote.
 *
 * @generated from message cortado.v1.PublicQuoteAddonSelection
 */
export type PublicQuoteAddonSelection = Message<"cortado.v1.PublicQuoteAddonSelection"> & {
  /**
   * @generated from field: string addon_offer_id = 1;
   */
  addonOfferId: string;

  /**
   * Deprecated: ignored by the server. Quantity is authored by the tenant on
   * the add-on offer; the customer can only opt in or out.
   *
   * @generated from field: double quantity = 2 [deprecated = true];
   * @deprecated
   */
  quantity: number;
};

/**
 * Describes the message cortado.v1.PublicQuoteAddonSelection.
 * Use `create(PublicQuoteAddonSelectionSchema)` to create a new message.
 */
export const PublicQuoteAddonSelectionSchema: GenMessage<PublicQuoteAddonSelection> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 45);

/**
 * @generated from message cortado.v1.PreviewPublicQuoteRequest
 */
export type PreviewPublicQuoteRequest = Message<"cortado.v1.PreviewPublicQuoteRequest"> & {
  /**
   * @generated from field: string quote_id = 1;
   */
  quoteId: string;

  /**
   * Token is extracted from Authorization header by backend
   *
   * @generated from field: repeated cortado.v1.PublicQuoteAddonSelection selections = 2;
   */
  selections: PublicQuoteAddonSelection[];
};

/**
 * Describes the message cortado.v1.PreviewPublicQuoteRequest.
 * Use `create(PreviewPublicQuoteRequestSchema)` to create a new message.
 */
export const PreviewPublicQuoteRequestSchema: GenMessage<PreviewPublicQuoteRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 46);

/**
 * @generated from message cortado.v1.PreviewPublicQuoteResponse
 */
export type PreviewPublicQuoteResponse = Message<"cortado.v1.PreviewPublicQuoteResponse"> & {
  /**
   * @generated from field: cortado.v1.PublicQuote quote = 1;
   */
  quote?: PublicQuote;
};

/**
 * Describes the message cortado.v1.PreviewPublicQuoteResponse.
 * Use `create(PreviewPublicQuoteResponseSchema)` to create a new message.
 */
export const PreviewPublicQuoteResponseSchema: GenMessage<PreviewPublicQuoteResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 47);

/**
 * @generated from message cortado.v1.AcceptPublicQuoteRequest
 */
export type AcceptPublicQuoteRequest = Message<"cortado.v1.AcceptPublicQuoteRequest"> & {
  /**
   * @generated from field: string quote_id = 1;
   */
  quoteId: string;

  /**
   * Token is extracted from Authorization header by backend
   *
   * @generated from field: repeated cortado.v1.PublicQuoteAddonSelection selections = 2;
   */
  selections: PublicQuoteAddonSelection[];

  /**
   * @generated from field: optional string revision_id = 3;
   */
  revisionId?: string;
};

/**
 * Describes the message cortado.v1.AcceptPublicQuoteRequest.
 * Use `create(AcceptPublicQuoteRequestSchema)` to create a new message.
 */
export const AcceptPublicQuoteRequestSchema: GenMessage<AcceptPublicQuoteRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 48);

/**
 * @generated from message cortado.v1.AcceptPublicQuoteResponse
 */
export type AcceptPublicQuoteResponse = Message<"cortado.v1.AcceptPublicQuoteResponse"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string invoice_id = 2;
   */
  invoiceId: string;

  /**
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * True if quote was already accepted before this request
   *
   * @generated from field: bool was_already_accepted = 4;
   */
  wasAlreadyAccepted: boolean;
};

/**
 * Describes the message cortado.v1.AcceptPublicQuoteResponse.
 * Use `create(AcceptPublicQuoteResponseSchema)` to create a new message.
 */
export const AcceptPublicQuoteResponseSchema: GenMessage<AcceptPublicQuoteResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 49);

/**
 * @generated from message cortado.v1.RejectPublicQuoteRequest
 */
export type RejectPublicQuoteRequest = Message<"cortado.v1.RejectPublicQuoteRequest"> & {
  /**
   * @generated from field: string quote_id = 1;
   */
  quoteId: string;

  /**
   * Optional free-text detail for the decline. Persisted on the quote and
   * forwarded to the organization notification. Required (non-empty) when
   * reason_category is QUOTE_REJECTION_REASON_OTHER.
   *
   * @generated from field: optional string reason = 2;
   */
  reason?: string;

  /**
   * Structured decline category. UNSPECIFIED is accepted for older clients.
   *
   * Token is extracted from Authorization header by backend
   *
   * @generated from field: cortado.v1.QuoteRejectionReasonEnum reason_category = 3;
   */
  reasonCategory: QuoteRejectionReasonEnum;
};

/**
 * Describes the message cortado.v1.RejectPublicQuoteRequest.
 * Use `create(RejectPublicQuoteRequestSchema)` to create a new message.
 */
export const RejectPublicQuoteRequestSchema: GenMessage<RejectPublicQuoteRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 50);

/**
 * @generated from message cortado.v1.RejectPublicQuoteResponse
 */
export type RejectPublicQuoteResponse = Message<"cortado.v1.RejectPublicQuoteResponse"> & {
  /**
   * @generated from field: cortado.v1.PublicQuote quote = 1;
   */
  quote?: PublicQuote;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * True if quote was already rejected before this request
   *
   * @generated from field: bool was_already_rejected = 3;
   */
  wasAlreadyRejected: boolean;
};

/**
 * Describes the message cortado.v1.RejectPublicQuoteResponse.
 * Use `create(RejectPublicQuoteResponseSchema)` to create a new message.
 */
export const RejectPublicQuoteResponseSchema: GenMessage<RejectPublicQuoteResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 51);

/**
 * @generated from message cortado.v1.MarkPublicQuoteViewedRequest
 */
export type MarkPublicQuoteViewedRequest = Message<"cortado.v1.MarkPublicQuoteViewedRequest"> & {
  /**
   * Token is extracted from Authorization header by backend
   *
   * @generated from field: string quote_id = 1;
   */
  quoteId: string;
};

/**
 * Describes the message cortado.v1.MarkPublicQuoteViewedRequest.
 * Use `create(MarkPublicQuoteViewedRequestSchema)` to create a new message.
 */
export const MarkPublicQuoteViewedRequestSchema: GenMessage<MarkPublicQuoteViewedRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 52);

/**
 * @generated from message cortado.v1.MarkPublicQuoteViewedResponse
 */
export type MarkPublicQuoteViewedResponse = Message<"cortado.v1.MarkPublicQuoteViewedResponse"> & {
  /**
   * Returns updated quote for cache sync
   *
   * @generated from field: cortado.v1.PublicQuote quote = 1;
   */
  quote?: PublicQuote;
};

/**
 * Describes the message cortado.v1.MarkPublicQuoteViewedResponse.
 * Use `create(MarkPublicQuoteViewedResponseSchema)` to create a new message.
 */
export const MarkPublicQuoteViewedResponseSchema: GenMessage<MarkPublicQuoteViewedResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 53);

/**
 * @generated from message cortado.v1.GetPublicBookingRequest
 */
export type GetPublicBookingRequest = Message<"cortado.v1.GetPublicBookingRequest"> & {
  /**
   * Booking ID
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetPublicBookingRequest.
 * Use `create(GetPublicBookingRequestSchema)` to create a new message.
 */
export const GetPublicBookingRequestSchema: GenMessage<GetPublicBookingRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 54);

/**
 * @generated from message cortado.v1.GetPublicBookingResponse
 */
export type GetPublicBookingResponse = Message<"cortado.v1.GetPublicBookingResponse"> & {
  /**
   * @generated from field: cortado.v1.PublicBooking booking = 1;
   */
  booking?: PublicBooking;
};

/**
 * Describes the message cortado.v1.GetPublicBookingResponse.
 * Use `create(GetPublicBookingResponseSchema)` to create a new message.
 */
export const GetPublicBookingResponseSchema: GenMessage<GetPublicBookingResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 55);

/**
 * @generated from message cortado.v1.SubmitPublicBookingQuestionnaireRequest
 */
export type SubmitPublicBookingQuestionnaireRequest = Message<"cortado.v1.SubmitPublicBookingQuestionnaireRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: repeated cortado.v1.QuestionnaireAnswerInput answers = 2;
   */
  answers: QuestionnaireAnswerInput[];
};

/**
 * Describes the message cortado.v1.SubmitPublicBookingQuestionnaireRequest.
 * Use `create(SubmitPublicBookingQuestionnaireRequestSchema)` to create a new message.
 */
export const SubmitPublicBookingQuestionnaireRequestSchema: GenMessage<SubmitPublicBookingQuestionnaireRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 56);

/**
 * @generated from message cortado.v1.SubmitPublicBookingQuestionnaireResponse
 */
export type SubmitPublicBookingQuestionnaireResponse = Message<"cortado.v1.SubmitPublicBookingQuestionnaireResponse"> & {
  /**
   * @generated from field: cortado.v1.Questionnaire questionnaire = 1;
   */
  questionnaire?: Questionnaire;
};

/**
 * Describes the message cortado.v1.SubmitPublicBookingQuestionnaireResponse.
 * Use `create(SubmitPublicBookingQuestionnaireResponseSchema)` to create a new message.
 */
export const SubmitPublicBookingQuestionnaireResponseSchema: GenMessage<SubmitPublicBookingQuestionnaireResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 57);

/**
 * @generated from message cortado.v1.UploadPublicBookingQuestionnaireFileRequest
 */
export type UploadPublicBookingQuestionnaireFileRequest = Message<"cortado.v1.UploadPublicBookingQuestionnaireFileRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * item_id must name a FILE_UPLOAD or FILE_UPLOAD_MULTIPLE item on the
   * booking's questionnaire.
   *
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * @generated from field: string filename = 3;
   */
  filename: string;

  /**
   * @generated from field: string file_base64 = 4;
   */
  fileBase64: string;
};

/**
 * Describes the message cortado.v1.UploadPublicBookingQuestionnaireFileRequest.
 * Use `create(UploadPublicBookingQuestionnaireFileRequestSchema)` to create a new message.
 */
export const UploadPublicBookingQuestionnaireFileRequestSchema: GenMessage<UploadPublicBookingQuestionnaireFileRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 58);

/**
 * @generated from message cortado.v1.UploadPublicBookingQuestionnaireFileResponse
 */
export type UploadPublicBookingQuestionnaireFileResponse = Message<"cortado.v1.UploadPublicBookingQuestionnaireFileResponse"> & {
  /**
   * @generated from field: cortado.v1.QuestionnaireFile file = 1;
   */
  file?: QuestionnaireFile;
};

/**
 * Describes the message cortado.v1.UploadPublicBookingQuestionnaireFileResponse.
 * Use `create(UploadPublicBookingQuestionnaireFileResponseSchema)` to create a new message.
 */
export const UploadPublicBookingQuestionnaireFileResponseSchema: GenMessage<UploadPublicBookingQuestionnaireFileResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 59);

/**
 * @generated from message cortado.v1.UpdateBookingQuestionnaireRequest
 */
export type UpdateBookingQuestionnaireRequest = Message<"cortado.v1.UpdateBookingQuestionnaireRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * Full desired list of items, in order. An empty list clears the
   * questionnaire. Any answer content on these items is ignored - answers are
   * server-owned and carried over from the existing snapshot.
   *
   * @generated from field: repeated cortado.v1.QuestionnaireItem items = 2;
   */
  items: QuestionnaireItem[];
};

/**
 * Describes the message cortado.v1.UpdateBookingQuestionnaireRequest.
 * Use `create(UpdateBookingQuestionnaireRequestSchema)` to create a new message.
 */
export const UpdateBookingQuestionnaireRequestSchema: GenMessage<UpdateBookingQuestionnaireRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 60);

/**
 * @generated from message cortado.v1.UpdateBookingQuestionnaireResponse
 */
export type UpdateBookingQuestionnaireResponse = Message<"cortado.v1.UpdateBookingQuestionnaireResponse"> & {
  /**
   * @generated from field: cortado.v1.Booking booking = 1;
   */
  booking?: Booking;
};

/**
 * Describes the message cortado.v1.UpdateBookingQuestionnaireResponse.
 * Use `create(UpdateBookingQuestionnaireResponseSchema)` to create a new message.
 */
export const UpdateBookingQuestionnaireResponseSchema: GenMessage<UpdateBookingQuestionnaireResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 61);

/**
 * @generated from message cortado.v1.GetPublicInvoiceRequest
 */
export type GetPublicInvoiceRequest = Message<"cortado.v1.GetPublicInvoiceRequest"> & {
  /**
   * Invoice ID
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetPublicInvoiceRequest.
 * Use `create(GetPublicInvoiceRequestSchema)` to create a new message.
 */
export const GetPublicInvoiceRequestSchema: GenMessage<GetPublicInvoiceRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 62);

/**
 * @generated from message cortado.v1.GetPublicInvoiceResponse
 */
export type GetPublicInvoiceResponse = Message<"cortado.v1.GetPublicInvoiceResponse"> & {
  /**
   * @generated from field: cortado.v1.PublicInvoice invoice = 1;
   */
  invoice?: PublicInvoice;
};

/**
 * Describes the message cortado.v1.GetPublicInvoiceResponse.
 * Use `create(GetPublicInvoiceResponseSchema)` to create a new message.
 */
export const GetPublicInvoiceResponseSchema: GenMessage<GetPublicInvoiceResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 63);

/**
 * UpdatePublicInvoiceTipRequest updates the tip amount for a public invoice
 *
 * @generated from message cortado.v1.UpdatePublicInvoiceTipRequest
 */
export type UpdatePublicInvoiceTipRequest = Message<"cortado.v1.UpdatePublicInvoiceTipRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * The new tip amount in cents (must be >= enforced minimum if applicable)
   *
   * @generated from field: int64 tip_cents = 2;
   */
  tipCents: bigint;
};

/**
 * Describes the message cortado.v1.UpdatePublicInvoiceTipRequest.
 * Use `create(UpdatePublicInvoiceTipRequestSchema)` to create a new message.
 */
export const UpdatePublicInvoiceTipRequestSchema: GenMessage<UpdatePublicInvoiceTipRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 64);

/**
 * UpdatePublicInvoiceTipResponse returns the updated invoice
 *
 * @generated from message cortado.v1.UpdatePublicInvoiceTipResponse
 */
export type UpdatePublicInvoiceTipResponse = Message<"cortado.v1.UpdatePublicInvoiceTipResponse"> & {
  /**
   * @generated from field: cortado.v1.PublicInvoice invoice = 1;
   */
  invoice?: PublicInvoice;
};

/**
 * Describes the message cortado.v1.UpdatePublicInvoiceTipResponse.
 * Use `create(UpdatePublicInvoiceTipResponseSchema)` to create a new message.
 */
export const UpdatePublicInvoiceTipResponseSchema: GenMessage<UpdatePublicInvoiceTipResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 65);

/**
 * @generated from message cortado.v1.CreatePublicPaymentIntentRequest
 */
export type CreatePublicPaymentIntentRequest = Message<"cortado.v1.CreatePublicPaymentIntentRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * Token is extracted from Authorization header by backend
   *
   * @generated from field: string payment_schedule_item_id = 2;
   */
  paymentScheduleItemId: string;
};

/**
 * Describes the message cortado.v1.CreatePublicPaymentIntentRequest.
 * Use `create(CreatePublicPaymentIntentRequestSchema)` to create a new message.
 */
export const CreatePublicPaymentIntentRequestSchema: GenMessage<CreatePublicPaymentIntentRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 66);

/**
 * @generated from message cortado.v1.CreatePublicPaymentIntentResponse
 */
export type CreatePublicPaymentIntentResponse = Message<"cortado.v1.CreatePublicPaymentIntentResponse"> & {
  /**
   * @generated from field: string payment_intent_id = 1;
   */
  paymentIntentId: string;

  /**
   * @generated from field: string client_secret = 2;
   */
  clientSecret: string;

  /**
   * @generated from field: int64 amount_cents = 3;
   */
  amountCents: bigint;

  /**
   * @generated from field: string stripe_account_id = 4;
   */
  stripeAccountId: string;
};

/**
 * Describes the message cortado.v1.CreatePublicPaymentIntentResponse.
 * Use `create(CreatePublicPaymentIntentResponseSchema)` to create a new message.
 */
export const CreatePublicPaymentIntentResponseSchema: GenMessage<CreatePublicPaymentIntentResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 67);

/**
 * @generated from message cortado.v1.CreatePublicCheckoutSessionRequest
 */
export type CreatePublicCheckoutSessionRequest = Message<"cortado.v1.CreatePublicCheckoutSessionRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * Token is extracted from Authorization header by backend
   *
   * @generated from field: string payment_schedule_item_id = 2;
   */
  paymentScheduleItemId: string;
};

/**
 * Describes the message cortado.v1.CreatePublicCheckoutSessionRequest.
 * Use `create(CreatePublicCheckoutSessionRequestSchema)` to create a new message.
 */
export const CreatePublicCheckoutSessionRequestSchema: GenMessage<CreatePublicCheckoutSessionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 68);

/**
 * @generated from message cortado.v1.CreatePublicCheckoutSessionResponse
 */
export type CreatePublicCheckoutSessionResponse = Message<"cortado.v1.CreatePublicCheckoutSessionResponse"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string client_secret = 2;
   */
  clientSecret: string;

  /**
   * @generated from field: int64 amount_cents = 3;
   */
  amountCents: bigint;

  /**
   * @generated from field: string stripe_account_id = 4;
   */
  stripeAccountId: string;

  /**
   * @generated from field: string return_url = 5;
   */
  returnUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 6;
   */
  expiresAt?: Timestamp;

  /**
   * @generated from field: int64 base_amount_cents = 7;
   */
  baseAmountCents: bigint;

  /**
   * @generated from field: int64 tip_amount_cents = 8;
   */
  tipAmountCents: bigint;
};

/**
 * Describes the message cortado.v1.CreatePublicCheckoutSessionResponse.
 * Use `create(CreatePublicCheckoutSessionResponseSchema)` to create a new message.
 */
export const CreatePublicCheckoutSessionResponseSchema: GenMessage<CreatePublicCheckoutSessionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 69);

/**
 * @generated from message cortado.v1.CreatePublicResidualTipCheckoutSessionRequest
 */
export type CreatePublicResidualTipCheckoutSessionRequest = Message<"cortado.v1.CreatePublicResidualTipCheckoutSessionRequest"> & {
  /**
   * Token is extracted from Authorization header by backend
   *
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;
};

/**
 * Describes the message cortado.v1.CreatePublicResidualTipCheckoutSessionRequest.
 * Use `create(CreatePublicResidualTipCheckoutSessionRequestSchema)` to create a new message.
 */
export const CreatePublicResidualTipCheckoutSessionRequestSchema: GenMessage<CreatePublicResidualTipCheckoutSessionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 70);

/**
 * @generated from message cortado.v1.CreatePublicResidualTipCheckoutSessionResponse
 */
export type CreatePublicResidualTipCheckoutSessionResponse = Message<"cortado.v1.CreatePublicResidualTipCheckoutSessionResponse"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string client_secret = 2;
   */
  clientSecret: string;

  /**
   * == tip_amount_cents (base is 0)
   *
   * @generated from field: int64 amount_cents = 3;
   */
  amountCents: bigint;

  /**
   * @generated from field: string stripe_account_id = 4;
   */
  stripeAccountId: string;

  /**
   * @generated from field: string return_url = 5;
   */
  returnUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 6;
   */
  expiresAt?: Timestamp;

  /**
   * always 0
   *
   * @generated from field: int64 base_amount_cents = 7;
   */
  baseAmountCents: bigint;

  /**
   * @generated from field: int64 tip_amount_cents = 8;
   */
  tipAmountCents: bigint;

  /**
   * written_off is true when the residual tip was below the chargeable card
   * minimum and was written off (tip ledger zeroed) instead of creating a
   * checkout session. When true, no session_id/client_secret is returned.
   *
   * @generated from field: bool written_off = 50;
   */
  writtenOff: boolean;
};

/**
 * Describes the message cortado.v1.CreatePublicResidualTipCheckoutSessionResponse.
 * Use `create(CreatePublicResidualTipCheckoutSessionResponseSchema)` to create a new message.
 */
export const CreatePublicResidualTipCheckoutSessionResponseSchema: GenMessage<CreatePublicResidualTipCheckoutSessionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 71);

/**
 * @generated from message cortado.v1.GetPublicCheckoutSessionStatusRequest
 */
export type GetPublicCheckoutSessionStatusRequest = Message<"cortado.v1.GetPublicCheckoutSessionStatusRequest"> & {
  /**
   * Token is extracted from Authorization header by backend
   *
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * Describes the message cortado.v1.GetPublicCheckoutSessionStatusRequest.
 * Use `create(GetPublicCheckoutSessionStatusRequestSchema)` to create a new message.
 */
export const GetPublicCheckoutSessionStatusRequestSchema: GenMessage<GetPublicCheckoutSessionStatusRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 72);

/**
 * @generated from message cortado.v1.GetPublicCheckoutSessionStatusResponse
 */
export type GetPublicCheckoutSessionStatusResponse = Message<"cortado.v1.GetPublicCheckoutSessionStatusResponse"> & {
  /**
   * @generated from field: cortado.v1.CheckoutSessionStatusEnum status = 1;
   */
  status: CheckoutSessionStatusEnum;

  /**
   * @generated from field: optional string payment_status = 2;
   */
  paymentStatus?: string;

  /**
   * @generated from field: optional string customer_email = 3;
   */
  customerEmail?: string;
};

/**
 * Describes the message cortado.v1.GetPublicCheckoutSessionStatusResponse.
 * Use `create(GetPublicCheckoutSessionStatusResponseSchema)` to create a new message.
 */
export const GetPublicCheckoutSessionStatusResponseSchema: GenMessage<GetPublicCheckoutSessionStatusResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 73);

/**
 * @generated from message cortado.v1.ConvertToPayInFullRequest
 */
export type ConvertToPayInFullRequest = Message<"cortado.v1.ConvertToPayInFullRequest"> & {
  /**
   * Token is extracted from Authorization header by backend
   *
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;
};

/**
 * Describes the message cortado.v1.ConvertToPayInFullRequest.
 * Use `create(ConvertToPayInFullRequestSchema)` to create a new message.
 */
export const ConvertToPayInFullRequestSchema: GenMessage<ConvertToPayInFullRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 74);

/**
 * @generated from message cortado.v1.ConvertToPayInFullResponse
 */
export type ConvertToPayInFullResponse = Message<"cortado.v1.ConvertToPayInFullResponse"> & {
  /**
   * @generated from field: cortado.v1.PublicPaymentSchedule payment_schedule = 1;
   */
  paymentSchedule?: PublicPaymentSchedule;

  /**
   * @generated from field: int64 total_amount_cents = 2;
   */
  totalAmountCents: bigint;

  /**
   * @generated from field: int32 original_schedule_count = 3;
   */
  originalScheduleCount: number;
};

/**
 * Describes the message cortado.v1.ConvertToPayInFullResponse.
 * Use `create(ConvertToPayInFullResponseSchema)` to create a new message.
 */
export const ConvertToPayInFullResponseSchema: GenMessage<ConvertToPayInFullResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 75);

/**
 * @generated from message cortado.v1.GetInquiryOrgInfoRequest
 */
export type GetInquiryOrgInfoRequest = Message<"cortado.v1.GetInquiryOrgInfoRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string short_code = 2;
   */
  shortCode: string;
};

/**
 * Describes the message cortado.v1.GetInquiryOrgInfoRequest.
 * Use `create(GetInquiryOrgInfoRequestSchema)` to create a new message.
 */
export const GetInquiryOrgInfoRequestSchema: GenMessage<GetInquiryOrgInfoRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 76);

/**
 * @generated from message cortado.v1.GetInquiryOrgInfoResponse
 */
export type GetInquiryOrgInfoResponse = Message<"cortado.v1.GetInquiryOrgInfoResponse"> & {
  /**
   * @generated from field: string org_name = 1;
   */
  orgName: string;

  /**
   * @generated from field: string org_logo_url = 2;
   */
  orgLogoUrl: string;

  /**
   * @generated from field: optional string recipient_email_hint = 3;
   */
  recipientEmailHint?: string;

  /**
   * @generated from field: bool can_resend = 4;
   */
  canResend: boolean;
};

/**
 * Describes the message cortado.v1.GetInquiryOrgInfoResponse.
 * Use `create(GetInquiryOrgInfoResponseSchema)` to create a new message.
 */
export const GetInquiryOrgInfoResponseSchema: GenMessage<GetInquiryOrgInfoResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 77);

/**
 * @generated from message cortado.v1.ResendPortalLinkRequest
 */
export type ResendPortalLinkRequest = Message<"cortado.v1.ResendPortalLinkRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string short_code = 2;
   */
  shortCode: string;
};

/**
 * Describes the message cortado.v1.ResendPortalLinkRequest.
 * Use `create(ResendPortalLinkRequestSchema)` to create a new message.
 */
export const ResendPortalLinkRequestSchema: GenMessage<ResendPortalLinkRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 78);

/**
 * @generated from message cortado.v1.ResendPortalLinkResponse
 */
export type ResendPortalLinkResponse = Message<"cortado.v1.ResendPortalLinkResponse"> & {
  /**
   * @generated from field: bool email_sent = 1;
   */
  emailSent: boolean;
};

/**
 * Describes the message cortado.v1.ResendPortalLinkResponse.
 * Use `create(ResendPortalLinkResponseSchema)` to create a new message.
 */
export const ResendPortalLinkResponseSchema: GenMessage<ResendPortalLinkResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 79);

/**
 * @generated from message cortado.v1.ResolvePortalLinkRequest
 */
export type ResolvePortalLinkRequest = Message<"cortado.v1.ResolvePortalLinkRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: optional string browser_id = 2;
   */
  browserId?: string;
};

/**
 * Describes the message cortado.v1.ResolvePortalLinkRequest.
 * Use `create(ResolvePortalLinkRequestSchema)` to create a new message.
 */
export const ResolvePortalLinkRequestSchema: GenMessage<ResolvePortalLinkRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 80);

/**
 * @generated from message cortado.v1.ResolvePortalLinkResponse
 */
export type ResolvePortalLinkResponse = Message<"cortado.v1.ResolvePortalLinkResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string resource_id = 2;
   */
  resourceId: string;

  /**
   * @generated from field: string destination_path = 3;
   */
  destinationPath: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 4;
   */
  expiresAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.ResolvePortalLinkResponse.
 * Use `create(ResolvePortalLinkResponseSchema)` to create a new message.
 */
export const ResolvePortalLinkResponseSchema: GenMessage<ResolvePortalLinkResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 81);

/**
 * @generated from message cortado.v1.GetPublicSignupEnabledRequest
 */
export type GetPublicSignupEnabledRequest = Message<"cortado.v1.GetPublicSignupEnabledRequest"> & {
};

/**
 * Describes the message cortado.v1.GetPublicSignupEnabledRequest.
 * Use `create(GetPublicSignupEnabledRequestSchema)` to create a new message.
 */
export const GetPublicSignupEnabledRequestSchema: GenMessage<GetPublicSignupEnabledRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 82);

/**
 * @generated from message cortado.v1.GetPublicSignupEnabledResponse
 */
export type GetPublicSignupEnabledResponse = Message<"cortado.v1.GetPublicSignupEnabledResponse"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;
};

/**
 * Describes the message cortado.v1.GetPublicSignupEnabledResponse.
 * Use `create(GetPublicSignupEnabledResponseSchema)` to create a new message.
 */
export const GetPublicSignupEnabledResponseSchema: GenMessage<GetPublicSignupEnabledResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 83);

/**
 * @generated from message cortado.v1.ListOrganizationInquiriesRequest
 */
export type ListOrganizationInquiriesRequest = Message<"cortado.v1.ListOrganizationInquiriesRequest"> & {
  /**
   * Organization ID to get inquiries for (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Optional limit on number of inquiries to return
   *
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * Optional offset for pagination
   *
   * @generated from field: optional int32 offset = 3;
   */
  offset?: number;

  /**
   * Optional filter by inquiry stages
   *
   * @generated from field: repeated cortado.v1.InquiryStageEnum stages = 4;
   */
  stages: InquiryStageEnum[];

  /**
   * Optional filter by created date (inquiries created since this date)
   *
   * @generated from field: optional google.protobuf.Timestamp since = 5;
   */
  since?: Timestamp;

  /**
   * Optional filter by event start date (events scheduled on or after this date)
   *
   * @generated from field: optional google.protobuf.Timestamp start_date = 6;
   */
  startDate?: Timestamp;

  /**
   * Optional filter by event end date (events scheduled on or before this date)
   *
   * @generated from field: optional google.protobuf.Timestamp end_date = 7;
   */
  endDate?: Timestamp;

  /**
   * Optional flag to include quote totals in response
   *
   * @generated from field: optional bool include_quote = 8;
   */
  includeQuote?: boolean;
};

/**
 * Describes the message cortado.v1.ListOrganizationInquiriesRequest.
 * Use `create(ListOrganizationInquiriesRequestSchema)` to create a new message.
 */
export const ListOrganizationInquiriesRequestSchema: GenMessage<ListOrganizationInquiriesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 84);

/**
 * @generated from message cortado.v1.ListOrganizationInquiriesResponse
 */
export type ListOrganizationInquiriesResponse = Message<"cortado.v1.ListOrganizationInquiriesResponse"> & {
  /**
   * Inquiries with enriched contact and quote_total fields populated
   *
   * @generated from field: repeated cortado.v1.Inquiry inquiries = 1;
   */
  inquiries: Inquiry[];
};

/**
 * Describes the message cortado.v1.ListOrganizationInquiriesResponse.
 * Use `create(ListOrganizationInquiriesResponseSchema)` to create a new message.
 */
export const ListOrganizationInquiriesResponseSchema: GenMessage<ListOrganizationInquiriesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 85);

/**
 * @generated from message cortado.v1.ListInquiriesRequest
 */
export type ListInquiriesRequest = Message<"cortado.v1.ListInquiriesRequest"> & {
  /**
   * Organization ID to get inquiries for (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Optional filter by contact ID
   *
   * @generated from field: optional string contact_id = 2;
   */
  contactId?: string;

  /**
   * Optional filter by inquiry stages
   *
   * @generated from field: repeated cortado.v1.InquiryStageEnum stages = 3;
   */
  stages: InquiryStageEnum[];

  /**
   * Optional filter by event types
   *
   * @generated from field: repeated cortado.v1.EventTypeEnum event_types = 4 [deprecated = true];
   * @deprecated
   */
  eventTypes: EventTypeEnum[];

  /**
   * Optional filter by event date start (events scheduled on or after this date)
   *
   * @generated from field: optional google.protobuf.Timestamp event_date_start = 5;
   */
  eventDateStart?: Timestamp;

  /**
   * Optional filter by event date end (events scheduled on or before this date)
   *
   * @generated from field: optional google.protobuf.Timestamp event_date_end = 6;
   */
  eventDateEnd?: Timestamp;

  /**
   * Optional filter by created date start (inquiries created on or after this date)
   *
   * @generated from field: optional google.protobuf.Timestamp since = 7;
   */
  since?: Timestamp;

  /**
   * Optional limit on number of inquiries to return (default: 50)
   *
   * @generated from field: optional int32 limit = 8;
   */
  limit?: number;

  /**
   * Optional offset for pagination (default: 0)
   *
   * @generated from field: optional int32 offset = 9;
   */
  offset?: number;

  /**
   * Optional filter by created date end (inquiries created on or before this date)
   *
   * @generated from field: optional google.protobuf.Timestamp created_before = 10;
   */
  createdBefore?: Timestamp;

  /**
   * Optional text search matching contact first/last name or company name (case-insensitive)
   *
   * @generated from field: optional string search = 11;
   */
  search?: string;

  /**
   * Optional exact derived source-channel matches (case-sensitive display labels)
   *
   * @generated from field: repeated string source_channels = 12;
   */
  sourceChannels: string[];

  /**
   * @generated from field: repeated string event_type_keys = 13;
   */
  eventTypeKeys: string[];

  /**
   * When true, archived inquiries are included
   *
   * @generated from field: optional bool include_archived = 14;
   */
  includeArchived?: boolean;

  /**
   * Optional filter by assigned user IDs (matches any of the provided IDs)
   *
   * @generated from field: repeated string assigned_to = 15;
   */
  assignedTo: string[];

  /**
   * When true, unassigned inquiries (assigned_to IS NULL) are included
   *
   * @generated from field: optional bool include_unassigned = 16;
   */
  includeUnassigned?: boolean;
};

/**
 * Describes the message cortado.v1.ListInquiriesRequest.
 * Use `create(ListInquiriesRequestSchema)` to create a new message.
 */
export const ListInquiriesRequestSchema: GenMessage<ListInquiriesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 86);

/**
 * @generated from message cortado.v1.ListInquiriesResponse
 */
export type ListInquiriesResponse = Message<"cortado.v1.ListInquiriesResponse"> & {
  /**
   * Lightweight inquiries optimized for list views
   *
   * @generated from field: repeated cortado.v1.InquiryLite inquiries = 1;
   */
  inquiries: InquiryLite[];

  /**
   * Total count of matching inquiries (for pagination)
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListInquiriesResponse.
 * Use `create(ListInquiriesResponseSchema)` to create a new message.
 */
export const ListInquiriesResponseSchema: GenMessage<ListInquiriesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 87);

/**
 * @generated from message cortado.v1.ListEventsRequest
 */
export type ListEventsRequest = Message<"cortado.v1.ListEventsRequest"> & {
  /**
   * Organization ID to get events for (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Optional filter by booking ID
   *
   * @generated from field: optional string booking_id = 2;
   */
  bookingId?: string;

  /**
   * Optional filter by contact ID
   *
   * @generated from field: optional string contact_id = 3;
   */
  contactId?: string;

  /**
   * Optional filter by event stages
   *
   * @generated from field: repeated cortado.v1.EventStageEnum stages = 4;
   */
  stages: EventStageEnum[];

  /**
   * Optional filter by event date start (events scheduled on or after this date)
   *
   * @generated from field: optional google.protobuf.Timestamp event_date_start = 5;
   */
  eventDateStart?: Timestamp;

  /**
   * Optional filter by event date end (events scheduled on or before this date)
   *
   * @generated from field: optional google.protobuf.Timestamp event_date_end = 6;
   */
  eventDateEnd?: Timestamp;

  /**
   * Optional filter by created date (events created since this date)
   *
   * @generated from field: optional google.protobuf.Timestamp since = 7;
   */
  since?: Timestamp;

  /**
   * Optional limit on number of events to return (default: 50)
   *
   * @generated from field: optional int32 limit = 8;
   */
  limit?: number;

  /**
   * Optional offset for pagination (default: 0)
   *
   * @generated from field: optional int32 offset = 9;
   */
  offset?: number;

  /**
   * Optional case-insensitive substring filter over the contact's full name
   *
   * @generated from field: optional string contact_name_filter = 10;
   */
  contactNameFilter?: string;

  /**
   * Optional Events-page bucket. Unspecified preserves the generic list behavior.
   *
   * @generated from field: cortado.v1.EventListBucketEnum list_bucket = 11;
   */
  listBucket: EventListBucketEnum;

  /**
   * Browser-local start-of-day boundary used by list_bucket.
   *
   * @generated from field: optional google.protobuf.Timestamp list_bucket_boundary = 12;
   */
  listBucketBoundary?: Timestamp;

  /**
   * When true, archived events are included
   *
   * @generated from field: optional bool include_archived = 13;
   */
  includeArchived?: boolean;
};

/**
 * Describes the message cortado.v1.ListEventsRequest.
 * Use `create(ListEventsRequestSchema)` to create a new message.
 */
export const ListEventsRequestSchema: GenMessage<ListEventsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 88);

/**
 * @generated from message cortado.v1.ListEventsResponse
 */
export type ListEventsResponse = Message<"cortado.v1.ListEventsResponse"> & {
  /**
   * Lightweight events optimized for list views
   *
   * @generated from field: repeated cortado.v1.EventLite events = 1;
   */
  events: EventLite[];

  /**
   * Total count of matching events (for pagination)
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListEventsResponse.
 * Use `create(ListEventsResponseSchema)` to create a new message.
 */
export const ListEventsResponseSchema: GenMessage<ListEventsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 89);

/**
 * @generated from message cortado.v1.ListInquiryTasksRequest
 */
export type ListInquiryTasksRequest = Message<"cortado.v1.ListInquiryTasksRequest"> & {
  /**
   * @generated from field: string inquiry_id = 1;
   */
  inquiryId: string;
};

/**
 * Describes the message cortado.v1.ListInquiryTasksRequest.
 * Use `create(ListInquiryTasksRequestSchema)` to create a new message.
 */
export const ListInquiryTasksRequestSchema: GenMessage<ListInquiryTasksRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 90);

/**
 * @generated from message cortado.v1.ListInquiryTasksResponse
 */
export type ListInquiryTasksResponse = Message<"cortado.v1.ListInquiryTasksResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.Task tasks = 1;
   */
  tasks: Task[];
};

/**
 * Describes the message cortado.v1.ListInquiryTasksResponse.
 * Use `create(ListInquiryTasksResponseSchema)` to create a new message.
 */
export const ListInquiryTasksResponseSchema: GenMessage<ListInquiryTasksResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 91);

/**
 * @generated from message cortado.v1.ListInquiryNotesRequest
 */
export type ListInquiryNotesRequest = Message<"cortado.v1.ListInquiryNotesRequest"> & {
  /**
   * @generated from field: string inquiry_id = 1;
   */
  inquiryId: string;
};

/**
 * Describes the message cortado.v1.ListInquiryNotesRequest.
 * Use `create(ListInquiryNotesRequestSchema)` to create a new message.
 */
export const ListInquiryNotesRequestSchema: GenMessage<ListInquiryNotesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 92);

/**
 * @generated from message cortado.v1.ListInquiryNotesResponse
 */
export type ListInquiryNotesResponse = Message<"cortado.v1.ListInquiryNotesResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.Note notes = 1;
   */
  notes: Note[];
};

/**
 * Describes the message cortado.v1.ListInquiryNotesResponse.
 * Use `create(ListInquiryNotesResponseSchema)` to create a new message.
 */
export const ListInquiryNotesResponseSchema: GenMessage<ListInquiryNotesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 93);

/**
 * @generated from message cortado.v1.GetBookingRequest
 */
export type GetBookingRequest = Message<"cortado.v1.GetBookingRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetBookingRequest.
 * Use `create(GetBookingRequestSchema)` to create a new message.
 */
export const GetBookingRequestSchema: GenMessage<GetBookingRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 94);

/**
 * @generated from message cortado.v1.GetBookingResponse
 */
export type GetBookingResponse = Message<"cortado.v1.GetBookingResponse"> & {
  /**
   * @generated from field: cortado.v1.Booking booking = 1;
   */
  booking?: Booking;
};

/**
 * Describes the message cortado.v1.GetBookingResponse.
 * Use `create(GetBookingResponseSchema)` to create a new message.
 */
export const GetBookingResponseSchema: GenMessage<GetBookingResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 95);

/**
 * @generated from message cortado.v1.UpdateBookingRequest
 */
export type UpdateBookingRequest = Message<"cortado.v1.UpdateBookingRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional cortado.v1.BookingStageEnum stage = 2;
   */
  stage?: BookingStageEnum;

  /**
   * @generated from field: optional cortado.v1.EventTypeEnum event_type = 3 [deprecated = true];
   * @deprecated
   */
  eventType?: EventTypeEnum;

  /**
   * @generated from field: optional string event_state = 5;
   */
  eventState?: string;

  /**
   * @generated from field: optional string event_county = 6;
   */
  eventCounty?: string;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 7;
   */
  updateMask?: FieldMask;

  /**
   * @generated from field: optional string event_type_key = 8;
   */
  eventTypeKey?: string;
};

/**
 * Describes the message cortado.v1.UpdateBookingRequest.
 * Use `create(UpdateBookingRequestSchema)` to create a new message.
 */
export const UpdateBookingRequestSchema: GenMessage<UpdateBookingRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 96);

/**
 * @generated from message cortado.v1.UpdateBookingResponse
 */
export type UpdateBookingResponse = Message<"cortado.v1.UpdateBookingResponse"> & {
  /**
   * @generated from field: cortado.v1.Booking booking = 1;
   */
  booking?: Booking;
};

/**
 * Describes the message cortado.v1.UpdateBookingResponse.
 * Use `create(UpdateBookingResponseSchema)` to create a new message.
 */
export const UpdateBookingResponseSchema: GenMessage<UpdateBookingResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 97);

/**
 * @generated from message cortado.v1.MoveInquiryToEventsRequest
 */
export type MoveInquiryToEventsRequest = Message<"cortado.v1.MoveInquiryToEventsRequest"> & {
  /**
   * @generated from field: string inquiry_id = 1;
   */
  inquiryId: string;
};

/**
 * Describes the message cortado.v1.MoveInquiryToEventsRequest.
 * Use `create(MoveInquiryToEventsRequestSchema)` to create a new message.
 */
export const MoveInquiryToEventsRequestSchema: GenMessage<MoveInquiryToEventsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 98);

/**
 * @generated from message cortado.v1.MoveInquiryToEventsResponse
 */
export type MoveInquiryToEventsResponse = Message<"cortado.v1.MoveInquiryToEventsResponse"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: repeated string event_ids = 2;
   */
  eventIds: string[];
};

/**
 * Describes the message cortado.v1.MoveInquiryToEventsResponse.
 * Use `create(MoveInquiryToEventsResponseSchema)` to create a new message.
 */
export const MoveInquiryToEventsResponseSchema: GenMessage<MoveInquiryToEventsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 99);

/**
 * @generated from message cortado.v1.AcceptQuoteAsAdminRequest
 */
export type AcceptQuoteAsAdminRequest = Message<"cortado.v1.AcceptQuoteAsAdminRequest"> & {
  /**
   * @generated from field: string inquiry_id = 1;
   */
  inquiryId: string;

  /**
   * @generated from field: string quote_id = 2;
   */
  quoteId: string;
};

/**
 * Describes the message cortado.v1.AcceptQuoteAsAdminRequest.
 * Use `create(AcceptQuoteAsAdminRequestSchema)` to create a new message.
 */
export const AcceptQuoteAsAdminRequestSchema: GenMessage<AcceptQuoteAsAdminRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 100);

/**
 * @generated from message cortado.v1.AcceptQuoteAsAdminResponse
 */
export type AcceptQuoteAsAdminResponse = Message<"cortado.v1.AcceptQuoteAsAdminResponse"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string invoice_id = 2;
   */
  invoiceId: string;

  /**
   * @generated from field: repeated string event_ids = 3;
   */
  eventIds: string[];
};

/**
 * Describes the message cortado.v1.AcceptQuoteAsAdminResponse.
 * Use `create(AcceptQuoteAsAdminResponseSchema)` to create a new message.
 */
export const AcceptQuoteAsAdminResponseSchema: GenMessage<AcceptQuoteAsAdminResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 101);

/**
 * @generated from message cortado.v1.ListOrganizationBookingsRequest
 */
export type ListOrganizationBookingsRequest = Message<"cortado.v1.ListOrganizationBookingsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListOrganizationBookingsRequest.
 * Use `create(ListOrganizationBookingsRequestSchema)` to create a new message.
 */
export const ListOrganizationBookingsRequestSchema: GenMessage<ListOrganizationBookingsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 102);

/**
 * @generated from message cortado.v1.ListOrganizationBookingsResponse
 */
export type ListOrganizationBookingsResponse = Message<"cortado.v1.ListOrganizationBookingsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.Booking bookings = 1;
   */
  bookings: Booking[];
};

/**
 * Describes the message cortado.v1.ListOrganizationBookingsResponse.
 * Use `create(ListOrganizationBookingsResponseSchema)` to create a new message.
 */
export const ListOrganizationBookingsResponseSchema: GenMessage<ListOrganizationBookingsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 103);

/**
 * @generated from message cortado.v1.GetEventRequest
 */
export type GetEventRequest = Message<"cortado.v1.GetEventRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetEventRequest.
 * Use `create(GetEventRequestSchema)` to create a new message.
 */
export const GetEventRequestSchema: GenMessage<GetEventRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 104);

/**
 * @generated from message cortado.v1.GetEventResponse
 */
export type GetEventResponse = Message<"cortado.v1.GetEventResponse"> & {
  /**
   * @generated from field: cortado.v1.Event event = 1;
   */
  event?: Event;
};

/**
 * Describes the message cortado.v1.GetEventResponse.
 * Use `create(GetEventResponseSchema)` to create a new message.
 */
export const GetEventResponseSchema: GenMessage<GetEventResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 105);

/**
 * @generated from message cortado.v1.GetEventDetailRequest
 */
export type GetEventDetailRequest = Message<"cortado.v1.GetEventDetailRequest"> & {
  /**
   * Event ID
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetEventDetailRequest.
 * Use `create(GetEventDetailRequestSchema)` to create a new message.
 */
export const GetEventDetailRequestSchema: GenMessage<GetEventDetailRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 106);

/**
 * @generated from message cortado.v1.GetEventDetailResponse
 */
export type GetEventDetailResponse = Message<"cortado.v1.GetEventDetailResponse"> & {
  /**
   * @generated from field: cortado.v1.Event event = 1;
   */
  event?: Event;

  /**
   * The event's parent booking (always present)
   *
   * @generated from field: cortado.v1.Booking booking = 2;
   */
  booking?: Booking;

  /**
   * Absent for direct bookings (Booking.inquiry_id is optional)
   *
   * @generated from field: optional cortado.v1.Inquiry inquiry = 3;
   */
  inquiry?: Inquiry;
};

/**
 * Describes the message cortado.v1.GetEventDetailResponse.
 * Use `create(GetEventDetailResponseSchema)` to create a new message.
 */
export const GetEventDetailResponseSchema: GenMessage<GetEventDetailResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 107);

/**
 * @generated from message cortado.v1.CreateEventRequest
 */
export type CreateEventRequest = Message<"cortado.v1.CreateEventRequest"> & {
  /**
   * Booking ID to create the event for (required)
   *
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * Date of the event (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp event_date = 2;
   */
  eventDate?: Timestamp;

  /**
   * Length of the event in hours (optional)
   *
   * @generated from field: optional double event_length = 3;
   */
  eventLength?: number;

  /**
   * Number of guests (optional)
   *
   * @generated from field: optional int32 event_guests = 4;
   */
  eventGuests?: number;

  /**
   * Timezone of the event (optional)
   *
   * @generated from field: optional string event_timezone = 5;
   */
  eventTimezone?: string;

  /**
   * Type of event (optional)
   *
   * @generated from field: optional cortado.v1.EventTypeEnum event_type = 6 [deprecated = true];
   * @deprecated
   */
  eventType?: EventTypeEnum;

  /**
   * Location of the event (optional)
   *
   * @generated from field: optional string event_location = 7;
   */
  eventLocation?: string;

  /**
   * Number of baristas needed (optional) - for resource planning
   *
   * @generated from field: optional int32 barista_count = 8;
   */
  baristaCount?: number;

  /**
   * Number of carts needed (optional) - for resource planning
   *
   * @generated from field: optional int32 cart_count = 9;
   */
  cartCount?: number;

  /**
   * @generated from field: optional string event_type_key = 10;
   */
  eventTypeKey?: string;
};

/**
 * Describes the message cortado.v1.CreateEventRequest.
 * Use `create(CreateEventRequestSchema)` to create a new message.
 */
export const CreateEventRequestSchema: GenMessage<CreateEventRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 108);

/**
 * @generated from message cortado.v1.CreateEventResponse
 */
export type CreateEventResponse = Message<"cortado.v1.CreateEventResponse"> & {
  /**
   * @generated from field: cortado.v1.Event event = 1;
   */
  event?: Event;
};

/**
 * Describes the message cortado.v1.CreateEventResponse.
 * Use `create(CreateEventResponseSchema)` to create a new message.
 */
export const CreateEventResponseSchema: GenMessage<CreateEventResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 109);

/**
 * @generated from message cortado.v1.UpdateEventRequest
 */
export type UpdateEventRequest = Message<"cortado.v1.UpdateEventRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional cortado.v1.EventStageEnum stage = 2;
   */
  stage?: EventStageEnum;

  /**
   * @generated from field: optional google.protobuf.Timestamp event_date = 3;
   */
  eventDate?: Timestamp;

  /**
   * @generated from field: optional double event_length = 4;
   */
  eventLength?: number;

  /**
   * @generated from field: optional int32 event_guests = 5;
   */
  eventGuests?: number;

  /**
   * @generated from field: optional string event_timezone = 6;
   */
  eventTimezone?: string;

  /**
   * Deprecated and ignored by the server. Aliases the internal Google event ID
   * mapping (events.calendar_id) and is managed by the sync engine; any
   * client-supplied value is dropped.
   *
   * @generated from field: optional string calendar_id = 7;
   */
  calendarId?: string;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 8;
   */
  updateMask?: FieldMask;

  /**
   * Type of event (optional)
   *
   * @generated from field: optional cortado.v1.EventTypeEnum event_type = 9 [deprecated = true];
   * @deprecated
   */
  eventType?: EventTypeEnum;

  /**
   * Location of the event (optional)
   *
   * @generated from field: optional string event_location = 10;
   */
  eventLocation?: string;

  /**
   * Number of baristas needed (optional) - for resource planning
   *
   * @generated from field: optional int32 barista_count = 11;
   */
  baristaCount?: number;

  /**
   * Number of carts needed (optional) - for resource planning
   *
   * @generated from field: optional int32 cart_count = 12;
   */
  cartCount?: number;

  /**
   * @generated from field: optional string event_type_key = 13;
   */
  eventTypeKey?: string;

  /**
   * Per-event override of the Google Calendar description template source.
   * Setting an empty string resets to inheriting the organization template.
   *
   * @generated from field: optional string calendar_description_override = 14;
   */
  calendarDescriptionOverride?: string;
};

/**
 * Describes the message cortado.v1.UpdateEventRequest.
 * Use `create(UpdateEventRequestSchema)` to create a new message.
 */
export const UpdateEventRequestSchema: GenMessage<UpdateEventRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 110);

/**
 * @generated from message cortado.v1.UpdateEventResponse
 */
export type UpdateEventResponse = Message<"cortado.v1.UpdateEventResponse"> & {
  /**
   * @generated from field: cortado.v1.Event event = 1;
   */
  event?: Event;
};

/**
 * Describes the message cortado.v1.UpdateEventResponse.
 * Use `create(UpdateEventResponseSchema)` to create a new message.
 */
export const UpdateEventResponseSchema: GenMessage<UpdateEventResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 111);

/**
 * @generated from message cortado.v1.SyncEventCalendarRequest
 */
export type SyncEventCalendarRequest = Message<"cortado.v1.SyncEventCalendarRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;
};

/**
 * Describes the message cortado.v1.SyncEventCalendarRequest.
 * Use `create(SyncEventCalendarRequestSchema)` to create a new message.
 */
export const SyncEventCalendarRequestSchema: GenMessage<SyncEventCalendarRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 112);

/**
 * @generated from message cortado.v1.SyncEventCalendarResponse
 */
export type SyncEventCalendarResponse = Message<"cortado.v1.SyncEventCalendarResponse"> & {
  /**
   * Whether the sync succeeded
   *
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * Action taken: "created", "updated", "skipped", "failed"
   *
   * @generated from field: string action = 2;
   */
  action: string;

  /**
   * Human-readable status message
   *
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * Google Calendar event ID (if created/updated)
   *
   * @generated from field: string calendar_id = 4;
   */
  calendarId: string;
};

/**
 * Describes the message cortado.v1.SyncEventCalendarResponse.
 * Use `create(SyncEventCalendarResponseSchema)` to create a new message.
 */
export const SyncEventCalendarResponseSchema: GenMessage<SyncEventCalendarResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 113);

/**
 * @generated from message cortado.v1.PreviewCalendarDescriptionRequest
 */
export type PreviewCalendarDescriptionRequest = Message<"cortado.v1.PreviewCalendarDescriptionRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Template source to render. May differ from what is currently stored so the
   * editor can preview unsaved edits.
   *
   * @generated from field: string template_source = 2;
   */
  templateSource: string;

  /**
   * Event to render against. When unset the server picks the org's next
   * upcoming event, falling back to the most recent one.
   *
   * @generated from field: optional string event_id = 3;
   */
  eventId?: string;
};

/**
 * Describes the message cortado.v1.PreviewCalendarDescriptionRequest.
 * Use `create(PreviewCalendarDescriptionRequestSchema)` to create a new message.
 */
export const PreviewCalendarDescriptionRequestSchema: GenMessage<PreviewCalendarDescriptionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 114);

/**
 * @generated from message cortado.v1.PreviewCalendarDescriptionResponse
 */
export type PreviewCalendarDescriptionResponse = Message<"cortado.v1.PreviewCalendarDescriptionResponse"> & {
  /**
   * Rendered description, already reduced to the Google Calendar HTML subset.
   *
   * @generated from field: string rendered_html = 1;
   */
  renderedHtml: string;

  /**
   * Length of the sanitized description BEFORE truncation, in runes, for the
   * 4000-rune cap warning. rendered_html is already capped at 4000, so its own
   * length could never trip that warning.
   *
   * @generated from field: int32 rune_count = 2;
   */
  runeCount: number;

  /**
   * Template paths whose root segment is not one of trigger/entity/org — in
   * practice authoring typos like {{ .contact.first_name }} that are missing
   * the .entity prefix. Advisory only: a legitimately absent quote is NOT
   * reported here, since entity.quote is a valid root path either way.
   *
   * @generated from field: repeated string unresolved_variables = 3;
   */
  unresolvedVariables: string[];

  /**
   * Event actually rendered against; empty when a synthetic fixture was used.
   *
   * @generated from field: string resolved_event_id = 4;
   */
  resolvedEventId: string;

  /**
   * True when no real event existed and a synthetic fixture was rendered.
   *
   * @generated from field: bool used_sample_event = 5;
   */
  usedSampleEvent: boolean;
};

/**
 * Describes the message cortado.v1.PreviewCalendarDescriptionResponse.
 * Use `create(PreviewCalendarDescriptionResponseSchema)` to create a new message.
 */
export const PreviewCalendarDescriptionResponseSchema: GenMessage<PreviewCalendarDescriptionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 115);

/**
 * @generated from message cortado.v1.ApplyCalendarDescriptionTemplateRequest
 */
export type ApplyCalendarDescriptionTemplateRequest = Message<"cortado.v1.ApplyCalendarDescriptionTemplateRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * When true, return affected_event_count without triggering any resync.
   *
   * @generated from field: bool dry_run = 2;
   */
  dryRun: boolean;
};

/**
 * Describes the message cortado.v1.ApplyCalendarDescriptionTemplateRequest.
 * Use `create(ApplyCalendarDescriptionTemplateRequestSchema)` to create a new message.
 */
export const ApplyCalendarDescriptionTemplateRequestSchema: GenMessage<ApplyCalendarDescriptionTemplateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 116);

/**
 * @generated from message cortado.v1.ApplyCalendarDescriptionTemplateResponse
 */
export type ApplyCalendarDescriptionTemplateResponse = Message<"cortado.v1.ApplyCalendarDescriptionTemplateResponse"> & {
  /**
   * Events currently in calendar sync scope that a resync would re-push.
   *
   * @generated from field: int32 affected_event_count = 1;
   */
  affectedEventCount: number;

  /**
   * False when dry_run was set.
   *
   * @generated from field: bool resync_triggered = 2;
   */
  resyncTriggered: boolean;
};

/**
 * Describes the message cortado.v1.ApplyCalendarDescriptionTemplateResponse.
 * Use `create(ApplyCalendarDescriptionTemplateResponseSchema)` to create a new message.
 */
export const ApplyCalendarDescriptionTemplateResponseSchema: GenMessage<ApplyCalendarDescriptionTemplateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 117);

/**
 * @generated from message cortado.v1.GetEventDriveTimeRequest
 */
export type GetEventDriveTimeRequest = Message<"cortado.v1.GetEventDriveTimeRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;
};

/**
 * Describes the message cortado.v1.GetEventDriveTimeRequest.
 * Use `create(GetEventDriveTimeRequestSchema)` to create a new message.
 */
export const GetEventDriveTimeRequestSchema: GenMessage<GetEventDriveTimeRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 118);

/**
 * @generated from message cortado.v1.GetEventDriveTimeResponse
 */
export type GetEventDriveTimeResponse = Message<"cortado.v1.GetEventDriveTimeResponse"> & {
  /**
   * @generated from field: int32 drive_time_seconds = 1;
   */
  driveTimeSeconds: number;

  /**
   * @generated from field: string distance = 2;
   */
  distance: string;

  /**
   * @generated from field: string formatted_duration = 3;
   */
  formattedDuration: string;
};

/**
 * Describes the message cortado.v1.GetEventDriveTimeResponse.
 * Use `create(GetEventDriveTimeResponseSchema)` to create a new message.
 */
export const GetEventDriveTimeResponseSchema: GenMessage<GetEventDriveTimeResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 119);

/**
 * @generated from message cortado.v1.GetInquiryDriveTimeRequest
 */
export type GetInquiryDriveTimeRequest = Message<"cortado.v1.GetInquiryDriveTimeRequest"> & {
  /**
   * @generated from field: string inquiry_id = 1;
   */
  inquiryId: string;
};

/**
 * Describes the message cortado.v1.GetInquiryDriveTimeRequest.
 * Use `create(GetInquiryDriveTimeRequestSchema)` to create a new message.
 */
export const GetInquiryDriveTimeRequestSchema: GenMessage<GetInquiryDriveTimeRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 120);

/**
 * @generated from message cortado.v1.GetInquiryDriveTimeResponse
 */
export type GetInquiryDriveTimeResponse = Message<"cortado.v1.GetInquiryDriveTimeResponse"> & {
  /**
   * @generated from field: int32 drive_time_seconds = 1;
   */
  driveTimeSeconds: number;

  /**
   * @generated from field: string distance = 2;
   */
  distance: string;

  /**
   * @generated from field: string formatted_duration = 3;
   */
  formattedDuration: string;
};

/**
 * Describes the message cortado.v1.GetInquiryDriveTimeResponse.
 * Use `create(GetInquiryDriveTimeResponseSchema)` to create a new message.
 */
export const GetInquiryDriveTimeResponseSchema: GenMessage<GetInquiryDriveTimeResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 121);

/**
 * @generated from message cortado.v1.ResolveLocationTimezoneRequest
 */
export type ResolveLocationTimezoneRequest = Message<"cortado.v1.ResolveLocationTimezoneRequest"> & {
  /**
   * Organization that owns the surface invoking this lookup. Required for
   * RBAC scoping; the geocode lookup itself is location-only.
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Free-form postal address string, e.g. the event_location field. The
   * backend forwards it to the Google Maps geocoding API.
   *
   * @generated from field: string location = 2;
   */
  location: string;
};

/**
 * Describes the message cortado.v1.ResolveLocationTimezoneRequest.
 * Use `create(ResolveLocationTimezoneRequestSchema)` to create a new message.
 */
export const ResolveLocationTimezoneRequestSchema: GenMessage<ResolveLocationTimezoneRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 122);

/**
 * @generated from message cortado.v1.ResolveLocationTimezoneResponse
 */
export type ResolveLocationTimezoneResponse = Message<"cortado.v1.ResolveLocationTimezoneResponse"> & {
  /**
   * IANA timezone identifier resolved from the location, e.g. "America/Chicago".
   * Populated only when status == OK; empty otherwise.
   *
   * @generated from field: string timezone = 1;
   */
  timezone: string;

  /**
   * Outcome of the resolution attempt. See ResolveLocationTimezoneStatus.
   *
   * @generated from field: cortado.v1.ResolveLocationTimezoneStatus status = 2;
   */
  status: ResolveLocationTimezoneStatus;
};

/**
 * Describes the message cortado.v1.ResolveLocationTimezoneResponse.
 * Use `create(ResolveLocationTimezoneResponseSchema)` to create a new message.
 */
export const ResolveLocationTimezoneResponseSchema: GenMessage<ResolveLocationTimezoneResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 123);

/**
 * @generated from message cortado.v1.ListOrganizationEventsRequest
 */
export type ListOrganizationEventsRequest = Message<"cortado.v1.ListOrganizationEventsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListOrganizationEventsRequest.
 * Use `create(ListOrganizationEventsRequestSchema)` to create a new message.
 */
export const ListOrganizationEventsRequestSchema: GenMessage<ListOrganizationEventsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 124);

/**
 * @generated from message cortado.v1.ListOrganizationEventsResponse
 */
export type ListOrganizationEventsResponse = Message<"cortado.v1.ListOrganizationEventsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.Event events = 1;
   */
  events: Event[];
};

/**
 * Describes the message cortado.v1.ListOrganizationEventsResponse.
 * Use `create(ListOrganizationEventsResponseSchema)` to create a new message.
 */
export const ListOrganizationEventsResponseSchema: GenMessage<ListOrganizationEventsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 125);

/**
 * @generated from message cortado.v1.ListUserSchedulingsRequest
 */
export type ListUserSchedulingsRequest = Message<"cortado.v1.ListUserSchedulingsRequest"> & {
  /**
   * Organization ID to get user schedulings for (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Optional filter by event ID
   *
   * @generated from field: optional string event_id = 2;
   */
  eventId?: string;

  /**
   * Optional filter by user ID
   *
   * @generated from field: optional string user_id = 3;
   */
  userId?: string;

  /**
   * Optional filter by statuses
   *
   * @generated from field: repeated cortado.v1.UserSchedulingStatusEnum statuses = 4;
   */
  statuses: UserSchedulingStatusEnum[];

  /**
   * Optional limit on number to return (default: 50)
   *
   * @generated from field: optional int32 limit = 5;
   */
  limit?: number;

  /**
   * Optional offset for pagination (default: 0)
   *
   * @generated from field: optional int32 offset = 6;
   */
  offset?: number;
};

/**
 * Describes the message cortado.v1.ListUserSchedulingsRequest.
 * Use `create(ListUserSchedulingsRequestSchema)` to create a new message.
 */
export const ListUserSchedulingsRequestSchema: GenMessage<ListUserSchedulingsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 126);

/**
 * @generated from message cortado.v1.ListUserSchedulingsResponse
 */
export type ListUserSchedulingsResponse = Message<"cortado.v1.ListUserSchedulingsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.UserScheduling schedulings = 1;
   */
  schedulings: UserScheduling[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListUserSchedulingsResponse.
 * Use `create(ListUserSchedulingsResponseSchema)` to create a new message.
 */
export const ListUserSchedulingsResponseSchema: GenMessage<ListUserSchedulingsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 127);

/**
 * @generated from message cortado.v1.GetUserSchedulingRequest
 */
export type GetUserSchedulingRequest = Message<"cortado.v1.GetUserSchedulingRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetUserSchedulingRequest.
 * Use `create(GetUserSchedulingRequestSchema)` to create a new message.
 */
export const GetUserSchedulingRequestSchema: GenMessage<GetUserSchedulingRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 128);

/**
 * @generated from message cortado.v1.GetUserSchedulingResponse
 */
export type GetUserSchedulingResponse = Message<"cortado.v1.GetUserSchedulingResponse"> & {
  /**
   * @generated from field: cortado.v1.UserScheduling scheduling = 1;
   */
  scheduling?: UserScheduling;
};

/**
 * Describes the message cortado.v1.GetUserSchedulingResponse.
 * Use `create(GetUserSchedulingResponseSchema)` to create a new message.
 */
export const GetUserSchedulingResponseSchema: GenMessage<GetUserSchedulingResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 129);

/**
 * @generated from message cortado.v1.CreateUserSchedulingRequest
 */
export type CreateUserSchedulingRequest = Message<"cortado.v1.CreateUserSchedulingRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_at = 3;
   */
  scheduledAt?: Timestamp;

  /**
   * @generated from field: double duration = 4;
   */
  duration: number;

  /**
   * @generated from field: optional cortado.v1.UserSchedulingStatusEnum status = 5;
   */
  status?: UserSchedulingStatusEnum;

  /**
   * Unset: the first person on the event becomes LEAD, later ones BARISTA.
   * LEAD makes this assignment the lead and the previous lead a BARISTA.
   *
   * @generated from field: optional cortado.v1.UserSchedulingRoleEnum role = 6;
   */
  role?: UserSchedulingRoleEnum;
};

/**
 * Describes the message cortado.v1.CreateUserSchedulingRequest.
 * Use `create(CreateUserSchedulingRequestSchema)` to create a new message.
 */
export const CreateUserSchedulingRequestSchema: GenMessage<CreateUserSchedulingRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 130);

/**
 * @generated from message cortado.v1.CreateUserSchedulingResponse
 */
export type CreateUserSchedulingResponse = Message<"cortado.v1.CreateUserSchedulingResponse"> & {
  /**
   * @generated from field: cortado.v1.UserScheduling scheduling = 1;
   */
  scheduling?: UserScheduling;
};

/**
 * Describes the message cortado.v1.CreateUserSchedulingResponse.
 * Use `create(CreateUserSchedulingResponseSchema)` to create a new message.
 */
export const CreateUserSchedulingResponseSchema: GenMessage<CreateUserSchedulingResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 131);

/**
 * @generated from message cortado.v1.UpdateUserSchedulingRequest
 */
export type UpdateUserSchedulingRequest = Message<"cortado.v1.UpdateUserSchedulingRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp scheduled_at = 2;
   */
  scheduledAt?: Timestamp;

  /**
   * @generated from field: optional double duration = 3;
   */
  duration?: number;

  /**
   * @generated from field: optional cortado.v1.UserSchedulingStatusEnum status = 4;
   */
  status?: UserSchedulingStatusEnum;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 5;
   */
  updateMask?: FieldMask;

  /**
   * LEAD reassigns the event's lead to this assignment. BARISTA is refused
   * for the current lead (make someone else lead instead).
   *
   * @generated from field: optional cortado.v1.UserSchedulingRoleEnum role = 6;
   */
  role?: UserSchedulingRoleEnum;
};

/**
 * Describes the message cortado.v1.UpdateUserSchedulingRequest.
 * Use `create(UpdateUserSchedulingRequestSchema)` to create a new message.
 */
export const UpdateUserSchedulingRequestSchema: GenMessage<UpdateUserSchedulingRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 132);

/**
 * @generated from message cortado.v1.UpdateUserSchedulingResponse
 */
export type UpdateUserSchedulingResponse = Message<"cortado.v1.UpdateUserSchedulingResponse"> & {
  /**
   * @generated from field: cortado.v1.UserScheduling scheduling = 1;
   */
  scheduling?: UserScheduling;
};

/**
 * Describes the message cortado.v1.UpdateUserSchedulingResponse.
 * Use `create(UpdateUserSchedulingResponseSchema)` to create a new message.
 */
export const UpdateUserSchedulingResponseSchema: GenMessage<UpdateUserSchedulingResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 133);

/**
 * @generated from message cortado.v1.DeleteUserSchedulingRequest
 */
export type DeleteUserSchedulingRequest = Message<"cortado.v1.DeleteUserSchedulingRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteUserSchedulingRequest.
 * Use `create(DeleteUserSchedulingRequestSchema)` to create a new message.
 */
export const DeleteUserSchedulingRequestSchema: GenMessage<DeleteUserSchedulingRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 134);

/**
 * @generated from message cortado.v1.DeleteUserSchedulingResponse
 */
export type DeleteUserSchedulingResponse = Message<"cortado.v1.DeleteUserSchedulingResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteUserSchedulingResponse.
 * Use `create(DeleteUserSchedulingResponseSchema)` to create a new message.
 */
export const DeleteUserSchedulingResponseSchema: GenMessage<DeleteUserSchedulingResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 135);

/**
 * @generated from message cortado.v1.ListItemsRequest
 */
export type ListItemsRequest = Message<"cortado.v1.ListItemsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListItemsRequest.
 * Use `create(ListItemsRequestSchema)` to create a new message.
 */
export const ListItemsRequestSchema: GenMessage<ListItemsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 136);

/**
 * @generated from message cortado.v1.ListItemsResponse
 */
export type ListItemsResponse = Message<"cortado.v1.ListItemsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.Item items = 1;
   */
  items: Item[];
};

/**
 * Describes the message cortado.v1.ListItemsResponse.
 * Use `create(ListItemsResponseSchema)` to create a new message.
 */
export const ListItemsResponseSchema: GenMessage<ListItemsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 137);

/**
 * @generated from message cortado.v1.CreateItemRequest
 */
export type CreateItemRequest = Message<"cortado.v1.CreateItemRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: float price = 4;
   */
  price: number;

  /**
   * @generated from field: cortado.v1.ItemUnitEnum unit = 5;
   */
  unit: ItemUnitEnum;

  /**
   * @generated from field: bool always_include = 6;
   */
  alwaysInclude: boolean;

  /**
   * @generated from field: bool include_on_form = 7;
   */
  includeOnForm: boolean;

  /**
   * @generated from field: bool offer_as_addon = 8;
   */
  offerAsAddon: boolean;
};

/**
 * Describes the message cortado.v1.CreateItemRequest.
 * Use `create(CreateItemRequestSchema)` to create a new message.
 */
export const CreateItemRequestSchema: GenMessage<CreateItemRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 138);

/**
 * @generated from message cortado.v1.CreateItemResponse
 */
export type CreateItemResponse = Message<"cortado.v1.CreateItemResponse"> & {
  /**
   * @generated from field: cortado.v1.Item item = 1;
   */
  item?: Item;
};

/**
 * Describes the message cortado.v1.CreateItemResponse.
 * Use `create(CreateItemResponseSchema)` to create a new message.
 */
export const CreateItemResponseSchema: GenMessage<CreateItemResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 139);

/**
 * @generated from message cortado.v1.GetItemRequest
 */
export type GetItemRequest = Message<"cortado.v1.GetItemRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetItemRequest.
 * Use `create(GetItemRequestSchema)` to create a new message.
 */
export const GetItemRequestSchema: GenMessage<GetItemRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 140);

/**
 * @generated from message cortado.v1.GetItemResponse
 */
export type GetItemResponse = Message<"cortado.v1.GetItemResponse"> & {
  /**
   * @generated from field: cortado.v1.Item item = 1;
   */
  item?: Item;
};

/**
 * Describes the message cortado.v1.GetItemResponse.
 * Use `create(GetItemResponseSchema)` to create a new message.
 */
export const GetItemResponseSchema: GenMessage<GetItemResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 141);

/**
 * @generated from message cortado.v1.UpdateItemRequest
 */
export type UpdateItemRequest = Message<"cortado.v1.UpdateItemRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string title = 2;
   */
  title?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional float price = 4;
   */
  price?: number;

  /**
   * @generated from field: optional cortado.v1.ItemUnitEnum unit = 5;
   */
  unit?: ItemUnitEnum;

  /**
   * @generated from field: optional bool always_include = 6;
   */
  alwaysInclude?: boolean;

  /**
   * @generated from field: optional bool include_on_form = 7;
   */
  includeOnForm?: boolean;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 8;
   */
  updateMask?: FieldMask;

  /**
   * @generated from field: optional bool offer_as_addon = 9;
   */
  offerAsAddon?: boolean;
};

/**
 * Describes the message cortado.v1.UpdateItemRequest.
 * Use `create(UpdateItemRequestSchema)` to create a new message.
 */
export const UpdateItemRequestSchema: GenMessage<UpdateItemRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 142);

/**
 * @generated from message cortado.v1.UpdateItemResponse
 */
export type UpdateItemResponse = Message<"cortado.v1.UpdateItemResponse"> & {
  /**
   * @generated from field: cortado.v1.Item item = 1;
   */
  item?: Item;
};

/**
 * Describes the message cortado.v1.UpdateItemResponse.
 * Use `create(UpdateItemResponseSchema)` to create a new message.
 */
export const UpdateItemResponseSchema: GenMessage<UpdateItemResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 143);

/**
 * @generated from message cortado.v1.DeleteItemRequest
 */
export type DeleteItemRequest = Message<"cortado.v1.DeleteItemRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteItemRequest.
 * Use `create(DeleteItemRequestSchema)` to create a new message.
 */
export const DeleteItemRequestSchema: GenMessage<DeleteItemRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 144);

/**
 * @generated from message cortado.v1.DeleteItemResponse
 */
export type DeleteItemResponse = Message<"cortado.v1.DeleteItemResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteItemResponse.
 * Use `create(DeleteItemResponseSchema)` to create a new message.
 */
export const DeleteItemResponseSchema: GenMessage<DeleteItemResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 145);

/**
 * @generated from message cortado.v1.ReorderFormItemsRequest
 */
export type ReorderFormItemsRequest = Message<"cortado.v1.ReorderFormItemsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: repeated string item_ids = 2;
   */
  itemIds: string[];
};

/**
 * Describes the message cortado.v1.ReorderFormItemsRequest.
 * Use `create(ReorderFormItemsRequestSchema)` to create a new message.
 */
export const ReorderFormItemsRequestSchema: GenMessage<ReorderFormItemsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 146);

/**
 * @generated from message cortado.v1.ReorderFormItemsResponse
 */
export type ReorderFormItemsResponse = Message<"cortado.v1.ReorderFormItemsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.Item items = 1;
   */
  items: Item[];
};

/**
 * Describes the message cortado.v1.ReorderFormItemsResponse.
 * Use `create(ReorderFormItemsResponseSchema)` to create a new message.
 */
export const ReorderFormItemsResponseSchema: GenMessage<ReorderFormItemsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 147);

/**
 * @generated from message cortado.v1.GetTransportationItemRequest
 */
export type GetTransportationItemRequest = Message<"cortado.v1.GetTransportationItemRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.GetTransportationItemRequest.
 * Use `create(GetTransportationItemRequestSchema)` to create a new message.
 */
export const GetTransportationItemRequestSchema: GenMessage<GetTransportationItemRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 148);

/**
 * @generated from message cortado.v1.GetTransportationItemResponse
 */
export type GetTransportationItemResponse = Message<"cortado.v1.GetTransportationItemResponse"> & {
  /**
   * @generated from field: optional cortado.v1.Item item = 1;
   */
  item?: Item;
};

/**
 * Describes the message cortado.v1.GetTransportationItemResponse.
 * Use `create(GetTransportationItemResponseSchema)` to create a new message.
 */
export const GetTransportationItemResponseSchema: GenMessage<GetTransportationItemResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 149);

/**
 * @generated from message cortado.v1.UpsertTransportationItemRequest
 */
export type UpsertTransportationItemRequest = Message<"cortado.v1.UpsertTransportationItemRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: float price = 4;
   */
  price: number;

  /**
   * @generated from field: double mileage_threshold_miles = 5;
   */
  mileageThresholdMiles: number;

  /**
   * @generated from field: bool enabled_by_default = 6;
   */
  enabledByDefault: boolean;
};

/**
 * Describes the message cortado.v1.UpsertTransportationItemRequest.
 * Use `create(UpsertTransportationItemRequestSchema)` to create a new message.
 */
export const UpsertTransportationItemRequestSchema: GenMessage<UpsertTransportationItemRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 150);

/**
 * @generated from message cortado.v1.UpsertTransportationItemResponse
 */
export type UpsertTransportationItemResponse = Message<"cortado.v1.UpsertTransportationItemResponse"> & {
  /**
   * @generated from field: cortado.v1.Item item = 1;
   */
  item?: Item;
};

/**
 * Describes the message cortado.v1.UpsertTransportationItemResponse.
 * Use `create(UpsertTransportationItemResponseSchema)` to create a new message.
 */
export const UpsertTransportationItemResponseSchema: GenMessage<UpsertTransportationItemResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 151);

/**
 * @generated from message cortado.v1.UploadItemImageRequest
 */
export type UploadItemImageRequest = Message<"cortado.v1.UploadItemImageRequest"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: string filename = 2;
   */
  filename: string;

  /**
   * @generated from field: string file_base64 = 4;
   */
  fileBase64: string;

  /**
   * @generated from field: optional string alt_text = 5;
   */
  altText?: string;
};

/**
 * Describes the message cortado.v1.UploadItemImageRequest.
 * Use `create(UploadItemImageRequestSchema)` to create a new message.
 */
export const UploadItemImageRequestSchema: GenMessage<UploadItemImageRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 152);

/**
 * @generated from message cortado.v1.UploadItemImageResponse
 */
export type UploadItemImageResponse = Message<"cortado.v1.UploadItemImageResponse"> & {
  /**
   * @generated from field: cortado.v1.ItemImage image = 1;
   */
  image?: ItemImage;
};

/**
 * Describes the message cortado.v1.UploadItemImageResponse.
 * Use `create(UploadItemImageResponseSchema)` to create a new message.
 */
export const UploadItemImageResponseSchema: GenMessage<UploadItemImageResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 153);

/**
 * @generated from message cortado.v1.ListItemImagesRequest
 */
export type ListItemImagesRequest = Message<"cortado.v1.ListItemImagesRequest"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;
};

/**
 * Describes the message cortado.v1.ListItemImagesRequest.
 * Use `create(ListItemImagesRequestSchema)` to create a new message.
 */
export const ListItemImagesRequestSchema: GenMessage<ListItemImagesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 154);

/**
 * @generated from message cortado.v1.ListItemImagesResponse
 */
export type ListItemImagesResponse = Message<"cortado.v1.ListItemImagesResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.ItemImage images = 1;
   */
  images: ItemImage[];
};

/**
 * Describes the message cortado.v1.ListItemImagesResponse.
 * Use `create(ListItemImagesResponseSchema)` to create a new message.
 */
export const ListItemImagesResponseSchema: GenMessage<ListItemImagesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 155);

/**
 * @generated from message cortado.v1.UpdateItemImageRequest
 */
export type UpdateItemImageRequest = Message<"cortado.v1.UpdateItemImageRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string alt_text = 2;
   */
  altText?: string;

  /**
   * @generated from field: optional bool is_primary = 3;
   */
  isPrimary?: boolean;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 4;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message cortado.v1.UpdateItemImageRequest.
 * Use `create(UpdateItemImageRequestSchema)` to create a new message.
 */
export const UpdateItemImageRequestSchema: GenMessage<UpdateItemImageRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 156);

/**
 * @generated from message cortado.v1.UpdateItemImageResponse
 */
export type UpdateItemImageResponse = Message<"cortado.v1.UpdateItemImageResponse"> & {
  /**
   * @generated from field: cortado.v1.ItemImage image = 1;
   */
  image?: ItemImage;
};

/**
 * Describes the message cortado.v1.UpdateItemImageResponse.
 * Use `create(UpdateItemImageResponseSchema)` to create a new message.
 */
export const UpdateItemImageResponseSchema: GenMessage<UpdateItemImageResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 157);

/**
 * @generated from message cortado.v1.ReorderItemImagesRequest
 */
export type ReorderItemImagesRequest = Message<"cortado.v1.ReorderItemImagesRequest"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * Every image ID of the item, in the desired display order.
   *
   * @generated from field: repeated string image_ids = 2;
   */
  imageIds: string[];
};

/**
 * Describes the message cortado.v1.ReorderItemImagesRequest.
 * Use `create(ReorderItemImagesRequestSchema)` to create a new message.
 */
export const ReorderItemImagesRequestSchema: GenMessage<ReorderItemImagesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 158);

/**
 * @generated from message cortado.v1.ReorderItemImagesResponse
 */
export type ReorderItemImagesResponse = Message<"cortado.v1.ReorderItemImagesResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.ItemImage images = 1;
   */
  images: ItemImage[];
};

/**
 * Describes the message cortado.v1.ReorderItemImagesResponse.
 * Use `create(ReorderItemImagesResponseSchema)` to create a new message.
 */
export const ReorderItemImagesResponseSchema: GenMessage<ReorderItemImagesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 159);

/**
 * @generated from message cortado.v1.DeleteItemImageRequest
 */
export type DeleteItemImageRequest = Message<"cortado.v1.DeleteItemImageRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteItemImageRequest.
 * Use `create(DeleteItemImageRequestSchema)` to create a new message.
 */
export const DeleteItemImageRequestSchema: GenMessage<DeleteItemImageRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 160);

/**
 * @generated from message cortado.v1.DeleteItemImageResponse
 */
export type DeleteItemImageResponse = Message<"cortado.v1.DeleteItemImageResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteItemImageResponse.
 * Use `create(DeleteItemImageResponseSchema)` to create a new message.
 */
export const DeleteItemImageResponseSchema: GenMessage<DeleteItemImageResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 161);

/**
 * @generated from message cortado.v1.UploadOrganizationGalleryImageRequest
 */
export type UploadOrganizationGalleryImageRequest = Message<"cortado.v1.UploadOrganizationGalleryImageRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string filename = 2;
   */
  filename: string;

  /**
   * @generated from field: string file_base64 = 3;
   */
  fileBase64: string;

  /**
   * @generated from field: optional string alt_text = 4;
   */
  altText?: string;
};

/**
 * Describes the message cortado.v1.UploadOrganizationGalleryImageRequest.
 * Use `create(UploadOrganizationGalleryImageRequestSchema)` to create a new message.
 */
export const UploadOrganizationGalleryImageRequestSchema: GenMessage<UploadOrganizationGalleryImageRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 162);

/**
 * @generated from message cortado.v1.UploadOrganizationGalleryImageResponse
 */
export type UploadOrganizationGalleryImageResponse = Message<"cortado.v1.UploadOrganizationGalleryImageResponse"> & {
  /**
   * @generated from field: cortado.v1.OrganizationGalleryImage image = 1;
   */
  image?: OrganizationGalleryImage;
};

/**
 * Describes the message cortado.v1.UploadOrganizationGalleryImageResponse.
 * Use `create(UploadOrganizationGalleryImageResponseSchema)` to create a new message.
 */
export const UploadOrganizationGalleryImageResponseSchema: GenMessage<UploadOrganizationGalleryImageResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 163);

/**
 * @generated from message cortado.v1.ListOrganizationGalleryImagesRequest
 */
export type ListOrganizationGalleryImagesRequest = Message<"cortado.v1.ListOrganizationGalleryImagesRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListOrganizationGalleryImagesRequest.
 * Use `create(ListOrganizationGalleryImagesRequestSchema)` to create a new message.
 */
export const ListOrganizationGalleryImagesRequestSchema: GenMessage<ListOrganizationGalleryImagesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 164);

/**
 * @generated from message cortado.v1.ListOrganizationGalleryImagesResponse
 */
export type ListOrganizationGalleryImagesResponse = Message<"cortado.v1.ListOrganizationGalleryImagesResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.OrganizationGalleryImage images = 1;
   */
  images: OrganizationGalleryImage[];
};

/**
 * Describes the message cortado.v1.ListOrganizationGalleryImagesResponse.
 * Use `create(ListOrganizationGalleryImagesResponseSchema)` to create a new message.
 */
export const ListOrganizationGalleryImagesResponseSchema: GenMessage<ListOrganizationGalleryImagesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 165);

/**
 * @generated from message cortado.v1.UpdateOrganizationGalleryImageRequest
 */
export type UpdateOrganizationGalleryImageRequest = Message<"cortado.v1.UpdateOrganizationGalleryImageRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: optional string alt_text = 3;
   */
  altText?: string;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 4;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message cortado.v1.UpdateOrganizationGalleryImageRequest.
 * Use `create(UpdateOrganizationGalleryImageRequestSchema)` to create a new message.
 */
export const UpdateOrganizationGalleryImageRequestSchema: GenMessage<UpdateOrganizationGalleryImageRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 166);

/**
 * @generated from message cortado.v1.UpdateOrganizationGalleryImageResponse
 */
export type UpdateOrganizationGalleryImageResponse = Message<"cortado.v1.UpdateOrganizationGalleryImageResponse"> & {
  /**
   * @generated from field: cortado.v1.OrganizationGalleryImage image = 1;
   */
  image?: OrganizationGalleryImage;
};

/**
 * Describes the message cortado.v1.UpdateOrganizationGalleryImageResponse.
 * Use `create(UpdateOrganizationGalleryImageResponseSchema)` to create a new message.
 */
export const UpdateOrganizationGalleryImageResponseSchema: GenMessage<UpdateOrganizationGalleryImageResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 167);

/**
 * @generated from message cortado.v1.ReorderOrganizationGalleryImagesRequest
 */
export type ReorderOrganizationGalleryImagesRequest = Message<"cortado.v1.ReorderOrganizationGalleryImagesRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Every image ID of the organization's gallery, in the desired display order.
   *
   * @generated from field: repeated string image_ids = 2;
   */
  imageIds: string[];
};

/**
 * Describes the message cortado.v1.ReorderOrganizationGalleryImagesRequest.
 * Use `create(ReorderOrganizationGalleryImagesRequestSchema)` to create a new message.
 */
export const ReorderOrganizationGalleryImagesRequestSchema: GenMessage<ReorderOrganizationGalleryImagesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 168);

/**
 * @generated from message cortado.v1.ReorderOrganizationGalleryImagesResponse
 */
export type ReorderOrganizationGalleryImagesResponse = Message<"cortado.v1.ReorderOrganizationGalleryImagesResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.OrganizationGalleryImage images = 1;
   */
  images: OrganizationGalleryImage[];
};

/**
 * Describes the message cortado.v1.ReorderOrganizationGalleryImagesResponse.
 * Use `create(ReorderOrganizationGalleryImagesResponseSchema)` to create a new message.
 */
export const ReorderOrganizationGalleryImagesResponseSchema: GenMessage<ReorderOrganizationGalleryImagesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 169);

/**
 * @generated from message cortado.v1.DeleteOrganizationGalleryImageRequest
 */
export type DeleteOrganizationGalleryImageRequest = Message<"cortado.v1.DeleteOrganizationGalleryImageRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteOrganizationGalleryImageRequest.
 * Use `create(DeleteOrganizationGalleryImageRequestSchema)` to create a new message.
 */
export const DeleteOrganizationGalleryImageRequestSchema: GenMessage<DeleteOrganizationGalleryImageRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 170);

/**
 * @generated from message cortado.v1.DeleteOrganizationGalleryImageResponse
 */
export type DeleteOrganizationGalleryImageResponse = Message<"cortado.v1.DeleteOrganizationGalleryImageResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteOrganizationGalleryImageResponse.
 * Use `create(DeleteOrganizationGalleryImageResponseSchema)` to create a new message.
 */
export const DeleteOrganizationGalleryImageResponseSchema: GenMessage<DeleteOrganizationGalleryImageResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 171);

/**
 * @generated from message cortado.v1.TransportationMileageDestination
 */
export type TransportationMileageDestination = Message<"cortado.v1.TransportationMileageDestination"> & {
  /**
   * @generated from field: string client_key = 1;
   */
  clientKey: string;

  /**
   * @generated from field: string location = 2;
   */
  location: string;
};

/**
 * Describes the message cortado.v1.TransportationMileageDestination.
 * Use `create(TransportationMileageDestinationSchema)` to create a new message.
 */
export const TransportationMileageDestinationSchema: GenMessage<TransportationMileageDestination> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 172);

/**
 * @generated from message cortado.v1.TransportationMileageRoute
 */
export type TransportationMileageRoute = Message<"cortado.v1.TransportationMileageRoute"> & {
  /**
   * @generated from field: string client_key = 1;
   */
  clientKey: string;

  /**
   * @generated from field: string location = 2;
   */
  location: string;

  /**
   * @generated from field: double one_way_miles = 3;
   */
  oneWayMiles: number;

  /**
   * @generated from field: double trip_miles = 4;
   */
  tripMiles: number;

  /**
   * @generated from field: optional string error = 5;
   */
  error?: string;
};

/**
 * Describes the message cortado.v1.TransportationMileageRoute.
 * Use `create(TransportationMileageRouteSchema)` to create a new message.
 */
export const TransportationMileageRouteSchema: GenMessage<TransportationMileageRoute> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 173);

/**
 * @generated from message cortado.v1.CalculateTransportationMileageRequest
 */
export type CalculateTransportationMileageRequest = Message<"cortado.v1.CalculateTransportationMileageRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string transportation_item_id = 2;
   */
  transportationItemId: string;

  /**
   * @generated from field: repeated cortado.v1.TransportationMileageDestination destinations = 3;
   */
  destinations: TransportationMileageDestination[];

  /**
   * @generated from field: bool round_trip = 4;
   */
  roundTrip: boolean;
};

/**
 * Describes the message cortado.v1.CalculateTransportationMileageRequest.
 * Use `create(CalculateTransportationMileageRequestSchema)` to create a new message.
 */
export const CalculateTransportationMileageRequestSchema: GenMessage<CalculateTransportationMileageRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 174);

/**
 * @generated from message cortado.v1.CalculateTransportationMileageResponse
 */
export type CalculateTransportationMileageResponse = Message<"cortado.v1.CalculateTransportationMileageResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.TransportationMileageRoute routes = 1;
   */
  routes: TransportationMileageRoute[];

  /**
   * @generated from field: double total_miles = 2;
   */
  totalMiles: number;

  /**
   * @generated from field: double threshold_miles = 3;
   */
  thresholdMiles: number;

  /**
   * @generated from field: double billable_miles = 4;
   */
  billableMiles: number;

  /**
   * @generated from field: bool threshold_applied = 5;
   */
  thresholdApplied: boolean;

  /**
   * @generated from field: bool complete = 6;
   */
  complete: boolean;

  /**
   * @generated from field: cortado.v1.Item transportation_item = 7;
   */
  transportationItem?: Item;
};

/**
 * Describes the message cortado.v1.CalculateTransportationMileageResponse.
 * Use `create(CalculateTransportationMileageResponseSchema)` to create a new message.
 */
export const CalculateTransportationMileageResponseSchema: GenMessage<CalculateTransportationMileageResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 175);

/**
 * @generated from message cortado.v1.ListTaxRatesRequest
 */
export type ListTaxRatesRequest = Message<"cortado.v1.ListTaxRatesRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListTaxRatesRequest.
 * Use `create(ListTaxRatesRequestSchema)` to create a new message.
 */
export const ListTaxRatesRequestSchema: GenMessage<ListTaxRatesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 176);

/**
 * @generated from message cortado.v1.ListTaxRatesResponse
 */
export type ListTaxRatesResponse = Message<"cortado.v1.ListTaxRatesResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.TaxRate tax_rates = 1;
   */
  taxRates: TaxRate[];
};

/**
 * Describes the message cortado.v1.ListTaxRatesResponse.
 * Use `create(ListTaxRatesResponseSchema)` to create a new message.
 */
export const ListTaxRatesResponseSchema: GenMessage<ListTaxRatesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 177);

/**
 * @generated from message cortado.v1.CreateTaxRateRequest
 */
export type CreateTaxRateRequest = Message<"cortado.v1.CreateTaxRateRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string tax_type = 2;
   */
  taxType: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: float percentage = 4;
   */
  percentage: number;
};

/**
 * Describes the message cortado.v1.CreateTaxRateRequest.
 * Use `create(CreateTaxRateRequestSchema)` to create a new message.
 */
export const CreateTaxRateRequestSchema: GenMessage<CreateTaxRateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 178);

/**
 * @generated from message cortado.v1.CreateTaxRateResponse
 */
export type CreateTaxRateResponse = Message<"cortado.v1.CreateTaxRateResponse"> & {
  /**
   * @generated from field: cortado.v1.TaxRate tax_rate = 1;
   */
  taxRate?: TaxRate;
};

/**
 * Describes the message cortado.v1.CreateTaxRateResponse.
 * Use `create(CreateTaxRateResponseSchema)` to create a new message.
 */
export const CreateTaxRateResponseSchema: GenMessage<CreateTaxRateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 179);

/**
 * @generated from message cortado.v1.ArchiveTaxRateRequest
 */
export type ArchiveTaxRateRequest = Message<"cortado.v1.ArchiveTaxRateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.ArchiveTaxRateRequest.
 * Use `create(ArchiveTaxRateRequestSchema)` to create a new message.
 */
export const ArchiveTaxRateRequestSchema: GenMessage<ArchiveTaxRateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 180);

/**
 * @generated from message cortado.v1.ArchiveTaxRateResponse
 */
export type ArchiveTaxRateResponse = Message<"cortado.v1.ArchiveTaxRateResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.ArchiveTaxRateResponse.
 * Use `create(ArchiveTaxRateResponseSchema)` to create a new message.
 */
export const ArchiveTaxRateResponseSchema: GenMessage<ArchiveTaxRateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 181);

/**
 * @generated from message cortado.v1.GetTaxRateRequest
 */
export type GetTaxRateRequest = Message<"cortado.v1.GetTaxRateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetTaxRateRequest.
 * Use `create(GetTaxRateRequestSchema)` to create a new message.
 */
export const GetTaxRateRequestSchema: GenMessage<GetTaxRateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 182);

/**
 * @generated from message cortado.v1.GetTaxRateResponse
 */
export type GetTaxRateResponse = Message<"cortado.v1.GetTaxRateResponse"> & {
  /**
   * @generated from field: cortado.v1.TaxRate tax_rate = 1;
   */
  taxRate?: TaxRate;
};

/**
 * Describes the message cortado.v1.GetTaxRateResponse.
 * Use `create(GetTaxRateResponseSchema)` to create a new message.
 */
export const GetTaxRateResponseSchema: GenMessage<GetTaxRateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 183);

/**
 * @generated from message cortado.v1.UpdateTaxRateRequest
 */
export type UpdateTaxRateRequest = Message<"cortado.v1.UpdateTaxRateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string tax_type = 2;
   */
  taxType?: string;

  /**
   * @generated from field: optional string name = 3;
   */
  name?: string;

  /**
   * @generated from field: optional float percentage = 4;
   */
  percentage?: number;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 5;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message cortado.v1.UpdateTaxRateRequest.
 * Use `create(UpdateTaxRateRequestSchema)` to create a new message.
 */
export const UpdateTaxRateRequestSchema: GenMessage<UpdateTaxRateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 184);

/**
 * @generated from message cortado.v1.UpdateTaxRateResponse
 */
export type UpdateTaxRateResponse = Message<"cortado.v1.UpdateTaxRateResponse"> & {
  /**
   * @generated from field: cortado.v1.TaxRate tax_rate = 1;
   */
  taxRate?: TaxRate;
};

/**
 * Describes the message cortado.v1.UpdateTaxRateResponse.
 * Use `create(UpdateTaxRateResponseSchema)` to create a new message.
 */
export const UpdateTaxRateResponseSchema: GenMessage<UpdateTaxRateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 185);

/**
 * @generated from message cortado.v1.DeleteTaxRateRequest
 */
export type DeleteTaxRateRequest = Message<"cortado.v1.DeleteTaxRateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteTaxRateRequest.
 * Use `create(DeleteTaxRateRequestSchema)` to create a new message.
 */
export const DeleteTaxRateRequestSchema: GenMessage<DeleteTaxRateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 186);

/**
 * @generated from message cortado.v1.DeleteTaxRateResponse
 */
export type DeleteTaxRateResponse = Message<"cortado.v1.DeleteTaxRateResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteTaxRateResponse.
 * Use `create(DeleteTaxRateResponseSchema)` to create a new message.
 */
export const DeleteTaxRateResponseSchema: GenMessage<DeleteTaxRateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 187);

/**
 * @generated from message cortado.v1.ListDiscountsRequest
 */
export type ListDiscountsRequest = Message<"cortado.v1.ListDiscountsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListDiscountsRequest.
 * Use `create(ListDiscountsRequestSchema)` to create a new message.
 */
export const ListDiscountsRequestSchema: GenMessage<ListDiscountsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 188);

/**
 * @generated from message cortado.v1.ListDiscountsResponse
 */
export type ListDiscountsResponse = Message<"cortado.v1.ListDiscountsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.Discount discounts = 1;
   */
  discounts: Discount[];
};

/**
 * Describes the message cortado.v1.ListDiscountsResponse.
 * Use `create(ListDiscountsResponseSchema)` to create a new message.
 */
export const ListDiscountsResponseSchema: GenMessage<ListDiscountsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 189);

/**
 * @generated from message cortado.v1.CreateDiscountRequest
 */
export type CreateDiscountRequest = Message<"cortado.v1.CreateDiscountRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: cortado.v1.DiscountTypeEnum discount_type = 4;
   */
  discountType: DiscountTypeEnum;

  /**
   * @generated from field: float value = 5;
   */
  value: number;

  /**
   * @generated from field: optional bool is_active = 6;
   */
  isActive?: boolean;
};

/**
 * Describes the message cortado.v1.CreateDiscountRequest.
 * Use `create(CreateDiscountRequestSchema)` to create a new message.
 */
export const CreateDiscountRequestSchema: GenMessage<CreateDiscountRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 190);

/**
 * @generated from message cortado.v1.CreateDiscountResponse
 */
export type CreateDiscountResponse = Message<"cortado.v1.CreateDiscountResponse"> & {
  /**
   * @generated from field: cortado.v1.Discount discount = 1;
   */
  discount?: Discount;
};

/**
 * Describes the message cortado.v1.CreateDiscountResponse.
 * Use `create(CreateDiscountResponseSchema)` to create a new message.
 */
export const CreateDiscountResponseSchema: GenMessage<CreateDiscountResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 191);

/**
 * @generated from message cortado.v1.GetDiscountRequest
 */
export type GetDiscountRequest = Message<"cortado.v1.GetDiscountRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetDiscountRequest.
 * Use `create(GetDiscountRequestSchema)` to create a new message.
 */
export const GetDiscountRequestSchema: GenMessage<GetDiscountRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 192);

/**
 * @generated from message cortado.v1.GetDiscountResponse
 */
export type GetDiscountResponse = Message<"cortado.v1.GetDiscountResponse"> & {
  /**
   * @generated from field: cortado.v1.Discount discount = 1;
   */
  discount?: Discount;
};

/**
 * Describes the message cortado.v1.GetDiscountResponse.
 * Use `create(GetDiscountResponseSchema)` to create a new message.
 */
export const GetDiscountResponseSchema: GenMessage<GetDiscountResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 193);

/**
 * @generated from message cortado.v1.UpdateDiscountRequest
 */
export type UpdateDiscountRequest = Message<"cortado.v1.UpdateDiscountRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional cortado.v1.DiscountTypeEnum discount_type = 4;
   */
  discountType?: DiscountTypeEnum;

  /**
   * @generated from field: optional float value = 5;
   */
  value?: number;

  /**
   * @generated from field: optional bool is_active = 6;
   */
  isActive?: boolean;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 7;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message cortado.v1.UpdateDiscountRequest.
 * Use `create(UpdateDiscountRequestSchema)` to create a new message.
 */
export const UpdateDiscountRequestSchema: GenMessage<UpdateDiscountRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 194);

/**
 * @generated from message cortado.v1.UpdateDiscountResponse
 */
export type UpdateDiscountResponse = Message<"cortado.v1.UpdateDiscountResponse"> & {
  /**
   * @generated from field: cortado.v1.Discount discount = 1;
   */
  discount?: Discount;
};

/**
 * Describes the message cortado.v1.UpdateDiscountResponse.
 * Use `create(UpdateDiscountResponseSchema)` to create a new message.
 */
export const UpdateDiscountResponseSchema: GenMessage<UpdateDiscountResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 195);

/**
 * @generated from message cortado.v1.DeleteDiscountRequest
 */
export type DeleteDiscountRequest = Message<"cortado.v1.DeleteDiscountRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteDiscountRequest.
 * Use `create(DeleteDiscountRequestSchema)` to create a new message.
 */
export const DeleteDiscountRequestSchema: GenMessage<DeleteDiscountRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 196);

/**
 * @generated from message cortado.v1.DeleteDiscountResponse
 */
export type DeleteDiscountResponse = Message<"cortado.v1.DeleteDiscountResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteDiscountResponse.
 * Use `create(DeleteDiscountResponseSchema)` to create a new message.
 */
export const DeleteDiscountResponseSchema: GenMessage<DeleteDiscountResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 197);

/**
 * @generated from message cortado.v1.ListQuoteTemplatesRequest
 */
export type ListQuoteTemplatesRequest = Message<"cortado.v1.ListQuoteTemplatesRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListQuoteTemplatesRequest.
 * Use `create(ListQuoteTemplatesRequestSchema)` to create a new message.
 */
export const ListQuoteTemplatesRequestSchema: GenMessage<ListQuoteTemplatesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 198);

/**
 * @generated from message cortado.v1.ListQuoteTemplatesResponse
 */
export type ListQuoteTemplatesResponse = Message<"cortado.v1.ListQuoteTemplatesResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.QuoteTemplate quote_templates = 1;
   */
  quoteTemplates: QuoteTemplate[];
};

/**
 * Describes the message cortado.v1.ListQuoteTemplatesResponse.
 * Use `create(ListQuoteTemplatesResponseSchema)` to create a new message.
 */
export const ListQuoteTemplatesResponseSchema: GenMessage<ListQuoteTemplatesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 199);

/**
 * @generated from message cortado.v1.CreateQuoteTemplateRequest
 */
export type CreateQuoteTemplateRequest = Message<"cortado.v1.CreateQuoteTemplateRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: optional cortado.v1.EventTypeEnum event_type = 2 [deprecated = true];
   * @deprecated
   */
  eventType?: EventTypeEnum;

  /**
   * @generated from field: optional string base_item_id = 3;
   */
  baseItemId?: string;

  /**
   * @generated from field: optional string hourly_item_id = 4;
   */
  hourlyItemId?: string;

  /**
   * @generated from field: int32 minimum_hours = 5;
   */
  minimumHours: number;

  /**
   * @generated from field: optional bool is_active = 6;
   */
  isActive?: boolean;

  /**
   * @generated from field: int64 base_item_rate_cents = 7;
   */
  baseItemRateCents: bigint;

  /**
   * @generated from field: int64 hourly_item_rate_cents = 8;
   */
  hourlyItemRateCents: bigint;

  /**
   * @generated from field: repeated cortado.v1.QuoteTemplateItemInput template_items = 9;
   */
  templateItems: QuoteTemplateItemInput[];

  /**
   * @generated from field: string title = 10;
   */
  title: string;

  /**
   * @generated from field: optional string quote_title = 11;
   */
  quoteTitle?: string;

  /**
   * @generated from field: optional string quote_description = 12;
   */
  quoteDescription?: string;

  /**
   * @generated from field: optional string event_type_key = 13;
   */
  eventTypeKey?: string;
};

/**
 * Describes the message cortado.v1.CreateQuoteTemplateRequest.
 * Use `create(CreateQuoteTemplateRequestSchema)` to create a new message.
 */
export const CreateQuoteTemplateRequestSchema: GenMessage<CreateQuoteTemplateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 200);

/**
 * @generated from message cortado.v1.QuoteTemplateItemInput
 */
export type QuoteTemplateItemInput = Message<"cortado.v1.QuoteTemplateItemInput"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: cortado.v1.QuoteTemplateItemScalingType scaling_type = 2;
   */
  scalingType: QuoteTemplateItemScalingType;

  /**
   * @generated from field: int64 rate_cents = 3;
   */
  rateCents: bigint;

  /**
   * @generated from field: int32 sort_order = 4;
   */
  sortOrder: number;
};

/**
 * Describes the message cortado.v1.QuoteTemplateItemInput.
 * Use `create(QuoteTemplateItemInputSchema)` to create a new message.
 */
export const QuoteTemplateItemInputSchema: GenMessage<QuoteTemplateItemInput> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 201);

/**
 * @generated from message cortado.v1.CreateQuoteTemplateResponse
 */
export type CreateQuoteTemplateResponse = Message<"cortado.v1.CreateQuoteTemplateResponse"> & {
  /**
   * @generated from field: cortado.v1.QuoteTemplate quote_template = 1;
   */
  quoteTemplate?: QuoteTemplate;
};

/**
 * Describes the message cortado.v1.CreateQuoteTemplateResponse.
 * Use `create(CreateQuoteTemplateResponseSchema)` to create a new message.
 */
export const CreateQuoteTemplateResponseSchema: GenMessage<CreateQuoteTemplateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 202);

/**
 * @generated from message cortado.v1.GetQuoteTemplateRequest
 */
export type GetQuoteTemplateRequest = Message<"cortado.v1.GetQuoteTemplateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetQuoteTemplateRequest.
 * Use `create(GetQuoteTemplateRequestSchema)` to create a new message.
 */
export const GetQuoteTemplateRequestSchema: GenMessage<GetQuoteTemplateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 203);

/**
 * @generated from message cortado.v1.GetQuoteTemplateResponse
 */
export type GetQuoteTemplateResponse = Message<"cortado.v1.GetQuoteTemplateResponse"> & {
  /**
   * @generated from field: cortado.v1.QuoteTemplate quote_template = 1;
   */
  quoteTemplate?: QuoteTemplate;
};

/**
 * Describes the message cortado.v1.GetQuoteTemplateResponse.
 * Use `create(GetQuoteTemplateResponseSchema)` to create a new message.
 */
export const GetQuoteTemplateResponseSchema: GenMessage<GetQuoteTemplateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 204);

/**
 * @generated from message cortado.v1.GetQuoteTemplateByEventTypeRequest
 */
export type GetQuoteTemplateByEventTypeRequest = Message<"cortado.v1.GetQuoteTemplateByEventTypeRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: cortado.v1.EventTypeEnum event_type = 2 [deprecated = true];
   * @deprecated
   */
  eventType: EventTypeEnum;

  /**
   * @generated from field: optional string event_type_key = 3;
   */
  eventTypeKey?: string;
};

/**
 * Describes the message cortado.v1.GetQuoteTemplateByEventTypeRequest.
 * Use `create(GetQuoteTemplateByEventTypeRequestSchema)` to create a new message.
 */
export const GetQuoteTemplateByEventTypeRequestSchema: GenMessage<GetQuoteTemplateByEventTypeRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 205);

/**
 * @generated from message cortado.v1.GetQuoteTemplateByEventTypeResponse
 */
export type GetQuoteTemplateByEventTypeResponse = Message<"cortado.v1.GetQuoteTemplateByEventTypeResponse"> & {
  /**
   * @generated from field: optional cortado.v1.QuoteTemplate quote_template = 1;
   */
  quoteTemplate?: QuoteTemplate;
};

/**
 * Describes the message cortado.v1.GetQuoteTemplateByEventTypeResponse.
 * Use `create(GetQuoteTemplateByEventTypeResponseSchema)` to create a new message.
 */
export const GetQuoteTemplateByEventTypeResponseSchema: GenMessage<GetQuoteTemplateByEventTypeResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 206);

/**
 * @generated from message cortado.v1.UpdateQuoteTemplateRequest
 */
export type UpdateQuoteTemplateRequest = Message<"cortado.v1.UpdateQuoteTemplateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional cortado.v1.EventTypeEnum event_type = 2 [deprecated = true];
   * @deprecated
   */
  eventType?: EventTypeEnum;

  /**
   * @generated from field: optional string base_item_id = 3;
   */
  baseItemId?: string;

  /**
   * @generated from field: optional string hourly_item_id = 4;
   */
  hourlyItemId?: string;

  /**
   * @generated from field: optional int32 minimum_hours = 5;
   */
  minimumHours?: number;

  /**
   * @generated from field: optional bool is_active = 6;
   */
  isActive?: boolean;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 7;
   */
  updateMask?: FieldMask;

  /**
   * @generated from field: optional int64 base_item_rate_cents = 8;
   */
  baseItemRateCents?: bigint;

  /**
   * @generated from field: optional int64 hourly_item_rate_cents = 9;
   */
  hourlyItemRateCents?: bigint;

  /**
   * @generated from field: repeated cortado.v1.QuoteTemplateItemInput template_items = 10;
   */
  templateItems: QuoteTemplateItemInput[];

  /**
   * @generated from field: optional string title = 11;
   */
  title?: string;

  /**
   * @generated from field: optional string quote_title = 12;
   */
  quoteTitle?: string;

  /**
   * @generated from field: optional string quote_description = 13;
   */
  quoteDescription?: string;

  /**
   * @generated from field: optional string event_type_key = 14;
   */
  eventTypeKey?: string;
};

/**
 * Describes the message cortado.v1.UpdateQuoteTemplateRequest.
 * Use `create(UpdateQuoteTemplateRequestSchema)` to create a new message.
 */
export const UpdateQuoteTemplateRequestSchema: GenMessage<UpdateQuoteTemplateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 207);

/**
 * @generated from message cortado.v1.UpdateQuoteTemplateResponse
 */
export type UpdateQuoteTemplateResponse = Message<"cortado.v1.UpdateQuoteTemplateResponse"> & {
  /**
   * @generated from field: cortado.v1.QuoteTemplate quote_template = 1;
   */
  quoteTemplate?: QuoteTemplate;
};

/**
 * Describes the message cortado.v1.UpdateQuoteTemplateResponse.
 * Use `create(UpdateQuoteTemplateResponseSchema)` to create a new message.
 */
export const UpdateQuoteTemplateResponseSchema: GenMessage<UpdateQuoteTemplateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 208);

/**
 * @generated from message cortado.v1.DeleteQuoteTemplateRequest
 */
export type DeleteQuoteTemplateRequest = Message<"cortado.v1.DeleteQuoteTemplateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteQuoteTemplateRequest.
 * Use `create(DeleteQuoteTemplateRequestSchema)` to create a new message.
 */
export const DeleteQuoteTemplateRequestSchema: GenMessage<DeleteQuoteTemplateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 209);

/**
 * @generated from message cortado.v1.DeleteQuoteTemplateResponse
 */
export type DeleteQuoteTemplateResponse = Message<"cortado.v1.DeleteQuoteTemplateResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteQuoteTemplateResponse.
 * Use `create(DeleteQuoteTemplateResponseSchema)` to create a new message.
 */
export const DeleteQuoteTemplateResponseSchema: GenMessage<DeleteQuoteTemplateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 210);

/**
 * @generated from message cortado.v1.GetQuotePreFillRequest
 */
export type GetQuotePreFillRequest = Message<"cortado.v1.GetQuotePreFillRequest"> & {
  /**
   * @generated from field: string inquiry_id = 1;
   */
  inquiryId: string;

  /**
   * @generated from field: optional string quote_template_id = 2;
   */
  quoteTemplateId?: string;
};

/**
 * Describes the message cortado.v1.GetQuotePreFillRequest.
 * Use `create(GetQuotePreFillRequestSchema)` to create a new message.
 */
export const GetQuotePreFillRequestSchema: GenMessage<GetQuotePreFillRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 211);

/**
 * @generated from message cortado.v1.GetQuotePreFillResponse
 */
export type GetQuotePreFillResponse = Message<"cortado.v1.GetQuotePreFillResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.QuotePreFillEventGroup event_groups = 1;
   */
  eventGroups: QuotePreFillEventGroup[];

  /**
   * @generated from field: repeated cortado.v1.QuoteLineItemInput general_items = 2;
   */
  generalItems: QuoteLineItemInput[];

  /**
   * @generated from field: repeated cortado.v1.QuoteEventInput quote_events = 3;
   */
  quoteEvents: QuoteEventInput[];

  /**
   * @generated from field: optional string quote_title = 4;
   */
  quoteTitle?: string;

  /**
   * @generated from field: optional string quote_description = 5;
   */
  quoteDescription?: string;

  /**
   * Every line the new quote starts with, in order: event_groups' lines, then
   * general_items. A quote keeps one flat line list, so clients read this
   * instead of flattening event_groups themselves.
   *
   * @generated from field: repeated cortado.v1.QuoteLineItemInput line_items = 6;
   */
  lineItems: QuoteLineItemInput[];
};

/**
 * Describes the message cortado.v1.GetQuotePreFillResponse.
 * Use `create(GetQuotePreFillResponseSchema)` to create a new message.
 */
export const GetQuotePreFillResponseSchema: GenMessage<GetQuotePreFillResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 212);

/**
 * @generated from message cortado.v1.QuotePreFillEventGroup
 */
export type QuotePreFillEventGroup = Message<"cortado.v1.QuotePreFillEventGroup"> & {
  /**
   * @generated from field: int32 event_index = 1;
   */
  eventIndex: number;

  /**
   * @generated from field: cortado.v1.QuoteEventInput event = 2;
   */
  event?: QuoteEventInput;

  /**
   * @generated from field: repeated cortado.v1.QuoteLineItemInput line_items = 3;
   */
  lineItems: QuoteLineItemInput[];
};

/**
 * Describes the message cortado.v1.QuotePreFillEventGroup.
 * Use `create(QuotePreFillEventGroupSchema)` to create a new message.
 */
export const QuotePreFillEventGroupSchema: GenMessage<QuotePreFillEventGroup> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 213);

/**
 * QuoteEventInput represents input data for creating/updating quote events
 * Used in CreateQuoteRequest and UpdateQuoteRequest for multi-event support
 *
 * @generated from message cortado.v1.QuoteEventInput
 */
export type QuoteEventInput = Message<"cortado.v1.QuoteEventInput"> & {
  /**
   * Date of the event (optional - may not be set initially)
   *
   * @generated from field: optional google.protobuf.Timestamp event_date = 1;
   */
  eventDate?: Timestamp;

  /**
   * Length of the event in hours (optional)
   *
   * @generated from field: optional double event_length = 2;
   */
  eventLength?: number;

  /**
   * Number of guests (optional)
   *
   * @generated from field: optional int32 event_guests = 3;
   */
  eventGuests?: number;

  /**
   * Timezone of the event (optional)
   *
   * @generated from field: optional string event_timezone = 4;
   */
  eventTimezone?: string;

  /**
   * Location of the event (optional)
   *
   * @generated from field: optional string event_location = 5;
   */
  eventLocation?: string;

  /**
   * Number of baristas (optional)
   *
   * @generated from field: optional int32 barista_count = 6;
   */
  baristaCount?: number;

  /**
   * Number of carts (optional)
   *
   * @generated from field: optional int32 cart_count = 7;
   */
  cartCount?: number;

  /**
   * Inquiry (request) event this quote event was copied from (optional).
   * GetQuotePreFill sets it; clients echo it back on create and update.
   *
   * @generated from field: optional string source_inquiry_event_id = 8;
   */
  sourceInquiryEventId?: string;
};

/**
 * Describes the message cortado.v1.QuoteEventInput.
 * Use `create(QuoteEventInputSchema)` to create a new message.
 */
export const QuoteEventInputSchema: GenMessage<QuoteEventInput> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 214);

/**
 * @generated from message cortado.v1.ListQuotesRequest
 */
export type ListQuotesRequest = Message<"cortado.v1.ListQuotesRequest"> & {
  /**
   * Organization ID to get quotes for (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Optional filter by inquiry ID
   *
   * @generated from field: optional string inquiry_id = 2;
   */
  inquiryId?: string;

  /**
   * Optional filter by quote statuses
   *
   * @generated from field: repeated cortado.v1.QuoteStatusEnum statuses = 3;
   */
  statuses: QuoteStatusEnum[];

  /**
   * Optional filter by created date (quotes created since this date)
   *
   * @generated from field: optional google.protobuf.Timestamp since = 4;
   */
  since?: Timestamp;

  /**
   * Optional limit on number of quotes to return (default: 50)
   *
   * @generated from field: optional int32 limit = 5;
   */
  limit?: number;

  /**
   * Optional offset for pagination (default: 0)
   *
   * @generated from field: optional int32 offset = 6;
   */
  offset?: number;

  /**
   * Optional filter by contact ID
   *
   * @generated from field: optional string contact_id = 7;
   */
  contactId?: string;

  /**
   * Optional case-insensitive search over quote number, title, and the
   * contact's name, email addresses, and phone number (phone compares digits only)
   *
   * @generated from field: optional string search = 8;
   */
  search?: string;
};

/**
 * Describes the message cortado.v1.ListQuotesRequest.
 * Use `create(ListQuotesRequestSchema)` to create a new message.
 */
export const ListQuotesRequestSchema: GenMessage<ListQuotesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 215);

/**
 * @generated from message cortado.v1.ListQuotesResponse
 */
export type ListQuotesResponse = Message<"cortado.v1.ListQuotesResponse"> & {
  /**
   * Lightweight quotes optimized for list views
   *
   * @generated from field: repeated cortado.v1.QuoteLite quotes = 1;
   */
  quotes: QuoteLite[];

  /**
   * Total count of matching quotes (for pagination)
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListQuotesResponse.
 * Use `create(ListQuotesResponseSchema)` to create a new message.
 */
export const ListQuotesResponseSchema: GenMessage<ListQuotesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 216);

/**
 * @generated from message cortado.v1.GetQuoteStatsRequest
 */
export type GetQuoteStatsRequest = Message<"cortado.v1.GetQuoteStatsRequest"> & {
  /**
   * Organization ID to get quote stats for (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.GetQuoteStatsRequest.
 * Use `create(GetQuoteStatsRequestSchema)` to create a new message.
 */
export const GetQuoteStatsRequestSchema: GenMessage<GetQuoteStatsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 217);

/**
 * GetQuoteStatsResponse aggregates match the quotes list page stat cards.
 * Buckets (totals are current-revision total_cents sums):
 *   draft    = Draft
 *   open     = Sent/Viewed (not past valid_until), Revised, and any unknown status
 *   accepted = Accepted
 *   inactive = Expired, Rejected, Cancelled, plus Sent/Viewed past valid_until
 *              (mirrors the read-time EffectiveQuoteStatus expiry derivation)
 *
 * @generated from message cortado.v1.GetQuoteStatsResponse
 */
export type GetQuoteStatsResponse = Message<"cortado.v1.GetQuoteStatsResponse"> & {
  /**
   * @generated from field: int64 draft_total_cents = 20;
   */
  draftTotalCents: bigint;

  /**
   * @generated from field: int32 draft_count = 21;
   */
  draftCount: number;

  /**
   * @generated from field: int64 open_total_cents = 22;
   */
  openTotalCents: bigint;

  /**
   * @generated from field: int32 open_count = 23;
   */
  openCount: number;

  /**
   * @generated from field: int64 accepted_total_cents = 24;
   */
  acceptedTotalCents: bigint;

  /**
   * @generated from field: int32 accepted_count = 25;
   */
  acceptedCount: number;

  /**
   * @generated from field: int64 inactive_total_cents = 26;
   */
  inactiveTotalCents: bigint;

  /**
   * @generated from field: int32 inactive_count = 27;
   */
  inactiveCount: number;
};

/**
 * Describes the message cortado.v1.GetQuoteStatsResponse.
 * Use `create(GetQuoteStatsResponseSchema)` to create a new message.
 */
export const GetQuoteStatsResponseSchema: GenMessage<GetQuoteStatsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 218);

/**
 * @generated from message cortado.v1.ListContactQuoteInteractionsRequest
 */
export type ListContactQuoteInteractionsRequest = Message<"cortado.v1.ListContactQuoteInteractionsRequest"> & {
  /**
   * Organization ID to get quote interactions for (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Contact ID whose public quote token interactions should be listed (required)
   *
   * @generated from field: string contact_id = 2;
   */
  contactId: string;

  /**
   * Optional legacy filter by a single quote ID. Prefer quote_ids for new callers.
   *
   * @generated from field: optional string quote_id = 3;
   */
  quoteId?: string;

  /**
   * Optional filter by quote IDs
   *
   * @generated from field: repeated string quote_ids = 4;
   */
  quoteIds: string[];

  /**
   * Pagination fields intentionally use field numbers 10 and 11 by convention.
   * Optional limit on number of interactions to return (default: 50)
   *
   * @generated from field: optional int32 limit = 10;
   */
  limit?: number;

  /**
   * Optional offset for pagination (default: 0)
   *
   * @generated from field: optional int32 offset = 11;
   */
  offset?: number;
};

/**
 * Describes the message cortado.v1.ListContactQuoteInteractionsRequest.
 * Use `create(ListContactQuoteInteractionsRequestSchema)` to create a new message.
 */
export const ListContactQuoteInteractionsRequestSchema: GenMessage<ListContactQuoteInteractionsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 219);

/**
 * @generated from message cortado.v1.ListContactQuoteInteractionsResponse
 */
export type ListContactQuoteInteractionsResponse = Message<"cortado.v1.ListContactQuoteInteractionsResponse"> & {
  /**
   * Public quote token interactions for the contact
   *
   * @generated from field: repeated cortado.v1.ContactQuoteInteraction interactions = 1;
   */
  interactions: ContactQuoteInteraction[];

  /**
   * Total count of matching interactions (for pagination)
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListContactQuoteInteractionsResponse.
 * Use `create(ListContactQuoteInteractionsResponseSchema)` to create a new message.
 */
export const ListContactQuoteInteractionsResponseSchema: GenMessage<ListContactQuoteInteractionsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 220);

/**
 * @generated from message cortado.v1.ListPortalVisitorActivityRequest
 */
export type ListPortalVisitorActivityRequest = Message<"cortado.v1.ListPortalVisitorActivityRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: cortado.v1.ParentTypeEnum parent_type = 2;
   */
  parentType: ParentTypeEnum;

  /**
   * @generated from field: string parent_id = 3;
   */
  parentId: string;

  /**
   * @generated from field: optional int32 limit = 10;
   */
  limit?: number;

  /**
   * @generated from field: optional int32 offset = 11;
   */
  offset?: number;
};

/**
 * Describes the message cortado.v1.ListPortalVisitorActivityRequest.
 * Use `create(ListPortalVisitorActivityRequestSchema)` to create a new message.
 */
export const ListPortalVisitorActivityRequestSchema: GenMessage<ListPortalVisitorActivityRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 221);

/**
 * @generated from message cortado.v1.PortalVisitorActivity
 */
export type PortalVisitorActivity = Message<"cortado.v1.PortalVisitorActivity"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string alias_id = 2;
   */
  aliasId: string;

  /**
   * @generated from field: string visitor_id = 3;
   */
  visitorId: string;

  /**
   * @generated from field: string source_id = 4;
   */
  sourceId: string;

  /**
   * @generated from field: cortado.v1.ParentTypeEnum source_kind = 5;
   */
  sourceKind: ParentTypeEnum;

  /**
   * @generated from field: optional string intended_contact_id = 10;
   */
  intendedContactId?: string;

  /**
   * @generated from field: optional string intended_contact_name = 11;
   */
  intendedContactName?: string;

  /**
   * @generated from field: optional string intended_recipient_email = 12;
   */
  intendedRecipientEmail?: string;

  /**
   * @generated from field: cortado.v1.PortalAttributionModeEnum attribution_mode = 20;
   */
  attributionMode: PortalAttributionModeEnum;

  /**
   * @generated from field: cortado.v1.PortalLinkIssuanceChannelEnum issuance_channel = 21;
   */
  issuanceChannel: PortalLinkIssuanceChannelEnum;

  /**
   * @generated from field: int32 open_count = 40;
   */
  openCount: number;

  /**
   * @generated from field: bool is_bot = 50;
   */
  isBot: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp first_opened_at = 60;
   */
  firstOpenedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp last_opened_at = 61;
   */
  lastOpenedAt?: Timestamp;

  /**
   * @generated from field: optional string device_type = 70;
   */
  deviceType?: string;

  /**
   * @generated from field: optional string device_label = 71;
   */
  deviceLabel?: string;

  /**
   * @generated from field: optional string location_label = 72;
   */
  locationLabel?: string;
};

/**
 * Describes the message cortado.v1.PortalVisitorActivity.
 * Use `create(PortalVisitorActivitySchema)` to create a new message.
 */
export const PortalVisitorActivitySchema: GenMessage<PortalVisitorActivity> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 222);

/**
 * @generated from message cortado.v1.ListPortalVisitorActivityResponse
 */
export type ListPortalVisitorActivityResponse = Message<"cortado.v1.ListPortalVisitorActivityResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.PortalVisitorActivity activities = 1;
   */
  activities: PortalVisitorActivity[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * @generated from field: int64 total_opens = 3;
   */
  totalOpens: bigint;

  /**
   * @generated from field: int64 unique_browsers = 4;
   */
  uniqueBrowsers: bigint;

  /**
   * @generated from field: int64 intended_recipients = 5;
   */
  intendedRecipients: bigint;

  /**
   * @generated from field: int64 unidentified_open_count = 6;
   */
  unidentifiedOpenCount: bigint;

  /**
   * @generated from field: int64 bot_open_count = 7;
   */
  botOpenCount: bigint;
};

/**
 * Describes the message cortado.v1.ListPortalVisitorActivityResponse.
 * Use `create(ListPortalVisitorActivityResponseSchema)` to create a new message.
 */
export const ListPortalVisitorActivityResponseSchema: GenMessage<ListPortalVisitorActivityResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 223);

/**
 * @generated from message cortado.v1.CreateQuoteRequest
 */
export type CreateQuoteRequest = Message<"cortado.v1.CreateQuoteRequest"> & {
  /**
   * @generated from field: string inquiry_id = 1;
   */
  inquiryId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: double sales_tax_rate = 4;
   */
  salesTaxRate: number;

  /**
   * @generated from field: optional google.protobuf.Timestamp valid_until = 5;
   */
  validUntil?: Timestamp;

  /**
   * @generated from field: repeated cortado.v1.QuoteLineItemInput line_items = 6;
   */
  lineItems: QuoteLineItemInput[];

  /**
   * Discount fields - support both saved (ID) and inline (name/type/value)
   *
   * @generated from field: optional string discount_id = 7;
   */
  discountId?: string;

  /**
   * @generated from field: optional string discount_name = 8;
   */
  discountName?: string;

  /**
   * @generated from field: optional cortado.v1.DiscountTypeEnum discount_type = 9;
   */
  discountType?: DiscountTypeEnum;

  /**
   * @generated from field: optional double discount_value = 10;
   */
  discountValue?: number;

  /**
   * Enforced tip fields (backend calculates enforced_tip_cents from percentage)
   *
   * @generated from field: optional bool enforced_tip_enabled = 14;
   */
  enforcedTipEnabled?: boolean;

  /**
   * @generated from field: optional double enforced_tip_percentage = 15;
   */
  enforcedTipPercentage?: number;

  /**
   * Event details - LEGACY single event fields (for backward compatibility)
   * Use quote_events for multi-event support
   *
   * @generated from field: optional google.protobuf.Timestamp event_date = 16;
   */
  eventDate?: Timestamp;

  /**
   * @generated from field: optional string event_location = 17;
   */
  eventLocation?: string;

  /**
   * @generated from field: optional int32 guest_count = 18;
   */
  guestCount?: number;

  /**
   * in hours
   *
   * @generated from field: optional double event_duration = 19;
   */
  eventDuration?: number;

  /**
   * Payment schedules - configuration for payment installments
   *
   * @generated from field: repeated cortado.v1.QuotePaymentScheduleInput payment_schedules = 20;
   */
  paymentSchedules: QuotePaymentScheduleInput[];

  /**
   * Quote events - multi-event support (preferred over single event fields)
   * If provided, these events determine the booking events on quote acceptance
   *
   * @generated from field: repeated cortado.v1.QuoteEventInput quote_events = 25;
   */
  quoteEvents: QuoteEventInput[];

  /**
   * Payment method override for checkout (empty = use org defaults)
   *
   * @generated from field: repeated cortado.v1.StripeCheckoutPaymentMethodEnum checkout_payment_methods = 30;
   */
  checkoutPaymentMethods: StripeCheckoutPaymentMethodEnum[];

  /**
   * Add-on offers available to the customer on this quote (trigger new revision when changed)
   *
   * @generated from field: repeated cortado.v1.QuoteAddonOfferInput addon_offers = 31;
   */
  addonOffers: QuoteAddonOfferInput[];

  /**
   * Whether accepting this quote attaches a questionnaire to the booking.
   * Absent inherits the lead's value.
   *
   * @generated from field: optional bool requires_questionnaire = 32;
   */
  requiresQuestionnaire?: boolean;

  /**
   * Unset: use org default
   *
   * @generated from field: optional cortado.v1.TipAllocationModeEnum tip_allocation_mode = 33;
   */
  tipAllocationMode?: TipAllocationModeEnum;
};

/**
 * Describes the message cortado.v1.CreateQuoteRequest.
 * Use `create(CreateQuoteRequestSchema)` to create a new message.
 */
export const CreateQuoteRequestSchema: GenMessage<CreateQuoteRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 224);

/**
 * @generated from message cortado.v1.CreateQuoteResponse
 */
export type CreateQuoteResponse = Message<"cortado.v1.CreateQuoteResponse"> & {
  /**
   * @generated from field: cortado.v1.Quote quote = 1;
   */
  quote?: Quote;
};

/**
 * Describes the message cortado.v1.CreateQuoteResponse.
 * Use `create(CreateQuoteResponseSchema)` to create a new message.
 */
export const CreateQuoteResponseSchema: GenMessage<CreateQuoteResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 225);

/**
 * @generated from message cortado.v1.GetQuoteRequest
 */
export type GetQuoteRequest = Message<"cortado.v1.GetQuoteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetQuoteRequest.
 * Use `create(GetQuoteRequestSchema)` to create a new message.
 */
export const GetQuoteRequestSchema: GenMessage<GetQuoteRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 226);

/**
 * @generated from message cortado.v1.GetQuoteResponse
 */
export type GetQuoteResponse = Message<"cortado.v1.GetQuoteResponse"> & {
  /**
   * @generated from field: cortado.v1.Quote quote = 1;
   */
  quote?: Quote;
};

/**
 * Describes the message cortado.v1.GetQuoteResponse.
 * Use `create(GetQuoteResponseSchema)` to create a new message.
 */
export const GetQuoteResponseSchema: GenMessage<GetQuoteResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 227);

/**
 * @generated from message cortado.v1.GetQuoteDetailRequest
 */
export type GetQuoteDetailRequest = Message<"cortado.v1.GetQuoteDetailRequest"> & {
  /**
   * Quote ID
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetQuoteDetailRequest.
 * Use `create(GetQuoteDetailRequestSchema)` to create a new message.
 */
export const GetQuoteDetailRequestSchema: GenMessage<GetQuoteDetailRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 228);

/**
 * @generated from message cortado.v1.GetQuoteDetailResponse
 */
export type GetQuoteDetailResponse = Message<"cortado.v1.GetQuoteDetailResponse"> & {
  /**
   * @generated from field: cortado.v1.Quote quote = 1;
   */
  quote?: Quote;

  /**
   * quote.inquiry_id; absent when not set or deleted
   *
   * @generated from field: optional cortado.v1.Inquiry inquiry = 2;
   */
  inquiry?: Inquiry;

  /**
   * quote.contact_id; absent when not set or deleted
   *
   * @generated from field: optional cortado.v1.Contact contact = 3;
   */
  contact?: Contact;

  /**
   * inquiry.booking_id; absent for unconverted inquiries
   *
   * @generated from field: optional cortado.v1.Booking booking = 4;
   */
  booking?: Booking;

  /**
   * The invoice created from this quote, if any
   *
   * @generated from field: optional cortado.v1.InvoiceLite converted_invoice = 5;
   */
  convertedInvoice?: InvoiceLite;
};

/**
 * Describes the message cortado.v1.GetQuoteDetailResponse.
 * Use `create(GetQuoteDetailResponseSchema)` to create a new message.
 */
export const GetQuoteDetailResponseSchema: GenMessage<GetQuoteDetailResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 229);

/**
 * @generated from message cortado.v1.UpdateQuoteRequest
 */
export type UpdateQuoteRequest = Message<"cortado.v1.UpdateQuoteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Metadata fields (can update without new revision)
   *
   * @generated from field: optional string title = 2;
   */
  title?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional cortado.v1.QuoteStatusEnum status = 4;
   */
  status?: QuoteStatusEnum;

  /**
   * Financial fields (trigger new revision when changed)
   *
   * @generated from field: optional google.protobuf.Timestamp valid_until = 8;
   */
  validUntil?: Timestamp;

  /**
   * Discount fields (trigger new revision when changed)
   * Support both saved (ID) and inline (name/type/value)
   *
   * @generated from field: optional string discount_id = 9;
   */
  discountId?: string;

  /**
   * @generated from field: optional string discount_name = 10;
   */
  discountName?: string;

  /**
   * @generated from field: optional cortado.v1.DiscountTypeEnum discount_type = 11;
   */
  discountType?: DiscountTypeEnum;

  /**
   * @generated from field: optional double discount_value = 12;
   */
  discountValue?: number;

  /**
   * Line items (trigger new revision when changed)
   *
   * @generated from field: repeated cortado.v1.QuoteLineItemInput line_items = 13;
   */
  lineItems: QuoteLineItemInput[];

  /**
   * Field mask to specify which fields to update
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 14;
   */
  updateMask?: FieldMask;

  /**
   * Optional reason for creating new revision
   *
   * @generated from field: optional string revision_reason = 15;
   */
  revisionReason?: string;

  /**
   * Enforced tip fields (trigger new revision when changed)
   *
   * @generated from field: optional bool enforced_tip_enabled = 16;
   */
  enforcedTipEnabled?: boolean;

  /**
   * @generated from field: optional double enforced_tip_percentage = 17;
   */
  enforcedTipPercentage?: number;

  /**
   * Event details - LEGACY single event fields (for backward compatibility)
   * Use quote_events for multi-event support (trigger new revision when changed)
   *
   * @generated from field: optional google.protobuf.Timestamp event_date = 18;
   */
  eventDate?: Timestamp;

  /**
   * @generated from field: optional string event_location = 19;
   */
  eventLocation?: string;

  /**
   * @generated from field: optional int32 guest_count = 21;
   */
  guestCount?: number;

  /**
   * in hours
   *
   * @generated from field: optional double event_duration = 22;
   */
  eventDuration?: number;

  /**
   * Payment schedules (trigger new revision when changed)
   *
   * @generated from field: repeated cortado.v1.QuotePaymentScheduleInput payment_schedules = 20;
   */
  paymentSchedules: QuotePaymentScheduleInput[];

  /**
   * Quote events - multi-event support (trigger new revision when changed)
   * If provided, replaces all existing events for this revision
   *
   * @generated from field: repeated cortado.v1.QuoteEventInput quote_events = 25;
   */
  quoteEvents: QuoteEventInput[];

  /**
   * Payment method override for checkout (empty = use org defaults)
   *
   * @generated from field: repeated cortado.v1.StripeCheckoutPaymentMethodEnum checkout_payment_methods = 30;
   */
  checkoutPaymentMethods: StripeCheckoutPaymentMethodEnum[];

  /**
   * Add-on offers available to the customer on this quote (trigger new revision when changed)
   *
   * @generated from field: repeated cortado.v1.QuoteAddonOfferInput addon_offers = 31;
   */
  addonOffers: QuoteAddonOfferInput[];

  /**
   * Metadata field (does NOT trigger a new revision). Only applied when in
   * update_mask.
   *
   * @generated from field: optional bool requires_questionnaire = 32;
   */
  requiresQuestionnaire?: boolean;

  /**
   * Mask path: tip_allocation_mode
   *
   * @generated from field: optional cortado.v1.TipAllocationModeEnum tip_allocation_mode = 33;
   */
  tipAllocationMode?: TipAllocationModeEnum;
};

/**
 * Describes the message cortado.v1.UpdateQuoteRequest.
 * Use `create(UpdateQuoteRequestSchema)` to create a new message.
 */
export const UpdateQuoteRequestSchema: GenMessage<UpdateQuoteRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 230);

/**
 * @generated from message cortado.v1.UpdateQuoteResponse
 */
export type UpdateQuoteResponse = Message<"cortado.v1.UpdateQuoteResponse"> & {
  /**
   * @generated from field: cortado.v1.Quote quote = 1;
   */
  quote?: Quote;
};

/**
 * Describes the message cortado.v1.UpdateQuoteResponse.
 * Use `create(UpdateQuoteResponseSchema)` to create a new message.
 */
export const UpdateQuoteResponseSchema: GenMessage<UpdateQuoteResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 231);

/**
 * @generated from message cortado.v1.DeleteQuoteRequest
 */
export type DeleteQuoteRequest = Message<"cortado.v1.DeleteQuoteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteQuoteRequest.
 * Use `create(DeleteQuoteRequestSchema)` to create a new message.
 */
export const DeleteQuoteRequestSchema: GenMessage<DeleteQuoteRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 232);

/**
 * @generated from message cortado.v1.DeleteQuoteResponse
 */
export type DeleteQuoteResponse = Message<"cortado.v1.DeleteQuoteResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteQuoteResponse.
 * Use `create(DeleteQuoteResponseSchema)` to create a new message.
 */
export const DeleteQuoteResponseSchema: GenMessage<DeleteQuoteResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 233);

/**
 * QuoteEmailOverride is a per-send override of the "Quote Sent" system email.
 * The values are RAW slot SOURCE: they may contain `{{.Var}}` tokens and, for
 * rich-text slots, email-safe HTML. They are never persisted — the org's saved
 * system email template is untouched by a send that carries one.
 *
 * Key presence is authoritative: a slot key present with an empty value CLEARS
 * that slot for this send, whereas an absent key inherits the org (or default)
 * copy. This differs deliberately from the stored org override, where an empty
 * value means "inherit".
 *
 * @generated from message cortado.v1.QuoteEmailOverride
 */
export type QuoteEmailOverride = Message<"cortado.v1.QuoteEmailOverride"> & {
  /**
   * @generated from field: optional string subject = 1;
   */
  subject?: string;

  /**
   * Slot key -> raw source. Valid keys are the "quote_sent" template's slots:
   * greeting | mainMessage | closingMessage | ctaButtonText.
   *
   * @generated from field: map<string, string> text_slots = 2;
   */
  textSlots: { [key: string]: string };
};

/**
 * Describes the message cortado.v1.QuoteEmailOverride.
 * Use `create(QuoteEmailOverrideSchema)` to create a new message.
 */
export const QuoteEmailOverrideSchema: GenMessage<QuoteEmailOverride> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 234);

/**
 * @generated from message cortado.v1.SendQuoteRequest
 */
export type SendQuoteRequest = Message<"cortado.v1.SendQuoteRequest"> & {
  /**
   * Quote ID to send
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Client-generated UUID for this logical send operation. Reuse it when
   * retrying an ambiguous request; generate a new UUID for an intentional resend.
   *
   * @generated from field: optional string idempotency_key = 2;
   */
  idempotencyKey?: string;

  /**
   * Extra addresses that receive the SAME composed email as the primary
   * contact, each with their own attributed portal link. Max 10 total.
   *
   * @generated from field: repeated string additional_recipient_emails = 3;
   */
  additionalRecipientEmails: string[];

  /**
   * Per-send, never-persisted override of the Quote Sent system email.
   *
   * @generated from field: optional cortado.v1.QuoteEmailOverride email_override = 4;
   */
  emailOverride?: QuoteEmailOverride;
};

/**
 * Describes the message cortado.v1.SendQuoteRequest.
 * Use `create(SendQuoteRequestSchema)` to create a new message.
 */
export const SendQuoteRequestSchema: GenMessage<SendQuoteRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 235);

/**
 * @generated from message cortado.v1.QuoteSendRecipientResult
 */
export type QuoteSendRecipientResult = Message<"cortado.v1.QuoteSendRecipientResult"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: bool is_primary = 2;
   */
  isPrimary: boolean;

  /**
   * @generated from field: cortado.v1.QuoteSendRecipientStatusEnum status = 3;
   */
  status: QuoteSendRecipientStatusEnum;
};

/**
 * Describes the message cortado.v1.QuoteSendRecipientResult.
 * Use `create(QuoteSendRecipientResultSchema)` to create a new message.
 */
export const QuoteSendRecipientResultSchema: GenMessage<QuoteSendRecipientResult> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 236);

/**
 * @generated from message cortado.v1.SendQuoteResponse
 */
export type SendQuoteResponse = Message<"cortado.v1.SendQuoteResponse"> & {
  /**
   * Updated quote with SENT status
   *
   * @generated from field: cortado.v1.Quote quote = 1;
   */
  quote?: Quote;

  /**
   * Per-recipient outcome, primary first. A non-SENT status on an additional
   * recipient is a partial success: the primary send succeeded.
   *
   * @generated from field: repeated cortado.v1.QuoteSendRecipientResult recipient_results = 2;
   */
  recipientResults: QuoteSendRecipientResult[];

  /**
   * @generated from field: int32 emails_sent = 3;
   */
  emailsSent: number;
};

/**
 * Describes the message cortado.v1.SendQuoteResponse.
 * Use `create(SendQuoteResponseSchema)` to create a new message.
 */
export const SendQuoteResponseSchema: GenMessage<SendQuoteResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 237);

/**
 * PreviewQuoteSendEmailRequest renders the Quote Sent email for ONE real quote,
 * with an optional per-send override applied. It is quote-scoped (not
 * org-scoped) because the rendered body carries that quote's customer name,
 * event date and total.
 *
 * @generated from message cortado.v1.PreviewQuoteSendEmailRequest
 */
export type PreviewQuoteSendEmailRequest = Message<"cortado.v1.PreviewQuoteSendEmailRequest"> & {
  /**
   * @generated from field: string quote_id = 1;
   */
  quoteId: string;

  /**
   * @generated from field: optional cortado.v1.QuoteEmailOverride email_override = 2;
   */
  emailOverride?: QuoteEmailOverride;
};

/**
 * Describes the message cortado.v1.PreviewQuoteSendEmailRequest.
 * Use `create(PreviewQuoteSendEmailRequestSchema)` to create a new message.
 */
export const PreviewQuoteSendEmailRequestSchema: GenMessage<PreviewQuoteSendEmailRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 238);

/**
 * @generated from message cortado.v1.PreviewQuoteSendEmailResponse
 */
export type PreviewQuoteSendEmailResponse = Message<"cortado.v1.PreviewQuoteSendEmailResponse"> & {
  /**
   * @generated from field: string rendered_subject = 1;
   */
  renderedSubject: string;

  /**
   * @generated from field: string rendered_html = 2;
   */
  renderedHtml: string;
};

/**
 * Describes the message cortado.v1.PreviewQuoteSendEmailResponse.
 * Use `create(PreviewQuoteSendEmailResponseSchema)` to create a new message.
 */
export const PreviewQuoteSendEmailResponseSchema: GenMessage<PreviewQuoteSendEmailResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 239);

/**
 * @generated from message cortado.v1.DuplicateQuoteRequest
 */
export type DuplicateQuoteRequest = Message<"cortado.v1.DuplicateQuoteRequest"> & {
  /**
   * Quote ID to duplicate
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DuplicateQuoteRequest.
 * Use `create(DuplicateQuoteRequestSchema)` to create a new message.
 */
export const DuplicateQuoteRequestSchema: GenMessage<DuplicateQuoteRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 240);

/**
 * @generated from message cortado.v1.DuplicateQuoteResponse
 */
export type DuplicateQuoteResponse = Message<"cortado.v1.DuplicateQuoteResponse"> & {
  /**
   * The newly created duplicate quote
   *
   * @generated from field: cortado.v1.Quote quote = 1;
   */
  quote?: Quote;
};

/**
 * Describes the message cortado.v1.DuplicateQuoteResponse.
 * Use `create(DuplicateQuoteResponseSchema)` to create a new message.
 */
export const DuplicateQuoteResponseSchema: GenMessage<DuplicateQuoteResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 241);

/**
 * @generated from message cortado.v1.ListQuoteItemsRequest
 */
export type ListQuoteItemsRequest = Message<"cortado.v1.ListQuoteItemsRequest"> & {
  /**
   * @generated from field: string quote_id = 1;
   */
  quoteId: string;
};

/**
 * Describes the message cortado.v1.ListQuoteItemsRequest.
 * Use `create(ListQuoteItemsRequestSchema)` to create a new message.
 */
export const ListQuoteItemsRequestSchema: GenMessage<ListQuoteItemsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 242);

/**
 * @generated from message cortado.v1.ListQuoteItemsResponse
 */
export type ListQuoteItemsResponse = Message<"cortado.v1.ListQuoteItemsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.QuoteItem items = 1;
   */
  items: QuoteItem[];
};

/**
 * Describes the message cortado.v1.ListQuoteItemsResponse.
 * Use `create(ListQuoteItemsResponseSchema)` to create a new message.
 */
export const ListQuoteItemsResponseSchema: GenMessage<ListQuoteItemsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 243);

/**
 * @generated from message cortado.v1.CreateQuoteItemRequest
 */
export type CreateQuoteItemRequest = Message<"cortado.v1.CreateQuoteItemRequest"> & {
  /**
   * @generated from field: string quote_id = 1;
   */
  quoteId: string;

  /**
   * @generated from field: optional string item_id = 2;
   */
  itemId?: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: optional string description = 4;
   */
  description?: string;

  /**
   * @generated from field: float price = 5;
   */
  price: number;

  /**
   * @generated from field: cortado.v1.ItemUnitEnum unit = 6;
   */
  unit: ItemUnitEnum;

  /**
   * @generated from field: float amount = 7;
   */
  amount: number;

  /**
   * @generated from field: optional int32 ordering = 8;
   */
  ordering?: number;
};

/**
 * Describes the message cortado.v1.CreateQuoteItemRequest.
 * Use `create(CreateQuoteItemRequestSchema)` to create a new message.
 */
export const CreateQuoteItemRequestSchema: GenMessage<CreateQuoteItemRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 244);

/**
 * @generated from message cortado.v1.CreateQuoteItemResponse
 */
export type CreateQuoteItemResponse = Message<"cortado.v1.CreateQuoteItemResponse"> & {
  /**
   * @generated from field: cortado.v1.QuoteItem quote_item = 1;
   */
  quoteItem?: QuoteItem;
};

/**
 * Describes the message cortado.v1.CreateQuoteItemResponse.
 * Use `create(CreateQuoteItemResponseSchema)` to create a new message.
 */
export const CreateQuoteItemResponseSchema: GenMessage<CreateQuoteItemResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 245);

/**
 * @generated from message cortado.v1.GetQuoteItemRequest
 */
export type GetQuoteItemRequest = Message<"cortado.v1.GetQuoteItemRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetQuoteItemRequest.
 * Use `create(GetQuoteItemRequestSchema)` to create a new message.
 */
export const GetQuoteItemRequestSchema: GenMessage<GetQuoteItemRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 246);

/**
 * @generated from message cortado.v1.GetQuoteItemResponse
 */
export type GetQuoteItemResponse = Message<"cortado.v1.GetQuoteItemResponse"> & {
  /**
   * @generated from field: cortado.v1.QuoteItem quote_item = 1;
   */
  quoteItem?: QuoteItem;
};

/**
 * Describes the message cortado.v1.GetQuoteItemResponse.
 * Use `create(GetQuoteItemResponseSchema)` to create a new message.
 */
export const GetQuoteItemResponseSchema: GenMessage<GetQuoteItemResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 247);

/**
 * @generated from message cortado.v1.UpdateQuoteItemRequest
 */
export type UpdateQuoteItemRequest = Message<"cortado.v1.UpdateQuoteItemRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string title = 2;
   */
  title?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional float price = 4;
   */
  price?: number;

  /**
   * @generated from field: optional cortado.v1.ItemUnitEnum unit = 5;
   */
  unit?: ItemUnitEnum;

  /**
   * @generated from field: optional float amount = 6;
   */
  amount?: number;

  /**
   * @generated from field: optional int32 ordering = 7;
   */
  ordering?: number;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 8;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message cortado.v1.UpdateQuoteItemRequest.
 * Use `create(UpdateQuoteItemRequestSchema)` to create a new message.
 */
export const UpdateQuoteItemRequestSchema: GenMessage<UpdateQuoteItemRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 248);

/**
 * @generated from message cortado.v1.UpdateQuoteItemResponse
 */
export type UpdateQuoteItemResponse = Message<"cortado.v1.UpdateQuoteItemResponse"> & {
  /**
   * @generated from field: cortado.v1.QuoteItem quote_item = 1;
   */
  quoteItem?: QuoteItem;
};

/**
 * Describes the message cortado.v1.UpdateQuoteItemResponse.
 * Use `create(UpdateQuoteItemResponseSchema)` to create a new message.
 */
export const UpdateQuoteItemResponseSchema: GenMessage<UpdateQuoteItemResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 249);

/**
 * @generated from message cortado.v1.DeleteQuoteItemRequest
 */
export type DeleteQuoteItemRequest = Message<"cortado.v1.DeleteQuoteItemRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteQuoteItemRequest.
 * Use `create(DeleteQuoteItemRequestSchema)` to create a new message.
 */
export const DeleteQuoteItemRequestSchema: GenMessage<DeleteQuoteItemRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 250);

/**
 * @generated from message cortado.v1.DeleteQuoteItemResponse
 */
export type DeleteQuoteItemResponse = Message<"cortado.v1.DeleteQuoteItemResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteQuoteItemResponse.
 * Use `create(DeleteQuoteItemResponseSchema)` to create a new message.
 */
export const DeleteQuoteItemResponseSchema: GenMessage<DeleteQuoteItemResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 251);

/**
 * @generated from message cortado.v1.GetQuoteLitesByIdsRequest
 */
export type GetQuoteLitesByIdsRequest = Message<"cortado.v1.GetQuoteLitesByIdsRequest"> & {
  /**
   * Quote IDs to fetch
   *
   * @generated from field: repeated string ids = 1;
   */
  ids: string[];
};

/**
 * Describes the message cortado.v1.GetQuoteLitesByIdsRequest.
 * Use `create(GetQuoteLitesByIdsRequestSchema)` to create a new message.
 */
export const GetQuoteLitesByIdsRequestSchema: GenMessage<GetQuoteLitesByIdsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 252);

/**
 * @generated from message cortado.v1.GetQuoteLitesByIdsResponse
 */
export type GetQuoteLitesByIdsResponse = Message<"cortado.v1.GetQuoteLitesByIdsResponse"> & {
  /**
   * Lightweight quotes (only those found, filtered by RBAC)
   *
   * @generated from field: repeated cortado.v1.QuoteLite quotes = 1;
   */
  quotes: QuoteLite[];
};

/**
 * Describes the message cortado.v1.GetQuoteLitesByIdsResponse.
 * Use `create(GetQuoteLitesByIdsResponseSchema)` to create a new message.
 */
export const GetQuoteLitesByIdsResponseSchema: GenMessage<GetQuoteLitesByIdsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 253);

/**
 * @generated from message cortado.v1.ListInvoicesRequest
 */
export type ListInvoicesRequest = Message<"cortado.v1.ListInvoicesRequest"> & {
  /**
   * Organization ID to get invoices for (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Optional filter by booking ID
   *
   * @generated from field: optional string booking_id = 2;
   */
  bookingId?: string;

  /**
   * Optional filter by contact ID
   *
   * @generated from field: optional string contact_id = 3;
   */
  contactId?: string;

  /**
   * Optional filter by invoice statuses
   *
   * @generated from field: repeated cortado.v1.InvoiceStatusEnum statuses = 4;
   */
  statuses: InvoiceStatusEnum[];

  /**
   * Optional filter by created date (invoices created since this date)
   *
   * @generated from field: optional google.protobuf.Timestamp since = 5;
   */
  since?: Timestamp;

  /**
   * Optional limit on number of invoices to return (default: 50)
   *
   * @generated from field: optional int32 limit = 6;
   */
  limit?: number;

  /**
   * Optional offset for pagination (default: 0)
   *
   * @generated from field: optional int32 offset = 7;
   */
  offset?: number;

  /**
   * Optional case-insensitive substring filter over invoice title
   *
   * @generated from field: optional string title_filter = 8;
   */
  titleFilter?: string;
};

/**
 * Describes the message cortado.v1.ListInvoicesRequest.
 * Use `create(ListInvoicesRequestSchema)` to create a new message.
 */
export const ListInvoicesRequestSchema: GenMessage<ListInvoicesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 254);

/**
 * @generated from message cortado.v1.ListInvoicesResponse
 */
export type ListInvoicesResponse = Message<"cortado.v1.ListInvoicesResponse"> & {
  /**
   * Lightweight invoices optimized for list views
   *
   * @generated from field: repeated cortado.v1.InvoiceLite invoices = 1;
   */
  invoices: InvoiceLite[];

  /**
   * Total count of matching invoices (for pagination)
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListInvoicesResponse.
 * Use `create(ListInvoicesResponseSchema)` to create a new message.
 */
export const ListInvoicesResponseSchema: GenMessage<ListInvoicesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 255);

/**
 * @generated from message cortado.v1.GetInvoiceStatsRequest
 */
export type GetInvoiceStatsRequest = Message<"cortado.v1.GetInvoiceStatsRequest"> & {
  /**
   * Organization ID to get invoice stats for (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.GetInvoiceStatsRequest.
 * Use `create(GetInvoiceStatsRequestSchema)` to create a new message.
 */
export const GetInvoiceStatsRequestSchema: GenMessage<GetInvoiceStatsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 256);

/**
 * GetInvoiceStatsResponse aggregates match the invoices list page stat cards.
 * Buckets (totals are invoice total_cents sums):
 *   open      = Draft, Sent, Viewed, PaymentPending, PartiallyPaid, and any unknown status
 *   overdue   = Overdue
 *   paid      = Paid, Overpaid
 *   cancelled = Cancelled
 *
 * @generated from message cortado.v1.GetInvoiceStatsResponse
 */
export type GetInvoiceStatsResponse = Message<"cortado.v1.GetInvoiceStatsResponse"> & {
  /**
   * @generated from field: int64 open_total_cents = 20;
   */
  openTotalCents: bigint;

  /**
   * @generated from field: int32 open_count = 21;
   */
  openCount: number;

  /**
   * @generated from field: int64 overdue_total_cents = 22;
   */
  overdueTotalCents: bigint;

  /**
   * @generated from field: int32 overdue_count = 23;
   */
  overdueCount: number;

  /**
   * @generated from field: int64 paid_total_cents = 24;
   */
  paidTotalCents: bigint;

  /**
   * @generated from field: int32 paid_count = 25;
   */
  paidCount: number;

  /**
   * @generated from field: int64 cancelled_total_cents = 26;
   */
  cancelledTotalCents: bigint;

  /**
   * @generated from field: int32 cancelled_count = 27;
   */
  cancelledCount: number;
};

/**
 * Describes the message cortado.v1.GetInvoiceStatsResponse.
 * Use `create(GetInvoiceStatsResponseSchema)` to create a new message.
 */
export const GetInvoiceStatsResponseSchema: GenMessage<GetInvoiceStatsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 257);

/**
 * CreateInvoiceRequest supports two modes:
 * 1. Quote-based invoice: Provide quote_id and accepted_quote_revision_id
 *    - Invoice copies from accepted quote revision
 *    - All financial fields are optional (default to quote values)
 *    - line_items are optional (default to quote line items)
 * 2. Standalone invoice: Omit quote_id and accepted_quote_revision_id
 *    - Must provide: title, issue_date, line_items (at least one)
 *    - All other financial fields are optional
 *
 * @generated from message cortado.v1.CreateInvoiceRequest
 */
export type CreateInvoiceRequest = Message<"cortado.v1.CreateInvoiceRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string booking_id = 2;
   */
  bookingId: string;

  /**
   * Optional - omit for standalone invoices
   *
   * @generated from field: optional string quote_id = 3;
   */
  quoteId?: string;

  /**
   * Optional - omit for standalone invoices
   *
   * @generated from field: optional string accepted_quote_revision_id = 4;
   */
  acceptedQuoteRevisionId?: string;

  /**
   * @generated from field: string contact_id = 5;
   */
  contactId: string;

  /**
   * Line items: Optional for quote-based invoices (copies from quote), Required for standalone invoices
   *
   * @generated from field: repeated cortado.v1.QuoteLineItemInput line_items = 6;
   */
  lineItems: QuoteLineItemInput[];

  /**
   * Optional payment schedules to create immediately
   *
   * @generated from field: repeated cortado.v1.CreatePaymentScheduleInput payment_schedules = 7;
   */
  paymentSchedules: CreatePaymentScheduleInput[];

  /**
   * Financial fields: Optional for quote-based (defaults to quote), title and issue_date required for standalone
   *
   * @generated from field: optional string title = 8;
   */
  title?: string;

  /**
   * @generated from field: optional string description = 9;
   */
  description?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp issue_date = 10;
   */
  issueDate?: Timestamp;

  /**
   * Discount override fields
   *
   * @generated from field: optional string discount_id = 13;
   */
  discountId?: string;

  /**
   * @generated from field: optional string discount_name = 14;
   */
  discountName?: string;

  /**
   * @generated from field: optional cortado.v1.DiscountTypeEnum discount_type = 15;
   */
  discountType?: DiscountTypeEnum;

  /**
   * @generated from field: optional double discount_value = 16;
   */
  discountValue?: number;

  /**
   * Enforced tip override fields
   *
   * @generated from field: optional bool enforced_tip_enabled = 17;
   */
  enforcedTipEnabled?: boolean;

  /**
   * @generated from field: optional double enforced_tip_percentage = 18;
   */
  enforcedTipPercentage?: number;

  /**
   * Tip amount in cents for standalone invoices
   *
   * @generated from field: optional int64 tip_cents = 19;
   */
  tipCents?: bigint;

  /**
   * Payment method override for this invoice (empty = use org defaults)
   *
   * @generated from field: repeated cortado.v1.StripeCheckoutPaymentMethodEnum checkout_payment_methods = 20;
   */
  checkoutPaymentMethods: StripeCheckoutPaymentMethodEnum[];

  /**
   * Unset: quote value, else org default
   *
   * @generated from field: optional cortado.v1.TipAllocationModeEnum tip_allocation_mode = 21;
   */
  tipAllocationMode?: TipAllocationModeEnum;
};

/**
 * Describes the message cortado.v1.CreateInvoiceRequest.
 * Use `create(CreateInvoiceRequestSchema)` to create a new message.
 */
export const CreateInvoiceRequestSchema: GenMessage<CreateInvoiceRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 258);

/**
 * @generated from message cortado.v1.CreateInvoiceResponse
 */
export type CreateInvoiceResponse = Message<"cortado.v1.CreateInvoiceResponse"> & {
  /**
   * @generated from field: cortado.v1.Invoice invoice = 1;
   */
  invoice?: Invoice;
};

/**
 * Describes the message cortado.v1.CreateInvoiceResponse.
 * Use `create(CreateInvoiceResponseSchema)` to create a new message.
 */
export const CreateInvoiceResponseSchema: GenMessage<CreateInvoiceResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 259);

/**
 * @generated from message cortado.v1.GetInvoiceRequest
 */
export type GetInvoiceRequest = Message<"cortado.v1.GetInvoiceRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetInvoiceRequest.
 * Use `create(GetInvoiceRequestSchema)` to create a new message.
 */
export const GetInvoiceRequestSchema: GenMessage<GetInvoiceRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 260);

/**
 * @generated from message cortado.v1.GetInvoiceResponse
 */
export type GetInvoiceResponse = Message<"cortado.v1.GetInvoiceResponse"> & {
  /**
   * @generated from field: cortado.v1.Invoice invoice = 1;
   */
  invoice?: Invoice;
};

/**
 * Describes the message cortado.v1.GetInvoiceResponse.
 * Use `create(GetInvoiceResponseSchema)` to create a new message.
 */
export const GetInvoiceResponseSchema: GenMessage<GetInvoiceResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 261);

/**
 * @generated from message cortado.v1.GetInvoiceDetailRequest
 */
export type GetInvoiceDetailRequest = Message<"cortado.v1.GetInvoiceDetailRequest"> & {
  /**
   * Invoice ID
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetInvoiceDetailRequest.
 * Use `create(GetInvoiceDetailRequestSchema)` to create a new message.
 */
export const GetInvoiceDetailRequestSchema: GenMessage<GetInvoiceDetailRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 262);

/**
 * @generated from message cortado.v1.GetInvoiceDetailResponse
 */
export type GetInvoiceDetailResponse = Message<"cortado.v1.GetInvoiceDetailResponse"> & {
  /**
   * @generated from field: cortado.v1.Invoice invoice = 1;
   */
  invoice?: Invoice;

  /**
   * invoice.contact_id; absent when not set or deleted
   *
   * @generated from field: optional cortado.v1.Contact contact = 2;
   */
  contact?: Contact;

  /**
   * invoice.booking_id; absent for standalone invoices
   *
   * @generated from field: optional cortado.v1.Booking booking = 3;
   */
  booking?: Booking;
};

/**
 * Describes the message cortado.v1.GetInvoiceDetailResponse.
 * Use `create(GetInvoiceDetailResponseSchema)` to create a new message.
 */
export const GetInvoiceDetailResponseSchema: GenMessage<GetInvoiceDetailResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 263);

/**
 * @generated from message cortado.v1.UpdateInvoiceRequest
 */
export type UpdateInvoiceRequest = Message<"cortado.v1.UpdateInvoiceRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string title = 2;
   */
  title?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional int64 tip_cents = 4;
   */
  tipCents?: bigint;

  /**
   * Line item modifications (creates new revision)
   *
   * @generated from field: repeated cortado.v1.QuoteLineItemInput line_items = 5;
   */
  lineItems: QuoteLineItemInput[];

  /**
   * @generated from field: optional string revision_reason = 6;
   */
  revisionReason?: string;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 7;
   */
  updateMask?: FieldMask;

  /**
   * Discount fields (creates new revision if changed)
   *
   * UUID of saved discount to apply
   *
   * @generated from field: optional string discount_id = 8;
   */
  discountId?: string;

  /**
   * Name for inline discount
   *
   * @generated from field: optional string discount_name = 9;
   */
  discountName?: string;

  /**
   * Type for inline discount
   *
   * @generated from field: optional cortado.v1.DiscountTypeEnum discount_type = 10;
   */
  discountType?: DiscountTypeEnum;

  /**
   * Value for inline discount
   *
   * @generated from field: optional double discount_value = 11;
   */
  discountValue?: number;

  /**
   * Enforced tip fields (creates new revision if changed)
   *
   * Enable/disable enforced tipping
   *
   * @generated from field: optional bool enforced_tip_enabled = 12;
   */
  enforcedTipEnabled?: boolean;

  /**
   * Enforced tip percentage
   *
   * @generated from field: optional double enforced_tip_percentage = 13;
   */
  enforcedTipPercentage?: number;

  /**
   * Metadata-only status update
   *
   * @generated from field: optional cortado.v1.InvoiceStatusEnum status = 14;
   */
  status?: InvoiceStatusEnum;

  /**
   * Payment method override for this invoice (empty = use org defaults)
   *
   * @generated from field: repeated cortado.v1.StripeCheckoutPaymentMethodEnum checkout_payment_methods = 15;
   */
  checkoutPaymentMethods: StripeCheckoutPaymentMethodEnum[];

  /**
   * Controls how invoice total deltas are applied to editable payment schedules.
   *
   * @generated from field: cortado.v1.InvoicePaymentScheduleAdjustmentStrategyEnum payment_schedule_adjustment_strategy = 16;
   */
  paymentScheduleAdjustmentStrategy: InvoicePaymentScheduleAdjustmentStrategyEnum;

  /**
   * Mask path: tip_allocation_mode
   *
   * @generated from field: optional cortado.v1.TipAllocationModeEnum tip_allocation_mode = 17;
   */
  tipAllocationMode?: TipAllocationModeEnum;
};

/**
 * Describes the message cortado.v1.UpdateInvoiceRequest.
 * Use `create(UpdateInvoiceRequestSchema)` to create a new message.
 */
export const UpdateInvoiceRequestSchema: GenMessage<UpdateInvoiceRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 264);

/**
 * @generated from message cortado.v1.UpdateInvoiceResponse
 */
export type UpdateInvoiceResponse = Message<"cortado.v1.UpdateInvoiceResponse"> & {
  /**
   * @generated from field: cortado.v1.Invoice invoice = 1;
   */
  invoice?: Invoice;
};

/**
 * Describes the message cortado.v1.UpdateInvoiceResponse.
 * Use `create(UpdateInvoiceResponseSchema)` to create a new message.
 */
export const UpdateInvoiceResponseSchema: GenMessage<UpdateInvoiceResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 265);

/**
 * @generated from message cortado.v1.DeleteInvoiceRequest
 */
export type DeleteInvoiceRequest = Message<"cortado.v1.DeleteInvoiceRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteInvoiceRequest.
 * Use `create(DeleteInvoiceRequestSchema)` to create a new message.
 */
export const DeleteInvoiceRequestSchema: GenMessage<DeleteInvoiceRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 266);

/**
 * @generated from message cortado.v1.DeleteInvoiceResponse
 */
export type DeleteInvoiceResponse = Message<"cortado.v1.DeleteInvoiceResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteInvoiceResponse.
 * Use `create(DeleteInvoiceResponseSchema)` to create a new message.
 */
export const DeleteInvoiceResponseSchema: GenMessage<DeleteInvoiceResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 267);

/**
 * @generated from message cortado.v1.GetInvoiceLitesByIdsRequest
 */
export type GetInvoiceLitesByIdsRequest = Message<"cortado.v1.GetInvoiceLitesByIdsRequest"> & {
  /**
   * Invoice IDs to fetch
   *
   * @generated from field: repeated string ids = 1;
   */
  ids: string[];
};

/**
 * Describes the message cortado.v1.GetInvoiceLitesByIdsRequest.
 * Use `create(GetInvoiceLitesByIdsRequestSchema)` to create a new message.
 */
export const GetInvoiceLitesByIdsRequestSchema: GenMessage<GetInvoiceLitesByIdsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 268);

/**
 * @generated from message cortado.v1.GetInvoiceLitesByIdsResponse
 */
export type GetInvoiceLitesByIdsResponse = Message<"cortado.v1.GetInvoiceLitesByIdsResponse"> & {
  /**
   * Lightweight invoices (only those found, filtered by RBAC)
   *
   * @generated from field: repeated cortado.v1.InvoiceLite invoices = 1;
   */
  invoices: InvoiceLite[];
};

/**
 * Describes the message cortado.v1.GetInvoiceLitesByIdsResponse.
 * Use `create(GetInvoiceLitesByIdsResponseSchema)` to create a new message.
 */
export const GetInvoiceLitesByIdsResponseSchema: GenMessage<GetInvoiceLitesByIdsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 269);

/**
 * @generated from message cortado.v1.CreatePaymentScheduleRequest
 */
export type CreatePaymentScheduleRequest = Message<"cortado.v1.CreatePaymentScheduleRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * @generated from field: int32 sequence_number = 2;
   */
  sequenceNumber: number;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 4;
   */
  dueDate?: Timestamp;

  /**
   * @generated from field: int64 amount_cents = 5;
   */
  amountCents: bigint;
};

/**
 * Describes the message cortado.v1.CreatePaymentScheduleRequest.
 * Use `create(CreatePaymentScheduleRequestSchema)` to create a new message.
 */
export const CreatePaymentScheduleRequestSchema: GenMessage<CreatePaymentScheduleRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 270);

/**
 * @generated from message cortado.v1.CreatePaymentScheduleResponse
 */
export type CreatePaymentScheduleResponse = Message<"cortado.v1.CreatePaymentScheduleResponse"> & {
  /**
   * @generated from field: cortado.v1.PaymentSchedule payment_schedule = 1;
   */
  paymentSchedule?: PaymentSchedule;
};

/**
 * Describes the message cortado.v1.CreatePaymentScheduleResponse.
 * Use `create(CreatePaymentScheduleResponseSchema)` to create a new message.
 */
export const CreatePaymentScheduleResponseSchema: GenMessage<CreatePaymentScheduleResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 271);

/**
 * @generated from message cortado.v1.UpdatePaymentScheduleRequest
 */
export type UpdatePaymentScheduleRequest = Message<"cortado.v1.UpdatePaymentScheduleRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string description = 2;
   */
  description?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp due_date = 3;
   */
  dueDate?: Timestamp;

  /**
   * @generated from field: optional int64 amount_cents = 4;
   */
  amountCents?: bigint;

  /**
   * @generated from field: optional cortado.v1.PaymentScheduleStatusEnum status = 5;
   */
  status?: PaymentScheduleStatusEnum;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 6;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message cortado.v1.UpdatePaymentScheduleRequest.
 * Use `create(UpdatePaymentScheduleRequestSchema)` to create a new message.
 */
export const UpdatePaymentScheduleRequestSchema: GenMessage<UpdatePaymentScheduleRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 272);

/**
 * @generated from message cortado.v1.UpdatePaymentScheduleResponse
 */
export type UpdatePaymentScheduleResponse = Message<"cortado.v1.UpdatePaymentScheduleResponse"> & {
  /**
   * @generated from field: cortado.v1.PaymentSchedule payment_schedule = 1;
   */
  paymentSchedule?: PaymentSchedule;
};

/**
 * Describes the message cortado.v1.UpdatePaymentScheduleResponse.
 * Use `create(UpdatePaymentScheduleResponseSchema)` to create a new message.
 */
export const UpdatePaymentScheduleResponseSchema: GenMessage<UpdatePaymentScheduleResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 273);

/**
 * @generated from message cortado.v1.DeletePaymentScheduleRequest
 */
export type DeletePaymentScheduleRequest = Message<"cortado.v1.DeletePaymentScheduleRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeletePaymentScheduleRequest.
 * Use `create(DeletePaymentScheduleRequestSchema)` to create a new message.
 */
export const DeletePaymentScheduleRequestSchema: GenMessage<DeletePaymentScheduleRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 274);

/**
 * @generated from message cortado.v1.DeletePaymentScheduleResponse
 */
export type DeletePaymentScheduleResponse = Message<"cortado.v1.DeletePaymentScheduleResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeletePaymentScheduleResponse.
 * Use `create(DeletePaymentScheduleResponseSchema)` to create a new message.
 */
export const DeletePaymentScheduleResponseSchema: GenMessage<DeletePaymentScheduleResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 275);

/**
 * PaymentScheduleInput is one element of a full schedule-set replacement.
 * No id — ReplacePaymentSchedules atomically deletes old rows and inserts
 * new ones, so ids are not preserved.
 *
 * @generated from message cortado.v1.PaymentScheduleInput
 */
export type PaymentScheduleInput = Message<"cortado.v1.PaymentScheduleInput"> & {
  /**
   * @generated from field: int32 sequence_number = 1;
   */
  sequenceNumber: number;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 3;
   */
  dueDate?: Timestamp;

  /**
   * @generated from field: int64 amount_cents = 4;
   */
  amountCents: bigint;
};

/**
 * Describes the message cortado.v1.PaymentScheduleInput.
 * Use `create(PaymentScheduleInputSchema)` to create a new message.
 */
export const PaymentScheduleInputSchema: GenMessage<PaymentScheduleInput> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 276);

/**
 * @generated from message cortado.v1.ReplacePaymentSchedulesRequest
 */
export type ReplacePaymentSchedulesRequest = Message<"cortado.v1.ReplacePaymentSchedulesRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * @generated from field: repeated cortado.v1.PaymentScheduleInput schedules = 2;
   */
  schedules: PaymentScheduleInput[];
};

/**
 * Describes the message cortado.v1.ReplacePaymentSchedulesRequest.
 * Use `create(ReplacePaymentSchedulesRequestSchema)` to create a new message.
 */
export const ReplacePaymentSchedulesRequestSchema: GenMessage<ReplacePaymentSchedulesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 277);

/**
 * @generated from message cortado.v1.ReplacePaymentSchedulesResponse
 */
export type ReplacePaymentSchedulesResponse = Message<"cortado.v1.ReplacePaymentSchedulesResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.PaymentSchedule payment_schedules = 1;
   */
  paymentSchedules: PaymentSchedule[];
};

/**
 * Describes the message cortado.v1.ReplacePaymentSchedulesResponse.
 * Use `create(ReplacePaymentSchedulesResponseSchema)` to create a new message.
 */
export const ReplacePaymentSchedulesResponseSchema: GenMessage<ReplacePaymentSchedulesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 278);

/**
 * @generated from message cortado.v1.CreatePaymentIntentRequest
 */
export type CreatePaymentIntentRequest = Message<"cortado.v1.CreatePaymentIntentRequest"> & {
  /**
   * @generated from field: string payment_schedule_id = 1;
   */
  paymentScheduleId: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents: bigint;
};

/**
 * Describes the message cortado.v1.CreatePaymentIntentRequest.
 * Use `create(CreatePaymentIntentRequestSchema)` to create a new message.
 */
export const CreatePaymentIntentRequestSchema: GenMessage<CreatePaymentIntentRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 279);

/**
 * @generated from message cortado.v1.CreatePaymentIntentResponse
 */
export type CreatePaymentIntentResponse = Message<"cortado.v1.CreatePaymentIntentResponse"> & {
  /**
   * @generated from field: cortado.v1.PaymentIntent payment_intent = 1;
   */
  paymentIntent?: PaymentIntent;
};

/**
 * Describes the message cortado.v1.CreatePaymentIntentResponse.
 * Use `create(CreatePaymentIntentResponseSchema)` to create a new message.
 */
export const CreatePaymentIntentResponseSchema: GenMessage<CreatePaymentIntentResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 280);

/**
 * @generated from message cortado.v1.GetPaymentIntentRequest
 */
export type GetPaymentIntentRequest = Message<"cortado.v1.GetPaymentIntentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetPaymentIntentRequest.
 * Use `create(GetPaymentIntentRequestSchema)` to create a new message.
 */
export const GetPaymentIntentRequestSchema: GenMessage<GetPaymentIntentRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 281);

/**
 * @generated from message cortado.v1.GetPaymentIntentResponse
 */
export type GetPaymentIntentResponse = Message<"cortado.v1.GetPaymentIntentResponse"> & {
  /**
   * @generated from field: cortado.v1.PaymentIntent payment_intent = 1;
   */
  paymentIntent?: PaymentIntent;
};

/**
 * Describes the message cortado.v1.GetPaymentIntentResponse.
 * Use `create(GetPaymentIntentResponseSchema)` to create a new message.
 */
export const GetPaymentIntentResponseSchema: GenMessage<GetPaymentIntentResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 282);

/**
 * @generated from message cortado.v1.UpdatePaymentIntentFromWebhookRequest
 */
export type UpdatePaymentIntentFromWebhookRequest = Message<"cortado.v1.UpdatePaymentIntentFromWebhookRequest"> & {
  /**
   * @generated from field: string stripe_payment_intent_id = 1;
   */
  stripePaymentIntentId: string;

  /**
   * @generated from field: string webhook_payload = 2;
   */
  webhookPayload: string;
};

/**
 * Describes the message cortado.v1.UpdatePaymentIntentFromWebhookRequest.
 * Use `create(UpdatePaymentIntentFromWebhookRequestSchema)` to create a new message.
 */
export const UpdatePaymentIntentFromWebhookRequestSchema: GenMessage<UpdatePaymentIntentFromWebhookRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 283);

/**
 * @generated from message cortado.v1.UpdatePaymentIntentFromWebhookResponse
 */
export type UpdatePaymentIntentFromWebhookResponse = Message<"cortado.v1.UpdatePaymentIntentFromWebhookResponse"> & {
  /**
   * @generated from field: cortado.v1.PaymentIntent payment_intent = 1;
   */
  paymentIntent?: PaymentIntent;
};

/**
 * Describes the message cortado.v1.UpdatePaymentIntentFromWebhookResponse.
 * Use `create(UpdatePaymentIntentFromWebhookResponseSchema)` to create a new message.
 */
export const UpdatePaymentIntentFromWebhookResponseSchema: GenMessage<UpdatePaymentIntentFromWebhookResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 284);

/**
 * @generated from message cortado.v1.ListStripePaymentsRequest
 */
export type ListStripePaymentsRequest = Message<"cortado.v1.ListStripePaymentsRequest"> & {
  /**
   * Organization ID (required for permission check)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Filter by checkout session ID
   *
   * @generated from field: optional string checkout_session_id = 2;
   */
  checkoutSessionId?: string;

  /**
   * Filter by invoice ID (returns payments for all checkout sessions on the invoice)
   *
   * @generated from field: optional string invoice_id = 3;
   */
  invoiceId?: string;

  /**
   * Filter by status
   *
   * @generated from field: repeated cortado.v1.StripePaymentStatusEnum statuses = 4;
   */
  statuses: StripePaymentStatusEnum[];

  /**
   * Filter by risk level (for fraud monitoring)
   *
   * @generated from field: repeated cortado.v1.PaymentRiskLevelEnum risk_levels = 5;
   */
  riskLevels: PaymentRiskLevelEnum[];

  /**
   * Pagination
   *
   * @generated from field: optional int32 limit = 10;
   */
  limit?: number;

  /**
   * @generated from field: optional int32 offset = 11;
   */
  offset?: number;
};

/**
 * Describes the message cortado.v1.ListStripePaymentsRequest.
 * Use `create(ListStripePaymentsRequestSchema)` to create a new message.
 */
export const ListStripePaymentsRequestSchema: GenMessage<ListStripePaymentsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 285);

/**
 * @generated from message cortado.v1.ListStripePaymentsResponse
 */
export type ListStripePaymentsResponse = Message<"cortado.v1.ListStripePaymentsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.StripePayment payments = 1;
   */
  payments: StripePayment[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListStripePaymentsResponse.
 * Use `create(ListStripePaymentsResponseSchema)` to create a new message.
 */
export const ListStripePaymentsResponseSchema: GenMessage<ListStripePaymentsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 286);

/**
 * @generated from message cortado.v1.GetStripePaymentRequest
 */
export type GetStripePaymentRequest = Message<"cortado.v1.GetStripePaymentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetStripePaymentRequest.
 * Use `create(GetStripePaymentRequestSchema)` to create a new message.
 */
export const GetStripePaymentRequestSchema: GenMessage<GetStripePaymentRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 287);

/**
 * @generated from message cortado.v1.GetStripePaymentResponse
 */
export type GetStripePaymentResponse = Message<"cortado.v1.GetStripePaymentResponse"> & {
  /**
   * @generated from field: cortado.v1.StripePayment payment = 1;
   */
  payment?: StripePayment;
};

/**
 * Describes the message cortado.v1.GetStripePaymentResponse.
 * Use `create(GetStripePaymentResponseSchema)` to create a new message.
 */
export const GetStripePaymentResponseSchema: GenMessage<GetStripePaymentResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 288);

/**
 * @generated from message cortado.v1.CreatePaymentScheduleInput
 */
export type CreatePaymentScheduleInput = Message<"cortado.v1.CreatePaymentScheduleInput"> & {
  /**
   * @generated from field: int32 sequence_number = 1;
   */
  sequenceNumber: number;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 3;
   */
  dueDate?: Timestamp;

  /**
   * @generated from field: int64 amount_cents = 4;
   */
  amountCents: bigint;
};

/**
 * Describes the message cortado.v1.CreatePaymentScheduleInput.
 * Use `create(CreatePaymentScheduleInputSchema)` to create a new message.
 */
export const CreatePaymentScheduleInputSchema: GenMessage<CreatePaymentScheduleInput> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 289);

/**
 * @generated from message cortado.v1.CreateNoteRequest
 */
export type CreateNoteRequest = Message<"cortado.v1.CreateNoteRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: cortado.v1.ParentTypeEnum parent_type = 2;
   */
  parentType: ParentTypeEnum;

  /**
   * @generated from field: string parent_id = 3;
   */
  parentId: string;

  /**
   * @generated from field: string note = 4;
   */
  note: string;

  /**
   * @generated from field: repeated string mentioned_user_ids = 5;
   */
  mentionedUserIds: string[];
};

/**
 * Describes the message cortado.v1.CreateNoteRequest.
 * Use `create(CreateNoteRequestSchema)` to create a new message.
 */
export const CreateNoteRequestSchema: GenMessage<CreateNoteRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 290);

/**
 * @generated from message cortado.v1.CreateNoteResponse
 */
export type CreateNoteResponse = Message<"cortado.v1.CreateNoteResponse"> & {
  /**
   * @generated from field: cortado.v1.Note note = 1;
   */
  note?: Note;
};

/**
 * Describes the message cortado.v1.CreateNoteResponse.
 * Use `create(CreateNoteResponseSchema)` to create a new message.
 */
export const CreateNoteResponseSchema: GenMessage<CreateNoteResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 291);

/**
 * @generated from message cortado.v1.GetNoteRequest
 */
export type GetNoteRequest = Message<"cortado.v1.GetNoteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetNoteRequest.
 * Use `create(GetNoteRequestSchema)` to create a new message.
 */
export const GetNoteRequestSchema: GenMessage<GetNoteRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 292);

/**
 * @generated from message cortado.v1.GetNoteResponse
 */
export type GetNoteResponse = Message<"cortado.v1.GetNoteResponse"> & {
  /**
   * @generated from field: cortado.v1.Note note = 1;
   */
  note?: Note;
};

/**
 * Describes the message cortado.v1.GetNoteResponse.
 * Use `create(GetNoteResponseSchema)` to create a new message.
 */
export const GetNoteResponseSchema: GenMessage<GetNoteResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 293);

/**
 * @generated from message cortado.v1.UpdateNoteRequest
 */
export type UpdateNoteRequest = Message<"cortado.v1.UpdateNoteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string note = 2;
   */
  note?: string;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask;

  /**
   * @generated from field: repeated string mentioned_user_ids = 4;
   */
  mentionedUserIds: string[];
};

/**
 * Describes the message cortado.v1.UpdateNoteRequest.
 * Use `create(UpdateNoteRequestSchema)` to create a new message.
 */
export const UpdateNoteRequestSchema: GenMessage<UpdateNoteRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 294);

/**
 * @generated from message cortado.v1.UpdateNoteResponse
 */
export type UpdateNoteResponse = Message<"cortado.v1.UpdateNoteResponse"> & {
  /**
   * @generated from field: cortado.v1.Note note = 1;
   */
  note?: Note;
};

/**
 * Describes the message cortado.v1.UpdateNoteResponse.
 * Use `create(UpdateNoteResponseSchema)` to create a new message.
 */
export const UpdateNoteResponseSchema: GenMessage<UpdateNoteResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 295);

/**
 * @generated from message cortado.v1.DeleteNoteRequest
 */
export type DeleteNoteRequest = Message<"cortado.v1.DeleteNoteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteNoteRequest.
 * Use `create(DeleteNoteRequestSchema)` to create a new message.
 */
export const DeleteNoteRequestSchema: GenMessage<DeleteNoteRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 296);

/**
 * @generated from message cortado.v1.DeleteNoteResponse
 */
export type DeleteNoteResponse = Message<"cortado.v1.DeleteNoteResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteNoteResponse.
 * Use `create(DeleteNoteResponseSchema)` to create a new message.
 */
export const DeleteNoteResponseSchema: GenMessage<DeleteNoteResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 297);

/**
 * @generated from message cortado.v1.ListNotesRequest
 */
export type ListNotesRequest = Message<"cortado.v1.ListNotesRequest"> & {
  /**
   * Organization ID to get notes for (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Optional filter by parent type
   *
   * @generated from field: optional cortado.v1.ParentTypeEnum parent_type = 2;
   */
  parentType?: ParentTypeEnum;

  /**
   * Optional filter by parent ID
   *
   * @generated from field: optional string parent_id = 3;
   */
  parentId?: string;

  /**
   * Optional filter by created date (notes created since this date)
   *
   * @generated from field: optional google.protobuf.Timestamp since = 4;
   */
  since?: Timestamp;

  /**
   * Optional limit on number of notes to return (default: 50)
   *
   * @generated from field: optional int32 limit = 5;
   */
  limit?: number;

  /**
   * Optional offset for pagination (default: 0)
   *
   * @generated from field: optional int32 offset = 6;
   */
  offset?: number;

  /**
   * Optional filter by created date upper bound (notes created before this date, exclusive)
   *
   * @generated from field: optional google.protobuf.Timestamp before = 7;
   */
  before?: Timestamp;

  /**
   * @generated from field: optional string job_id = 8;
   */
  jobId?: string;
};

/**
 * Describes the message cortado.v1.ListNotesRequest.
 * Use `create(ListNotesRequestSchema)` to create a new message.
 */
export const ListNotesRequestSchema: GenMessage<ListNotesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 298);

/**
 * @generated from message cortado.v1.ListNotesResponse
 */
export type ListNotesResponse = Message<"cortado.v1.ListNotesResponse"> & {
  /**
   * Notes with full user enrichment
   *
   * @generated from field: repeated cortado.v1.Note notes = 1;
   */
  notes: Note[];

  /**
   * Total count of matching notes (for pagination)
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListNotesResponse.
 * Use `create(ListNotesResponseSchema)` to create a new message.
 */
export const ListNotesResponseSchema: GenMessage<ListNotesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 299);

/**
 * @generated from message cortado.v1.ListTasksRequest
 */
export type ListTasksRequest = Message<"cortado.v1.ListTasksRequest"> & {
  /**
   * Organization ID to get tasks for (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Optional filter by parent type
   *
   * @generated from field: optional cortado.v1.ParentTypeEnum parent_type = 2;
   */
  parentType?: ParentTypeEnum;

  /**
   * Optional filter by parent ID
   *
   * @generated from field: optional string parent_id = 3;
   */
  parentId?: string;

  /**
   * Optional filter by assigned user
   *
   * @generated from field: optional string assigned_to = 4;
   */
  assignedTo?: string;

  /**
   * Optional filter by task statuses
   *
   * @generated from field: repeated cortado.v1.TaskStatusEnum statuses = 5;
   */
  statuses: TaskStatusEnum[];

  /**
   * Optional filter by due date start (tasks due on or after this date)
   *
   * @generated from field: optional google.protobuf.Timestamp due_date_start = 6;
   */
  dueDateStart?: Timestamp;

  /**
   * Optional filter by due date end (tasks due on or before this date)
   *
   * @generated from field: optional google.protobuf.Timestamp due_date_end = 7;
   */
  dueDateEnd?: Timestamp;

  /**
   * Optional filter by created date (tasks created since this date)
   *
   * @generated from field: optional google.protobuf.Timestamp since = 8;
   */
  since?: Timestamp;

  /**
   * Optional limit on number of tasks to return (default: 50)
   *
   * @generated from field: optional int32 limit = 9;
   */
  limit?: number;

  /**
   * Optional offset for pagination (default: 0)
   *
   * @generated from field: optional int32 offset = 10;
   */
  offset?: number;

  /**
   * Optional filter by updated date (tasks updated on or after this date)
   *
   * @generated from field: optional google.protobuf.Timestamp updated_since = 11;
   */
  updatedSince?: Timestamp;

  /**
   * Optional filter by updated date upper bound (tasks updated before this date, exclusive)
   *
   * @generated from field: optional google.protobuf.Timestamp updated_before = 12;
   */
  updatedBefore?: Timestamp;

  /**
   * @generated from field: optional string job_id = 13;
   */
  jobId?: string;
};

/**
 * Describes the message cortado.v1.ListTasksRequest.
 * Use `create(ListTasksRequestSchema)` to create a new message.
 */
export const ListTasksRequestSchema: GenMessage<ListTasksRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 300);

/**
 * @generated from message cortado.v1.ListTasksResponse
 */
export type ListTasksResponse = Message<"cortado.v1.ListTasksResponse"> & {
  /**
   * Lightweight tasks optimized for list views
   *
   * @generated from field: repeated cortado.v1.TaskLite tasks = 1;
   */
  tasks: TaskLite[];

  /**
   * Total count of matching tasks (for pagination)
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListTasksResponse.
 * Use `create(ListTasksResponseSchema)` to create a new message.
 */
export const ListTasksResponseSchema: GenMessage<ListTasksResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 301);

/**
 * @generated from message cortado.v1.CreateTaskRequest
 */
export type CreateTaskRequest = Message<"cortado.v1.CreateTaskRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: cortado.v1.ParentTypeEnum parent_type = 2;
   */
  parentType: ParentTypeEnum;

  /**
   * @generated from field: string parent_id = 3;
   */
  parentId: string;

  /**
   * @generated from field: string assigned_to = 4;
   */
  assignedTo: string;

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 5;
   */
  dueDate?: Timestamp;

  /**
   * @generated from field: string title = 6;
   */
  title: string;

  /**
   * @generated from field: string description = 7;
   */
  description: string;
};

/**
 * Describes the message cortado.v1.CreateTaskRequest.
 * Use `create(CreateTaskRequestSchema)` to create a new message.
 */
export const CreateTaskRequestSchema: GenMessage<CreateTaskRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 302);

/**
 * @generated from message cortado.v1.CreateTaskResponse
 */
export type CreateTaskResponse = Message<"cortado.v1.CreateTaskResponse"> & {
  /**
   * @generated from field: cortado.v1.Task task = 1;
   */
  task?: Task;
};

/**
 * Describes the message cortado.v1.CreateTaskResponse.
 * Use `create(CreateTaskResponseSchema)` to create a new message.
 */
export const CreateTaskResponseSchema: GenMessage<CreateTaskResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 303);

/**
 * @generated from message cortado.v1.GetTaskRequest
 */
export type GetTaskRequest = Message<"cortado.v1.GetTaskRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetTaskRequest.
 * Use `create(GetTaskRequestSchema)` to create a new message.
 */
export const GetTaskRequestSchema: GenMessage<GetTaskRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 304);

/**
 * @generated from message cortado.v1.GetTaskResponse
 */
export type GetTaskResponse = Message<"cortado.v1.GetTaskResponse"> & {
  /**
   * @generated from field: cortado.v1.Task task = 1;
   */
  task?: Task;
};

/**
 * Describes the message cortado.v1.GetTaskResponse.
 * Use `create(GetTaskResponseSchema)` to create a new message.
 */
export const GetTaskResponseSchema: GenMessage<GetTaskResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 305);

/**
 * @generated from message cortado.v1.UpdateTaskRequest
 */
export type UpdateTaskRequest = Message<"cortado.v1.UpdateTaskRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string assigned_to = 2;
   */
  assignedTo?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp due_date = 3;
   */
  dueDate?: Timestamp;

  /**
   * @generated from field: optional cortado.v1.TaskStatusEnum task_status = 4;
   */
  taskStatus?: TaskStatusEnum;

  /**
   * @generated from field: optional string title = 5;
   */
  title?: string;

  /**
   * @generated from field: optional string description = 6;
   */
  description?: string;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 7;
   */
  updateMask?: FieldMask;

  /**
   * @generated from field: optional cortado.v1.ParentTypeEnum parent_type = 8;
   */
  parentType?: ParentTypeEnum;

  /**
   * @generated from field: optional string parent_id = 9;
   */
  parentId?: string;
};

/**
 * Describes the message cortado.v1.UpdateTaskRequest.
 * Use `create(UpdateTaskRequestSchema)` to create a new message.
 */
export const UpdateTaskRequestSchema: GenMessage<UpdateTaskRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 306);

/**
 * @generated from message cortado.v1.UpdateTaskResponse
 */
export type UpdateTaskResponse = Message<"cortado.v1.UpdateTaskResponse"> & {
  /**
   * @generated from field: cortado.v1.Task task = 1;
   */
  task?: Task;
};

/**
 * Describes the message cortado.v1.UpdateTaskResponse.
 * Use `create(UpdateTaskResponseSchema)` to create a new message.
 */
export const UpdateTaskResponseSchema: GenMessage<UpdateTaskResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 307);

/**
 * @generated from message cortado.v1.DeleteTaskRequest
 */
export type DeleteTaskRequest = Message<"cortado.v1.DeleteTaskRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteTaskRequest.
 * Use `create(DeleteTaskRequestSchema)` to create a new message.
 */
export const DeleteTaskRequestSchema: GenMessage<DeleteTaskRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 308);

/**
 * @generated from message cortado.v1.DeleteTaskResponse
 */
export type DeleteTaskResponse = Message<"cortado.v1.DeleteTaskResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteTaskResponse.
 * Use `create(DeleteTaskResponseSchema)` to create a new message.
 */
export const DeleteTaskResponseSchema: GenMessage<DeleteTaskResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 309);

/**
 * @generated from message cortado.v1.ListEmailTemplatesRequest
 */
export type ListEmailTemplatesRequest = Message<"cortado.v1.ListEmailTemplatesRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListEmailTemplatesRequest.
 * Use `create(ListEmailTemplatesRequestSchema)` to create a new message.
 */
export const ListEmailTemplatesRequestSchema: GenMessage<ListEmailTemplatesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 310);

/**
 * @generated from message cortado.v1.ListEmailTemplatesResponse
 */
export type ListEmailTemplatesResponse = Message<"cortado.v1.ListEmailTemplatesResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.EmailTemplate email_templates = 1;
   */
  emailTemplates: EmailTemplate[];
};

/**
 * Describes the message cortado.v1.ListEmailTemplatesResponse.
 * Use `create(ListEmailTemplatesResponseSchema)` to create a new message.
 */
export const ListEmailTemplatesResponseSchema: GenMessage<ListEmailTemplatesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 311);

/**
 * @generated from message cortado.v1.CreateEmailTemplateRequest
 */
export type CreateEmailTemplateRequest = Message<"cortado.v1.CreateEmailTemplateRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string category = 3;
   */
  category: string;

  /**
   * @generated from field: string subject = 4;
   */
  subject: string;

  /**
   * @generated from field: string body = 5;
   */
  body: string;

  /**
   * @generated from field: repeated string available_variables = 6;
   */
  availableVariables: string[];
};

/**
 * Describes the message cortado.v1.CreateEmailTemplateRequest.
 * Use `create(CreateEmailTemplateRequestSchema)` to create a new message.
 */
export const CreateEmailTemplateRequestSchema: GenMessage<CreateEmailTemplateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 312);

/**
 * @generated from message cortado.v1.CreateEmailTemplateResponse
 */
export type CreateEmailTemplateResponse = Message<"cortado.v1.CreateEmailTemplateResponse"> & {
  /**
   * @generated from field: cortado.v1.EmailTemplate email_template = 1;
   */
  emailTemplate?: EmailTemplate;
};

/**
 * Describes the message cortado.v1.CreateEmailTemplateResponse.
 * Use `create(CreateEmailTemplateResponseSchema)` to create a new message.
 */
export const CreateEmailTemplateResponseSchema: GenMessage<CreateEmailTemplateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 313);

/**
 * @generated from message cortado.v1.GetEmailTemplateRequest
 */
export type GetEmailTemplateRequest = Message<"cortado.v1.GetEmailTemplateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetEmailTemplateRequest.
 * Use `create(GetEmailTemplateRequestSchema)` to create a new message.
 */
export const GetEmailTemplateRequestSchema: GenMessage<GetEmailTemplateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 314);

/**
 * @generated from message cortado.v1.GetEmailTemplateResponse
 */
export type GetEmailTemplateResponse = Message<"cortado.v1.GetEmailTemplateResponse"> & {
  /**
   * @generated from field: cortado.v1.EmailTemplate email_template = 1;
   */
  emailTemplate?: EmailTemplate;
};

/**
 * Describes the message cortado.v1.GetEmailTemplateResponse.
 * Use `create(GetEmailTemplateResponseSchema)` to create a new message.
 */
export const GetEmailTemplateResponseSchema: GenMessage<GetEmailTemplateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 315);

/**
 * @generated from message cortado.v1.EmailTemplateRenderContext
 */
export type EmailTemplateRenderContext = Message<"cortado.v1.EmailTemplateRenderContext"> & {
  /**
   * @generated from field: optional string organization_id = 1;
   */
  organizationId?: string;

  /**
   * @generated from field: optional string inquiry_id = 2;
   */
  inquiryId?: string;

  /**
   * @generated from field: optional string contact_id = 3;
   */
  contactId?: string;

  /**
   * @generated from field: optional string event_id = 4;
   */
  eventId?: string;

  /**
   * @generated from field: optional string actor_id = 5;
   */
  actorId?: string;

  /**
   * Booking-parented renders. Compose accepts a BOOKING parent, so the render
   * context has to be able to name one; without this the booking silently
   * rendered as its contact.
   *
   * @generated from field: optional string booking_id = 6;
   */
  bookingId?: string;

  /**
   * Quote-parented renders. Maps to emailrender.TemplateRenderContext.QuoteID.
   *
   * @generated from field: optional string quote_id = 7;
   */
  quoteId?: string;

  /**
   * Invoice-parented renders. Maps to emailrender.TemplateRenderContext.InvoiceID.
   *
   * @generated from field: optional string invoice_id = 8;
   */
  invoiceId?: string;

  /**
   * Payment-parented renders. Maps to emailrender.TemplateRenderContext.PaymentID;
   * the renderer resolves the payment up to its invoice.
   *
   * @generated from field: optional string payment_id = 9;
   */
  paymentId?: string;
};

/**
 * Describes the message cortado.v1.EmailTemplateRenderContext.
 * Use `create(EmailTemplateRenderContextSchema)` to create a new message.
 */
export const EmailTemplateRenderContextSchema: GenMessage<EmailTemplateRenderContext> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 316);

/**
 * @generated from message cortado.v1.RenderEmailTemplateRequest
 */
export type RenderEmailTemplateRequest = Message<"cortado.v1.RenderEmailTemplateRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;

  /**
   * @generated from field: cortado.v1.EmailTemplateRenderContext context = 2;
   */
  context?: EmailTemplateRenderContext;
};

/**
 * Describes the message cortado.v1.RenderEmailTemplateRequest.
 * Use `create(RenderEmailTemplateRequestSchema)` to create a new message.
 */
export const RenderEmailTemplateRequestSchema: GenMessage<RenderEmailTemplateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 317);

/**
 * @generated from message cortado.v1.RenderEmailTemplateResponse
 */
export type RenderEmailTemplateResponse = Message<"cortado.v1.RenderEmailTemplateResponse"> & {
  /**
   * @generated from field: string subject = 1;
   */
  subject: string;

  /**
   * @generated from field: string body = 2;
   */
  body: string;

  /**
   * @generated from field: repeated string unresolved_variables = 3;
   */
  unresolvedVariables: string[];
};

/**
 * Describes the message cortado.v1.RenderEmailTemplateResponse.
 * Use `create(RenderEmailTemplateResponseSchema)` to create a new message.
 */
export const RenderEmailTemplateResponseSchema: GenMessage<RenderEmailTemplateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 318);

/**
 * @generated from message cortado.v1.UpdateEmailTemplateRequest
 */
export type UpdateEmailTemplateRequest = Message<"cortado.v1.UpdateEmailTemplateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional string category = 3;
   */
  category?: string;

  /**
   * @generated from field: optional string subject = 4;
   */
  subject?: string;

  /**
   * @generated from field: optional string body = 5;
   */
  body?: string;

  /**
   * @generated from field: repeated string available_variables = 6;
   */
  availableVariables: string[];

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 7;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message cortado.v1.UpdateEmailTemplateRequest.
 * Use `create(UpdateEmailTemplateRequestSchema)` to create a new message.
 */
export const UpdateEmailTemplateRequestSchema: GenMessage<UpdateEmailTemplateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 319);

/**
 * @generated from message cortado.v1.UpdateEmailTemplateResponse
 */
export type UpdateEmailTemplateResponse = Message<"cortado.v1.UpdateEmailTemplateResponse"> & {
  /**
   * @generated from field: cortado.v1.EmailTemplate email_template = 1;
   */
  emailTemplate?: EmailTemplate;
};

/**
 * Describes the message cortado.v1.UpdateEmailTemplateResponse.
 * Use `create(UpdateEmailTemplateResponseSchema)` to create a new message.
 */
export const UpdateEmailTemplateResponseSchema: GenMessage<UpdateEmailTemplateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 320);

/**
 * @generated from message cortado.v1.DeleteEmailTemplateRequest
 */
export type DeleteEmailTemplateRequest = Message<"cortado.v1.DeleteEmailTemplateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteEmailTemplateRequest.
 * Use `create(DeleteEmailTemplateRequestSchema)` to create a new message.
 */
export const DeleteEmailTemplateRequestSchema: GenMessage<DeleteEmailTemplateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 321);

/**
 * @generated from message cortado.v1.DeleteEmailTemplateResponse
 */
export type DeleteEmailTemplateResponse = Message<"cortado.v1.DeleteEmailTemplateResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteEmailTemplateResponse.
 * Use `create(DeleteEmailTemplateResponseSchema)` to create a new message.
 */
export const DeleteEmailTemplateResponseSchema: GenMessage<DeleteEmailTemplateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 322);

/**
 * @generated from message cortado.v1.GetEmailTemplateCategoriesRequest
 */
export type GetEmailTemplateCategoriesRequest = Message<"cortado.v1.GetEmailTemplateCategoriesRequest"> & {
};

/**
 * Describes the message cortado.v1.GetEmailTemplateCategoriesRequest.
 * Use `create(GetEmailTemplateCategoriesRequestSchema)` to create a new message.
 */
export const GetEmailTemplateCategoriesRequestSchema: GenMessage<GetEmailTemplateCategoriesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 323);

/**
 * EmailTemplateCategory represents a template category with metadata
 *
 * @generated from message cortado.v1.EmailTemplateCategoryInfo
 */
export type EmailTemplateCategoryInfo = Message<"cortado.v1.EmailTemplateCategoryInfo"> & {
  /**
   * Category value (e.g., "General", "Invoice")
   *
   * @generated from field: string value = 1;
   */
  value: string;

  /**
   * Human-readable label
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * Description of when to use this category
   *
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * Describes the message cortado.v1.EmailTemplateCategoryInfo.
 * Use `create(EmailTemplateCategoryInfoSchema)` to create a new message.
 */
export const EmailTemplateCategoryInfoSchema: GenMessage<EmailTemplateCategoryInfo> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 324);

/**
 * @generated from message cortado.v1.GetEmailTemplateCategoriesResponse
 */
export type GetEmailTemplateCategoriesResponse = Message<"cortado.v1.GetEmailTemplateCategoriesResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.EmailTemplateCategoryInfo categories = 1;
   */
  categories: EmailTemplateCategoryInfo[];
};

/**
 * Describes the message cortado.v1.GetEmailTemplateCategoriesResponse.
 * Use `create(GetEmailTemplateCategoriesResponseSchema)` to create a new message.
 */
export const GetEmailTemplateCategoriesResponseSchema: GenMessage<GetEmailTemplateCategoriesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 325);

/**
 * @generated from message cortado.v1.GetDashboardTasksRequest
 */
export type GetDashboardTasksRequest = Message<"cortado.v1.GetDashboardTasksRequest"> & {
  /**
   * Organization ID to get tasks for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Optional limit on number of tasks to return
   *
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * Optional filter by task statuses
   *
   * @generated from field: repeated cortado.v1.TaskStatusEnum statuses = 3;
   */
  statuses: TaskStatusEnum[];

  /**
   * Optional end date filter for tasks due by this date
   *
   * @generated from field: optional google.protobuf.Timestamp end_date = 4;
   */
  endDate?: Timestamp;
};

/**
 * Describes the message cortado.v1.GetDashboardTasksRequest.
 * Use `create(GetDashboardTasksRequestSchema)` to create a new message.
 */
export const GetDashboardTasksRequestSchema: GenMessage<GetDashboardTasksRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 326);

/**
 * @generated from message cortado.v1.GetDashboardTasksResponse
 */
export type GetDashboardTasksResponse = Message<"cortado.v1.GetDashboardTasksResponse"> & {
  /**
   * Tasks with enriched assigned_to_user and created_by_user fields populated
   *
   * @generated from field: repeated cortado.v1.Task tasks = 1;
   */
  tasks: Task[];
};

/**
 * Describes the message cortado.v1.GetDashboardTasksResponse.
 * Use `create(GetDashboardTasksResponseSchema)` to create a new message.
 */
export const GetDashboardTasksResponseSchema: GenMessage<GetDashboardTasksResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 327);

/**
 * @generated from message cortado.v1.GetDashboardUpcomingEventsRequest
 */
export type GetDashboardUpcomingEventsRequest = Message<"cortado.v1.GetDashboardUpcomingEventsRequest"> & {
  /**
   * Organization ID to get events for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Optional start date filter
   *
   * @generated from field: optional google.protobuf.Timestamp start_date = 2;
   */
  startDate?: Timestamp;

  /**
   * Optional end date filter
   *
   * @generated from field: optional google.protobuf.Timestamp end_date = 3;
   */
  endDate?: Timestamp;
};

/**
 * Describes the message cortado.v1.GetDashboardUpcomingEventsRequest.
 * Use `create(GetDashboardUpcomingEventsRequestSchema)` to create a new message.
 */
export const GetDashboardUpcomingEventsRequestSchema: GenMessage<GetDashboardUpcomingEventsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 328);

/**
 * @generated from message cortado.v1.GetDashboardUpcomingEventsResponse
 */
export type GetDashboardUpcomingEventsResponse = Message<"cortado.v1.GetDashboardUpcomingEventsResponse"> & {
  /**
   * Events with enriched contact field populated
   *
   * @generated from field: repeated cortado.v1.Event events = 1;
   */
  events: Event[];

  /**
   * User schedulings with enriched user field populated
   *
   * @generated from field: repeated cortado.v1.UserScheduling schedulings = 2;
   */
  schedulings: UserScheduling[];
};

/**
 * Describes the message cortado.v1.GetDashboardUpcomingEventsResponse.
 * Use `create(GetDashboardUpcomingEventsResponseSchema)` to create a new message.
 */
export const GetDashboardUpcomingEventsResponseSchema: GenMessage<GetDashboardUpcomingEventsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 329);

/**
 * @generated from message cortado.v1.GetDashboardBookingsRequest
 */
export type GetDashboardBookingsRequest = Message<"cortado.v1.GetDashboardBookingsRequest"> & {
  /**
   * Organization ID to get bookings for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Optional start date filter for events in bookings
   *
   * @generated from field: optional google.protobuf.Timestamp start_date = 2;
   */
  startDate?: Timestamp;

  /**
   * Optional end date filter for events in bookings
   *
   * @generated from field: optional google.protobuf.Timestamp end_date = 3;
   */
  endDate?: Timestamp;

  /**
   * Optional limit on number of bookings to return
   *
   * @generated from field: optional int32 limit = 4;
   */
  limit?: number;
};

/**
 * Describes the message cortado.v1.GetDashboardBookingsRequest.
 * Use `create(GetDashboardBookingsRequestSchema)` to create a new message.
 */
export const GetDashboardBookingsRequestSchema: GenMessage<GetDashboardBookingsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 330);

/**
 * @generated from message cortado.v1.GetDashboardBookingsResponse
 */
export type GetDashboardBookingsResponse = Message<"cortado.v1.GetDashboardBookingsResponse"> & {
  /**
   * Bookings with enriched nested data (events, contacts, scheduling)
   *
   * @generated from field: repeated cortado.v1.DashboardBooking bookings = 1;
   */
  bookings: DashboardBooking[];
};

/**
 * Describes the message cortado.v1.GetDashboardBookingsResponse.
 * Use `create(GetDashboardBookingsResponseSchema)` to create a new message.
 */
export const GetDashboardBookingsResponseSchema: GenMessage<GetDashboardBookingsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 331);

/**
 * DashboardBooking is an enriched booking for dashboard views
 *
 * @generated from message cortado.v1.DashboardBooking
 */
export type DashboardBooking = Message<"cortado.v1.DashboardBooking"> & {
  /**
   * Core booking data
   *
   * @generated from field: cortado.v1.Booking booking = 1;
   */
  booking?: Booking;

  /**
   * Contact associated with the booking
   *
   * @generated from field: cortado.v1.Contact contact = 2;
   */
  contact?: Contact;

  /**
   * Events associated with the booking
   *
   * @generated from field: repeated cortado.v1.Event events = 3;
   */
  events: Event[];

  /**
   * User schedulings for all events in the booking
   *
   * @generated from field: repeated cortado.v1.UserScheduling schedulings = 4;
   */
  schedulings: UserScheduling[];
};

/**
 * Describes the message cortado.v1.DashboardBooking.
 * Use `create(DashboardBookingSchema)` to create a new message.
 */
export const DashboardBookingSchema: GenMessage<DashboardBooking> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 332);

/**
 * @generated from message cortado.v1.GetDashboardOverduePaymentSchedulesRequest
 */
export type GetDashboardOverduePaymentSchedulesRequest = Message<"cortado.v1.GetDashboardOverduePaymentSchedulesRequest"> & {
  /**
   * Organization ID to get overdue payment schedules for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Optional limit on number of schedules to return (default: 50)
   *
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message cortado.v1.GetDashboardOverduePaymentSchedulesRequest.
 * Use `create(GetDashboardOverduePaymentSchedulesRequestSchema)` to create a new message.
 */
export const GetDashboardOverduePaymentSchedulesRequestSchema: GenMessage<GetDashboardOverduePaymentSchedulesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 333);

/**
 * @generated from message cortado.v1.GetDashboardOverduePaymentSchedulesResponse
 */
export type GetDashboardOverduePaymentSchedulesResponse = Message<"cortado.v1.GetDashboardOverduePaymentSchedulesResponse"> & {
  /**
   * Overdue payment schedules with enriched contact and invoice data
   *
   * @generated from field: repeated cortado.v1.PaymentScheduleLite schedules = 1;
   */
  schedules: PaymentScheduleLite[];

  /**
   * Total count of overdue schedules (may exceed limit)
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.GetDashboardOverduePaymentSchedulesResponse.
 * Use `create(GetDashboardOverduePaymentSchedulesResponseSchema)` to create a new message.
 */
export const GetDashboardOverduePaymentSchedulesResponseSchema: GenMessage<GetDashboardOverduePaymentSchedulesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 334);

/**
 * @generated from message cortado.v1.GetDashboardUpcomingPaymentSchedulesRequest
 */
export type GetDashboardUpcomingPaymentSchedulesRequest = Message<"cortado.v1.GetDashboardUpcomingPaymentSchedulesRequest"> & {
  /**
   * Organization ID to get upcoming payment schedules for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Number of days to look ahead (e.g., 7 for one week)
   *
   * @generated from field: int32 days_ahead = 2;
   */
  daysAhead: number;

  /**
   * Optional limit on number of schedules to return (default: 50)
   *
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;
};

/**
 * Describes the message cortado.v1.GetDashboardUpcomingPaymentSchedulesRequest.
 * Use `create(GetDashboardUpcomingPaymentSchedulesRequestSchema)` to create a new message.
 */
export const GetDashboardUpcomingPaymentSchedulesRequestSchema: GenMessage<GetDashboardUpcomingPaymentSchedulesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 335);

/**
 * @generated from message cortado.v1.GetDashboardUpcomingPaymentSchedulesResponse
 */
export type GetDashboardUpcomingPaymentSchedulesResponse = Message<"cortado.v1.GetDashboardUpcomingPaymentSchedulesResponse"> & {
  /**
   * Upcoming payment schedules with enriched contact and invoice data
   *
   * @generated from field: repeated cortado.v1.PaymentScheduleLite schedules = 1;
   */
  schedules: PaymentScheduleLite[];

  /**
   * Total count of upcoming schedules (may exceed limit)
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.GetDashboardUpcomingPaymentSchedulesResponse.
 * Use `create(GetDashboardUpcomingPaymentSchedulesResponseSchema)` to create a new message.
 */
export const GetDashboardUpcomingPaymentSchedulesResponseSchema: GenMessage<GetDashboardUpcomingPaymentSchedulesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 336);

/**
 * @generated from message cortado.v1.GetDashboardSummaryRequest
 */
export type GetDashboardSummaryRequest = Message<"cortado.v1.GetDashboardSummaryRequest"> & {
  /**
   * Organization ID to get the dashboard summary for (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * ---- Events this week (ThisWeekCard / OperationsCards) ----
   * Week window start (inclusive), computed client-side to respect the user's local timezone
   *
   * @generated from field: optional google.protobuf.Timestamp week_start = 2;
   */
  weekStart?: Timestamp;

  /**
   * Week window end (inclusive)
   *
   * @generated from field: optional google.protobuf.Timestamp week_end = 3;
   */
  weekEnd?: Timestamp;

  /**
   * ---- Pending tasks (widest due-date window; client narrows to 7/14/30-day selections locally) ----
   * Optional filter by assigned user
   *
   * @generated from field: optional string task_assigned_to = 4;
   */
  taskAssignedTo?: string;

  /**
   * Optional filter by task statuses
   *
   * @generated from field: repeated cortado.v1.TaskStatusEnum task_statuses = 5;
   */
  taskStatuses: TaskStatusEnum[];

  /**
   * Widest due-date window end. No start bound is sent so overdue tasks are included too.
   *
   * @generated from field: optional google.protobuf.Timestamp task_due_date_end = 6;
   */
  taskDueDateEnd?: Timestamp;

  /**
   * ---- Recent leads (LeadCard) ----
   * Optional filter by inquiry stages for the recent-leads list
   *
   * @generated from field: repeated cortado.v1.InquiryStageEnum lead_stages = 7;
   */
  leadStages: InquiryStageEnum[];

  /**
   * Recency cutoff (inquiries created on or after this date)
   *
   * @generated from field: optional google.protobuf.Timestamp lead_since = 8;
   */
  leadSince?: Timestamp;

  /**
   * Optional filter by event date start for the recent-leads list
   *
   * @generated from field: optional google.protobuf.Timestamp lead_event_date_start = 9;
   */
  leadEventDateStart?: Timestamp;

  /**
   * Optional filter by event date end for the recent-leads list
   *
   * @generated from field: optional google.protobuf.Timestamp lead_event_date_end = 10;
   */
  leadEventDateEnd?: Timestamp;

  /**
   * Optional limit on number of recent leads to return (default: 10)
   *
   * @generated from field: optional int32 lead_limit = 11;
   */
  leadLimit?: number;

  /**
   * ---- Open leads pipeline count (OperationsCards) ----
   * Optional filter by inquiry stages for the open-leads count
   *
   * @generated from field: repeated cortado.v1.InquiryStageEnum open_lead_stages = 12;
   */
  openLeadStages: InquiryStageEnum[];

  /**
   * ---- Payment schedules (OperationsCards / PaymentScheduleCard) ----
   * Optional limit on number of overdue schedules to return (default: 50)
   *
   * @generated from field: optional int32 overdue_schedule_limit = 13;
   */
  overdueScheduleLimit?: number;

  /**
   * Number of days to look ahead for upcoming schedules (e.g., 7 for one week)
   *
   * @generated from field: int32 upcoming_schedule_days_ahead = 14;
   */
  upcomingScheduleDaysAhead: number;

  /**
   * Optional limit on number of upcoming schedules to return (default: 50)
   *
   * @generated from field: optional int32 upcoming_schedule_limit = 15;
   */
  upcomingScheduleLimit?: number;
};

/**
 * Describes the message cortado.v1.GetDashboardSummaryRequest.
 * Use `create(GetDashboardSummaryRequestSchema)` to create a new message.
 */
export const GetDashboardSummaryRequestSchema: GenMessage<GetDashboardSummaryRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 337);

/**
 * @generated from message cortado.v1.GetDashboardSummaryResponse
 */
export type GetDashboardSummaryResponse = Message<"cortado.v1.GetDashboardSummaryResponse"> & {
  /**
   * Events within the requested week window
   *
   * @generated from field: repeated cortado.v1.EventLite events = 1;
   */
  events: EventLite[];

  /**
   * Pending tasks within the widest due-date window
   *
   * @generated from field: repeated cortado.v1.TaskLite tasks = 2;
   */
  tasks: TaskLite[];

  /**
   * Total count of matching tasks (drives the "Pending Tasks" operations card)
   *
   * @generated from field: int32 tasks_total_count = 3;
   */
  tasksTotalCount: number;

  /**
   * Recent leads matching lead_stages/lead_since/lead_event_date_*
   *
   * @generated from field: repeated cortado.v1.InquiryLite recent_inquiries = 4;
   */
  recentInquiries: InquiryLite[];

  /**
   * Total count of leads matching open_lead_stages (drives the "Open Leads" operations card)
   *
   * @generated from field: int32 open_leads_count = 5;
   */
  openLeadsCount: number;

  /**
   * Overdue payment schedules with enriched contact and invoice data
   *
   * @generated from field: repeated cortado.v1.PaymentScheduleLite overdue_payment_schedules = 6;
   */
  overduePaymentSchedules: PaymentScheduleLite[];

  /**
   * Total count of overdue schedules (may exceed limit)
   *
   * @generated from field: int32 overdue_payment_schedules_total_count = 7;
   */
  overduePaymentSchedulesTotalCount: number;

  /**
   * Upcoming payment schedules with enriched contact and invoice data
   *
   * @generated from field: repeated cortado.v1.PaymentScheduleLite upcoming_payment_schedules = 8;
   */
  upcomingPaymentSchedules: PaymentScheduleLite[];

  /**
   * Total count of upcoming schedules (may exceed limit)
   *
   * @generated from field: int32 upcoming_payment_schedules_total_count = 9;
   */
  upcomingPaymentSchedulesTotalCount: number;
};

/**
 * Describes the message cortado.v1.GetDashboardSummaryResponse.
 * Use `create(GetDashboardSummaryResponseSchema)` to create a new message.
 */
export const GetDashboardSummaryResponseSchema: GenMessage<GetDashboardSummaryResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 338);

/**
 * @generated from message cortado.v1.ListActivitiesRequest
 */
export type ListActivitiesRequest = Message<"cortado.v1.ListActivitiesRequest"> & {
  /**
   * Organization ID to get activities for (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Optional filter by activity types
   *
   * @generated from field: repeated cortado.v1.ActivityTypeEnum activity_types = 2;
   */
  activityTypes: ActivityTypeEnum[];

  /**
   * Optional filter by entity type (PascalCase ParentType values: e.g. 'Inquiry', 'Quote', 'Invoice')
   *
   * @generated from field: optional string entity_type = 3;
   */
  entityType?: string;

  /**
   * Optional filter by entity ID (to get all activities for a specific entity)
   *
   * @generated from field: optional string entity_id = 4;
   */
  entityId?: string;

  /**
   * Optional filter by contact ID (to get all activities related to a contact)
   *
   * @generated from field: optional string contact_id = 5;
   */
  contactId?: string;

  /**
   * Optional filter by created date (activities created since this date)
   *
   * @generated from field: optional google.protobuf.Timestamp since = 6;
   */
  since?: Timestamp;

  /**
   * Optional limit on number of activities to return (default: 20)
   *
   * @generated from field: optional int32 limit = 7;
   */
  limit?: number;

  /**
   * Optional offset for pagination (default: 0)
   *
   * @generated from field: optional int32 offset = 8;
   */
  offset?: number;
};

/**
 * Describes the message cortado.v1.ListActivitiesRequest.
 * Use `create(ListActivitiesRequestSchema)` to create a new message.
 */
export const ListActivitiesRequestSchema: GenMessage<ListActivitiesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 339);

/**
 * @generated from message cortado.v1.ListActivitiesResponse
 */
export type ListActivitiesResponse = Message<"cortado.v1.ListActivitiesResponse"> & {
  /**
   * Lightweight activities optimized for feed display
   *
   * @generated from field: repeated cortado.v1.ActivityLite activities = 1;
   */
  activities: ActivityLite[];

  /**
   * Total count of matching activities (for pagination)
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListActivitiesResponse.
 * Use `create(ListActivitiesResponseSchema)` to create a new message.
 */
export const ListActivitiesResponseSchema: GenMessage<ListActivitiesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 340);

/**
 * @generated from message cortado.v1.ListOrganizationRolesRequest
 */
export type ListOrganizationRolesRequest = Message<"cortado.v1.ListOrganizationRolesRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListOrganizationRolesRequest.
 * Use `create(ListOrganizationRolesRequestSchema)` to create a new message.
 */
export const ListOrganizationRolesRequestSchema: GenMessage<ListOrganizationRolesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 341);

/**
 * @generated from message cortado.v1.ListOrganizationRolesResponse
 */
export type ListOrganizationRolesResponse = Message<"cortado.v1.ListOrganizationRolesResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.Role roles = 1;
   */
  roles: Role[];
};

/**
 * Describes the message cortado.v1.ListOrganizationRolesResponse.
 * Use `create(ListOrganizationRolesResponseSchema)` to create a new message.
 */
export const ListOrganizationRolesResponseSchema: GenMessage<ListOrganizationRolesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 342);

/**
 * @generated from message cortado.v1.GetOrganizationRoleRequest
 */
export type GetOrganizationRoleRequest = Message<"cortado.v1.GetOrganizationRoleRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetOrganizationRoleRequest.
 * Use `create(GetOrganizationRoleRequestSchema)` to create a new message.
 */
export const GetOrganizationRoleRequestSchema: GenMessage<GetOrganizationRoleRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 343);

/**
 * @generated from message cortado.v1.GetOrganizationRoleResponse
 */
export type GetOrganizationRoleResponse = Message<"cortado.v1.GetOrganizationRoleResponse"> & {
  /**
   * @generated from field: cortado.v1.Role role = 1;
   */
  role?: Role;
};

/**
 * Describes the message cortado.v1.GetOrganizationRoleResponse.
 * Use `create(GetOrganizationRoleResponseSchema)` to create a new message.
 */
export const GetOrganizationRoleResponseSchema: GenMessage<GetOrganizationRoleResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 344);

/**
 * @generated from message cortado.v1.CreateOrganizationRoleRequest
 */
export type CreateOrganizationRoleRequest = Message<"cortado.v1.CreateOrganizationRoleRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * Deprecated: use permission_keys. Retained for backward compatibility until
   * clients migrate to the string-keyed vocabulary.
   *
   * @generated from field: repeated cortado.v1.PermissionEnum permissions = 4;
   */
  permissions: PermissionEnum[];

  /**
   * Permission keys to assign, e.g. ["ContactsView", "LeadsManage"]. Takes precedence
   * over permissions when non-empty. Validated against the canonical assignable set.
   *
   * @generated from field: repeated string permission_keys = 5;
   */
  permissionKeys: string[];
};

/**
 * Describes the message cortado.v1.CreateOrganizationRoleRequest.
 * Use `create(CreateOrganizationRoleRequestSchema)` to create a new message.
 */
export const CreateOrganizationRoleRequestSchema: GenMessage<CreateOrganizationRoleRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 345);

/**
 * @generated from message cortado.v1.CreateOrganizationRoleResponse
 */
export type CreateOrganizationRoleResponse = Message<"cortado.v1.CreateOrganizationRoleResponse"> & {
  /**
   * @generated from field: cortado.v1.Role role = 1;
   */
  role?: Role;
};

/**
 * Describes the message cortado.v1.CreateOrganizationRoleResponse.
 * Use `create(CreateOrganizationRoleResponseSchema)` to create a new message.
 */
export const CreateOrganizationRoleResponseSchema: GenMessage<CreateOrganizationRoleResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 346);

/**
 * @generated from message cortado.v1.UpdateOrganizationRoleRequest
 */
export type UpdateOrganizationRoleRequest = Message<"cortado.v1.UpdateOrganizationRoleRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string description = 2;
   */
  description?: string;

  /**
   * Deprecated: use permission_keys. Retained for backward compatibility until
   * clients migrate to the string-keyed vocabulary.
   *
   * @generated from field: repeated cortado.v1.PermissionEnum permissions = 3;
   */
  permissions: PermissionEnum[];

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 4;
   */
  updateMask?: FieldMask;

  /**
   * Permission keys to assign, e.g. ["ContactsView", "LeadsManage"]. Takes precedence
   * over permissions when non-empty. Validated against the canonical assignable set.
   *
   * @generated from field: repeated string permission_keys = 5;
   */
  permissionKeys: string[];
};

/**
 * Describes the message cortado.v1.UpdateOrganizationRoleRequest.
 * Use `create(UpdateOrganizationRoleRequestSchema)` to create a new message.
 */
export const UpdateOrganizationRoleRequestSchema: GenMessage<UpdateOrganizationRoleRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 347);

/**
 * @generated from message cortado.v1.UpdateOrganizationRoleResponse
 */
export type UpdateOrganizationRoleResponse = Message<"cortado.v1.UpdateOrganizationRoleResponse"> & {
  /**
   * @generated from field: cortado.v1.Role role = 1;
   */
  role?: Role;
};

/**
 * Describes the message cortado.v1.UpdateOrganizationRoleResponse.
 * Use `create(UpdateOrganizationRoleResponseSchema)` to create a new message.
 */
export const UpdateOrganizationRoleResponseSchema: GenMessage<UpdateOrganizationRoleResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 348);

/**
 * @generated from message cortado.v1.DeleteOrganizationRoleRequest
 */
export type DeleteOrganizationRoleRequest = Message<"cortado.v1.DeleteOrganizationRoleRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteOrganizationRoleRequest.
 * Use `create(DeleteOrganizationRoleRequestSchema)` to create a new message.
 */
export const DeleteOrganizationRoleRequestSchema: GenMessage<DeleteOrganizationRoleRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 349);

/**
 * @generated from message cortado.v1.DeleteOrganizationRoleResponse
 */
export type DeleteOrganizationRoleResponse = Message<"cortado.v1.DeleteOrganizationRoleResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteOrganizationRoleResponse.
 * Use `create(DeleteOrganizationRoleResponseSchema)` to create a new message.
 */
export const DeleteOrganizationRoleResponseSchema: GenMessage<DeleteOrganizationRoleResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 350);

/**
 * @generated from message cortado.v1.ListPermissionsRequest
 */
export type ListPermissionsRequest = Message<"cortado.v1.ListPermissionsRequest"> & {
};

/**
 * Describes the message cortado.v1.ListPermissionsRequest.
 * Use `create(ListPermissionsRequestSchema)` to create a new message.
 */
export const ListPermissionsRequestSchema: GenMessage<ListPermissionsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 351);

/**
 * @generated from message cortado.v1.ListPermissionsResponse
 */
export type ListPermissionsResponse = Message<"cortado.v1.ListPermissionsResponse"> & {
  /**
   * Deprecated: use permission_info. Retained for backward compatibility until
   * clients migrate to the string-keyed vocabulary.
   *
   * @generated from field: repeated cortado.v1.PermissionEnum permissions = 1;
   */
  permissions: PermissionEnum[];

  /**
   * Every assignable permission with the display metadata the role editor renders
   * from.
   *
   * @generated from field: repeated cortado.v1.PermissionInfo permission_info = 2;
   */
  permissionInfo: PermissionInfo[];
};

/**
 * Describes the message cortado.v1.ListPermissionsResponse.
 * Use `create(ListPermissionsResponseSchema)` to create a new message.
 */
export const ListPermissionsResponseSchema: GenMessage<ListPermissionsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 352);

/**
 * @generated from message cortado.v1.ListOrganizationEventTypesRequest
 */
export type ListOrganizationEventTypesRequest = Message<"cortado.v1.ListOrganizationEventTypesRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * When true, archived (is_active = false) event types are included
   *
   * @generated from field: optional bool include_archived = 2;
   */
  includeArchived?: boolean;
};

/**
 * Describes the message cortado.v1.ListOrganizationEventTypesRequest.
 * Use `create(ListOrganizationEventTypesRequestSchema)` to create a new message.
 */
export const ListOrganizationEventTypesRequestSchema: GenMessage<ListOrganizationEventTypesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 353);

/**
 * @generated from message cortado.v1.ListOrganizationEventTypesResponse
 */
export type ListOrganizationEventTypesResponse = Message<"cortado.v1.ListOrganizationEventTypesResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.OrganizationEventType event_types = 1;
   */
  eventTypes: OrganizationEventType[];
};

/**
 * Describes the message cortado.v1.ListOrganizationEventTypesResponse.
 * Use `create(ListOrganizationEventTypesResponseSchema)` to create a new message.
 */
export const ListOrganizationEventTypesResponseSchema: GenMessage<ListOrganizationEventTypesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 354);

/**
 * @generated from message cortado.v1.CreateOrganizationEventTypeRequest
 */
export type CreateOrganizationEventTypeRequest = Message<"cortado.v1.CreateOrganizationEventTypeRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Display label; the immutable key is derived from it
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: optional string color = 3;
   */
  color?: string;

  /**
   * @generated from field: optional string icon = 4;
   */
  icon?: string;

  /**
   * @generated from field: optional int32 display_order = 5;
   */
  displayOrder?: number;

  /**
   * @generated from field: optional bool collect_company_name = 6;
   */
  collectCompanyName?: boolean;

  /**
   * @generated from field: optional cortado.v1.QuoteExpirationAnchorEnum quote_expiration_anchor = 7;
   */
  quoteExpirationAnchor?: QuoteExpirationAnchorEnum;

  /**
   * @generated from field: optional int32 quote_expiration_offset_days = 8;
   */
  quoteExpirationOffsetDays?: number;

  /**
   * @generated from field: optional cortado.v1.Questionnaire questionnaire = 9;
   */
  questionnaire?: Questionnaire;
};

/**
 * Describes the message cortado.v1.CreateOrganizationEventTypeRequest.
 * Use `create(CreateOrganizationEventTypeRequestSchema)` to create a new message.
 */
export const CreateOrganizationEventTypeRequestSchema: GenMessage<CreateOrganizationEventTypeRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 355);

/**
 * @generated from message cortado.v1.CreateOrganizationEventTypeResponse
 */
export type CreateOrganizationEventTypeResponse = Message<"cortado.v1.CreateOrganizationEventTypeResponse"> & {
  /**
   * @generated from field: cortado.v1.OrganizationEventType event_type = 1;
   */
  eventType?: OrganizationEventType;
};

/**
 * Describes the message cortado.v1.CreateOrganizationEventTypeResponse.
 * Use `create(CreateOrganizationEventTypeResponseSchema)` to create a new message.
 */
export const CreateOrganizationEventTypeResponseSchema: GenMessage<CreateOrganizationEventTypeResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 356);

/**
 * @generated from message cortado.v1.UpdateOrganizationEventTypeRequest
 */
export type UpdateOrganizationEventTypeRequest = Message<"cortado.v1.UpdateOrganizationEventTypeRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: optional string label = 3;
   */
  label?: string;

  /**
   * @generated from field: optional string color = 4;
   */
  color?: string;

  /**
   * @generated from field: optional string icon = 5;
   */
  icon?: string;

  /**
   * @generated from field: optional int32 display_order = 6;
   */
  displayOrder?: number;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 7;
   */
  updateMask?: FieldMask;

  /**
   * @generated from field: optional bool collect_company_name = 8;
   */
  collectCompanyName?: boolean;

  /**
   * @generated from field: optional cortado.v1.QuoteExpirationAnchorEnum quote_expiration_anchor = 9;
   */
  quoteExpirationAnchor?: QuoteExpirationAnchorEnum;

  /**
   * @generated from field: optional int32 quote_expiration_offset_days = 10;
   */
  quoteExpirationOffsetDays?: number;

  /**
   * @generated from field: optional cortado.v1.Questionnaire questionnaire = 11;
   */
  questionnaire?: Questionnaire;
};

/**
 * Describes the message cortado.v1.UpdateOrganizationEventTypeRequest.
 * Use `create(UpdateOrganizationEventTypeRequestSchema)` to create a new message.
 */
export const UpdateOrganizationEventTypeRequestSchema: GenMessage<UpdateOrganizationEventTypeRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 357);

/**
 * @generated from message cortado.v1.UpdateOrganizationEventTypeResponse
 */
export type UpdateOrganizationEventTypeResponse = Message<"cortado.v1.UpdateOrganizationEventTypeResponse"> & {
  /**
   * @generated from field: cortado.v1.OrganizationEventType event_type = 1;
   */
  eventType?: OrganizationEventType;
};

/**
 * Describes the message cortado.v1.UpdateOrganizationEventTypeResponse.
 * Use `create(UpdateOrganizationEventTypeResponseSchema)` to create a new message.
 */
export const UpdateOrganizationEventTypeResponseSchema: GenMessage<UpdateOrganizationEventTypeResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 358);

/**
 * @generated from message cortado.v1.ArchiveOrganizationEventTypeRequest
 */
export type ArchiveOrganizationEventTypeRequest = Message<"cortado.v1.ArchiveOrganizationEventTypeRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ArchiveOrganizationEventTypeRequest.
 * Use `create(ArchiveOrganizationEventTypeRequestSchema)` to create a new message.
 */
export const ArchiveOrganizationEventTypeRequestSchema: GenMessage<ArchiveOrganizationEventTypeRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 359);

/**
 * @generated from message cortado.v1.ArchiveOrganizationEventTypeResponse
 */
export type ArchiveOrganizationEventTypeResponse = Message<"cortado.v1.ArchiveOrganizationEventTypeResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.ArchiveOrganizationEventTypeResponse.
 * Use `create(ArchiveOrganizationEventTypeResponseSchema)` to create a new message.
 */
export const ArchiveOrganizationEventTypeResponseSchema: GenMessage<ArchiveOrganizationEventTypeResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 360);

/**
 * @generated from message cortado.v1.ReorderOrganizationEventTypesRequest
 */
export type ReorderOrganizationEventTypesRequest = Message<"cortado.v1.ReorderOrganizationEventTypesRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Full ordered list of event type IDs; display_order is renumbered 0..n-1
   *
   * @generated from field: repeated string event_type_ids = 2;
   */
  eventTypeIds: string[];
};

/**
 * Describes the message cortado.v1.ReorderOrganizationEventTypesRequest.
 * Use `create(ReorderOrganizationEventTypesRequestSchema)` to create a new message.
 */
export const ReorderOrganizationEventTypesRequestSchema: GenMessage<ReorderOrganizationEventTypesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 361);

/**
 * @generated from message cortado.v1.ReorderOrganizationEventTypesResponse
 */
export type ReorderOrganizationEventTypesResponse = Message<"cortado.v1.ReorderOrganizationEventTypesResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.OrganizationEventType event_types = 1;
   */
  eventTypes: OrganizationEventType[];
};

/**
 * Describes the message cortado.v1.ReorderOrganizationEventTypesResponse.
 * Use `create(ReorderOrganizationEventTypesResponseSchema)` to create a new message.
 */
export const ReorderOrganizationEventTypesResponseSchema: GenMessage<ReorderOrganizationEventTypesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 362);

/**
 * @generated from message cortado.v1.ListFeedbackRequest
 */
export type ListFeedbackRequest = Message<"cortado.v1.ListFeedbackRequest"> & {
  /**
   * Organization ID to filter feedback
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Optional filter by feedback stages
   *
   * @generated from field: repeated cortado.v1.FeedbackStageEnum stages = 10;
   */
  stages: FeedbackStageEnum[];

  /**
   * Pagination limit
   *
   * @generated from field: int32 limit = 20;
   */
  limit: number;

  /**
   * Pagination offset
   *
   * @generated from field: int32 offset = 21;
   */
  offset: number;
};

/**
 * Describes the message cortado.v1.ListFeedbackRequest.
 * Use `create(ListFeedbackRequestSchema)` to create a new message.
 */
export const ListFeedbackRequestSchema: GenMessage<ListFeedbackRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 363);

/**
 * @generated from message cortado.v1.ListFeedbackResponse
 */
export type ListFeedbackResponse = Message<"cortado.v1.ListFeedbackResponse"> & {
  /**
   * List of feedback items
   *
   * @generated from field: repeated cortado.v1.Feedback feedback = 1;
   */
  feedback: Feedback[];

  /**
   * Total count for pagination
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListFeedbackResponse.
 * Use `create(ListFeedbackResponseSchema)` to create a new message.
 */
export const ListFeedbackResponseSchema: GenMessage<ListFeedbackResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 364);

/**
 * @generated from message cortado.v1.CreateFeedbackRequest
 */
export type CreateFeedbackRequest = Message<"cortado.v1.CreateFeedbackRequest"> & {
  /**
   * Organization ID the feedback belongs to
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Feedback content
   *
   * @generated from field: string feedback = 2;
   */
  feedback: string;

  /**
   * Type/category of feedback
   *
   * @generated from field: cortado.v1.FeedbackTypeEnum feedback_type = 3;
   */
  feedbackType: FeedbackTypeEnum;
};

/**
 * Describes the message cortado.v1.CreateFeedbackRequest.
 * Use `create(CreateFeedbackRequestSchema)` to create a new message.
 */
export const CreateFeedbackRequestSchema: GenMessage<CreateFeedbackRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 365);

/**
 * @generated from message cortado.v1.CreateFeedbackResponse
 */
export type CreateFeedbackResponse = Message<"cortado.v1.CreateFeedbackResponse"> & {
  /**
   * Created feedback ID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Full feedback object
   *
   * @generated from field: cortado.v1.Feedback feedback = 2;
   */
  feedback?: Feedback;
};

/**
 * Describes the message cortado.v1.CreateFeedbackResponse.
 * Use `create(CreateFeedbackResponseSchema)` to create a new message.
 */
export const CreateFeedbackResponseSchema: GenMessage<CreateFeedbackResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 366);

/**
 * @generated from message cortado.v1.UpdateFeedbackRequest
 */
export type UpdateFeedbackRequest = Message<"cortado.v1.UpdateFeedbackRequest"> & {
  /**
   * Feedback ID to update
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Updated feedback content
   *
   * @generated from field: string feedback = 2;
   */
  feedback: string;
};

/**
 * Describes the message cortado.v1.UpdateFeedbackRequest.
 * Use `create(UpdateFeedbackRequestSchema)` to create a new message.
 */
export const UpdateFeedbackRequestSchema: GenMessage<UpdateFeedbackRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 367);

/**
 * @generated from message cortado.v1.UpdateFeedbackResponse
 */
export type UpdateFeedbackResponse = Message<"cortado.v1.UpdateFeedbackResponse"> & {
  /**
   * Updated feedback object
   *
   * @generated from field: cortado.v1.Feedback feedback = 1;
   */
  feedback?: Feedback;
};

/**
 * Describes the message cortado.v1.UpdateFeedbackResponse.
 * Use `create(UpdateFeedbackResponseSchema)` to create a new message.
 */
export const UpdateFeedbackResponseSchema: GenMessage<UpdateFeedbackResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 368);

/**
 * @generated from message cortado.v1.DeleteFeedbackRequest
 */
export type DeleteFeedbackRequest = Message<"cortado.v1.DeleteFeedbackRequest"> & {
  /**
   * Feedback ID to delete
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteFeedbackRequest.
 * Use `create(DeleteFeedbackRequestSchema)` to create a new message.
 */
export const DeleteFeedbackRequestSchema: GenMessage<DeleteFeedbackRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 369);

/**
 * Empty response on success
 *
 * @generated from message cortado.v1.DeleteFeedbackResponse
 */
export type DeleteFeedbackResponse = Message<"cortado.v1.DeleteFeedbackResponse"> & {
};

/**
 * Describes the message cortado.v1.DeleteFeedbackResponse.
 * Use `create(DeleteFeedbackResponseSchema)` to create a new message.
 */
export const DeleteFeedbackResponseSchema: GenMessage<DeleteFeedbackResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 370);

/**
 * @generated from message cortado.v1.UpvoteFeedbackRequest
 */
export type UpvoteFeedbackRequest = Message<"cortado.v1.UpvoteFeedbackRequest"> & {
  /**
   * Feedback ID to upvote
   *
   * @generated from field: string feedback_id = 1;
   */
  feedbackId: string;
};

/**
 * Describes the message cortado.v1.UpvoteFeedbackRequest.
 * Use `create(UpvoteFeedbackRequestSchema)` to create a new message.
 */
export const UpvoteFeedbackRequestSchema: GenMessage<UpvoteFeedbackRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 371);

/**
 * Empty response on success
 *
 * @generated from message cortado.v1.UpvoteFeedbackResponse
 */
export type UpvoteFeedbackResponse = Message<"cortado.v1.UpvoteFeedbackResponse"> & {
};

/**
 * Describes the message cortado.v1.UpvoteFeedbackResponse.
 * Use `create(UpvoteFeedbackResponseSchema)` to create a new message.
 */
export const UpvoteFeedbackResponseSchema: GenMessage<UpvoteFeedbackResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 372);

/**
 * @generated from message cortado.v1.RemoveUpvoteRequest
 */
export type RemoveUpvoteRequest = Message<"cortado.v1.RemoveUpvoteRequest"> & {
  /**
   * Feedback ID to remove upvote from
   *
   * @generated from field: string feedback_id = 1;
   */
  feedbackId: string;
};

/**
 * Describes the message cortado.v1.RemoveUpvoteRequest.
 * Use `create(RemoveUpvoteRequestSchema)` to create a new message.
 */
export const RemoveUpvoteRequestSchema: GenMessage<RemoveUpvoteRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 373);

/**
 * Empty response on success
 *
 * @generated from message cortado.v1.RemoveUpvoteResponse
 */
export type RemoveUpvoteResponse = Message<"cortado.v1.RemoveUpvoteResponse"> & {
};

/**
 * Describes the message cortado.v1.RemoveUpvoteResponse.
 * Use `create(RemoveUpvoteResponseSchema)` to create a new message.
 */
export const RemoveUpvoteResponseSchema: GenMessage<RemoveUpvoteResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 374);

/**
 * PublicDomainDnsRecord represents a DNS record required for public domain setup
 *
 * @generated from message cortado.v1.PublicDomainDnsRecord
 */
export type PublicDomainDnsRecord = Message<"cortado.v1.PublicDomainDnsRecord"> & {
  /**
   * DNS record type, for example CNAME or TXT
   *
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * DNS record host/name
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * DNS record value/target
   *
   * @generated from field: string value = 3;
   */
  value: string;

  /**
   * Provider status for this record
   *
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * Optional priority for records that need one
   *
   * @generated from field: optional int32 priority = 5;
   */
  priority?: number;
};

/**
 * Describes the message cortado.v1.PublicDomainDnsRecord.
 * Use `create(PublicDomainDnsRecordSchema)` to create a new message.
 */
export const PublicDomainDnsRecordSchema: GenMessage<PublicDomainDnsRecord> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 375);

/**
 * PublicDomain represents an organization's custom public form or portal domain
 *
 * @generated from message cortado.v1.PublicDomain
 */
export type PublicDomain = Message<"cortado.v1.PublicDomain"> & {
  /**
   * Unique identifier for the public domain
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID the domain belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Public surface served by this domain
   *
   * @generated from field: cortado.v1.PublicDomainSurfaceEnum surface = 3;
   */
  surface: PublicDomainSurfaceEnum;

  /**
   * Fully-qualified custom subdomain
   *
   * @generated from field: string domain = 4;
   */
  domain: string;

  /**
   * Current provider/DNS verification status
   *
   * @generated from field: cortado.v1.PublicDomainStatusEnum status = 5;
   */
  status: PublicDomainStatusEnum;

  /**
   * Domain provider name
   *
   * @generated from field: string provider = 6;
   */
  provider: string;

  /**
   * Provider project ID used for this surface
   *
   * @generated from field: string provider_project_id = 7;
   */
  providerProjectId: string;

  /**
   * Required DNS records for routing/TLS
   *
   * @generated from field: repeated cortado.v1.PublicDomainDnsRecord dns_records = 8;
   */
  dnsRecords: PublicDomainDnsRecord[];

  /**
   * Required DNS records for ownership verification
   *
   * @generated from field: repeated cortado.v1.PublicDomainDnsRecord verification_records = 9;
   */
  verificationRecords: PublicDomainDnsRecord[];

  /**
   * Timestamp when the domain was verified
   *
   * @generated from field: optional google.protobuf.Timestamp verified_at = 10;
   */
  verifiedAt?: Timestamp;

  /**
   * Timestamp when verification status was last checked
   *
   * @generated from field: optional google.protobuf.Timestamp last_checked_at = 11;
   */
  lastCheckedAt?: Timestamp;

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */
  createdAt?: Timestamp;

  /**
   * Updated at timestamp
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 13;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.PublicDomain.
 * Use `create(PublicDomainSchema)` to create a new message.
 */
export const PublicDomainSchema: GenMessage<PublicDomain> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 376);

/**
 * @generated from message cortado.v1.ListPublicDomainsRequest
 */
export type ListPublicDomainsRequest = Message<"cortado.v1.ListPublicDomainsRequest"> & {
  /**
   * Organization ID to list domains for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListPublicDomainsRequest.
 * Use `create(ListPublicDomainsRequestSchema)` to create a new message.
 */
export const ListPublicDomainsRequestSchema: GenMessage<ListPublicDomainsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 377);

/**
 * @generated from message cortado.v1.ListPublicDomainsResponse
 */
export type ListPublicDomainsResponse = Message<"cortado.v1.ListPublicDomainsResponse"> & {
  /**
   * Public domains configured for the organization
   *
   * @generated from field: repeated cortado.v1.PublicDomain public_domains = 1;
   */
  publicDomains: PublicDomain[];
};

/**
 * Describes the message cortado.v1.ListPublicDomainsResponse.
 * Use `create(ListPublicDomainsResponseSchema)` to create a new message.
 */
export const ListPublicDomainsResponseSchema: GenMessage<ListPublicDomainsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 378);

/**
 * @generated from message cortado.v1.AddPublicDomainRequest
 */
export type AddPublicDomainRequest = Message<"cortado.v1.AddPublicDomainRequest"> & {
  /**
   * Organization ID to add the domain for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Surface the domain should serve
   *
   * @generated from field: cortado.v1.PublicDomainSurfaceEnum surface = 2;
   */
  surface: PublicDomainSurfaceEnum;

  /**
   * Custom subdomain, for example events.acme.com
   *
   * @generated from field: string domain = 3;
   */
  domain: string;
};

/**
 * Describes the message cortado.v1.AddPublicDomainRequest.
 * Use `create(AddPublicDomainRequestSchema)` to create a new message.
 */
export const AddPublicDomainRequestSchema: GenMessage<AddPublicDomainRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 379);

/**
 * @generated from message cortado.v1.AddPublicDomainResponse
 */
export type AddPublicDomainResponse = Message<"cortado.v1.AddPublicDomainResponse"> & {
  /**
   * Created public domain with DNS instructions
   *
   * @generated from field: cortado.v1.PublicDomain public_domain = 1;
   */
  publicDomain?: PublicDomain;
};

/**
 * Describes the message cortado.v1.AddPublicDomainResponse.
 * Use `create(AddPublicDomainResponseSchema)` to create a new message.
 */
export const AddPublicDomainResponseSchema: GenMessage<AddPublicDomainResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 380);

/**
 * @generated from message cortado.v1.VerifyPublicDomainRequest
 */
export type VerifyPublicDomainRequest = Message<"cortado.v1.VerifyPublicDomainRequest"> & {
  /**
   * Public domain ID to verify
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.VerifyPublicDomainRequest.
 * Use `create(VerifyPublicDomainRequestSchema)` to create a new message.
 */
export const VerifyPublicDomainRequestSchema: GenMessage<VerifyPublicDomainRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 381);

/**
 * @generated from message cortado.v1.VerifyPublicDomainResponse
 */
export type VerifyPublicDomainResponse = Message<"cortado.v1.VerifyPublicDomainResponse"> & {
  /**
   * Updated public domain with verification status
   *
   * @generated from field: cortado.v1.PublicDomain public_domain = 1;
   */
  publicDomain?: PublicDomain;
};

/**
 * Describes the message cortado.v1.VerifyPublicDomainResponse.
 * Use `create(VerifyPublicDomainResponseSchema)` to create a new message.
 */
export const VerifyPublicDomainResponseSchema: GenMessage<VerifyPublicDomainResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 382);

/**
 * @generated from message cortado.v1.DeletePublicDomainRequest
 */
export type DeletePublicDomainRequest = Message<"cortado.v1.DeletePublicDomainRequest"> & {
  /**
   * Public domain ID to delete
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeletePublicDomainRequest.
 * Use `create(DeletePublicDomainRequestSchema)` to create a new message.
 */
export const DeletePublicDomainRequestSchema: GenMessage<DeletePublicDomainRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 383);

/**
 * @generated from message cortado.v1.DeletePublicDomainResponse
 */
export type DeletePublicDomainResponse = Message<"cortado.v1.DeletePublicDomainResponse"> & {
  /**
   * Success message
   *
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeletePublicDomainResponse.
 * Use `create(DeletePublicDomainResponseSchema)` to create a new message.
 */
export const DeletePublicDomainResponseSchema: GenMessage<DeletePublicDomainResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 384);

/**
 * @generated from message cortado.v1.GetConnectInboxURLRequest
 */
export type GetConnectInboxURLRequest = Message<"cortado.v1.GetConnectInboxURLRequest"> & {
  /**
   * Organization to connect the mailbox to
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Which provider to sign in with
   *
   * @generated from field: cortado.v1.ConnectedMailboxProvider provider = 2;
   */
  provider: ConnectedMailboxProvider;
};

/**
 * Describes the message cortado.v1.GetConnectInboxURLRequest.
 * Use `create(GetConnectInboxURLRequestSchema)` to create a new message.
 */
export const GetConnectInboxURLRequestSchema: GenMessage<GetConnectInboxURLRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 385);

/**
 * @generated from message cortado.v1.GetConnectInboxURLResponse
 */
export type GetConnectInboxURLResponse = Message<"cortado.v1.GetConnectInboxURLResponse"> & {
  /**
   * Hosted-auth URL to send the browser to
   *
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * Describes the message cortado.v1.GetConnectInboxURLResponse.
 * Use `create(GetConnectInboxURLResponseSchema)` to create a new message.
 */
export const GetConnectInboxURLResponseSchema: GenMessage<GetConnectInboxURLResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 386);

/**
 * @generated from message cortado.v1.CompleteConnectInboxRequest
 */
export type CompleteConnectInboxRequest = Message<"cortado.v1.CompleteConnectInboxRequest"> & {
  /**
   * Organization the connect was started in
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Authorization code from the hosted-auth callback
   *
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * Signed state from the hosted-auth callback
   *
   * @generated from field: string state = 3;
   */
  state: string;
};

/**
 * Describes the message cortado.v1.CompleteConnectInboxRequest.
 * Use `create(CompleteConnectInboxRequestSchema)` to create a new message.
 */
export const CompleteConnectInboxRequestSchema: GenMessage<CompleteConnectInboxRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 387);

/**
 * @generated from message cortado.v1.CompleteConnectInboxResponse
 */
export type CompleteConnectInboxResponse = Message<"cortado.v1.CompleteConnectInboxResponse"> & {
  /**
   * The connected mailbox
   *
   * @generated from field: cortado.v1.ConnectedMailbox mailbox = 1;
   */
  mailbox?: ConnectedMailbox;
};

/**
 * Describes the message cortado.v1.CompleteConnectInboxResponse.
 * Use `create(CompleteConnectInboxResponseSchema)` to create a new message.
 */
export const CompleteConnectInboxResponseSchema: GenMessage<CompleteConnectInboxResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 388);

/**
 * @generated from message cortado.v1.ListConnectedMailboxesRequest
 */
export type ListConnectedMailboxesRequest = Message<"cortado.v1.ListConnectedMailboxesRequest"> & {
  /**
   * Organization to list mailboxes for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListConnectedMailboxesRequest.
 * Use `create(ListConnectedMailboxesRequestSchema)` to create a new message.
 */
export const ListConnectedMailboxesRequestSchema: GenMessage<ListConnectedMailboxesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 389);

/**
 * @generated from message cortado.v1.ListConnectedMailboxesResponse
 */
export type ListConnectedMailboxesResponse = Message<"cortado.v1.ListConnectedMailboxesResponse"> & {
  /**
   * Mailboxes, org default first
   *
   * @generated from field: repeated cortado.v1.ConnectedMailbox mailboxes = 1;
   */
  mailboxes: ConnectedMailbox[];

  /**
   * The caller's own live mailbox count has reached the per-user limit
   *
   * @generated from field: bool caller_at_limit = 2;
   */
  callerAtLimit: boolean;
};

/**
 * Describes the message cortado.v1.ListConnectedMailboxesResponse.
 * Use `create(ListConnectedMailboxesResponseSchema)` to create a new message.
 */
export const ListConnectedMailboxesResponseSchema: GenMessage<ListConnectedMailboxesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 390);

/**
 * @generated from message cortado.v1.DisconnectMailboxRequest
 */
export type DisconnectMailboxRequest = Message<"cortado.v1.DisconnectMailboxRequest"> & {
  /**
   * Organization the mailbox belongs to
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Mailbox to disconnect
   *
   * @generated from field: string mailbox_id = 2;
   */
  mailboxId: string;
};

/**
 * Describes the message cortado.v1.DisconnectMailboxRequest.
 * Use `create(DisconnectMailboxRequestSchema)` to create a new message.
 */
export const DisconnectMailboxRequestSchema: GenMessage<DisconnectMailboxRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 391);

/**
 * @generated from message cortado.v1.DisconnectMailboxResponse
 */
export type DisconnectMailboxResponse = Message<"cortado.v1.DisconnectMailboxResponse"> & {
  /**
   * The disconnected mailbox
   *
   * @generated from field: cortado.v1.ConnectedMailbox mailbox = 1;
   */
  mailbox?: ConnectedMailbox;

  /**
   * The mailbox that became the org default, when the disconnected one was
   * the default and another active mailbox took over. Unset otherwise.
   *
   * @generated from field: cortado.v1.ConnectedMailbox new_default = 2;
   */
  newDefault?: ConnectedMailbox;
};

/**
 * Describes the message cortado.v1.DisconnectMailboxResponse.
 * Use `create(DisconnectMailboxResponseSchema)` to create a new message.
 */
export const DisconnectMailboxResponseSchema: GenMessage<DisconnectMailboxResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 392);

/**
 * @generated from message cortado.v1.SetDefaultConnectedMailboxRequest
 */
export type SetDefaultConnectedMailboxRequest = Message<"cortado.v1.SetDefaultConnectedMailboxRequest"> & {
  /**
   * Organization the mailbox belongs to
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Mailbox to make the org default
   *
   * @generated from field: string mailbox_id = 2;
   */
  mailboxId: string;
};

/**
 * Describes the message cortado.v1.SetDefaultConnectedMailboxRequest.
 * Use `create(SetDefaultConnectedMailboxRequestSchema)` to create a new message.
 */
export const SetDefaultConnectedMailboxRequestSchema: GenMessage<SetDefaultConnectedMailboxRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 393);

/**
 * @generated from message cortado.v1.SetDefaultConnectedMailboxResponse
 */
export type SetDefaultConnectedMailboxResponse = Message<"cortado.v1.SetDefaultConnectedMailboxResponse"> & {
  /**
   * The new org default mailbox
   *
   * @generated from field: cortado.v1.ConnectedMailbox mailbox = 1;
   */
  mailbox?: ConnectedMailbox;
};

/**
 * Describes the message cortado.v1.SetDefaultConnectedMailboxResponse.
 * Use `create(SetDefaultConnectedMailboxResponseSchema)` to create a new message.
 */
export const SetDefaultConnectedMailboxResponseSchema: GenMessage<SetDefaultConnectedMailboxResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 394);

/**
 * @generated from message cortado.v1.ListSendableMailboxesRequest
 */
export type ListSendableMailboxesRequest = Message<"cortado.v1.ListSendableMailboxesRequest"> & {
  /**
   * Organization to compose in
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListSendableMailboxesRequest.
 * Use `create(ListSendableMailboxesRequestSchema)` to create a new message.
 */
export const ListSendableMailboxesRequestSchema: GenMessage<ListSendableMailboxesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 395);

/**
 * @generated from message cortado.v1.ListSendableMailboxesResponse
 */
export type ListSendableMailboxesResponse = Message<"cortado.v1.ListSendableMailboxesResponse"> & {
  /**
   * Active mailboxes: the caller's own first, then the org default, then the
   * ones shared with the caller, then the rest. caller_can_send marks the ones
   * the caller may pick.
   *
   * @generated from field: repeated cortado.v1.ConnectedMailbox mailboxes = 1;
   */
  mailboxes: ConnectedMailbox[];

  /**
   * Mailbox to preselect: the caller's own, else the org default. Empty when
   * there is nothing to send from. Compose uses the same mailbox when no
   * from_account_id is sent.
   *
   * @generated from field: string default_mailbox_id = 2;
   */
  defaultMailboxId: string;
};

/**
 * Describes the message cortado.v1.ListSendableMailboxesResponse.
 * Use `create(ListSendableMailboxesResponseSchema)` to create a new message.
 */
export const ListSendableMailboxesResponseSchema: GenMessage<ListSendableMailboxesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 396);

/**
 * @generated from message cortado.v1.GetAutomatedEmailSenderRequest
 */
export type GetAutomatedEmailSenderRequest = Message<"cortado.v1.GetAutomatedEmailSenderRequest"> & {
  /**
   * Organization whose automated email sender to report
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.GetAutomatedEmailSenderRequest.
 * Use `create(GetAutomatedEmailSenderRequestSchema)` to create a new message.
 */
export const GetAutomatedEmailSenderRequestSchema: GenMessage<GetAutomatedEmailSenderRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 397);

/**
 * @generated from message cortado.v1.GetAutomatedEmailSenderResponse
 */
export type GetAutomatedEmailSenderResponse = Message<"cortado.v1.GetAutomatedEmailSenderResponse"> & {
  /**
   * Step of the chain that sends
   *
   * @generated from field: cortado.v1.AutomatedEmailSenderKind kind = 1;
   */
  kind: AutomatedEmailSenderKind;

  /**
   * Address automated email sends from
   *
   * @generated from field: string email_address = 2;
   */
  emailAddress: string;
};

/**
 * Describes the message cortado.v1.GetAutomatedEmailSenderResponse.
 * Use `create(GetAutomatedEmailSenderResponseSchema)` to create a new message.
 */
export const GetAutomatedEmailSenderResponseSchema: GenMessage<GetAutomatedEmailSenderResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 398);

/**
 * @generated from message cortado.v1.ListMailboxSendAccessRequest
 */
export type ListMailboxSendAccessRequest = Message<"cortado.v1.ListMailboxSendAccessRequest"> & {
  /**
   * Organization the mailbox belongs to
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Mailbox to list access for
   *
   * @generated from field: string mailbox_id = 2;
   */
  mailboxId: string;
};

/**
 * Describes the message cortado.v1.ListMailboxSendAccessRequest.
 * Use `create(ListMailboxSendAccessRequestSchema)` to create a new message.
 */
export const ListMailboxSendAccessRequestSchema: GenMessage<ListMailboxSendAccessRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 399);

/**
 * @generated from message cortado.v1.ListMailboxSendAccessResponse
 */
export type ListMailboxSendAccessResponse = Message<"cortado.v1.ListMailboxSendAccessResponse"> & {
  /**
   * Teammates the mailbox is shared with, longest-shared first
   *
   * @generated from field: repeated cortado.v1.MailboxSendAccess grants = 1;
   */
  grants: MailboxSendAccess[];
};

/**
 * Describes the message cortado.v1.ListMailboxSendAccessResponse.
 * Use `create(ListMailboxSendAccessResponseSchema)` to create a new message.
 */
export const ListMailboxSendAccessResponseSchema: GenMessage<ListMailboxSendAccessResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 400);

/**
 * @generated from message cortado.v1.GrantMailboxSendAccessRequest
 */
export type GrantMailboxSendAccessRequest = Message<"cortado.v1.GrantMailboxSendAccessRequest"> & {
  /**
   * Organization the mailbox belongs to
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Mailbox to share
   *
   * @generated from field: string mailbox_id = 2;
   */
  mailboxId: string;

  /**
   * Team member to share it with
   *
   * @generated from field: string user_id = 3;
   */
  userId: string;
};

/**
 * Describes the message cortado.v1.GrantMailboxSendAccessRequest.
 * Use `create(GrantMailboxSendAccessRequestSchema)` to create a new message.
 */
export const GrantMailboxSendAccessRequestSchema: GenMessage<GrantMailboxSendAccessRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 401);

/**
 * @generated from message cortado.v1.GrantMailboxSendAccessResponse
 */
export type GrantMailboxSendAccessResponse = Message<"cortado.v1.GrantMailboxSendAccessResponse"> & {
  /**
   * The grant
   *
   * @generated from field: cortado.v1.MailboxSendAccess grant = 1;
   */
  grant?: MailboxSendAccess;
};

/**
 * Describes the message cortado.v1.GrantMailboxSendAccessResponse.
 * Use `create(GrantMailboxSendAccessResponseSchema)` to create a new message.
 */
export const GrantMailboxSendAccessResponseSchema: GenMessage<GrantMailboxSendAccessResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 402);

/**
 * @generated from message cortado.v1.RevokeMailboxSendAccessRequest
 */
export type RevokeMailboxSendAccessRequest = Message<"cortado.v1.RevokeMailboxSendAccessRequest"> & {
  /**
   * Organization the mailbox belongs to
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Mailbox to stop sharing
   *
   * @generated from field: string mailbox_id = 2;
   */
  mailboxId: string;

  /**
   * Team member to stop sharing it with
   *
   * @generated from field: string user_id = 3;
   */
  userId: string;
};

/**
 * Describes the message cortado.v1.RevokeMailboxSendAccessRequest.
 * Use `create(RevokeMailboxSendAccessRequestSchema)` to create a new message.
 */
export const RevokeMailboxSendAccessRequestSchema: GenMessage<RevokeMailboxSendAccessRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 403);

/**
 * @generated from message cortado.v1.RevokeMailboxSendAccessResponse
 */
export type RevokeMailboxSendAccessResponse = Message<"cortado.v1.RevokeMailboxSendAccessResponse"> & {
};

/**
 * Describes the message cortado.v1.RevokeMailboxSendAccessResponse.
 * Use `create(RevokeMailboxSendAccessResponseSchema)` to create a new message.
 */
export const RevokeMailboxSendAccessResponseSchema: GenMessage<RevokeMailboxSendAccessResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 404);

/**
 * @generated from message cortado.v1.ListEmailCaptureExclusionsRequest
 */
export type ListEmailCaptureExclusionsRequest = Message<"cortado.v1.ListEmailCaptureExclusionsRequest"> & {
  /**
   * Organization to list
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListEmailCaptureExclusionsRequest.
 * Use `create(ListEmailCaptureExclusionsRequestSchema)` to create a new message.
 */
export const ListEmailCaptureExclusionsRequestSchema: GenMessage<ListEmailCaptureExclusionsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 405);

/**
 * @generated from message cortado.v1.ListEmailCaptureExclusionsResponse
 */
export type ListEmailCaptureExclusionsResponse = Message<"cortado.v1.ListEmailCaptureExclusionsResponse"> & {
  /**
   * Org-wide entries first, then mailbox entries; each group by pattern
   *
   * @generated from field: repeated cortado.v1.EmailCaptureExclusion exclusions = 1;
   */
  exclusions: EmailCaptureExclusion[];
};

/**
 * Describes the message cortado.v1.ListEmailCaptureExclusionsResponse.
 * Use `create(ListEmailCaptureExclusionsResponseSchema)` to create a new message.
 */
export const ListEmailCaptureExclusionsResponseSchema: GenMessage<ListEmailCaptureExclusionsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 406);

/**
 * @generated from message cortado.v1.AddEmailCaptureExclusionRequest
 */
export type AddEmailCaptureExclusionRequest = Message<"cortado.v1.AddEmailCaptureExclusionRequest"> & {
  /**
   * Organization to add the entry to
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Mailbox the entry applies to; empty for an org-wide entry
   *
   * @generated from field: string mailbox_id = 2;
   */
  mailboxId: string;

  /**
   * An address (name@example.com) or a domain (example.com)
   *
   * @generated from field: string pattern = 3;
   */
  pattern: string;

  /**
   * Conversation whose captured messages to delete as well; empty to keep
   * existing mail
   *
   * @generated from field: string wipe_thread_id = 4;
   */
  wipeThreadId: string;
};

/**
 * Describes the message cortado.v1.AddEmailCaptureExclusionRequest.
 * Use `create(AddEmailCaptureExclusionRequestSchema)` to create a new message.
 */
export const AddEmailCaptureExclusionRequestSchema: GenMessage<AddEmailCaptureExclusionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 407);

/**
 * @generated from message cortado.v1.AddEmailCaptureExclusionResponse
 */
export type AddEmailCaptureExclusionResponse = Message<"cortado.v1.AddEmailCaptureExclusionResponse"> & {
  /**
   * The entry
   *
   * @generated from field: cortado.v1.EmailCaptureExclusion exclusion = 1;
   */
  exclusion?: EmailCaptureExclusion;

  /**
   * How many captured messages were deleted from wipe_thread_id
   *
   * @generated from field: int32 wiped_message_count = 2;
   */
  wipedMessageCount: number;
};

/**
 * Describes the message cortado.v1.AddEmailCaptureExclusionResponse.
 * Use `create(AddEmailCaptureExclusionResponseSchema)` to create a new message.
 */
export const AddEmailCaptureExclusionResponseSchema: GenMessage<AddEmailCaptureExclusionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 408);

/**
 * @generated from message cortado.v1.RemoveEmailCaptureExclusionRequest
 */
export type RemoveEmailCaptureExclusionRequest = Message<"cortado.v1.RemoveEmailCaptureExclusionRequest"> & {
  /**
   * Organization the entry belongs to
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Entry to remove
   *
   * @generated from field: string id = 2;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.RemoveEmailCaptureExclusionRequest.
 * Use `create(RemoveEmailCaptureExclusionRequestSchema)` to create a new message.
 */
export const RemoveEmailCaptureExclusionRequestSchema: GenMessage<RemoveEmailCaptureExclusionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 409);

/**
 * @generated from message cortado.v1.RemoveEmailCaptureExclusionResponse
 */
export type RemoveEmailCaptureExclusionResponse = Message<"cortado.v1.RemoveEmailCaptureExclusionResponse"> & {
};

/**
 * Describes the message cortado.v1.RemoveEmailCaptureExclusionResponse.
 * Use `create(RemoveEmailCaptureExclusionResponseSchema)` to create a new message.
 */
export const RemoveEmailCaptureExclusionResponseSchema: GenMessage<RemoveEmailCaptureExclusionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 410);

/**
 * @generated from message cortado.v1.ListEmailSenderSuggestionsRequest
 */
export type ListEmailSenderSuggestionsRequest = Message<"cortado.v1.ListEmailSenderSuggestionsRequest"> & {
  /**
   * Organization to list
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListEmailSenderSuggestionsRequest.
 * Use `create(ListEmailSenderSuggestionsRequestSchema)` to create a new message.
 */
export const ListEmailSenderSuggestionsRequestSchema: GenMessage<ListEmailSenderSuggestionsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 411);

/**
 * @generated from message cortado.v1.ListEmailSenderSuggestionsResponse
 */
export type ListEmailSenderSuggestionsResponse = Message<"cortado.v1.ListEmailSenderSuggestionsResponse"> & {
  /**
   * Open suggestions, latest message first
   *
   * @generated from field: repeated cortado.v1.EmailSenderSuggestion suggestions = 1;
   */
  suggestions: EmailSenderSuggestion[];

  /**
   * Whether the organization keeps suggestions for new senders
   *
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;
};

/**
 * Describes the message cortado.v1.ListEmailSenderSuggestionsResponse.
 * Use `create(ListEmailSenderSuggestionsResponseSchema)` to create a new message.
 */
export const ListEmailSenderSuggestionsResponseSchema: GenMessage<ListEmailSenderSuggestionsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 412);

/**
 * @generated from message cortado.v1.ResolveEmailSenderSuggestionRequest
 */
export type ResolveEmailSenderSuggestionRequest = Message<"cortado.v1.ResolveEmailSenderSuggestionRequest"> & {
  /**
   * Organization the suggestion belongs to
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Suggestion to act on
   *
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * What to do with it
   *
   * @generated from field: cortado.v1.EmailSenderSuggestionActionEnum action = 3;
   */
  action: EmailSenderSuggestionActionEnum;

  /**
   * Contact to add the sender to; required for LINK_CONTACT
   *
   * @generated from field: string contact_id = 4;
   */
  contactId: string;
};

/**
 * Describes the message cortado.v1.ResolveEmailSenderSuggestionRequest.
 * Use `create(ResolveEmailSenderSuggestionRequestSchema)` to create a new message.
 */
export const ResolveEmailSenderSuggestionRequestSchema: GenMessage<ResolveEmailSenderSuggestionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 413);

/**
 * @generated from message cortado.v1.ResolveEmailSenderSuggestionResponse
 */
export type ResolveEmailSenderSuggestionResponse = Message<"cortado.v1.ResolveEmailSenderSuggestionResponse"> & {
  /**
   * Whether capturing the kept messages started (LINK_CONTACT only)
   *
   * @generated from field: bool capture_started = 1;
   */
  captureStarted: boolean;
};

/**
 * Describes the message cortado.v1.ResolveEmailSenderSuggestionResponse.
 * Use `create(ResolveEmailSenderSuggestionResponseSchema)` to create a new message.
 */
export const ResolveEmailSenderSuggestionResponseSchema: GenMessage<ResolveEmailSenderSuggestionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 414);

/**
 * @generated from message cortado.v1.SetEmailSenderSuggestionsEnabledRequest
 */
export type SetEmailSenderSuggestionsEnabledRequest = Message<"cortado.v1.SetEmailSenderSuggestionsEnabledRequest"> & {
  /**
   * Organization to change
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Keep suggestions for new senders
   *
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;
};

/**
 * Describes the message cortado.v1.SetEmailSenderSuggestionsEnabledRequest.
 * Use `create(SetEmailSenderSuggestionsEnabledRequestSchema)` to create a new message.
 */
export const SetEmailSenderSuggestionsEnabledRequestSchema: GenMessage<SetEmailSenderSuggestionsEnabledRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 415);

/**
 * @generated from message cortado.v1.SetEmailSenderSuggestionsEnabledResponse
 */
export type SetEmailSenderSuggestionsEnabledResponse = Message<"cortado.v1.SetEmailSenderSuggestionsEnabledResponse"> & {
};

/**
 * Describes the message cortado.v1.SetEmailSenderSuggestionsEnabledResponse.
 * Use `create(SetEmailSenderSuggestionsEnabledResponseSchema)` to create a new message.
 */
export const SetEmailSenderSuggestionsEnabledResponseSchema: GenMessage<SetEmailSenderSuggestionsEnabledResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 416);

/**
 * @generated from message cortado.v1.GetEmailCaptureSettingsRequest
 */
export type GetEmailCaptureSettingsRequest = Message<"cortado.v1.GetEmailCaptureSettingsRequest"> & {
  /**
   * Organization to read
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.GetEmailCaptureSettingsRequest.
 * Use `create(GetEmailCaptureSettingsRequestSchema)` to create a new message.
 */
export const GetEmailCaptureSettingsRequestSchema: GenMessage<GetEmailCaptureSettingsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 417);

/**
 * @generated from message cortado.v1.GetEmailCaptureSettingsResponse
 */
export type GetEmailCaptureSettingsResponse = Message<"cortado.v1.GetEmailCaptureSettingsResponse"> & {
  /**
   * @generated from field: cortado.v1.EmailCaptureSettings settings = 1;
   */
  settings?: EmailCaptureSettings;
};

/**
 * Describes the message cortado.v1.GetEmailCaptureSettingsResponse.
 * Use `create(GetEmailCaptureSettingsResponseSchema)` to create a new message.
 */
export const GetEmailCaptureSettingsResponseSchema: GenMessage<GetEmailCaptureSettingsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 418);

/**
 * @generated from message cortado.v1.UpdateEmailCaptureSettingsRequest
 */
export type UpdateEmailCaptureSettingsRequest = Message<"cortado.v1.UpdateEmailCaptureSettingsRequest"> & {
  /**
   * Organization to change
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Company domain matching; unset leaves it as it is
   *
   * @generated from field: optional bool match_company_domains = 20;
   */
  matchCompanyDomains?: boolean;
};

/**
 * Describes the message cortado.v1.UpdateEmailCaptureSettingsRequest.
 * Use `create(UpdateEmailCaptureSettingsRequestSchema)` to create a new message.
 */
export const UpdateEmailCaptureSettingsRequestSchema: GenMessage<UpdateEmailCaptureSettingsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 419);

/**
 * @generated from message cortado.v1.UpdateEmailCaptureSettingsResponse
 */
export type UpdateEmailCaptureSettingsResponse = Message<"cortado.v1.UpdateEmailCaptureSettingsResponse"> & {
  /**
   * @generated from field: cortado.v1.EmailCaptureSettings settings = 1;
   */
  settings?: EmailCaptureSettings;
};

/**
 * Describes the message cortado.v1.UpdateEmailCaptureSettingsResponse.
 * Use `create(UpdateEmailCaptureSettingsResponseSchema)` to create a new message.
 */
export const UpdateEmailCaptureSettingsResponseSchema: GenMessage<UpdateEmailCaptureSettingsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 420);

/**
 * @generated from message cortado.v1.ListMailboxesNeedingReconnectRequest
 */
export type ListMailboxesNeedingReconnectRequest = Message<"cortado.v1.ListMailboxesNeedingReconnectRequest"> & {
  /**
   * Organization to check
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListMailboxesNeedingReconnectRequest.
 * Use `create(ListMailboxesNeedingReconnectRequestSchema)` to create a new message.
 */
export const ListMailboxesNeedingReconnectRequestSchema: GenMessage<ListMailboxesNeedingReconnectRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 421);

/**
 * @generated from message cortado.v1.ListMailboxesNeedingReconnectResponse
 */
export type ListMailboxesNeedingReconnectResponse = Message<"cortado.v1.ListMailboxesNeedingReconnectResponse"> & {
  /**
   * Mailboxes whose owner must reconnect them, longest-connected first
   *
   * @generated from field: repeated cortado.v1.ConnectedMailbox mailboxes = 1;
   */
  mailboxes: ConnectedMailbox[];
};

/**
 * Describes the message cortado.v1.ListMailboxesNeedingReconnectResponse.
 * Use `create(ListMailboxesNeedingReconnectResponseSchema)` to create a new message.
 */
export const ListMailboxesNeedingReconnectResponseSchema: GenMessage<ListMailboxesNeedingReconnectResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 422);

/**
 * @generated from message cortado.v1.ListEmailSuppressionsRequest
 */
export type ListEmailSuppressionsRequest = Message<"cortado.v1.ListEmailSuppressionsRequest"> & {
  /**
   * Organization ID to list suppressions for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Optional filter by suppression reason
   *
   * @generated from field: optional cortado.v1.EmailSuppressionReason reason = 2;
   */
  reason?: EmailSuppressionReason;

  /**
   * Optional substring filter on email address
   *
   * @generated from field: optional string email_address = 3;
   */
  emailAddress?: string;

  /**
   * Optional limit on number of suppressions to return (default: 50)
   *
   * @generated from field: optional int32 limit = 10;
   */
  limit?: number;

  /**
   * Optional offset for pagination (default: 0)
   *
   * @generated from field: optional int32 offset = 11;
   */
  offset?: number;
};

/**
 * Describes the message cortado.v1.ListEmailSuppressionsRequest.
 * Use `create(ListEmailSuppressionsRequestSchema)` to create a new message.
 */
export const ListEmailSuppressionsRequestSchema: GenMessage<ListEmailSuppressionsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 423);

/**
 * @generated from message cortado.v1.ListEmailSuppressionsResponse
 */
export type ListEmailSuppressionsResponse = Message<"cortado.v1.ListEmailSuppressionsResponse"> & {
  /**
   * Suppressed email addresses
   *
   * @generated from field: repeated cortado.v1.EmailSuppression suppressions = 1;
   */
  suppressions: EmailSuppression[];

  /**
   * Total count of matching suppressions (for pagination)
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListEmailSuppressionsResponse.
 * Use `create(ListEmailSuppressionsResponseSchema)` to create a new message.
 */
export const ListEmailSuppressionsResponseSchema: GenMessage<ListEmailSuppressionsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 424);

/**
 * @generated from message cortado.v1.CreateEmailSuppressionRequest
 */
export type CreateEmailSuppressionRequest = Message<"cortado.v1.CreateEmailSuppressionRequest"> & {
  /**
   * Organization ID to create the suppression for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Email address to suppress
   *
   * @generated from field: string email_address = 2;
   */
  emailAddress: string;

  /**
   * Free-form notes about why the address was suppressed (optional)
   *
   * @generated from field: optional string notes = 3;
   */
  notes?: string;
};

/**
 * Describes the message cortado.v1.CreateEmailSuppressionRequest.
 * Use `create(CreateEmailSuppressionRequestSchema)` to create a new message.
 */
export const CreateEmailSuppressionRequestSchema: GenMessage<CreateEmailSuppressionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 425);

/**
 * @generated from message cortado.v1.CreateEmailSuppressionResponse
 */
export type CreateEmailSuppressionResponse = Message<"cortado.v1.CreateEmailSuppressionResponse"> & {
  /**
   * Created email suppression (reason is server-set to MANUAL)
   *
   * @generated from field: cortado.v1.EmailSuppression suppression = 1;
   */
  suppression?: EmailSuppression;
};

/**
 * Describes the message cortado.v1.CreateEmailSuppressionResponse.
 * Use `create(CreateEmailSuppressionResponseSchema)` to create a new message.
 */
export const CreateEmailSuppressionResponseSchema: GenMessage<CreateEmailSuppressionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 426);

/**
 * @generated from message cortado.v1.DeleteEmailSuppressionRequest
 */
export type DeleteEmailSuppressionRequest = Message<"cortado.v1.DeleteEmailSuppressionRequest"> & {
  /**
   * Suppression ID to delete
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteEmailSuppressionRequest.
 * Use `create(DeleteEmailSuppressionRequestSchema)` to create a new message.
 */
export const DeleteEmailSuppressionRequestSchema: GenMessage<DeleteEmailSuppressionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 427);

/**
 * @generated from message cortado.v1.DeleteEmailSuppressionResponse
 */
export type DeleteEmailSuppressionResponse = Message<"cortado.v1.DeleteEmailSuppressionResponse"> & {
};

/**
 * Describes the message cortado.v1.DeleteEmailSuppressionResponse.
 * Use `create(DeleteEmailSuppressionResponseSchema)` to create a new message.
 */
export const DeleteEmailSuppressionResponseSchema: GenMessage<DeleteEmailSuppressionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 428);

/**
 * @generated from message cortado.v1.ListApiKeysRequest
 */
export type ListApiKeysRequest = Message<"cortado.v1.ListApiKeysRequest"> & {
  /**
   * Organization ID to list keys for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListApiKeysRequest.
 * Use `create(ListApiKeysRequestSchema)` to create a new message.
 */
export const ListApiKeysRequestSchema: GenMessage<ListApiKeysRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 429);

/**
 * @generated from message cortado.v1.ListApiKeysResponse
 */
export type ListApiKeysResponse = Message<"cortado.v1.ListApiKeysResponse"> & {
  /**
   * API keys, newest first (includes revoked keys)
   *
   * @generated from field: repeated cortado.v1.ApiKey api_keys = 1;
   */
  apiKeys: ApiKey[];
};

/**
 * Describes the message cortado.v1.ListApiKeysResponse.
 * Use `create(ListApiKeysResponseSchema)` to create a new message.
 */
export const ListApiKeysResponseSchema: GenMessage<ListApiKeysResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 430);

/**
 * @generated from message cortado.v1.CreateApiKeyRequest
 */
export type CreateApiKeyRequest = Message<"cortado.v1.CreateApiKeyRequest"> & {
  /**
   * Organization ID to create the key for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Human-readable label for the key
   *
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message cortado.v1.CreateApiKeyRequest.
 * Use `create(CreateApiKeyRequestSchema)` to create a new message.
 */
export const CreateApiKeyRequestSchema: GenMessage<CreateApiKeyRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 431);

/**
 * @generated from message cortado.v1.CreateApiKeyResponse
 */
export type CreateApiKeyResponse = Message<"cortado.v1.CreateApiKeyResponse"> & {
  /**
   * Created key metadata
   *
   * @generated from field: cortado.v1.ApiKey api_key = 1;
   */
  apiKey?: ApiKey;

  /**
   * Plaintext secret. Shown once; never retrievable again.
   *
   * @generated from field: string secret = 2;
   */
  secret: string;
};

/**
 * Describes the message cortado.v1.CreateApiKeyResponse.
 * Use `create(CreateApiKeyResponseSchema)` to create a new message.
 */
export const CreateApiKeyResponseSchema: GenMessage<CreateApiKeyResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 432);

/**
 * @generated from message cortado.v1.RevokeApiKeyRequest
 */
export type RevokeApiKeyRequest = Message<"cortado.v1.RevokeApiKeyRequest"> & {
  /**
   * Organization ID that owns the key
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * API key ID to revoke
   *
   * @generated from field: string id = 2;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.RevokeApiKeyRequest.
 * Use `create(RevokeApiKeyRequestSchema)` to create a new message.
 */
export const RevokeApiKeyRequestSchema: GenMessage<RevokeApiKeyRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 433);

/**
 * @generated from message cortado.v1.RevokeApiKeyResponse
 */
export type RevokeApiKeyResponse = Message<"cortado.v1.RevokeApiKeyResponse"> & {
  /**
   * Revoked key metadata
   *
   * @generated from field: cortado.v1.ApiKey api_key = 1;
   */
  apiKey?: ApiKey;
};

/**
 * Describes the message cortado.v1.RevokeApiKeyResponse.
 * Use `create(RevokeApiKeyResponseSchema)` to create a new message.
 */
export const RevokeApiKeyResponseSchema: GenMessage<RevokeApiKeyResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 434);

/**
 * @generated from message cortado.v1.SendInquiryEmailRequest
 */
export type SendInquiryEmailRequest = Message<"cortado.v1.SendInquiryEmailRequest"> & {
  /**
   * Inquiry ID to link the email to
   *
   * @generated from field: string inquiry_id = 1;
   */
  inquiryId: string;

  /**
   * Email account ID to send from. Optional: leave blank to let the server run
   * the compose chain (the user's own domain account, then the organization's
   * system domain account).
   *
   * @generated from field: string from_account_id = 2;
   */
  fromAccountId: string;

  /**
   * Recipient email address
   *
   * @generated from field: string to_email = 3;
   */
  toEmail: string;

  /**
   * Email subject
   *
   * @generated from field: string subject = 4;
   */
  subject: string;

  /**
   * Email body (plain text or HTML)
   *
   * @generated from field: string body = 5;
   */
  body: string;

  /**
   * Attachment IDs (uploaded via CreateAttachment with parent_type=INQUIRY) to include with this email. Max 10 attachments, total size <= 20 MB.
   *
   * @generated from field: repeated string attachment_ids = 6;
   */
  attachmentIds: string[];

  /**
   * Attachment library IDs to include with this email (org-library attachments).
   *
   * @generated from field: repeated string library_attachment_ids = 7;
   */
  libraryAttachmentIds: string[];

  /**
   * Client-generated idempotency key (UUID). Reuse it across retries of the
   * same send so a double-click or a transport retry sends one email. Omit it
   * and the server generates one, which gives no double-submit protection.
   *
   * @generated from field: optional string idempotency_key = 8;
   */
  idempotencyKey?: string;
};

/**
 * Describes the message cortado.v1.SendInquiryEmailRequest.
 * Use `create(SendInquiryEmailRequestSchema)` to create a new message.
 */
export const SendInquiryEmailRequestSchema: GenMessage<SendInquiryEmailRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 435);

/**
 * @generated from message cortado.v1.SendInquiryEmailResponse
 */
export type SendInquiryEmailResponse = Message<"cortado.v1.SendInquiryEmailResponse"> & {
  /**
   * Created email message
   *
   * @generated from field: cortado.v1.Email email = 1;
   */
  email?: Email;

  /**
   * Email thread (created or updated)
   *
   * @generated from field: cortado.v1.EmailThread email_thread = 2;
   */
  emailThread?: EmailThread;
};

/**
 * Describes the message cortado.v1.SendInquiryEmailResponse.
 * Use `create(SendInquiryEmailResponseSchema)` to create a new message.
 */
export const SendInquiryEmailResponseSchema: GenMessage<SendInquiryEmailResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 436);

/**
 * @generated from message cortado.v1.SendEmailRequest
 */
export type SendEmailRequest = Message<"cortado.v1.SendEmailRequest"> & {
  /**
   * Organization ID for the email send
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Parent entity type to associate the email with
   *
   * @generated from field: cortado.v1.ParentTypeEnum parent_type = 2;
   */
  parentType: ParentTypeEnum;

  /**
   * Parent entity ID to associate the email with
   *
   * @generated from field: string parent_id = 3;
   */
  parentId: string;

  /**
   * Connected mailbox ID to send from (see ListSendableMailboxes). Optional:
   * leave blank to let the server run the compose chain (the sender's own
   * mailbox, then the organization's default mailbox). A mailbox that is
   * disconnected or not in the organization fails the send.
   *
   * @generated from field: string from_account_id = 4;
   */
  fromAccountId: string;

  /**
   * Recipient email address. Single-recipient legacy form; prefer to_emails.
   * When both are set the server sends the union.
   *
   * @generated from field: string to_email = 5;
   */
  toEmail: string;

  /**
   * Email subject
   *
   * @generated from field: string subject = 6;
   */
  subject: string;

  /**
   * Email body (plain text or HTML)
   *
   * @generated from field: string body = 7;
   */
  body: string;

  /**
   * Attachment IDs uploaded via CreateAttachment for the selected parent. Max 10 attachments, total size <= 20 MB.
   *
   * @generated from field: repeated string attachment_ids = 8;
   */
  attachmentIds: string[];

  /**
   * Attachment library IDs to include with this email (org-library attachments).
   *
   * @generated from field: repeated string library_attachment_ids = 9;
   */
  libraryAttachmentIds: string[];

  /**
   * Recipient email addresses (composer To chips)
   *
   * @generated from field: repeated string to_emails = 10;
   */
  toEmails: string[];

  /**
   * CC email addresses
   *
   * @generated from field: repeated string cc_emails = 11;
   */
  ccEmails: string[];

  /**
   * BCC email addresses
   *
   * @generated from field: repeated string bcc_emails = 12;
   */
  bccEmails: string[];

  /**
   * Compose draft this send came from, if any. The server promotes that draft
   * row to the sent message instead of leaving it behind.
   *
   * @generated from field: optional string draft_id = 13;
   */
  draftId?: string;

  /**
   * Client-generated idempotency key (UUID). Reuse it across retries of the
   * same send so a double-click or a transport retry sends one email. Omit it
   * and the server generates one, which gives no double-submit protection.
   *
   * @generated from field: optional string idempotency_key = 14;
   */
  idempotencyKey?: string;
};

/**
 * Describes the message cortado.v1.SendEmailRequest.
 * Use `create(SendEmailRequestSchema)` to create a new message.
 */
export const SendEmailRequestSchema: GenMessage<SendEmailRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 437);

/**
 * @generated from message cortado.v1.SendEmailResponse
 */
export type SendEmailResponse = Message<"cortado.v1.SendEmailResponse"> & {
  /**
   * Created email message
   *
   * @generated from field: cortado.v1.Email email = 1;
   */
  email?: Email;

  /**
   * Email thread (created or updated)
   *
   * @generated from field: cortado.v1.EmailThread email_thread = 2;
   */
  emailThread?: EmailThread;
};

/**
 * Describes the message cortado.v1.SendEmailResponse.
 * Use `create(SendEmailResponseSchema)` to create a new message.
 */
export const SendEmailResponseSchema: GenMessage<SendEmailResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 438);

/**
 * @generated from message cortado.v1.ListInquiryEmailsRequest
 */
export type ListInquiryEmailsRequest = Message<"cortado.v1.ListInquiryEmailsRequest"> & {
  /**
   * Inquiry ID to get emails for
   *
   * @generated from field: string inquiry_id = 1;
   */
  inquiryId: string;
};

/**
 * Describes the message cortado.v1.ListInquiryEmailsRequest.
 * Use `create(ListInquiryEmailsRequestSchema)` to create a new message.
 */
export const ListInquiryEmailsRequestSchema: GenMessage<ListInquiryEmailsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 439);

/**
 * @generated from message cortado.v1.ListInquiryEmailsResponse
 */
export type ListInquiryEmailsResponse = Message<"cortado.v1.ListInquiryEmailsResponse"> & {
  /**
   * Email thread with all messages (may be null if no emails exist)
   *
   * @generated from field: cortado.v1.EmailThread email_thread = 1;
   */
  emailThread?: EmailThread;
};

/**
 * Describes the message cortado.v1.ListInquiryEmailsResponse.
 * Use `create(ListInquiryEmailsResponseSchema)` to create a new message.
 */
export const ListInquiryEmailsResponseSchema: GenMessage<ListInquiryEmailsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 440);

/**
 * @generated from message cortado.v1.CreateAttachmentRequest
 */
export type CreateAttachmentRequest = Message<"cortado.v1.CreateAttachmentRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: cortado.v1.ParentTypeEnum parent_type = 2;
   */
  parentType: ParentTypeEnum;

  /**
   * @generated from field: string parent_id = 3;
   */
  parentId: string;

  /**
   * @generated from field: string filename = 4;
   */
  filename: string;

  /**
   * @generated from field: string content_type = 5;
   */
  contentType: string;

  /**
   * @generated from field: string file_base64 = 6;
   */
  fileBase64: string;

  /**
   * @generated from field: optional string folder_id = 7;
   */
  folderId?: string;
};

/**
 * Describes the message cortado.v1.CreateAttachmentRequest.
 * Use `create(CreateAttachmentRequestSchema)` to create a new message.
 */
export const CreateAttachmentRequestSchema: GenMessage<CreateAttachmentRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 441);

/**
 * @generated from message cortado.v1.CreateAttachmentResponse
 */
export type CreateAttachmentResponse = Message<"cortado.v1.CreateAttachmentResponse"> & {
  /**
   * @generated from field: cortado.v1.Attachment attachment = 1;
   */
  attachment?: Attachment;
};

/**
 * Describes the message cortado.v1.CreateAttachmentResponse.
 * Use `create(CreateAttachmentResponseSchema)` to create a new message.
 */
export const CreateAttachmentResponseSchema: GenMessage<CreateAttachmentResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 442);

/**
 * @generated from message cortado.v1.GetAttachmentRequest
 */
export type GetAttachmentRequest = Message<"cortado.v1.GetAttachmentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetAttachmentRequest.
 * Use `create(GetAttachmentRequestSchema)` to create a new message.
 */
export const GetAttachmentRequestSchema: GenMessage<GetAttachmentRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 443);

/**
 * @generated from message cortado.v1.GetAttachmentResponse
 */
export type GetAttachmentResponse = Message<"cortado.v1.GetAttachmentResponse"> & {
  /**
   * @generated from field: cortado.v1.Attachment attachment = 1;
   */
  attachment?: Attachment;
};

/**
 * Describes the message cortado.v1.GetAttachmentResponse.
 * Use `create(GetAttachmentResponseSchema)` to create a new message.
 */
export const GetAttachmentResponseSchema: GenMessage<GetAttachmentResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 444);

/**
 * @generated from message cortado.v1.UpdateAttachmentRequest
 */
export type UpdateAttachmentRequest = Message<"cortado.v1.UpdateAttachmentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string filename = 2;
   */
  filename?: string;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message cortado.v1.UpdateAttachmentRequest.
 * Use `create(UpdateAttachmentRequestSchema)` to create a new message.
 */
export const UpdateAttachmentRequestSchema: GenMessage<UpdateAttachmentRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 445);

/**
 * @generated from message cortado.v1.UpdateAttachmentResponse
 */
export type UpdateAttachmentResponse = Message<"cortado.v1.UpdateAttachmentResponse"> & {
  /**
   * @generated from field: cortado.v1.Attachment attachment = 1;
   */
  attachment?: Attachment;
};

/**
 * Describes the message cortado.v1.UpdateAttachmentResponse.
 * Use `create(UpdateAttachmentResponseSchema)` to create a new message.
 */
export const UpdateAttachmentResponseSchema: GenMessage<UpdateAttachmentResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 446);

/**
 * @generated from message cortado.v1.DeleteAttachmentRequest
 */
export type DeleteAttachmentRequest = Message<"cortado.v1.DeleteAttachmentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteAttachmentRequest.
 * Use `create(DeleteAttachmentRequestSchema)` to create a new message.
 */
export const DeleteAttachmentRequestSchema: GenMessage<DeleteAttachmentRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 447);

/**
 * @generated from message cortado.v1.DeleteAttachmentResponse
 */
export type DeleteAttachmentResponse = Message<"cortado.v1.DeleteAttachmentResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteAttachmentResponse.
 * Use `create(DeleteAttachmentResponseSchema)` to create a new message.
 */
export const DeleteAttachmentResponseSchema: GenMessage<DeleteAttachmentResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 448);

/**
 * @generated from message cortado.v1.ListAttachmentsRequest
 */
export type ListAttachmentsRequest = Message<"cortado.v1.ListAttachmentsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: optional cortado.v1.ParentTypeEnum parent_type = 2;
   */
  parentType?: ParentTypeEnum;

  /**
   * @generated from field: optional string parent_id = 3;
   */
  parentId?: string;

  /**
   * @generated from field: optional int32 limit = 4;
   */
  limit?: number;

  /**
   * @generated from field: optional int32 offset = 5;
   */
  offset?: number;
};

/**
 * Describes the message cortado.v1.ListAttachmentsRequest.
 * Use `create(ListAttachmentsRequestSchema)` to create a new message.
 */
export const ListAttachmentsRequestSchema: GenMessage<ListAttachmentsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 449);

/**
 * @generated from message cortado.v1.ListAttachmentsResponse
 */
export type ListAttachmentsResponse = Message<"cortado.v1.ListAttachmentsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.AttachmentLite attachments = 1;
   */
  attachments: AttachmentLite[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListAttachmentsResponse.
 * Use `create(ListAttachmentsResponseSchema)` to create a new message.
 */
export const ListAttachmentsResponseSchema: GenMessage<ListAttachmentsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 450);

/**
 * @generated from message cortado.v1.ListAttachmentFoldersRequest
 */
export type ListAttachmentFoldersRequest = Message<"cortado.v1.ListAttachmentFoldersRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListAttachmentFoldersRequest.
 * Use `create(ListAttachmentFoldersRequestSchema)` to create a new message.
 */
export const ListAttachmentFoldersRequestSchema: GenMessage<ListAttachmentFoldersRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 451);

/**
 * @generated from message cortado.v1.ListAttachmentFoldersResponse
 */
export type ListAttachmentFoldersResponse = Message<"cortado.v1.ListAttachmentFoldersResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.AttachmentFolder folders = 1;
   */
  folders: AttachmentFolder[];
};

/**
 * Describes the message cortado.v1.ListAttachmentFoldersResponse.
 * Use `create(ListAttachmentFoldersResponseSchema)` to create a new message.
 */
export const ListAttachmentFoldersResponseSchema: GenMessage<ListAttachmentFoldersResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 452);

/**
 * @generated from message cortado.v1.CreateAttachmentFolderRequest
 */
export type CreateAttachmentFolderRequest = Message<"cortado.v1.CreateAttachmentFolderRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string parent_folder_id = 3;
   */
  parentFolderId?: string;
};

/**
 * Describes the message cortado.v1.CreateAttachmentFolderRequest.
 * Use `create(CreateAttachmentFolderRequestSchema)` to create a new message.
 */
export const CreateAttachmentFolderRequestSchema: GenMessage<CreateAttachmentFolderRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 453);

/**
 * @generated from message cortado.v1.CreateAttachmentFolderResponse
 */
export type CreateAttachmentFolderResponse = Message<"cortado.v1.CreateAttachmentFolderResponse"> & {
  /**
   * @generated from field: cortado.v1.AttachmentFolder folder = 1;
   */
  folder?: AttachmentFolder;
};

/**
 * Describes the message cortado.v1.CreateAttachmentFolderResponse.
 * Use `create(CreateAttachmentFolderResponseSchema)` to create a new message.
 */
export const CreateAttachmentFolderResponseSchema: GenMessage<CreateAttachmentFolderResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 454);

/**
 * @generated from message cortado.v1.RenameAttachmentFolderRequest
 */
export type RenameAttachmentFolderRequest = Message<"cortado.v1.RenameAttachmentFolderRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message cortado.v1.RenameAttachmentFolderRequest.
 * Use `create(RenameAttachmentFolderRequestSchema)` to create a new message.
 */
export const RenameAttachmentFolderRequestSchema: GenMessage<RenameAttachmentFolderRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 455);

/**
 * @generated from message cortado.v1.RenameAttachmentFolderResponse
 */
export type RenameAttachmentFolderResponse = Message<"cortado.v1.RenameAttachmentFolderResponse"> & {
  /**
   * @generated from field: cortado.v1.AttachmentFolder folder = 1;
   */
  folder?: AttachmentFolder;
};

/**
 * Describes the message cortado.v1.RenameAttachmentFolderResponse.
 * Use `create(RenameAttachmentFolderResponseSchema)` to create a new message.
 */
export const RenameAttachmentFolderResponseSchema: GenMessage<RenameAttachmentFolderResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 456);

/**
 * @generated from message cortado.v1.MoveAttachmentFolderRequest
 */
export type MoveAttachmentFolderRequest = Message<"cortado.v1.MoveAttachmentFolderRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string new_parent_folder_id = 2;
   */
  newParentFolderId?: string;
};

/**
 * Describes the message cortado.v1.MoveAttachmentFolderRequest.
 * Use `create(MoveAttachmentFolderRequestSchema)` to create a new message.
 */
export const MoveAttachmentFolderRequestSchema: GenMessage<MoveAttachmentFolderRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 457);

/**
 * @generated from message cortado.v1.MoveAttachmentFolderResponse
 */
export type MoveAttachmentFolderResponse = Message<"cortado.v1.MoveAttachmentFolderResponse"> & {
  /**
   * @generated from field: cortado.v1.AttachmentFolder folder = 1;
   */
  folder?: AttachmentFolder;
};

/**
 * Describes the message cortado.v1.MoveAttachmentFolderResponse.
 * Use `create(MoveAttachmentFolderResponseSchema)` to create a new message.
 */
export const MoveAttachmentFolderResponseSchema: GenMessage<MoveAttachmentFolderResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 458);

/**
 * @generated from message cortado.v1.DeleteAttachmentFolderRequest
 */
export type DeleteAttachmentFolderRequest = Message<"cortado.v1.DeleteAttachmentFolderRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteAttachmentFolderRequest.
 * Use `create(DeleteAttachmentFolderRequestSchema)` to create a new message.
 */
export const DeleteAttachmentFolderRequestSchema: GenMessage<DeleteAttachmentFolderRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 459);

/**
 * @generated from message cortado.v1.DeleteAttachmentFolderResponse
 */
export type DeleteAttachmentFolderResponse = Message<"cortado.v1.DeleteAttachmentFolderResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteAttachmentFolderResponse.
 * Use `create(DeleteAttachmentFolderResponseSchema)` to create a new message.
 */
export const DeleteAttachmentFolderResponseSchema: GenMessage<DeleteAttachmentFolderResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 460);

/**
 * WorkflowTrigger defines what event triggers the workflow
 *
 * @generated from message cortado.v1.WorkflowTrigger
 */
export type WorkflowTrigger = Message<"cortado.v1.WorkflowTrigger"> & {
  /**
   * @generated from field: cortado.v1.WorkflowTriggerEventType event_type = 1;
   */
  eventType: WorkflowTriggerEventType;

  /**
   * @generated from field: cortado.v1.WorkflowTriggerEntityType entity_type = 2;
   */
  entityType: WorkflowTriggerEntityType;

  /**
   * days_before is the lead time for relative-time triggers such as
   * WORKFLOW_TRIGGER_EVENT_TYPE_QUOTE_EXPIRING_SOON. Ignored by event types
   * that fire immediately.
   *
   * @generated from field: int32 days_before = 3;
   */
  daysBefore: number;
};

/**
 * Describes the message cortado.v1.WorkflowTrigger.
 * Use `create(WorkflowTriggerSchema)` to create a new message.
 */
export const WorkflowTriggerSchema: GenMessage<WorkflowTrigger> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 461);

/**
 * WorkflowConditionLeaf is a single field comparison condition
 *
 * @generated from message cortado.v1.WorkflowConditionLeaf
 */
export type WorkflowConditionLeaf = Message<"cortado.v1.WorkflowConditionLeaf"> & {
  /**
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * @generated from field: cortado.v1.WorkflowConditionOperator operator = 2;
   */
  operator: WorkflowConditionOperator;

  /**
   * @generated from field: string value = 3;
   */
  value: string;

  /**
   * Meaningful only on BRANCH-node conditions. Unset/UNSPECIFIED evaluates
   * field against the trigger entity itself ("self"); a set value evaluates
   * field against a one-hop related entity instead. Rejected at save time on
   * stop conditions and top-level trigger conditions, which always evaluate
   * against the trigger entity.
   *
   * @generated from field: optional cortado.v1.WorkflowTriggerEntityType target_entity_type = 4;
   */
  targetEntityType?: WorkflowTriggerEntityType;
};

/**
 * Describes the message cortado.v1.WorkflowConditionLeaf.
 * Use `create(WorkflowConditionLeafSchema)` to create a new message.
 */
export const WorkflowConditionLeafSchema: GenMessage<WorkflowConditionLeaf> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 462);

/**
 * WorkflowConditionGroup is a logical grouping of conditions
 *
 * @generated from message cortado.v1.WorkflowConditionGroup
 */
export type WorkflowConditionGroup = Message<"cortado.v1.WorkflowConditionGroup"> & {
  /**
   * @generated from field: cortado.v1.WorkflowConditionLogic logic = 1;
   */
  logic: WorkflowConditionLogic;

  /**
   * @generated from field: repeated cortado.v1.WorkflowCondition conditions = 2;
   */
  conditions: WorkflowCondition[];
};

/**
 * Describes the message cortado.v1.WorkflowConditionGroup.
 * Use `create(WorkflowConditionGroupSchema)` to create a new message.
 */
export const WorkflowConditionGroupSchema: GenMessage<WorkflowConditionGroup> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 463);

/**
 * WorkflowCondition is a recursive condition node (group or leaf)
 *
 * @generated from message cortado.v1.WorkflowCondition
 */
export type WorkflowCondition = Message<"cortado.v1.WorkflowCondition"> & {
  /**
   * @generated from oneof cortado.v1.WorkflowCondition.kind
   */
  kind: {
    /**
     * @generated from field: cortado.v1.WorkflowConditionGroup group = 1;
     */
    value: WorkflowConditionGroup;
    case: "group";
  } | {
    /**
     * @generated from field: cortado.v1.WorkflowConditionLeaf leaf = 2;
     */
    value: WorkflowConditionLeaf;
    case: "leaf";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message cortado.v1.WorkflowCondition.
 * Use `create(WorkflowConditionSchema)` to create a new message.
 */
export const WorkflowConditionSchema: GenMessage<WorkflowCondition> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 464);

/**
 * WorkflowStopCondition is a definition-level rule that aborts a running
 * workflow early when a matching lifecycle event is recorded for the run's
 * source resource. Any matching stop condition ends the run (OR semantics).
 *
 * @generated from message cortado.v1.WorkflowStopCondition
 */
export type WorkflowStopCondition = Message<"cortado.v1.WorkflowStopCondition"> & {
  /**
   * Lifecycle event that, when observed, can stop the run. Constrained to the
   * trigger's entity (same-entity correlation in v1).
   *
   * @generated from field: cortado.v1.WorkflowTriggerEventType event_type = 1;
   */
  eventType: WorkflowTriggerEventType;

  /**
   * Optional filter evaluated against the stop event's payload. When unset, any
   * occurrence of event_type stops the run.
   *
   * @generated from field: cortado.v1.WorkflowCondition conditions = 2;
   */
  conditions?: WorkflowCondition;

  /**
   * How the stop event is correlated to the run. Unset or SOURCE matches the
   * run's source_resource_id (v1 default). SUBJECT matches a shared parent
   * (e.g. any quote.accepted on the same inquiry stops a quote-triggered run).
   *
   * @generated from field: optional cortado.v1.WorkflowStopCorrelationScope correlation_scope = 3;
   */
  correlationScope?: WorkflowStopCorrelationScope;
};

/**
 * Describes the message cortado.v1.WorkflowStopCondition.
 * Use `create(WorkflowStopConditionSchema)` to create a new message.
 */
export const WorkflowStopConditionSchema: GenMessage<WorkflowStopCondition> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 465);

/**
 * WorkflowAction defines a single action to execute in the workflow
 *
 * @generated from message cortado.v1.WorkflowAction
 */
export type WorkflowAction = Message<"cortado.v1.WorkflowAction"> & {
  /**
   * @generated from field: cortado.v1.WorkflowActionType action_type = 1;
   */
  actionType: WorkflowActionType;

  /**
   * @generated from field: int32 ordering = 2;
   */
  ordering: number;

  /**
   * JSON-encoded action configuration; schema depends on action_type
   *
   * @generated from field: string config = 3;
   */
  config: string;
};

/**
 * Describes the message cortado.v1.WorkflowAction.
 * Use `create(WorkflowActionSchema)` to create a new message.
 */
export const WorkflowActionSchema: GenMessage<WorkflowAction> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 466);

/**
 * WorkflowNodePosition is the canvas position of a node.
 *
 * @generated from message cortado.v1.WorkflowNodePosition
 */
export type WorkflowNodePosition = Message<"cortado.v1.WorkflowNodePosition"> & {
  /**
   * @generated from field: float x = 1;
   */
  x: number;

  /**
   * @generated from field: float y = 2;
   */
  y: number;
};

/**
 * Describes the message cortado.v1.WorkflowNodePosition.
 * Use `create(WorkflowNodePositionSchema)` to create a new message.
 */
export const WorkflowNodePositionSchema: GenMessage<WorkflowNodePosition> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 467);

/**
 * @generated from message cortado.v1.WorkflowWaitNodeConfig
 */
export type WorkflowWaitNodeConfig = Message<"cortado.v1.WorkflowWaitNodeConfig"> & {
  /**
   * Duration string: "30m", "2h", "3d" (max 90 days).
   *
   * @generated from field: string duration = 1;
   */
  duration: string;
};

/**
 * Describes the message cortado.v1.WorkflowWaitNodeConfig.
 * Use `create(WorkflowWaitNodeConfigSchema)` to create a new message.
 */
export const WorkflowWaitNodeConfigSchema: GenMessage<WorkflowWaitNodeConfig> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 468);

/**
 * @generated from message cortado.v1.WorkflowSendTemplatedEmailNodeConfig
 */
export type WorkflowSendTemplatedEmailNodeConfig = Message<"cortado.v1.WorkflowSendTemplatedEmailNodeConfig"> & {
  /**
   * Dot-path resolved against template variables, e.g. "entity.contact.email".
   *
   * @generated from field: string to_field = 1;
   */
  toField: string;

  /**
   * Literal fallback recipient when to_field is empty or unresolvable.
   *
   * @generated from field: string to_email = 2;
   */
  toEmail: string;

  /**
   * @generated from field: repeated string cc = 3;
   */
  cc: string[];

  /**
   * @generated from field: repeated string bcc = 4;
   */
  bcc: string[];

  /**
   * Inline Go templates; ignored when a saved tenant template is selected
   * (template_id / template_name).
   *
   * @generated from field: string subject_template = 5;
   */
  subjectTemplate: string;

  /**
   * @generated from field: string body_template_html = 6;
   */
  bodyTemplateHtml: string;

  /**
   * DEPRECATED: superseded by template_id. Tenant email template name (matches
   * WorkflowTemplate.email_template_names). Still accepted on save for
   * back-compat — the server resolves it to template_id and stores both, with
   * the id authoritative and the name kept only as a display cache. Never
   * removed or reserved: pre-pinning execution snapshots still bind by it.
   *
   * @generated from field: string template_name = 7;
   */
  templateName: string;

  /**
   * Tenant email template ID (emails.email_templates.id). Supersedes
   * template_name: references bind by ID so a rename cannot break a saved
   * definition, and the referenced content is pinned into the execution
   * snapshot at trigger-match time so a later rename or delete cannot break a
   * run already in flight. When set it takes precedence over both
   * template_name and the inline subject/body templates.
   *
   * @generated from field: string template_id = 8;
   */
  templateId: string;
};

/**
 * Describes the message cortado.v1.WorkflowSendTemplatedEmailNodeConfig.
 * Use `create(WorkflowSendTemplatedEmailNodeConfigSchema)` to create a new message.
 */
export const WorkflowSendTemplatedEmailNodeConfigSchema: GenMessage<WorkflowSendTemplatedEmailNodeConfig> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 469);

/**
 * @generated from message cortado.v1.WorkflowCreateTaskNodeConfig
 */
export type WorkflowCreateTaskNodeConfig = Message<"cortado.v1.WorkflowCreateTaskNodeConfig"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: int32 due_in_days = 3;
   */
  dueInDays: number;

  /**
   * @generated from field: string assigned_to_user_id = 4;
   */
  assignedToUserId: string;

  /**
   * Fallback assignment strategy, e.g. "first_organization_user".
   *
   * @generated from field: string assigned_to_strategy = 5;
   */
  assignedToStrategy: string;
};

/**
 * Describes the message cortado.v1.WorkflowCreateTaskNodeConfig.
 * Use `create(WorkflowCreateTaskNodeConfigSchema)` to create a new message.
 */
export const WorkflowCreateTaskNodeConfigSchema: GenMessage<WorkflowCreateTaskNodeConfig> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 470);

/**
 * @generated from message cortado.v1.WorkflowUpdateFieldNodeConfig
 */
export type WorkflowUpdateFieldNodeConfig = Message<"cortado.v1.WorkflowUpdateFieldNodeConfig"> & {
  /**
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message cortado.v1.WorkflowUpdateFieldNodeConfig.
 * Use `create(WorkflowUpdateFieldNodeConfigSchema)` to create a new message.
 */
export const WorkflowUpdateFieldNodeConfigSchema: GenMessage<WorkflowUpdateFieldNodeConfig> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 471);

/**
 * @generated from message cortado.v1.WorkflowSendWebhookNodeConfig
 */
export type WorkflowSendWebhookNodeConfig = Message<"cortado.v1.WorkflowSendWebhookNodeConfig"> & {
  /**
   * Tenant webhook endpoint (workflows.webhook_endpoints.id) to deliver to.
   * The URL and signing secret live on the endpoint, never on the node, so a
   * rotated secret or edited URL applies to every workflow that references it.
   *
   * @generated from field: string endpoint_id = 1;
   */
  endpointId: string;
};

/**
 * Describes the message cortado.v1.WorkflowSendWebhookNodeConfig.
 * Use `create(WorkflowSendWebhookNodeConfigSchema)` to create a new message.
 */
export const WorkflowSendWebhookNodeConfigSchema: GenMessage<WorkflowSendWebhookNodeConfig> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 472);

/**
 * @generated from message cortado.v1.WorkflowBranchNodeConfig
 */
export type WorkflowBranchNodeConfig = Message<"cortado.v1.WorkflowBranchNodeConfig"> & {
  /**
   * Evaluated against the live entity when the node executes. v1 supports
   * EQUALS/NOT_EQUALS leaves on entity status fields (inquiry stage,
   * quote/invoice status), optionally inside a single AND/OR group.
   *
   * @generated from field: cortado.v1.WorkflowCondition condition = 1;
   */
  condition?: WorkflowCondition;
};

/**
 * Describes the message cortado.v1.WorkflowBranchNodeConfig.
 * Use `create(WorkflowBranchNodeConfigSchema)` to create a new message.
 */
export const WorkflowBranchNodeConfigSchema: GenMessage<WorkflowBranchNodeConfig> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 473);

/**
 * WorkflowSwitchCase is one ordered output of a SWITCH node. The stable id is
 * used as the outgoing edge label; changing the display label never breaks the
 * graph connection. Values within a case use OR semantics. Cases are evaluated
 * in declaration order and the first matching case wins.
 *
 * @generated from message cortado.v1.WorkflowSwitchCase
 */
export type WorkflowSwitchCase = Message<"cortado.v1.WorkflowSwitchCase"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: repeated string values = 3;
   */
  values: string[];
};

/**
 * Describes the message cortado.v1.WorkflowSwitchCase.
 * Use `create(WorkflowSwitchCaseSchema)` to create a new message.
 */
export const WorkflowSwitchCaseSchema: GenMessage<WorkflowSwitchCase> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 474);

/**
 * @generated from message cortado.v1.WorkflowSwitchNodeConfig
 */
export type WorkflowSwitchNodeConfig = Message<"cortado.v1.WorkflowSwitchNodeConfig"> & {
  /**
   * Live enum-backed field to route on, using the same field vocabulary as a
   * BRANCH node (e.g. "event_type", "item_id", "status").
   *
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * Optional one-hop related entity that owns field. Unset means the trigger
   * entity itself, matching WorkflowConditionLeaf.target_entity_type.
   *
   * @generated from field: optional cortado.v1.WorkflowTriggerEntityType target_entity_type = 2;
   */
  targetEntityType?: WorkflowTriggerEntityType;

  /**
   * Ordered cases. The first case whose values contain the live value wins.
   *
   * @generated from field: repeated cortado.v1.WorkflowSwitchCase cases = 3;
   */
  cases: WorkflowSwitchCase[];
};

/**
 * Describes the message cortado.v1.WorkflowSwitchNodeConfig.
 * Use `create(WorkflowSwitchNodeConfigSchema)` to create a new message.
 */
export const WorkflowSwitchNodeConfigSchema: GenMessage<WorkflowSwitchNodeConfig> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 475);

/**
 * WorkflowNode is a single block in a workflow graph.
 *
 * @generated from message cortado.v1.WorkflowNode
 */
export type WorkflowNode = Message<"cortado.v1.WorkflowNode"> & {
  /**
   * Client-generated stable ID, unique within the definition.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: cortado.v1.WorkflowNodeType node_type = 2;
   */
  nodeType: WorkflowNodeType;

  /**
   * @generated from field: cortado.v1.WorkflowNodePosition position = 3;
   */
  position?: WorkflowNodePosition;

  /**
   * Optional display label shown on the canvas.
   *
   * @generated from field: string label = 4;
   */
  label: string;

  /**
   * Optional plain-English description of what this step does. Free text,
   * author-supplied; surfaced in the builder inspector and as a hover tooltip
   * on the canvas. Has no effect on execution.
   *
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * The populated arm MUST match node_type. TRIGGER and STOP carry no config
   * (no arm set); the server rejects a type/config mismatch.
   *
   * @generated from oneof cortado.v1.WorkflowNode.config
   */
  config: {
    /**
     * @generated from field: cortado.v1.WorkflowWaitNodeConfig wait = 10;
     */
    value: WorkflowWaitNodeConfig;
    case: "wait";
  } | {
    /**
     * @generated from field: cortado.v1.WorkflowSendTemplatedEmailNodeConfig send_templated_email = 11;
     */
    value: WorkflowSendTemplatedEmailNodeConfig;
    case: "sendTemplatedEmail";
  } | {
    /**
     * @generated from field: cortado.v1.WorkflowCreateTaskNodeConfig create_task = 12;
     */
    value: WorkflowCreateTaskNodeConfig;
    case: "createTask";
  } | {
    /**
     * @generated from field: cortado.v1.WorkflowUpdateFieldNodeConfig update_field = 13;
     */
    value: WorkflowUpdateFieldNodeConfig;
    case: "updateField";
  } | {
    /**
     * @generated from field: cortado.v1.WorkflowBranchNodeConfig branch = 14;
     */
    value: WorkflowBranchNodeConfig;
    case: "branch";
  } | {
    /**
     * @generated from field: cortado.v1.WorkflowSwitchNodeConfig switch = 15;
     */
    value: WorkflowSwitchNodeConfig;
    case: "switch";
  } | {
    /**
     * @generated from field: cortado.v1.WorkflowSendWebhookNodeConfig send_webhook = 16;
     */
    value: WorkflowSendWebhookNodeConfig;
    case: "sendWebhook";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message cortado.v1.WorkflowNode.
 * Use `create(WorkflowNodeSchema)` to create a new message.
 */
export const WorkflowNodeSchema: GenMessage<WorkflowNode> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 476);

/**
 * WorkflowEdge connects two nodes in a workflow graph.
 *
 * @generated from message cortado.v1.WorkflowEdge
 */
export type WorkflowEdge = Message<"cortado.v1.WorkflowEdge"> & {
  /**
   * Client-generated stable ID, unique within the definition.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string from_node_id = 2;
   */
  fromNodeId: string;

  /**
   * @generated from field: string to_node_id = 3;
   */
  toNodeId: string;

  /**
   * Source output identifier. Exactly "true" or "false" for BRANCH; a stable
   * case id or "otherwise" for SWITCH; empty for linear nodes. The historical
   * field name is retained for wire compatibility.
   *
   * @generated from field: string branch_label = 4;
   */
  branchLabel: string;
};

/**
 * Describes the message cortado.v1.WorkflowEdge.
 * Use `create(WorkflowEdgeSchema)` to create a new message.
 */
export const WorkflowEdgeSchema: GenMessage<WorkflowEdge> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 477);

/**
 * WorkflowDefinition is the complete definition of an automation workflow
 *
 * @generated from message cortado.v1.WorkflowDefinition
 */
export type WorkflowDefinition = Message<"cortado.v1.WorkflowDefinition"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: bool enabled = 5;
   */
  enabled: boolean;

  /**
   * @generated from field: cortado.v1.WorkflowTrigger trigger = 6;
   */
  trigger?: WorkflowTrigger;

  /**
   * @generated from field: cortado.v1.WorkflowCondition conditions = 7;
   */
  conditions?: WorkflowCondition;

  /**
   * @generated from field: repeated cortado.v1.WorkflowAction actions = 8;
   */
  actions: WorkflowAction[];

  /**
   * @generated from field: bool stock = 9;
   */
  stock: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string created_by = 12;
   */
  createdBy: string;

  /**
   * @generated from field: string updated_by = 13;
   */
  updatedBy: string;

  /**
   * Most recent execution time, populated by ListWorkflowDefinitions only.
   *
   * @generated from field: optional google.protobuf.Timestamp last_run_at = 14;
   */
  lastRunAt?: Timestamp;

  /**
   * Graph representation. Always populated in responses: stored graph when
   * the definition was saved as a graph, otherwise synthesized server-side
   * from the legacy linear actions list. When nodes are present in a write
   * request, the graph is authoritative and actions are derived from it.
   *
   * @generated from field: repeated cortado.v1.WorkflowNode nodes = 15;
   */
  nodes: WorkflowNode[];

  /**
   * @generated from field: repeated cortado.v1.WorkflowEdge edges = 16;
   */
  edges: WorkflowEdge[];

  /**
   * Registry template this definition was installed from (empty for
   * hand-built definitions). Read-only: server-set by InstallWorkflowTemplate
   * and ignored on Create/Update.
   *
   * @generated from field: string template_key = 17;
   */
  templateKey: string;

  /**
   * @generated from field: int32 template_version = 18;
   */
  templateVersion: number;

  /**
   * Definition-level stop conditions. Any matching stop event aborts a running
   * execution at its next step boundary (OR semantics). Empty preserves
   * today's behavior.
   *
   * @generated from field: repeated cortado.v1.WorkflowStopCondition stop_conditions = 19;
   */
  stopConditions: WorkflowStopCondition[];

  /**
   * PER_SOURCE is the default. PER_SUBJECT coalesces live runs that share the
   * trigger event's publish-time subject.
   *
   * @generated from field: cortado.v1.WorkflowRunCardinality run_cardinality = 20;
   */
  runCardinality: WorkflowRunCardinality;
};

/**
 * Describes the message cortado.v1.WorkflowDefinition.
 * Use `create(WorkflowDefinitionSchema)` to create a new message.
 */
export const WorkflowDefinitionSchema: GenMessage<WorkflowDefinition> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 478);

/**
 * WorkflowExecution is a single execution of a workflow definition against a
 * triggering event. Mirrors the workflows.workflow_executions DB row.
 *
 * @generated from message cortado.v1.WorkflowExecution
 */
export type WorkflowExecution = Message<"cortado.v1.WorkflowExecution"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string workflow_definition_id = 3;
   */
  workflowDefinitionId: string;

  /**
   * @generated from field: cortado.v1.WorkflowExecutionStatus status = 4;
   */
  status: WorkflowExecutionStatus;

  /**
   * @generated from field: google.protobuf.Timestamp matched_at = 5;
   */
  matchedAt?: Timestamp;

  /**
   * @generated from field: string trigger_event_id = 6;
   */
  triggerEventId: string;

  /**
   * @generated from field: optional string source_resource_id = 7;
   */
  sourceResourceId?: string;

  /**
   * @generated from field: optional string error_message = 8;
   */
  errorMessage?: string;

  /**
   * @generated from field: int32 retry_count = 9;
   */
  retryCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional string retried_from_id = 11;
   */
  retriedFromId?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp started_at = 12;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp completed_at = 13;
   */
  completedAt?: Timestamp;

  /**
   * @generated from field: string trigger_entity_type = 14;
   */
  triggerEntityType: string;

  /**
   * waiting_until is DERIVED (not stored, not from Temporal): for a RUNNING run
   * whose latest step is an in-flight WAIT, it is that step's started_at plus the
   * WAIT node/action's configured duration. Unset for non-waiting / terminal runs.
   *
   * @generated from field: optional google.protobuf.Timestamp waiting_until = 15;
   */
  waitingUntil?: Timestamp;

  /**
   * current_step_label is the action/node type of the latest step row for an
   * active run (e.g. "WAIT", "SEND_TEMPLATED_EMAIL"). Empty for terminal runs.
   *
   * @generated from field: string current_step_label = 16;
   */
  currentStepLabel: string;

  /**
   * current_step_index is the action_index of the latest step row for an active
   * run. -1 when no step has been recorded yet.
   *
   * @generated from field: int32 current_step_index = 17;
   */
  currentStepIndex: number;

  /**
   * stopped_by_event_type is the lifecycle event that aborted the run; set only
   * when status == WORKFLOW_EXECUTION_STATUS_STOPPED.
   *
   * @generated from field: string stopped_by_event_type = 18;
   */
  stoppedByEventType: string;

  /**
   * manually_triggered is true when a user started this run by hand rather
   * than a lifecycle trigger.
   *
   * @generated from field: bool manually_triggered = 19;
   */
  manuallyTriggered: boolean;

  /**
   * Optional, display-ready list fields. Populated only when the list request
   * opts in so execution/detail paths do not pay for enrichment.
   *
   * @generated from field: string workflow_name = 70;
   */
  workflowName: string;

  /**
   * @generated from field: string entity_title = 71;
   */
  entityTitle: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp event_date = 72;
   */
  eventDate?: Timestamp;

  /**
   * @generated from field: string event_location = 73;
   */
  eventLocation: string;

  /**
   * linked_event_id is the event page this run should open. Set for EVENT
   * triggers (the source event) and BOOKING triggers (the booking's earliest
   * event — the same row entity_title and event_date come from). Empty when
   * that event does not exist. Never a booking id.
   *
   * @generated from field: string linked_event_id = 74;
   */
  linkedEventId: string;

  /**
   * linked_inquiry_id is the lead behind a BOOKING trigger, so a booking
   * with no event can still open its lead. Empty for other entity types.
   *
   * @generated from field: string linked_inquiry_id = 75;
   */
  linkedInquiryId: string;

  /**
   * @generated from field: string contact_name = 81;
   */
  contactName: string;

  /**
   * @generated from field: string contact_email = 82;
   */
  contactEmail: string;

  /**
   * @generated from field: string contact_phone = 83;
   */
  contactPhone: string;
};

/**
 * Describes the message cortado.v1.WorkflowExecution.
 * Use `create(WorkflowExecutionSchema)` to create a new message.
 */
export const WorkflowExecutionSchema: GenMessage<WorkflowExecution> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 479);

/**
 * WorkflowExecutionStep is one action result inside an execution.
 *
 * @generated from message cortado.v1.WorkflowExecutionStep
 */
export type WorkflowExecutionStep = Message<"cortado.v1.WorkflowExecutionStep"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string workflow_execution_id = 2;
   */
  workflowExecutionId: string;

  /**
   * @generated from field: int32 action_index = 3;
   */
  actionIndex: number;

  /**
   * @generated from field: string action_type = 4;
   */
  actionType: string;

  /**
   * @generated from field: cortado.v1.WorkflowExecutionStepStatus status = 5;
   */
  status: WorkflowExecutionStepStatus;

  /**
   * @generated from field: string result_data = 6;
   */
  resultData: string;

  /**
   * @generated from field: optional string error_message = 7;
   */
  errorMessage?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp started_at = 8;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp completed_at = 9;
   */
  completedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * Node identity from the v2 node-runtime execution model
   * (workflow_execution_steps.node_id, migration 000329). Empty for
   * legacy/pre-graph steps that predate node-identity-keyed history.
   *
   * @generated from field: string node_id = 11;
   */
  nodeId: string;

  /**
   * Retry attempt ordinal for this node (workflow_execution_steps.attempt).
   * 0 for legacy steps and for nodes that have not yet retried.
   *
   * @generated from field: int32 attempt = 12;
   */
  attempt: number;
};

/**
 * Describes the message cortado.v1.WorkflowExecutionStep.
 * Use `create(WorkflowExecutionStepSchema)` to create a new message.
 */
export const WorkflowExecutionStepSchema: GenMessage<WorkflowExecutionStep> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 480);

/**
 * @generated from message cortado.v1.CreateWorkflowDefinitionRequest
 */
export type CreateWorkflowDefinitionRequest = Message<"cortado.v1.CreateWorkflowDefinitionRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: bool enabled = 4;
   */
  enabled: boolean;

  /**
   * @generated from field: cortado.v1.WorkflowTrigger trigger = 5;
   */
  trigger?: WorkflowTrigger;

  /**
   * @generated from field: cortado.v1.WorkflowCondition conditions = 6;
   */
  conditions?: WorkflowCondition;

  /**
   * Legacy linear form. Ignored when nodes are provided.
   *
   * @generated from field: repeated cortado.v1.WorkflowAction actions = 7;
   */
  actions: WorkflowAction[];

  /**
   * Graph form. When non-empty, authoritative; actions are derived.
   *
   * @generated from field: repeated cortado.v1.WorkflowNode nodes = 8;
   */
  nodes: WorkflowNode[];

  /**
   * @generated from field: repeated cortado.v1.WorkflowEdge edges = 9;
   */
  edges: WorkflowEdge[];

  /**
   * Definition-level stop conditions saved with the workflow.
   *
   * @generated from field: repeated cortado.v1.WorkflowStopCondition stop_conditions = 10;
   */
  stopConditions: WorkflowStopCondition[];

  /**
   * Unspecified defaults to PER_SOURCE.
   *
   * @generated from field: cortado.v1.WorkflowRunCardinality run_cardinality = 11;
   */
  runCardinality: WorkflowRunCardinality;
};

/**
 * Describes the message cortado.v1.CreateWorkflowDefinitionRequest.
 * Use `create(CreateWorkflowDefinitionRequestSchema)` to create a new message.
 */
export const CreateWorkflowDefinitionRequestSchema: GenMessage<CreateWorkflowDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 481);

/**
 * @generated from message cortado.v1.CreateWorkflowDefinitionResponse
 */
export type CreateWorkflowDefinitionResponse = Message<"cortado.v1.CreateWorkflowDefinitionResponse"> & {
  /**
   * @generated from field: cortado.v1.WorkflowDefinition workflow_definition = 1;
   */
  workflowDefinition?: WorkflowDefinition;
};

/**
 * Describes the message cortado.v1.CreateWorkflowDefinitionResponse.
 * Use `create(CreateWorkflowDefinitionResponseSchema)` to create a new message.
 */
export const CreateWorkflowDefinitionResponseSchema: GenMessage<CreateWorkflowDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 482);

/**
 * WorkflowValidationIssue is one save-time validation failure, field-keyed so
 * the builder can route it directly to the offending control instead of
 * substring-matching English error text.
 *
 * @generated from message cortado.v1.WorkflowValidationIssue
 */
export type WorkflowValidationIssue = Message<"cortado.v1.WorkflowValidationIssue"> & {
  /**
   * Structured path into the definition, matching
   * internal/models/workflows.WorkflowValidationError.Field verbatim, e.g.
   * "trigger.event_type" or "nodes[abc123].config".
   *
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * Human-readable message, safe to display as-is.
   *
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * Node id parsed out of a "nodes[<id>]..." field path (the id may be a
   * client-authored node id or, for a handful of purely structural checks,
   * the node's array index — whatever the validator's field path carried).
   * Empty when the issue is not node-scoped (trigger, conditions,
   * stop_conditions, or a graph-level check with no single offending node).
   *
   * @generated from field: string node_id = 3;
   */
  nodeId: string;

  /**
   * Coarse, stable machine key for the section of validation that produced
   * the issue: "invalid_trigger", "invalid_condition", "invalid_graph",
   * "invalid_edge", "invalid_config", or "unknown".
   *
   * @generated from field: string code = 4;
   */
  code: string;
};

/**
 * Describes the message cortado.v1.WorkflowValidationIssue.
 * Use `create(WorkflowValidationIssueSchema)` to create a new message.
 */
export const WorkflowValidationIssueSchema: GenMessage<WorkflowValidationIssue> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 483);

/**
 * ValidateWorkflowDefinitionRequest carries the same definition-shaped fields
 * as CreateWorkflowDefinitionRequest, graph form only (the legacy actions
 * list is not accepted here — validate the graph the builder authors). No
 * write occurs; ValidateWorkflowDefinitionResponse.issues aggregates every
 * issue the backend validators can find in one pass.
 *
 * @generated from message cortado.v1.ValidateWorkflowDefinitionRequest
 */
export type ValidateWorkflowDefinitionRequest = Message<"cortado.v1.ValidateWorkflowDefinitionRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: cortado.v1.WorkflowTrigger trigger = 3;
   */
  trigger?: WorkflowTrigger;

  /**
   * @generated from field: cortado.v1.WorkflowCondition conditions = 4;
   */
  conditions?: WorkflowCondition;

  /**
   * @generated from field: repeated cortado.v1.WorkflowNode nodes = 5;
   */
  nodes: WorkflowNode[];

  /**
   * @generated from field: repeated cortado.v1.WorkflowEdge edges = 6;
   */
  edges: WorkflowEdge[];

  /**
   * Definition-level stop conditions, validated against the trigger's entity
   * type same as Create/UpdateWorkflowDefinition.
   *
   * @generated from field: repeated cortado.v1.WorkflowStopCondition stop_conditions = 7;
   */
  stopConditions: WorkflowStopCondition[];
};

/**
 * Describes the message cortado.v1.ValidateWorkflowDefinitionRequest.
 * Use `create(ValidateWorkflowDefinitionRequestSchema)` to create a new message.
 */
export const ValidateWorkflowDefinitionRequestSchema: GenMessage<ValidateWorkflowDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 484);

/**
 * @generated from message cortado.v1.ValidateWorkflowDefinitionResponse
 */
export type ValidateWorkflowDefinitionResponse = Message<"cortado.v1.ValidateWorkflowDefinitionResponse"> & {
  /**
   * True exactly when issues is empty.
   *
   * @generated from field: bool valid = 1;
   */
  valid: boolean;

  /**
   * @generated from field: repeated cortado.v1.WorkflowValidationIssue issues = 2;
   */
  issues: WorkflowValidationIssue[];
};

/**
 * Describes the message cortado.v1.ValidateWorkflowDefinitionResponse.
 * Use `create(ValidateWorkflowDefinitionResponseSchema)` to create a new message.
 */
export const ValidateWorkflowDefinitionResponseSchema: GenMessage<ValidateWorkflowDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 485);

/**
 * @generated from message cortado.v1.GetWorkflowDefinitionRequest
 */
export type GetWorkflowDefinitionRequest = Message<"cortado.v1.GetWorkflowDefinitionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetWorkflowDefinitionRequest.
 * Use `create(GetWorkflowDefinitionRequestSchema)` to create a new message.
 */
export const GetWorkflowDefinitionRequestSchema: GenMessage<GetWorkflowDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 486);

/**
 * @generated from message cortado.v1.GetWorkflowDefinitionResponse
 */
export type GetWorkflowDefinitionResponse = Message<"cortado.v1.GetWorkflowDefinitionResponse"> & {
  /**
   * @generated from field: cortado.v1.WorkflowDefinition workflow_definition = 1;
   */
  workflowDefinition?: WorkflowDefinition;
};

/**
 * Describes the message cortado.v1.GetWorkflowDefinitionResponse.
 * Use `create(GetWorkflowDefinitionResponseSchema)` to create a new message.
 */
export const GetWorkflowDefinitionResponseSchema: GenMessage<GetWorkflowDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 487);

/**
 * @generated from message cortado.v1.ListWorkflowDefinitionsRequest
 */
export type ListWorkflowDefinitionsRequest = Message<"cortado.v1.ListWorkflowDefinitionsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListWorkflowDefinitionsRequest.
 * Use `create(ListWorkflowDefinitionsRequestSchema)` to create a new message.
 */
export const ListWorkflowDefinitionsRequestSchema: GenMessage<ListWorkflowDefinitionsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 488);

/**
 * @generated from message cortado.v1.ListWorkflowDefinitionsResponse
 */
export type ListWorkflowDefinitionsResponse = Message<"cortado.v1.ListWorkflowDefinitionsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.WorkflowDefinition workflow_definitions = 1;
   */
  workflowDefinitions: WorkflowDefinition[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListWorkflowDefinitionsResponse.
 * Use `create(ListWorkflowDefinitionsResponseSchema)` to create a new message.
 */
export const ListWorkflowDefinitionsResponseSchema: GenMessage<ListWorkflowDefinitionsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 489);

/**
 * @generated from message cortado.v1.UpdateWorkflowDefinitionRequest
 */
export type UpdateWorkflowDefinitionRequest = Message<"cortado.v1.UpdateWorkflowDefinitionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional bool enabled = 4;
   */
  enabled?: boolean;

  /**
   * @generated from field: optional cortado.v1.WorkflowTrigger trigger = 5;
   */
  trigger?: WorkflowTrigger;

  /**
   * @generated from field: optional cortado.v1.WorkflowCondition conditions = 6;
   */
  conditions?: WorkflowCondition;

  /**
   * @generated from field: repeated cortado.v1.WorkflowAction actions = 7;
   */
  actions: WorkflowAction[];

  /**
   * @generated from field: bool update_actions = 8;
   */
  updateActions: boolean;

  /**
   * Graph form. Applied when update_graph is true; takes precedence over
   * actions/update_actions and re-derives the stored actions list.
   *
   * @generated from field: repeated cortado.v1.WorkflowNode nodes = 9;
   */
  nodes: WorkflowNode[];

  /**
   * @generated from field: repeated cortado.v1.WorkflowEdge edges = 10;
   */
  edges: WorkflowEdge[];

  /**
   * @generated from field: bool update_graph = 11;
   */
  updateGraph: boolean;

  /**
   * When true, conditions is applied as-is (including clearing when empty);
   * when false, conditions is left unchanged.
   *
   * @generated from field: bool update_conditions = 12;
   */
  updateConditions: boolean;

  /**
   * Definition-level stop conditions. Applied only when update_stop_conditions
   * is true (including clearing when empty); otherwise left unchanged.
   *
   * @generated from field: repeated cortado.v1.WorkflowStopCondition stop_conditions = 13;
   */
  stopConditions: WorkflowStopCondition[];

  /**
   * @generated from field: bool update_stop_conditions = 14;
   */
  updateStopConditions: boolean;

  /**
   * Applied only when present; unspecified is rejected when explicitly set.
   *
   * @generated from field: optional cortado.v1.WorkflowRunCardinality run_cardinality = 15;
   */
  runCardinality?: WorkflowRunCardinality;
};

/**
 * Describes the message cortado.v1.UpdateWorkflowDefinitionRequest.
 * Use `create(UpdateWorkflowDefinitionRequestSchema)` to create a new message.
 */
export const UpdateWorkflowDefinitionRequestSchema: GenMessage<UpdateWorkflowDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 490);

/**
 * @generated from message cortado.v1.UpdateWorkflowDefinitionResponse
 */
export type UpdateWorkflowDefinitionResponse = Message<"cortado.v1.UpdateWorkflowDefinitionResponse"> & {
  /**
   * @generated from field: cortado.v1.WorkflowDefinition workflow_definition = 1;
   */
  workflowDefinition?: WorkflowDefinition;
};

/**
 * Describes the message cortado.v1.UpdateWorkflowDefinitionResponse.
 * Use `create(UpdateWorkflowDefinitionResponseSchema)` to create a new message.
 */
export const UpdateWorkflowDefinitionResponseSchema: GenMessage<UpdateWorkflowDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 491);

/**
 * @generated from message cortado.v1.DeleteWorkflowDefinitionRequest
 */
export type DeleteWorkflowDefinitionRequest = Message<"cortado.v1.DeleteWorkflowDefinitionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteWorkflowDefinitionRequest.
 * Use `create(DeleteWorkflowDefinitionRequestSchema)` to create a new message.
 */
export const DeleteWorkflowDefinitionRequestSchema: GenMessage<DeleteWorkflowDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 492);

/**
 * @generated from message cortado.v1.DeleteWorkflowDefinitionResponse
 */
export type DeleteWorkflowDefinitionResponse = Message<"cortado.v1.DeleteWorkflowDefinitionResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteWorkflowDefinitionResponse.
 * Use `create(DeleteWorkflowDefinitionResponseSchema)` to create a new message.
 */
export const DeleteWorkflowDefinitionResponseSchema: GenMessage<DeleteWorkflowDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 493);

/**
 * @generated from message cortado.v1.ListWorkflowExecutionsRequest
 */
export type ListWorkflowExecutionsRequest = Message<"cortado.v1.ListWorkflowExecutionsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Optional. When set, scopes results to one workflow definition (the existing
   * per-definition Runs tab). When unset, lists across all definitions in the org
   * (global active-runs view, per-entity view).
   *
   * @generated from field: optional string workflow_definition_id = 2;
   */
  workflowDefinitionId?: string;

  /**
   * @generated from field: optional int32 page_size = 3;
   */
  pageSize?: number;

  /**
   * @generated from field: optional string page_token = 4;
   */
  pageToken?: string;

  /**
   * @generated from field: repeated cortado.v1.WorkflowExecutionStatus statuses = 5;
   */
  statuses: WorkflowExecutionStatus[];

  /**
   * Optional. Filters to executions whose source_resource_id equals this id
   * (per-entity view: inquiry id for leads, booking id for events).
   *
   * @generated from field: optional string source_resource_id = 6;
   */
  sourceResourceId?: string;

  /**
   * Optional. Filters to executions whose trigger_entity_type equals this value
   * (UPPERCASE entity name, e.g. "INQUIRY", "BOOKING"). Matches the existing
   * string representation on WorkflowExecution.trigger_entity_type.
   *
   * @generated from field: optional string trigger_entity_type = 7;
   */
  triggerEntityType?: string;

  /**
   * Populates each execution's optional workflow, source-entity, and contact
   * summary fields. Intended for the global active-runs table.
   *
   * @generated from field: bool include_display_context = 8;
   */
  includeDisplayContext: boolean;
};

/**
 * Describes the message cortado.v1.ListWorkflowExecutionsRequest.
 * Use `create(ListWorkflowExecutionsRequestSchema)` to create a new message.
 */
export const ListWorkflowExecutionsRequestSchema: GenMessage<ListWorkflowExecutionsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 494);

/**
 * @generated from message cortado.v1.ListWorkflowExecutionsResponse
 */
export type ListWorkflowExecutionsResponse = Message<"cortado.v1.ListWorkflowExecutionsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.WorkflowExecution executions = 1;
   */
  executions: WorkflowExecution[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message cortado.v1.ListWorkflowExecutionsResponse.
 * Use `create(ListWorkflowExecutionsResponseSchema)` to create a new message.
 */
export const ListWorkflowExecutionsResponseSchema: GenMessage<ListWorkflowExecutionsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 495);

/**
 * @generated from message cortado.v1.GetWorkflowExecutionRequest
 */
export type GetWorkflowExecutionRequest = Message<"cortado.v1.GetWorkflowExecutionRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string workflow_execution_id = 2;
   */
  workflowExecutionId: string;
};

/**
 * Describes the message cortado.v1.GetWorkflowExecutionRequest.
 * Use `create(GetWorkflowExecutionRequestSchema)` to create a new message.
 */
export const GetWorkflowExecutionRequestSchema: GenMessage<GetWorkflowExecutionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 496);

/**
 * @generated from message cortado.v1.GetWorkflowExecutionResponse
 */
export type GetWorkflowExecutionResponse = Message<"cortado.v1.GetWorkflowExecutionResponse"> & {
  /**
   * @generated from field: cortado.v1.WorkflowExecution execution = 1;
   */
  execution?: WorkflowExecution;

  /**
   * @generated from field: repeated cortado.v1.WorkflowExecutionStep steps = 2;
   */
  steps: WorkflowExecutionStep[];

  /**
   * @generated from field: repeated cortado.v1.WorkflowConditionTraceStep condition_trace = 3;
   */
  conditionTrace: WorkflowConditionTraceStep[];
};

/**
 * Describes the message cortado.v1.GetWorkflowExecutionResponse.
 * Use `create(GetWorkflowExecutionResponseSchema)` to create a new message.
 */
export const GetWorkflowExecutionResponseSchema: GenMessage<GetWorkflowExecutionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 497);

/**
 * @generated from message cortado.v1.GetWorkflowHealthRequest
 */
export type GetWorkflowHealthRequest = Message<"cortado.v1.GetWorkflowHealthRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.GetWorkflowHealthRequest.
 * Use `create(GetWorkflowHealthRequestSchema)` to create a new message.
 */
export const GetWorkflowHealthRequestSchema: GenMessage<GetWorkflowHealthRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 498);

/**
 * GetWorkflowHealthResponse summarizes failed workflow executions over a
 * server-owned rolling window. The window is deliberately not client-settable:
 * an unwindowed count never clears after a workflow is fixed and trains users
 * to ignore the badge.
 *
 * @generated from message cortado.v1.GetWorkflowHealthResponse
 */
export type GetWorkflowHealthResponse = Message<"cortado.v1.GetWorkflowHealthResponse"> & {
  /**
   * Number of failed executions in the window. This is the badge number — it
   * answers "how many customers didn't get emailed".
   *
   * @generated from field: int32 failed_execution_count = 1;
   */
  failedExecutionCount: number;

  /**
   * Number of distinct workflow definitions among those failed executions —
   * how much work the fix is.
   *
   * @generated from field: int32 affected_definition_count = 2;
   */
  affectedDefinitionCount: number;

  /**
   * Inclusive start of the window the counts were computed over. Clients should
   * render the window from this rather than assuming a fixed duration.
   *
   * @generated from field: google.protobuf.Timestamp since = 3;
   */
  since?: Timestamp;
};

/**
 * Describes the message cortado.v1.GetWorkflowHealthResponse.
 * Use `create(GetWorkflowHealthResponseSchema)` to create a new message.
 */
export const GetWorkflowHealthResponseSchema: GenMessage<GetWorkflowHealthResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 499);

/**
 * @generated from message cortado.v1.RetryWorkflowExecutionRequest
 */
export type RetryWorkflowExecutionRequest = Message<"cortado.v1.RetryWorkflowExecutionRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string workflow_execution_id = 2;
   */
  workflowExecutionId: string;
};

/**
 * Describes the message cortado.v1.RetryWorkflowExecutionRequest.
 * Use `create(RetryWorkflowExecutionRequestSchema)` to create a new message.
 */
export const RetryWorkflowExecutionRequestSchema: GenMessage<RetryWorkflowExecutionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 500);

/**
 * @generated from message cortado.v1.RetryWorkflowExecutionResponse
 */
export type RetryWorkflowExecutionResponse = Message<"cortado.v1.RetryWorkflowExecutionResponse"> & {
  /**
   * @generated from field: cortado.v1.WorkflowExecution execution = 1;
   */
  execution?: WorkflowExecution;
};

/**
 * Describes the message cortado.v1.RetryWorkflowExecutionResponse.
 * Use `create(RetryWorkflowExecutionResponseSchema)` to create a new message.
 */
export const RetryWorkflowExecutionResponseSchema: GenMessage<RetryWorkflowExecutionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 501);

/**
 * @generated from message cortado.v1.CancelWorkflowExecutionRequest
 */
export type CancelWorkflowExecutionRequest = Message<"cortado.v1.CancelWorkflowExecutionRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string workflow_execution_id = 2;
   */
  workflowExecutionId: string;
};

/**
 * Describes the message cortado.v1.CancelWorkflowExecutionRequest.
 * Use `create(CancelWorkflowExecutionRequestSchema)` to create a new message.
 */
export const CancelWorkflowExecutionRequestSchema: GenMessage<CancelWorkflowExecutionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 502);

/**
 * @generated from message cortado.v1.CancelWorkflowExecutionResponse
 */
export type CancelWorkflowExecutionResponse = Message<"cortado.v1.CancelWorkflowExecutionResponse"> & {
  /**
   * @generated from field: cortado.v1.WorkflowExecution execution = 1;
   */
  execution?: WorkflowExecution;
};

/**
 * Describes the message cortado.v1.CancelWorkflowExecutionResponse.
 * Use `create(CancelWorkflowExecutionResponseSchema)` to create a new message.
 */
export const CancelWorkflowExecutionResponseSchema: GenMessage<CancelWorkflowExecutionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 503);

/**
 * StartWorkflowExecutionRequest starts a workflow manually against a single
 * entity, bypassing the definition's trigger conditions.
 *
 * @generated from message cortado.v1.StartWorkflowExecutionRequest
 */
export type StartWorkflowExecutionRequest = Message<"cortado.v1.StartWorkflowExecutionRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string workflow_definition_id = 2;
   */
  workflowDefinitionId: string;

  /**
   * @generated from field: cortado.v1.WorkflowTriggerEntityType entity_type = 3;
   */
  entityType: WorkflowTriggerEntityType;

  /**
   * @generated from field: string source_resource_id = 4;
   */
  sourceResourceId: string;
};

/**
 * Describes the message cortado.v1.StartWorkflowExecutionRequest.
 * Use `create(StartWorkflowExecutionRequestSchema)` to create a new message.
 */
export const StartWorkflowExecutionRequestSchema: GenMessage<StartWorkflowExecutionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 504);

/**
 * @generated from message cortado.v1.StartWorkflowExecutionResponse
 */
export type StartWorkflowExecutionResponse = Message<"cortado.v1.StartWorkflowExecutionResponse"> & {
  /**
   * @generated from field: cortado.v1.WorkflowExecution execution = 1;
   */
  execution?: WorkflowExecution;
};

/**
 * Describes the message cortado.v1.StartWorkflowExecutionResponse.
 * Use `create(StartWorkflowExecutionResponseSchema)` to create a new message.
 */
export const StartWorkflowExecutionResponseSchema: GenMessage<StartWorkflowExecutionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 505);

/**
 * @generated from message cortado.v1.CloneWorkflowDefinitionRequest
 */
export type CloneWorkflowDefinitionRequest = Message<"cortado.v1.CloneWorkflowDefinitionRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string source_workflow_definition_id = 2;
   */
  sourceWorkflowDefinitionId: string;

  /**
   * @generated from field: optional string name = 3;
   */
  name?: string;
};

/**
 * Describes the message cortado.v1.CloneWorkflowDefinitionRequest.
 * Use `create(CloneWorkflowDefinitionRequestSchema)` to create a new message.
 */
export const CloneWorkflowDefinitionRequestSchema: GenMessage<CloneWorkflowDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 506);

/**
 * @generated from message cortado.v1.CloneWorkflowDefinitionResponse
 */
export type CloneWorkflowDefinitionResponse = Message<"cortado.v1.CloneWorkflowDefinitionResponse"> & {
  /**
   * @generated from field: cortado.v1.WorkflowDefinition workflow_definition = 1;
   */
  workflowDefinition?: WorkflowDefinition;
};

/**
 * Describes the message cortado.v1.CloneWorkflowDefinitionResponse.
 * Use `create(CloneWorkflowDefinitionResponseSchema)` to create a new message.
 */
export const CloneWorkflowDefinitionResponseSchema: GenMessage<CloneWorkflowDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 507);

/**
 * WorkflowConditionTraceStep is a single node's evaluation record from
 * conditionmatcher.Evaluate, returned by EvaluateWorkflowConditions.
 *
 * @generated from message cortado.v1.WorkflowConditionTraceStep
 */
export type WorkflowConditionTraceStep = Message<"cortado.v1.WorkflowConditionTraceStep"> & {
  /**
   * @generated from field: string op = 1;
   */
  op: string;

  /**
   * @generated from field: string field = 2;
   */
  field: string;

  /**
   * @generated from field: string expected = 3;
   */
  expected: string;

  /**
   * @generated from field: string actual = 4;
   */
  actual: string;

  /**
   * @generated from field: bool result = 5;
   */
  result: boolean;

  /**
   * @generated from field: string reason = 6;
   */
  reason: string;
};

/**
 * Describes the message cortado.v1.WorkflowConditionTraceStep.
 * Use `create(WorkflowConditionTraceStepSchema)` to create a new message.
 */
export const WorkflowConditionTraceStepSchema: GenMessage<WorkflowConditionTraceStep> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 508);

/**
 * @generated from message cortado.v1.EvaluateWorkflowConditionsRequest
 */
export type EvaluateWorkflowConditionsRequest = Message<"cortado.v1.EvaluateWorkflowConditionsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: cortado.v1.WorkflowTriggerEntityType entity_type = 2;
   */
  entityType: WorkflowTriggerEntityType;

  /**
   * @generated from field: cortado.v1.WorkflowCondition conditions = 3;
   */
  conditions?: WorkflowCondition;
};

/**
 * Describes the message cortado.v1.EvaluateWorkflowConditionsRequest.
 * Use `create(EvaluateWorkflowConditionsRequestSchema)` to create a new message.
 */
export const EvaluateWorkflowConditionsRequestSchema: GenMessage<EvaluateWorkflowConditionsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 509);

/**
 * @generated from message cortado.v1.EvaluateWorkflowConditionsResponse
 */
export type EvaluateWorkflowConditionsResponse = Message<"cortado.v1.EvaluateWorkflowConditionsResponse"> & {
  /**
   * @generated from field: bool sample_found = 1;
   */
  sampleFound: boolean;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * @generated from field: string entity_label = 3;
   */
  entityLabel: string;

  /**
   * @generated from field: bool matched = 4;
   */
  matched: boolean;

  /**
   * @generated from field: repeated cortado.v1.WorkflowConditionTraceStep trace = 5;
   */
  trace: WorkflowConditionTraceStep[];
};

/**
 * Describes the message cortado.v1.EvaluateWorkflowConditionsResponse.
 * Use `create(EvaluateWorkflowConditionsResponseSchema)` to create a new message.
 */
export const EvaluateWorkflowConditionsResponseSchema: GenMessage<EvaluateWorkflowConditionsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 510);

/**
 * WorkflowFieldSchema describes one condition field for an entity.
 *
 * @generated from message cortado.v1.WorkflowFieldSchema
 */
export type WorkflowFieldSchema = Message<"cortado.v1.WorkflowFieldSchema"> & {
  /**
   * Condition field key as evaluated against the trigger payload, e.g. "stage".
   *
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: cortado.v1.WorkflowFieldKind kind = 3;
   */
  kind: WorkflowFieldKind;

  /**
   * Set only when kind == ENUM; empty otherwise. System-settings source key the
   * client resolves options from, e.g. "inquiryStage", "eventType",
   * "bookingStage", "invoiceStatus", "paymentScheduleStatus".
   *
   * @generated from field: string enum_source = 4;
   */
  enumSource: string;

  /**
   * Entity this field is read from when used as a branch field. Unset/
   * UNSPECIFIED means the trigger entity itself ("self"); a set value names
   * a one-hop related entity, e.g. INQUIRY for a QUOTE-triggered branch
   * field reading the parent lead's stage.
   *
   * @generated from field: optional cortado.v1.WorkflowTriggerEntityType target_entity_type = 5;
   */
  targetEntityType?: WorkflowTriggerEntityType;
};

/**
 * Describes the message cortado.v1.WorkflowFieldSchema.
 * Use `create(WorkflowFieldSchemaSchema)` to create a new message.
 */
export const WorkflowFieldSchemaSchema: GenMessage<WorkflowFieldSchema> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 511);

/**
 * WorkflowVariableSchema describes one template variable available to
 * templated email subject/body for an entity.
 *
 * @generated from message cortado.v1.WorkflowVariableSchema
 */
export type WorkflowVariableSchema = Message<"cortado.v1.WorkflowVariableSchema"> & {
  /**
   * Dot path inserted into templates, e.g. "entity.contact.email".
   *
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * Illustrative example value shown in pickers.
   *
   * @generated from field: string example = 3;
   */
  example: string;
};

/**
 * Describes the message cortado.v1.WorkflowVariableSchema.
 * Use `create(WorkflowVariableSchemaSchema)` to create a new message.
 */
export const WorkflowVariableSchemaSchema: GenMessage<WorkflowVariableSchema> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 512);

/**
 * WorkflowEntityAuthoringSchema groups authoring vocabulary per entity type.
 *
 * @generated from message cortado.v1.WorkflowEntityAuthoringSchema
 */
export type WorkflowEntityAuthoringSchema = Message<"cortado.v1.WorkflowEntityAuthoringSchema"> & {
  /**
   * @generated from field: cortado.v1.WorkflowTriggerEntityType entity_type = 1;
   */
  entityType: WorkflowTriggerEntityType;

  /**
   * @generated from field: repeated cortado.v1.WorkflowFieldSchema condition_fields = 2;
   */
  conditionFields: WorkflowFieldSchema[];

  /**
   * @generated from field: repeated cortado.v1.WorkflowVariableSchema template_variables = 3;
   */
  templateVariables: WorkflowVariableSchema[];

  /**
   * Valid to_field recipient paths, e.g. "entity.contact.email".
   *
   * @generated from field: repeated string to_field_paths = 4;
   */
  toFieldPaths: string[];

  /**
   * Branch-node condition fields supported against live entity state (v1:
   * inquiry stage, quote/invoice status). An entry may carry
   * target_entity_type naming a one-hop related entity the field is read
   * from instead of this entity_type; unset means the trigger entity itself.
   *
   * @generated from field: repeated cortado.v1.WorkflowFieldSchema branch_fields = 5;
   */
  branchFields: WorkflowFieldSchema[];

  /**
   * Fields writable by UPDATE_FIELD nodes for this entity.
   *
   * @generated from field: repeated cortado.v1.WorkflowFieldSchema update_fields = 6;
   */
  updateFields: WorkflowFieldSchema[];

  /**
   * Node types that may be added to a workflow with THIS trigger entity, e.g.
   * CREATE_TASK is unsupported for CONTACT triggers. Mirrors the
   * server save-time allow-lists so the builder can validate before save.
   *
   * @generated from field: repeated cortado.v1.WorkflowNodeType supported_node_types = 7;
   */
  supportedNodeTypes: WorkflowNodeType[];

  /**
   * Lifecycle events that can stop a workflow triggered by THIS entity
   * (same-entity correlation). Only publisher-wired events are offered; the
   * stop-event picker reads this list.
   *
   * @generated from field: repeated cortado.v1.WorkflowTriggerEventType stop_events = 8;
   */
  stopEvents: WorkflowTriggerEventType[];

  /**
   * True when StartWorkflowExecution accepts a manual run against this
   * entity type (StartManual's supported-type allow-list).
   *
   * @generated from field: bool manual_run_supported = 9;
   */
  manualRunSupported: boolean;
};

/**
 * Describes the message cortado.v1.WorkflowEntityAuthoringSchema.
 * Use `create(WorkflowEntityAuthoringSchemaSchema)` to create a new message.
 */
export const WorkflowEntityAuthoringSchemaSchema: GenMessage<WorkflowEntityAuthoringSchema> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 513);

/**
 * WorkflowTriggerEventSchema describes one selectable trigger event.
 *
 * @generated from message cortado.v1.WorkflowTriggerEventSchema
 */
export type WorkflowTriggerEventSchema = Message<"cortado.v1.WorkflowTriggerEventSchema"> & {
  /**
   * @generated from field: cortado.v1.WorkflowTriggerEventType event_type = 1;
   */
  eventType: WorkflowTriggerEventType;

  /**
   * @generated from field: cortado.v1.WorkflowTriggerEntityType entity_type = 2;
   */
  entityType: WorkflowTriggerEntityType;

  /**
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * True when a backend publisher emits this event; only wired events are
   * selectable in the builder.
   *
   * @generated from field: bool publisher_wired = 5;
   */
  publisherWired: boolean;

  /**
   * Filter fields only this event's payload carries, offered on top of the
   * entity's condition_fields (e.g. the received email's subject).
   *
   * @generated from field: repeated cortado.v1.WorkflowFieldSchema condition_fields = 6;
   */
  conditionFields: WorkflowFieldSchema[];
};

/**
 * Describes the message cortado.v1.WorkflowTriggerEventSchema.
 * Use `create(WorkflowTriggerEventSchemaSchema)` to create a new message.
 */
export const WorkflowTriggerEventSchemaSchema: GenMessage<WorkflowTriggerEventSchema> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 514);

/**
 * @generated from message cortado.v1.GetWorkflowAuthoringSchemaRequest
 */
export type GetWorkflowAuthoringSchemaRequest = Message<"cortado.v1.GetWorkflowAuthoringSchemaRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.GetWorkflowAuthoringSchemaRequest.
 * Use `create(GetWorkflowAuthoringSchemaRequestSchema)` to create a new message.
 */
export const GetWorkflowAuthoringSchemaRequestSchema: GenMessage<GetWorkflowAuthoringSchemaRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 515);

/**
 * @generated from message cortado.v1.GetWorkflowAuthoringSchemaResponse
 */
export type GetWorkflowAuthoringSchemaResponse = Message<"cortado.v1.GetWorkflowAuthoringSchemaResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.WorkflowTriggerEventSchema trigger_events = 1;
   */
  triggerEvents: WorkflowTriggerEventSchema[];

  /**
   * @generated from field: repeated cortado.v1.WorkflowEntityAuthoringSchema entities = 2;
   */
  entities: WorkflowEntityAuthoringSchema[];

  /**
   * Node types the builder may add (TRIGGER excluded; it always exists).
   *
   * @generated from field: repeated cortado.v1.WorkflowNodeType addable_node_types = 3;
   */
  addableNodeTypes: WorkflowNodeType[];
};

/**
 * Describes the message cortado.v1.GetWorkflowAuthoringSchemaResponse.
 * Use `create(GetWorkflowAuthoringSchemaResponseSchema)` to create a new message.
 */
export const GetWorkflowAuthoringSchemaResponseSchema: GenMessage<GetWorkflowAuthoringSchemaResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 516);

/**
 * WorkflowTemplate is a code-defined, installable workflow blueprint. The
 * registry lives in backend Go code; templates are instantiated per org via
 * InstallWorkflowTemplate rather than pre-seeded as rows.
 *
 * @generated from message cortado.v1.WorkflowTemplate
 */
export type WorkflowTemplate = Message<"cortado.v1.WorkflowTemplate"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: int32 version = 4;
   */
  version: number;

  /**
   * @generated from field: cortado.v1.WorkflowTrigger trigger = 5;
   */
  trigger?: WorkflowTrigger;

  /**
   * @generated from field: cortado.v1.WorkflowCondition conditions = 6;
   */
  conditions?: WorkflowCondition;

  /**
   * @generated from field: repeated cortado.v1.WorkflowNode nodes = 7;
   */
  nodes: WorkflowNode[];

  /**
   * @generated from field: repeated cortado.v1.WorkflowEdge edges = 8;
   */
  edges: WorkflowEdge[];

  /**
   * Tenant email template names this workflow references; created for the
   * org on install when missing.
   *
   * @generated from field: repeated string email_template_names = 9;
   */
  emailTemplateNames: string[];

  /**
   * True when the org already has a non-deleted definition installed from
   * this template key.
   *
   * @generated from field: bool installed = 10;
   */
  installed: boolean;
};

/**
 * Describes the message cortado.v1.WorkflowTemplate.
 * Use `create(WorkflowTemplateSchema)` to create a new message.
 */
export const WorkflowTemplateSchema: GenMessage<WorkflowTemplate> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 517);

/**
 * @generated from message cortado.v1.ListWorkflowTemplatesRequest
 */
export type ListWorkflowTemplatesRequest = Message<"cortado.v1.ListWorkflowTemplatesRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListWorkflowTemplatesRequest.
 * Use `create(ListWorkflowTemplatesRequestSchema)` to create a new message.
 */
export const ListWorkflowTemplatesRequestSchema: GenMessage<ListWorkflowTemplatesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 518);

/**
 * @generated from message cortado.v1.ListWorkflowTemplatesResponse
 */
export type ListWorkflowTemplatesResponse = Message<"cortado.v1.ListWorkflowTemplatesResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.WorkflowTemplate templates = 1;
   */
  templates: WorkflowTemplate[];
};

/**
 * Describes the message cortado.v1.ListWorkflowTemplatesResponse.
 * Use `create(ListWorkflowTemplatesResponseSchema)` to create a new message.
 */
export const ListWorkflowTemplatesResponseSchema: GenMessage<ListWorkflowTemplatesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 519);

/**
 * @generated from message cortado.v1.InstallWorkflowTemplateRequest
 */
export type InstallWorkflowTemplateRequest = Message<"cortado.v1.InstallWorkflowTemplateRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string template_key = 2;
   */
  templateKey: string;

  /**
   * Optional override for the new definition's name.
   *
   * @generated from field: optional string name = 3;
   */
  name?: string;
};

/**
 * Describes the message cortado.v1.InstallWorkflowTemplateRequest.
 * Use `create(InstallWorkflowTemplateRequestSchema)` to create a new message.
 */
export const InstallWorkflowTemplateRequestSchema: GenMessage<InstallWorkflowTemplateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 520);

/**
 * @generated from message cortado.v1.InstallWorkflowTemplateResponse
 */
export type InstallWorkflowTemplateResponse = Message<"cortado.v1.InstallWorkflowTemplateResponse"> & {
  /**
   * @generated from field: cortado.v1.WorkflowDefinition workflow_definition = 1;
   */
  workflowDefinition?: WorkflowDefinition;
};

/**
 * Describes the message cortado.v1.InstallWorkflowTemplateResponse.
 * Use `create(InstallWorkflowTemplateResponseSchema)` to create a new message.
 */
export const InstallWorkflowTemplateResponseSchema: GenMessage<InstallWorkflowTemplateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 521);

/**
 * WebhookEndpoint is a tenant-registered outbound webhook destination. The
 * signing secret is never carried here; see CreateWebhookEndpointResponse and
 * RotateWebhookEndpointSecretResponse.
 *
 * @generated from message cortado.v1.WebhookEndpoint
 */
export type WebhookEndpoint = Message<"cortado.v1.WebhookEndpoint"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string name = 20;
   */
  name: string;

  /**
   * @generated from field: string description = 21;
   */
  description: string;

  /**
   * @generated from field: string url = 22;
   */
  url: string;

  /**
   * Sorted names of the custom outbound headers configured on this endpoint.
   * Header values are credentials and are never readable back through the
   * API — set or replace them via CreateWebhookEndpoint/UpdateWebhookEndpoint.
   *
   * @generated from field: repeated string header_names = 23;
   */
  headerNames: string[];

  /**
   * @generated from field: bool enabled = 50;
   */
  enabled: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 61;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.WebhookEndpoint.
 * Use `create(WebhookEndpointSchema)` to create a new message.
 */
export const WebhookEndpointSchema: GenMessage<WebhookEndpoint> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 522);

/**
 * WebhookEndpointHeaders is the write-only set of custom outbound HTTP
 * headers (e.g. "Authorization": "Bearer …") sent with every delivery to an
 * endpoint, for receivers that issue their own tokens instead of verifying
 * Cortado's HMAC signature.
 *
 * @generated from message cortado.v1.WebhookEndpointHeaders
 */
export type WebhookEndpointHeaders = Message<"cortado.v1.WebhookEndpointHeaders"> & {
  /**
   * @generated from field: map<string, string> values = 1;
   */
  values: { [key: string]: string };
};

/**
 * Describes the message cortado.v1.WebhookEndpointHeaders.
 * Use `create(WebhookEndpointHeadersSchema)` to create a new message.
 */
export const WebhookEndpointHeadersSchema: GenMessage<WebhookEndpointHeaders> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 523);

/**
 * @generated from message cortado.v1.ListWebhookEndpointsRequest
 */
export type ListWebhookEndpointsRequest = Message<"cortado.v1.ListWebhookEndpointsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListWebhookEndpointsRequest.
 * Use `create(ListWebhookEndpointsRequestSchema)` to create a new message.
 */
export const ListWebhookEndpointsRequestSchema: GenMessage<ListWebhookEndpointsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 524);

/**
 * @generated from message cortado.v1.ListWebhookEndpointsResponse
 */
export type ListWebhookEndpointsResponse = Message<"cortado.v1.ListWebhookEndpointsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.WebhookEndpoint endpoints = 1;
   */
  endpoints: WebhookEndpoint[];
};

/**
 * Describes the message cortado.v1.ListWebhookEndpointsResponse.
 * Use `create(ListWebhookEndpointsResponseSchema)` to create a new message.
 */
export const ListWebhookEndpointsResponseSchema: GenMessage<ListWebhookEndpointsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 525);

/**
 * @generated from message cortado.v1.CreateWebhookEndpointRequest
 */
export type CreateWebhookEndpointRequest = Message<"cortado.v1.CreateWebhookEndpointRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * Must be an https URL to a public host.
   *
   * @generated from field: string url = 4;
   */
  url: string;

  /**
   * Absent or empty means no custom headers.
   *
   * @generated from field: cortado.v1.WebhookEndpointHeaders headers = 5;
   */
  headers?: WebhookEndpointHeaders;
};

/**
 * Describes the message cortado.v1.CreateWebhookEndpointRequest.
 * Use `create(CreateWebhookEndpointRequestSchema)` to create a new message.
 */
export const CreateWebhookEndpointRequestSchema: GenMessage<CreateWebhookEndpointRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 526);

/**
 * @generated from message cortado.v1.CreateWebhookEndpointResponse
 */
export type CreateWebhookEndpointResponse = Message<"cortado.v1.CreateWebhookEndpointResponse"> & {
  /**
   * @generated from field: cortado.v1.WebhookEndpoint endpoint = 1;
   */
  endpoint?: WebhookEndpoint;

  /**
   * Shown once. Verify deliveries with HMAC-SHA256 over "<timestamp>.<body>".
   *
   * @generated from field: string signing_secret = 2;
   */
  signingSecret: string;
};

/**
 * Describes the message cortado.v1.CreateWebhookEndpointResponse.
 * Use `create(CreateWebhookEndpointResponseSchema)` to create a new message.
 */
export const CreateWebhookEndpointResponseSchema: GenMessage<CreateWebhookEndpointResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 527);

/**
 * @generated from message cortado.v1.UpdateWebhookEndpointRequest
 */
export type UpdateWebhookEndpointRequest = Message<"cortado.v1.UpdateWebhookEndpointRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional string url = 4;
   */
  url?: string;

  /**
   * @generated from field: optional bool enabled = 5;
   */
  enabled?: boolean;

  /**
   * Field absent = leave headers unchanged. Field present = replace the
   * entire set with exactly these entries (present-but-empty clears all
   * headers).
   *
   * @generated from field: cortado.v1.WebhookEndpointHeaders headers = 6;
   */
  headers?: WebhookEndpointHeaders;
};

/**
 * Describes the message cortado.v1.UpdateWebhookEndpointRequest.
 * Use `create(UpdateWebhookEndpointRequestSchema)` to create a new message.
 */
export const UpdateWebhookEndpointRequestSchema: GenMessage<UpdateWebhookEndpointRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 528);

/**
 * @generated from message cortado.v1.UpdateWebhookEndpointResponse
 */
export type UpdateWebhookEndpointResponse = Message<"cortado.v1.UpdateWebhookEndpointResponse"> & {
  /**
   * @generated from field: cortado.v1.WebhookEndpoint endpoint = 1;
   */
  endpoint?: WebhookEndpoint;
};

/**
 * Describes the message cortado.v1.UpdateWebhookEndpointResponse.
 * Use `create(UpdateWebhookEndpointResponseSchema)` to create a new message.
 */
export const UpdateWebhookEndpointResponseSchema: GenMessage<UpdateWebhookEndpointResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 529);

/**
 * @generated from message cortado.v1.DeleteWebhookEndpointRequest
 */
export type DeleteWebhookEndpointRequest = Message<"cortado.v1.DeleteWebhookEndpointRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteWebhookEndpointRequest.
 * Use `create(DeleteWebhookEndpointRequestSchema)` to create a new message.
 */
export const DeleteWebhookEndpointRequestSchema: GenMessage<DeleteWebhookEndpointRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 530);

/**
 * @generated from message cortado.v1.DeleteWebhookEndpointResponse
 */
export type DeleteWebhookEndpointResponse = Message<"cortado.v1.DeleteWebhookEndpointResponse"> & {
};

/**
 * Describes the message cortado.v1.DeleteWebhookEndpointResponse.
 * Use `create(DeleteWebhookEndpointResponseSchema)` to create a new message.
 */
export const DeleteWebhookEndpointResponseSchema: GenMessage<DeleteWebhookEndpointResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 531);

/**
 * @generated from message cortado.v1.RotateWebhookEndpointSecretRequest
 */
export type RotateWebhookEndpointSecretRequest = Message<"cortado.v1.RotateWebhookEndpointSecretRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.RotateWebhookEndpointSecretRequest.
 * Use `create(RotateWebhookEndpointSecretRequestSchema)` to create a new message.
 */
export const RotateWebhookEndpointSecretRequestSchema: GenMessage<RotateWebhookEndpointSecretRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 532);

/**
 * @generated from message cortado.v1.RotateWebhookEndpointSecretResponse
 */
export type RotateWebhookEndpointSecretResponse = Message<"cortado.v1.RotateWebhookEndpointSecretResponse"> & {
  /**
   * @generated from field: cortado.v1.WebhookEndpoint endpoint = 1;
   */
  endpoint?: WebhookEndpoint;

  /**
   * Shown once.
   *
   * @generated from field: string signing_secret = 2;
   */
  signingSecret: string;
};

/**
 * Describes the message cortado.v1.RotateWebhookEndpointSecretResponse.
 * Use `create(RotateWebhookEndpointSecretResponseSchema)` to create a new message.
 */
export const RotateWebhookEndpointSecretResponseSchema: GenMessage<RotateWebhookEndpointSecretResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 533);

/**
 * @generated from message cortado.v1.SendTestWebhookEndpointRequest
 */
export type SendTestWebhookEndpointRequest = Message<"cortado.v1.SendTestWebhookEndpointRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.SendTestWebhookEndpointRequest.
 * Use `create(SendTestWebhookEndpointRequestSchema)` to create a new message.
 */
export const SendTestWebhookEndpointRequestSchema: GenMessage<SendTestWebhookEndpointRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 534);

/**
 * @generated from message cortado.v1.SendTestWebhookEndpointResponse
 */
export type SendTestWebhookEndpointResponse = Message<"cortado.v1.SendTestWebhookEndpointResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: int32 status_code = 2;
   */
  statusCode: number;

  /**
   * Short excerpt of the response body or the transport error.
   *
   * @generated from field: string detail = 3;
   */
  detail: string;

  /**
   * The delivery id sent in X-Cortado-Delivery for the test.
   *
   * @generated from field: string delivery_id = 4;
   */
  deliveryId: string;
};

/**
 * Describes the message cortado.v1.SendTestWebhookEndpointResponse.
 * Use `create(SendTestWebhookEndpointResponseSchema)` to create a new message.
 */
export const SendTestWebhookEndpointResponseSchema: GenMessage<SendTestWebhookEndpointResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 535);

/**
 * @generated from message cortado.v1.GeneratePublicQuotePdfRequest
 */
export type GeneratePublicQuotePdfRequest = Message<"cortado.v1.GeneratePublicQuotePdfRequest"> & {
  /**
   * @generated from field: string quote_id = 1;
   */
  quoteId: string;
};

/**
 * Describes the message cortado.v1.GeneratePublicQuotePdfRequest.
 * Use `create(GeneratePublicQuotePdfRequestSchema)` to create a new message.
 */
export const GeneratePublicQuotePdfRequestSchema: GenMessage<GeneratePublicQuotePdfRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 536);

/**
 * @generated from message cortado.v1.GeneratePublicQuotePdfResponse
 */
export type GeneratePublicQuotePdfResponse = Message<"cortado.v1.GeneratePublicQuotePdfResponse"> & {
  /**
   * @generated from field: string attachment_id = 1;
   */
  attachmentId: string;

  /**
   * @generated from field: string filename = 20;
   */
  filename: string;

  /**
   * @generated from field: string download_url = 21;
   */
  downloadUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp download_url_expires_at = 40;
   */
  downloadUrlExpiresAt?: Timestamp;

  /**
   * @generated from field: bool cache_hit = 50;
   */
  cacheHit: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp generated_at = 60;
   */
  generatedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.GeneratePublicQuotePdfResponse.
 * Use `create(GeneratePublicQuotePdfResponseSchema)` to create a new message.
 */
export const GeneratePublicQuotePdfResponseSchema: GenMessage<GeneratePublicQuotePdfResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 537);

/**
 * @generated from message cortado.v1.GeneratePublicInvoicePdfRequest
 */
export type GeneratePublicInvoicePdfRequest = Message<"cortado.v1.GeneratePublicInvoicePdfRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;
};

/**
 * Describes the message cortado.v1.GeneratePublicInvoicePdfRequest.
 * Use `create(GeneratePublicInvoicePdfRequestSchema)` to create a new message.
 */
export const GeneratePublicInvoicePdfRequestSchema: GenMessage<GeneratePublicInvoicePdfRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 538);

/**
 * @generated from message cortado.v1.GeneratePublicInvoicePdfResponse
 */
export type GeneratePublicInvoicePdfResponse = Message<"cortado.v1.GeneratePublicInvoicePdfResponse"> & {
  /**
   * @generated from field: string attachment_id = 1;
   */
  attachmentId: string;

  /**
   * @generated from field: string filename = 20;
   */
  filename: string;

  /**
   * @generated from field: string download_url = 21;
   */
  downloadUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp download_url_expires_at = 40;
   */
  downloadUrlExpiresAt?: Timestamp;

  /**
   * @generated from field: bool cache_hit = 50;
   */
  cacheHit: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp generated_at = 60;
   */
  generatedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.GeneratePublicInvoicePdfResponse.
 * Use `create(GeneratePublicInvoicePdfResponseSchema)` to create a new message.
 */
export const GeneratePublicInvoicePdfResponseSchema: GenMessage<GeneratePublicInvoicePdfResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 539);

/**
 * @generated from message cortado.v1.GeneratePublicPaymentReceiptPdfRequest
 */
export type GeneratePublicPaymentReceiptPdfRequest = Message<"cortado.v1.GeneratePublicPaymentReceiptPdfRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * @generated from field: string payment_schedule_id = 2;
   */
  paymentScheduleId: string;
};

/**
 * Describes the message cortado.v1.GeneratePublicPaymentReceiptPdfRequest.
 * Use `create(GeneratePublicPaymentReceiptPdfRequestSchema)` to create a new message.
 */
export const GeneratePublicPaymentReceiptPdfRequestSchema: GenMessage<GeneratePublicPaymentReceiptPdfRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 540);

/**
 * @generated from message cortado.v1.GeneratePublicPaymentReceiptPdfResponse
 */
export type GeneratePublicPaymentReceiptPdfResponse = Message<"cortado.v1.GeneratePublicPaymentReceiptPdfResponse"> & {
  /**
   * @generated from field: string attachment_id = 1;
   */
  attachmentId: string;

  /**
   * @generated from field: string filename = 20;
   */
  filename: string;

  /**
   * @generated from field: string download_url = 21;
   */
  downloadUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp download_url_expires_at = 40;
   */
  downloadUrlExpiresAt?: Timestamp;

  /**
   * @generated from field: bool cache_hit = 50;
   */
  cacheHit: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp generated_at = 60;
   */
  generatedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.GeneratePublicPaymentReceiptPdfResponse.
 * Use `create(GeneratePublicPaymentReceiptPdfResponseSchema)` to create a new message.
 */
export const GeneratePublicPaymentReceiptPdfResponseSchema: GenMessage<GeneratePublicPaymentReceiptPdfResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 541);

/**
 * @generated from message cortado.v1.GenerateQuotePdfRequest
 */
export type GenerateQuotePdfRequest = Message<"cortado.v1.GenerateQuotePdfRequest"> & {
  /**
   * @generated from field: string quote_id = 1;
   */
  quoteId: string;
};

/**
 * Describes the message cortado.v1.GenerateQuotePdfRequest.
 * Use `create(GenerateQuotePdfRequestSchema)` to create a new message.
 */
export const GenerateQuotePdfRequestSchema: GenMessage<GenerateQuotePdfRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 542);

/**
 * @generated from message cortado.v1.GenerateQuotePdfResponse
 */
export type GenerateQuotePdfResponse = Message<"cortado.v1.GenerateQuotePdfResponse"> & {
  /**
   * @generated from field: string attachment_id = 1;
   */
  attachmentId: string;

  /**
   * @generated from field: string filename = 20;
   */
  filename: string;

  /**
   * @generated from field: string download_url = 21;
   */
  downloadUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp download_url_expires_at = 40;
   */
  downloadUrlExpiresAt?: Timestamp;

  /**
   * @generated from field: bool cache_hit = 50;
   */
  cacheHit: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp generated_at = 60;
   */
  generatedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.GenerateQuotePdfResponse.
 * Use `create(GenerateQuotePdfResponseSchema)` to create a new message.
 */
export const GenerateQuotePdfResponseSchema: GenMessage<GenerateQuotePdfResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 543);

/**
 * @generated from message cortado.v1.GenerateInvoicePdfRequest
 */
export type GenerateInvoicePdfRequest = Message<"cortado.v1.GenerateInvoicePdfRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;
};

/**
 * Describes the message cortado.v1.GenerateInvoicePdfRequest.
 * Use `create(GenerateInvoicePdfRequestSchema)` to create a new message.
 */
export const GenerateInvoicePdfRequestSchema: GenMessage<GenerateInvoicePdfRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 544);

/**
 * @generated from message cortado.v1.GenerateInvoicePdfResponse
 */
export type GenerateInvoicePdfResponse = Message<"cortado.v1.GenerateInvoicePdfResponse"> & {
  /**
   * @generated from field: string attachment_id = 1;
   */
  attachmentId: string;

  /**
   * @generated from field: string filename = 20;
   */
  filename: string;

  /**
   * @generated from field: string download_url = 21;
   */
  downloadUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp download_url_expires_at = 40;
   */
  downloadUrlExpiresAt?: Timestamp;

  /**
   * @generated from field: bool cache_hit = 50;
   */
  cacheHit: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp generated_at = 60;
   */
  generatedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.GenerateInvoicePdfResponse.
 * Use `create(GenerateInvoicePdfResponseSchema)` to create a new message.
 */
export const GenerateInvoicePdfResponseSchema: GenMessage<GenerateInvoicePdfResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 545);

/**
 * @generated from message cortado.v1.GeneratePaymentReceiptPdfRequest
 */
export type GeneratePaymentReceiptPdfRequest = Message<"cortado.v1.GeneratePaymentReceiptPdfRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * @generated from field: string payment_schedule_id = 2;
   */
  paymentScheduleId: string;
};

/**
 * Describes the message cortado.v1.GeneratePaymentReceiptPdfRequest.
 * Use `create(GeneratePaymentReceiptPdfRequestSchema)` to create a new message.
 */
export const GeneratePaymentReceiptPdfRequestSchema: GenMessage<GeneratePaymentReceiptPdfRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 546);

/**
 * @generated from message cortado.v1.GeneratePaymentReceiptPdfResponse
 */
export type GeneratePaymentReceiptPdfResponse = Message<"cortado.v1.GeneratePaymentReceiptPdfResponse"> & {
  /**
   * @generated from field: string attachment_id = 1;
   */
  attachmentId: string;

  /**
   * @generated from field: string filename = 20;
   */
  filename: string;

  /**
   * @generated from field: string download_url = 21;
   */
  downloadUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp download_url_expires_at = 40;
   */
  downloadUrlExpiresAt?: Timestamp;

  /**
   * @generated from field: bool cache_hit = 50;
   */
  cacheHit: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp generated_at = 60;
   */
  generatedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.GeneratePaymentReceiptPdfResponse.
 * Use `create(GeneratePaymentReceiptPdfResponseSchema)` to create a new message.
 */
export const GeneratePaymentReceiptPdfResponseSchema: GenMessage<GeneratePaymentReceiptPdfResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_cortado, 547);

/**
 * ResolveLocationTimezoneStatus distinguishes "we couldn't geocode this
 * address" (NOT_FOUND) from "the Google Maps API itself failed" (ERROR) so
 * the UI can surface the right message and ops can alert on the right signal.
 *
 * @generated from enum cortado.v1.ResolveLocationTimezoneStatus
 */
export enum ResolveLocationTimezoneStatus {
  /**
   * @generated from enum value: RESOLVE_LOCATION_TIMEZONE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RESOLVE_LOCATION_TIMEZONE_STATUS_OK = 1;
   */
  OK = 1,

  /**
   * @generated from enum value: RESOLVE_LOCATION_TIMEZONE_STATUS_NOT_FOUND = 2;
   */
  NOT_FOUND = 2,

  /**
   * @generated from enum value: RESOLVE_LOCATION_TIMEZONE_STATUS_ERROR = 3;
   */
  ERROR = 3,
}

/**
 * Describes the enum cortado.v1.ResolveLocationTimezoneStatus.
 */
export const ResolveLocationTimezoneStatusSchema: GenEnum<ResolveLocationTimezoneStatus> = /*@__PURE__*/
  enumDesc(file_cortado_v1_cortado, 0);

/**
 * @generated from enum cortado.v1.QuoteSendRecipientStatusEnum
 */
export enum QuoteSendRecipientStatusEnum {
  /**
   * @generated from enum value: QUOTE_SEND_RECIPIENT_STATUS_UNSPECIFIED = 0;
   */
  QUOTE_SEND_RECIPIENT_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: QUOTE_SEND_RECIPIENT_STATUS_SENT = 1;
   */
  QUOTE_SEND_RECIPIENT_STATUS_SENT = 1,

  /**
   * @generated from enum value: QUOTE_SEND_RECIPIENT_STATUS_INVALID_EMAIL = 2;
   */
  QUOTE_SEND_RECIPIENT_STATUS_INVALID_EMAIL = 2,

  /**
   * @generated from enum value: QUOTE_SEND_RECIPIENT_STATUS_SUPPRESSED = 3;
   */
  QUOTE_SEND_RECIPIENT_STATUS_SUPPRESSED = 3,

  /**
   * @generated from enum value: QUOTE_SEND_RECIPIENT_STATUS_FAILED = 4;
   */
  QUOTE_SEND_RECIPIENT_STATUS_FAILED = 4,
}

/**
 * Describes the enum cortado.v1.QuoteSendRecipientStatusEnum.
 */
export const QuoteSendRecipientStatusEnumSchema: GenEnum<QuoteSendRecipientStatusEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_cortado, 1);

/**
 * PublicDomainSurfaceEnum identifies the tenant-facing surface a domain serves
 *
 * @generated from enum cortado.v1.PublicDomainSurfaceEnum
 */
export enum PublicDomainSurfaceEnum {
  /**
   * @generated from enum value: PUBLIC_DOMAIN_SURFACE_ENUM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PUBLIC_DOMAIN_SURFACE_ENUM_FORM = 1;
   */
  FORM = 1,

  /**
   * @generated from enum value: PUBLIC_DOMAIN_SURFACE_ENUM_PORTAL = 2;
   */
  PORTAL = 2,
}

/**
 * Describes the enum cortado.v1.PublicDomainSurfaceEnum.
 */
export const PublicDomainSurfaceEnumSchema: GenEnum<PublicDomainSurfaceEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_cortado, 2);

/**
 * PublicDomainStatusEnum represents provider and DNS verification status
 *
 * @generated from enum cortado.v1.PublicDomainStatusEnum
 */
export enum PublicDomainStatusEnum {
  /**
   * @generated from enum value: PUBLIC_DOMAIN_STATUS_ENUM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PUBLIC_DOMAIN_STATUS_ENUM_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: PUBLIC_DOMAIN_STATUS_ENUM_CONFIGURING = 2;
   */
  CONFIGURING = 2,

  /**
   * @generated from enum value: PUBLIC_DOMAIN_STATUS_ENUM_VERIFIED = 3;
   */
  VERIFIED = 3,

  /**
   * @generated from enum value: PUBLIC_DOMAIN_STATUS_ENUM_FAILED = 4;
   */
  FAILED = 4,
}

/**
 * Describes the enum cortado.v1.PublicDomainStatusEnum.
 */
export const PublicDomainStatusEnumSchema: GenEnum<PublicDomainStatusEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_cortado, 3);

/**
 * Which step of the automated sender chain sends.
 *
 * @generated from enum cortado.v1.AutomatedEmailSenderKind
 */
export enum AutomatedEmailSenderKind {
  /**
   * @generated from enum value: AUTOMATED_EMAIL_SENDER_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Cortado's own address: the organization has no sender of its own
   *
   * @generated from enum value: AUTOMATED_EMAIL_SENDER_KIND_CORTADO = 1;
   */
  CORTADO = 1,

  /**
   * The organization's default connected mailbox
   *
   * @generated from enum value: AUTOMATED_EMAIL_SENDER_KIND_CONNECTED_MAILBOX = 2;
   */
  CONNECTED_MAILBOX = 2,

  /**
   * The organization's default Gmail
   *
   * @generated from enum value: AUTOMATED_EMAIL_SENDER_KIND_GMAIL = 3;
   */
  GMAIL = 3,
}

/**
 * Describes the enum cortado.v1.AutomatedEmailSenderKind.
 */
export const AutomatedEmailSenderKindSchema: GenEnum<AutomatedEmailSenderKind> = /*@__PURE__*/
  enumDesc(file_cortado_v1_cortado, 4);

/**
 * WorkflowTriggerEventType represents the event that triggers a workflow
 *
 * @generated from enum cortado.v1.WorkflowTriggerEventType
 */
export enum WorkflowTriggerEventType {
  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_INQUIRY_CREATED = 1;
   */
  INQUIRY_CREATED = 1,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_INQUIRY_STAGE_CHANGED = 2;
   */
  INQUIRY_STAGE_CHANGED = 2,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_INQUIRY_ASSIGNED = 3;
   */
  INQUIRY_ASSIGNED = 3,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_QUOTE_CREATED = 4;
   */
  QUOTE_CREATED = 4,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_QUOTE_SENT = 5;
   */
  QUOTE_SENT = 5,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_QUOTE_VIEWED = 6;
   */
  QUOTE_VIEWED = 6,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_QUOTE_ACCEPTED = 7;
   */
  QUOTE_ACCEPTED = 7,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_QUOTE_REJECTED = 8;
   */
  QUOTE_REJECTED = 8,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_QUOTE_EXPIRED = 9;
   */
  QUOTE_EXPIRED = 9,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_INVOICE_SENT = 10;
   */
  INVOICE_SENT = 10,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_INVOICE_PAID = 11;
   */
  INVOICE_PAID = 11,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_INVOICE_OVERDUE = 12;
   */
  INVOICE_OVERDUE = 12,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_PAYMENT_RECEIVED = 13;
   */
  PAYMENT_RECEIVED = 13,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_PAYMENT_FAILED = 14;
   */
  PAYMENT_FAILED = 14,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_EVENT_CREATED = 15;
   */
  EVENT_CREATED = 15,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_EVENT_COMPLETED = 16;
   */
  EVENT_COMPLETED = 16,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_EVENT_CANCELED = 17;
   */
  EVENT_CANCELED = 17,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_CONTACT_CREATED = 18;
   */
  CONTACT_CREATED = 18,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_QUOTE_EXPIRING_SOON = 19;
   */
  QUOTE_EXPIRING_SOON = 19,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_BOOKING_CREATED = 20;
   */
  BOOKING_CREATED = 20,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_BOOKING_STAGE_CHANGED = 21;
   */
  BOOKING_STAGE_CHANGED = 21,

  /**
   * A customer's email arrived on a conversation linked to the record. One
   * per entity type; each is also a stop condition ("stop when they reply").
   *
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_INQUIRY_EMAIL_RECEIVED = 22;
   */
  INQUIRY_EMAIL_RECEIVED = 22,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_BOOKING_EMAIL_RECEIVED = 23;
   */
  BOOKING_EMAIL_RECEIVED = 23,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_CONTACT_EMAIL_RECEIVED = 24;
   */
  CONTACT_EMAIL_RECEIVED = 24,

  /**
   * The lead's latest email is ours and the customer has not replied for
   * WorkflowTrigger.days_before days.
   *
   * @generated from enum value: WORKFLOW_TRIGGER_EVENT_TYPE_INQUIRY_NO_REPLY_FOR = 25;
   */
  INQUIRY_NO_REPLY_FOR = 25,
}

/**
 * Describes the enum cortado.v1.WorkflowTriggerEventType.
 */
export const WorkflowTriggerEventTypeSchema: GenEnum<WorkflowTriggerEventType> = /*@__PURE__*/
  enumDesc(file_cortado_v1_cortado, 5);

/**
 * WorkflowTriggerEntityType represents the entity type that a trigger applies to
 *
 * @generated from enum cortado.v1.WorkflowTriggerEntityType
 */
export enum WorkflowTriggerEntityType {
  /**
   * @generated from enum value: WORKFLOW_TRIGGER_ENTITY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_ENTITY_TYPE_INQUIRY = 1;
   */
  INQUIRY = 1,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_ENTITY_TYPE_BOOKING = 2;
   */
  BOOKING = 2,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_ENTITY_TYPE_CONTACT = 3;
   */
  CONTACT = 3,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_ENTITY_TYPE_INVOICE = 4;
   */
  INVOICE = 4,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_ENTITY_TYPE_EVENT = 5;
   */
  EVENT = 5,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_ENTITY_TYPE_QUOTE = 6;
   */
  QUOTE = 6,

  /**
   * @generated from enum value: WORKFLOW_TRIGGER_ENTITY_TYPE_PAYMENT = 7;
   */
  PAYMENT = 7,

  /**
   * Branch/switch target only, never a trigger entity: the installment
   * (payment schedule) an INVOICE run was triggered for, read live from the
   * trigger's payment_schedule_id.
   *
   * @generated from enum value: WORKFLOW_TRIGGER_ENTITY_TYPE_PAYMENT_SCHEDULE = 8;
   */
  PAYMENT_SCHEDULE = 8,
}

/**
 * Describes the enum cortado.v1.WorkflowTriggerEntityType.
 */
export const WorkflowTriggerEntityTypeSchema: GenEnum<WorkflowTriggerEntityType> = /*@__PURE__*/
  enumDesc(file_cortado_v1_cortado, 6);

/**
 * WorkflowConditionLogic represents the logical operator for a condition group
 *
 * @generated from enum cortado.v1.WorkflowConditionLogic
 */
export enum WorkflowConditionLogic {
  /**
   * @generated from enum value: WORKFLOW_CONDITION_LOGIC_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_CONDITION_LOGIC_AND = 1;
   */
  AND = 1,

  /**
   * @generated from enum value: WORKFLOW_CONDITION_LOGIC_OR = 2;
   */
  OR = 2,
}

/**
 * Describes the enum cortado.v1.WorkflowConditionLogic.
 */
export const WorkflowConditionLogicSchema: GenEnum<WorkflowConditionLogic> = /*@__PURE__*/
  enumDesc(file_cortado_v1_cortado, 7);

/**
 * WorkflowConditionOperator represents the comparison operator for a condition leaf
 *
 * @generated from enum cortado.v1.WorkflowConditionOperator
 */
export enum WorkflowConditionOperator {
  /**
   * @generated from enum value: WORKFLOW_CONDITION_OPERATOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_CONDITION_OPERATOR_EQUALS = 1;
   */
  EQUALS = 1,

  /**
   * @generated from enum value: WORKFLOW_CONDITION_OPERATOR_NOT_EQUALS = 2;
   */
  NOT_EQUALS = 2,

  /**
   * @generated from enum value: WORKFLOW_CONDITION_OPERATOR_CONTAINS = 3;
   */
  CONTAINS = 3,

  /**
   * @generated from enum value: WORKFLOW_CONDITION_OPERATOR_NOT_CONTAINS = 4;
   */
  NOT_CONTAINS = 4,

  /**
   * @generated from enum value: WORKFLOW_CONDITION_OPERATOR_GREATER_THAN = 5;
   */
  GREATER_THAN = 5,

  /**
   * @generated from enum value: WORKFLOW_CONDITION_OPERATOR_LESS_THAN = 6;
   */
  LESS_THAN = 6,

  /**
   * @generated from enum value: WORKFLOW_CONDITION_OPERATOR_SINCE = 7;
   */
  SINCE = 7,

  /**
   * @generated from enum value: WORKFLOW_CONDITION_OPERATOR_IN = 8;
   */
  IN = 8,

  /**
   * @generated from enum value: WORKFLOW_CONDITION_OPERATOR_IS_NULL = 9;
   */
  IS_NULL = 9,
}

/**
 * Describes the enum cortado.v1.WorkflowConditionOperator.
 */
export const WorkflowConditionOperatorSchema: GenEnum<WorkflowConditionOperator> = /*@__PURE__*/
  enumDesc(file_cortado_v1_cortado, 8);

/**
 * WorkflowActionType represents the type of action to execute
 *
 * @generated from enum cortado.v1.WorkflowActionType
 */
export enum WorkflowActionType {
  /**
   * @generated from enum value: WORKFLOW_ACTION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_ACTION_TYPE_UPDATE_FIELD = 3;
   */
  UPDATE_FIELD = 3,

  /**
   * @generated from enum value: WORKFLOW_ACTION_TYPE_SEND_TEMPLATED_EMAIL = 4;
   */
  SEND_TEMPLATED_EMAIL = 4,

  /**
   * @generated from enum value: WORKFLOW_ACTION_TYPE_CREATE_TASK = 5;
   */
  CREATE_TASK = 5,

  /**
   * @generated from enum value: WORKFLOW_ACTION_TYPE_WAIT = 6;
   */
  WAIT = 6,

  /**
   * @generated from enum value: WORKFLOW_ACTION_TYPE_SEND_WEBHOOK = 7;
   */
  SEND_WEBHOOK = 7,
}

/**
 * Describes the enum cortado.v1.WorkflowActionType.
 */
export const WorkflowActionTypeSchema: GenEnum<WorkflowActionType> = /*@__PURE__*/
  enumDesc(file_cortado_v1_cortado, 9);

/**
 * WorkflowExecutionStatus represents the lifecycle status of a workflow execution.
 * Mirrors the workflows.execution_status DB enum; "Unknown" maps to _UNSPECIFIED.
 *
 * @generated from enum cortado.v1.WorkflowExecutionStatus
 */
export enum WorkflowExecutionStatus {
  /**
   * @generated from enum value: WORKFLOW_EXECUTION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_STATUS_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_STATUS_SUCCEEDED = 3;
   */
  SUCCEEDED = 3,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_STATUS_FAILED = 4;
   */
  FAILED = 4,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_STATUS_CANCELLED = 5;
   */
  CANCELLED = 5,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_STATUS_CONDITION_UNMET = 6;
   */
  CONDITION_UNMET = 6,

  /**
   * Run aborted early by a matching definition-level stop condition.
   *
   * @generated from enum value: WORKFLOW_EXECUTION_STATUS_STOPPED = 7;
   */
  STOPPED = 7,
}

/**
 * Describes the enum cortado.v1.WorkflowExecutionStatus.
 */
export const WorkflowExecutionStatusSchema: GenEnum<WorkflowExecutionStatus> = /*@__PURE__*/
  enumDesc(file_cortado_v1_cortado, 10);

/**
 * WorkflowExecutionStepStatus represents the lifecycle status of a single
 * action step inside a workflow execution.
 *
 * @generated from enum cortado.v1.WorkflowExecutionStepStatus
 */
export enum WorkflowExecutionStepStatus {
  /**
   * @generated from enum value: WORKFLOW_EXECUTION_STEP_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_STEP_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_STEP_STATUS_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_STEP_STATUS_SUCCEEDED = 3;
   */
  SUCCEEDED = 3,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_STEP_STATUS_FAILED = 4;
   */
  FAILED = 4,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_STEP_STATUS_SKIPPED = 5;
   */
  SKIPPED = 5,
}

/**
 * Describes the enum cortado.v1.WorkflowExecutionStepStatus.
 */
export const WorkflowExecutionStepStatusSchema: GenEnum<WorkflowExecutionStepStatus> = /*@__PURE__*/
  enumDesc(file_cortado_v1_cortado, 11);

/**
 * WorkflowNodeType identifies the kind of node in a workflow graph.
 *
 * @generated from enum cortado.v1.WorkflowNodeType
 */
export enum WorkflowNodeType {
  /**
   * @generated from enum value: WORKFLOW_NODE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Entry point. Exactly one per graph; mirrors the definition trigger and
   * carries no config.
   *
   * @generated from enum value: WORKFLOW_NODE_TYPE_TRIGGER = 1;
   */
  TRIGGER = 1,

  /**
   * @generated from enum value: WORKFLOW_NODE_TYPE_WAIT = 2;
   */
  WAIT = 2,

  /**
   * @generated from enum value: WORKFLOW_NODE_TYPE_SEND_TEMPLATED_EMAIL = 3;
   */
  SEND_TEMPLATED_EMAIL = 3,

  /**
   * @generated from enum value: WORKFLOW_NODE_TYPE_CREATE_TASK = 4;
   */
  CREATE_TASK = 4,

  /**
   * @generated from enum value: WORKFLOW_NODE_TYPE_UPDATE_FIELD = 5;
   */
  UPDATE_FIELD = 5,

  /**
   * Evaluates a condition against the live entity; outgoing edges are
   * labeled "true" and "false".
   *
   * @generated from enum value: WORKFLOW_NODE_TYPE_BRANCH = 6;
   */
  BRANCH = 6,

  /**
   * Terminal node: ends the run successfully without executing further nodes.
   *
   * @generated from enum value: WORKFLOW_NODE_TYPE_STOP = 7;
   */
  STOP = 7,

  /**
   * Routes one live enum-backed field through ordered named cases, with an
   * always-present "otherwise" output for unmatched values.
   *
   * @generated from enum value: WORKFLOW_NODE_TYPE_SWITCH = 8;
   */
  SWITCH = 8,

  /**
   * POSTs a signed JSON event envelope to a tenant-registered webhook
   * endpoint (WebhookEndpoint). Supported on every trigger entity.
   *
   * @generated from enum value: WORKFLOW_NODE_TYPE_SEND_WEBHOOK = 9;
   */
  SEND_WEBHOOK = 9,
}

/**
 * Describes the enum cortado.v1.WorkflowNodeType.
 */
export const WorkflowNodeTypeSchema: GenEnum<WorkflowNodeType> = /*@__PURE__*/
  enumDesc(file_cortado_v1_cortado, 12);

/**
 * WorkflowFieldKind describes how a condition field should be edited.
 *
 * @generated from enum cortado.v1.WorkflowFieldKind
 */
export enum WorkflowFieldKind {
  /**
   * @generated from enum value: WORKFLOW_FIELD_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_FIELD_KIND_STRING = 1;
   */
  STRING = 1,

  /**
   * @generated from enum value: WORKFLOW_FIELD_KIND_NUMBER = 2;
   */
  NUMBER = 2,

  /**
   * @generated from enum value: WORKFLOW_FIELD_KIND_DATE = 3;
   */
  DATE = 3,

  /**
   * @generated from enum value: WORKFLOW_FIELD_KIND_ENUM = 4;
   */
  ENUM = 4,
}

/**
 * Describes the enum cortado.v1.WorkflowFieldKind.
 */
export const WorkflowFieldKindSchema: GenEnum<WorkflowFieldKind> = /*@__PURE__*/
  enumDesc(file_cortado_v1_cortado, 13);

/**
 * WorkflowStopCorrelationScope controls how a stop condition matches trigger
 * events to a running execution. SOURCE (default) correlates on the run's
 * source_resource_id. SUBJECT correlates on a shared parent (e.g. inquiry_id
 * for quote-triggered runs) so sibling records can stop the run.
 *
 * @generated from enum cortado.v1.WorkflowStopCorrelationScope
 */
export enum WorkflowStopCorrelationScope {
  /**
   * @generated from enum value: WORKFLOW_STOP_CORRELATION_SCOPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_STOP_CORRELATION_SCOPE_SOURCE = 1;
   */
  SOURCE = 1,

  /**
   * @generated from enum value: WORKFLOW_STOP_CORRELATION_SCOPE_SUBJECT = 2;
   */
  SUBJECT = 2,
}

/**
 * Describes the enum cortado.v1.WorkflowStopCorrelationScope.
 */
export const WorkflowStopCorrelationScopeSchema: GenEnum<WorkflowStopCorrelationScope> = /*@__PURE__*/
  enumDesc(file_cortado_v1_cortado, 14);

/**
 * WorkflowRunCardinality controls whether one trigger source creates its own
 * run or sibling sources with a shared subject coalesce into one live run.
 *
 * @generated from enum cortado.v1.WorkflowRunCardinality
 */
export enum WorkflowRunCardinality {
  /**
   * @generated from enum value: WORKFLOW_RUN_CARDINALITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_RUN_CARDINALITY_PER_SOURCE = 1;
   */
  PER_SOURCE = 1,

  /**
   * @generated from enum value: WORKFLOW_RUN_CARDINALITY_PER_SUBJECT = 2;
   */
  PER_SUBJECT = 2,
}

/**
 * Describes the enum cortado.v1.WorkflowRunCardinality.
 */
export const WorkflowRunCardinalitySchema: GenEnum<WorkflowRunCardinality> = /*@__PURE__*/
  enumDesc(file_cortado_v1_cortado, 15);

/**
 * CortadoService defines the main service for the Cortado project
 *
 * @generated from service cortado.v1.CortadoService
 */
export const CortadoService: GenService<{
  /**
   * Ping checks if the service is alive
   *
   * @generated from rpc cortado.v1.CortadoService.Ping
   */
  ping: {
    methodKind: "unary";
    input: typeof PingRequestSchema;
    output: typeof PingResponseSchema;
  },
  /**
   * GetMe retrieves the current authenticated user's data
   *
   * @generated from rpc cortado.v1.CortadoService.GetMe
   */
  getMe: {
    methodKind: "unary";
    input: typeof GetMeRequestSchema;
    output: typeof GetMeResponseSchema;
  },
  /**
   * UpdateMe updates the current authenticated user's profile
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateMe
   */
  updateMe: {
    methodKind: "unary";
    input: typeof UpdateMeRequestSchema;
    output: typeof UpdateMeResponseSchema;
  },
  /**
   * ListMyOrganizations retrieves the organizations for the current authenticated user
   *
   * @generated from rpc cortado.v1.CortadoService.ListMyOrganizations
   */
  listMyOrganizations: {
    methodKind: "unary";
    input: typeof ListMyOrganizationsRequestSchema;
    output: typeof ListMyOrganizationsResponseSchema;
  },
  /**
   * ListMySupportSessions returns the caller's active superadmin support sessions
   *
   * @generated from rpc cortado.v1.CortadoService.ListMySupportSessions
   */
  listMySupportSessions: {
    methodKind: "unary";
    input: typeof ListMySupportSessionsRequestSchema;
    output: typeof ListMySupportSessionsResponseSchema;
  },
  /**
   * GetOrganization retrieves an organization by ID
   *
   * @generated from rpc cortado.v1.CortadoService.GetOrganization
   */
  getOrganization: {
    methodKind: "unary";
    input: typeof GetOrganizationRequestSchema;
    output: typeof GetOrganizationResponseSchema;
  },
  /**
   * UpdateOrganization updates an organization
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateOrganization
   */
  updateOrganization: {
    methodKind: "unary";
    input: typeof UpdateOrganizationRequestSchema;
    output: typeof UpdateOrganizationResponseSchema;
  },
  /**
   * UploadOrganizationLogo uploads a logo for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.UploadOrganizationLogo
   */
  uploadOrganizationLogo: {
    methodKind: "unary";
    input: typeof UploadOrganizationLogoRequestSchema;
    output: typeof UploadOrganizationLogoResponseSchema;
  },
  /**
   * ListOrganizationUsers lists all users in an organization
   *
   * @generated from rpc cortado.v1.CortadoService.ListOrganizationUsers
   */
  listOrganizationUsers: {
    methodKind: "unary";
    input: typeof ListOrganizationUsersRequestSchema;
    output: typeof ListOrganizationUsersResponseSchema;
  },
  /**
   * AddUserToOrganization adds a user to an organization
   *
   * @generated from rpc cortado.v1.CortadoService.AddUserToOrganization
   */
  addUserToOrganization: {
    methodKind: "unary";
    input: typeof AddUserToOrganizationRequestSchema;
    output: typeof AddUserToOrganizationResponseSchema;
  },
  /**
   * UpdateOrganizationUser updates a user in an organization
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateOrganizationUser
   */
  updateOrganizationUser: {
    methodKind: "unary";
    input: typeof UpdateOrganizationUserRequestSchema;
    output: typeof UpdateOrganizationUserResponseSchema;
  },
  /**
   * RemoveUserFromOrganization removes a user from an organization
   *
   * @generated from rpc cortado.v1.CortadoService.RemoveUserFromOrganization
   */
  removeUserFromOrganization: {
    methodKind: "unary";
    input: typeof RemoveUserFromOrganizationRequestSchema;
    output: typeof RemoveUserFromOrganizationResponseSchema;
  },
  /**
   * CreateOrganization creates a new organization and adds the current user as admin
   *
   * @generated from rpc cortado.v1.CortadoService.CreateOrganization
   */
  createOrganization: {
    methodKind: "unary";
    input: typeof CreateOrganizationRequestSchema;
    output: typeof CreateOrganizationResponseSchema;
  },
  /**
   * GetOrganizationOnboarding retrieves the onboarding status for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.GetOrganizationOnboarding
   */
  getOrganizationOnboarding: {
    methodKind: "unary";
    input: typeof GetOrganizationOnboardingRequestSchema;
    output: typeof GetOrganizationOnboardingResponseSchema;
  },
  /**
   * UpdateOnboardingStep marks an onboarding step as complete or incomplete
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateOnboardingStep
   */
  updateOnboardingStep: {
    methodKind: "unary";
    input: typeof UpdateOnboardingStepRequestSchema;
    output: typeof UpdateOnboardingStepResponseSchema;
  },
  /**
   * SkipOnboardingStep marks an onboarding step as skipped
   *
   * @generated from rpc cortado.v1.CortadoService.SkipOnboardingStep
   */
  skipOnboardingStep: {
    methodKind: "unary";
    input: typeof SkipOnboardingStepRequestSchema;
    output: typeof SkipOnboardingStepResponseSchema;
  },
  /**
   * CheckSlugAvailability checks if a slug is available for use
   *
   * @generated from rpc cortado.v1.CortadoService.CheckSlugAvailability
   */
  checkSlugAvailability: {
    methodKind: "unary";
    input: typeof CheckSlugAvailabilityRequestSchema;
    output: typeof CheckSlugAvailabilityResponseSchema;
  },
  /**
   * ListAgreements lists all agreements for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.ListAgreements
   */
  listAgreements: {
    methodKind: "unary";
    input: typeof ListAgreementsRequestSchema;
    output: typeof ListAgreementsResponseSchema;
  },
  /**
   * GetAgreement retrieves an agreement by ID
   *
   * @generated from rpc cortado.v1.CortadoService.GetAgreement
   */
  getAgreement: {
    methodKind: "unary";
    input: typeof GetAgreementRequestSchema;
    output: typeof GetAgreementResponseSchema;
  },
  /**
   * CreateAgreement creates a new agreement
   *
   * @generated from rpc cortado.v1.CortadoService.CreateAgreement
   */
  createAgreement: {
    methodKind: "unary";
    input: typeof CreateAgreementRequestSchema;
    output: typeof CreateAgreementResponseSchema;
  },
  /**
   * UpdateAgreement updates an agreement
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateAgreement
   */
  updateAgreement: {
    methodKind: "unary";
    input: typeof UpdateAgreementRequestSchema;
    output: typeof UpdateAgreementResponseSchema;
  },
  /**
   * DeleteAgreement deletes an agreement
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteAgreement
   */
  deleteAgreement: {
    methodKind: "unary";
    input: typeof DeleteAgreementRequestSchema;
    output: typeof DeleteAgreementResponseSchema;
  },
  /**
   * CreateAgreementClause creates a new clause within an agreement
   *
   * @generated from rpc cortado.v1.CortadoService.CreateAgreementClause
   */
  createAgreementClause: {
    methodKind: "unary";
    input: typeof CreateAgreementClauseRequestSchema;
    output: typeof CreateAgreementClauseResponseSchema;
  },
  /**
   * UpdateAgreementClause updates a clause
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateAgreementClause
   */
  updateAgreementClause: {
    methodKind: "unary";
    input: typeof UpdateAgreementClauseRequestSchema;
    output: typeof UpdateAgreementClauseResponseSchema;
  },
  /**
   * DeleteAgreementClause deletes a clause
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteAgreementClause
   */
  deleteAgreementClause: {
    methodKind: "unary";
    input: typeof DeleteAgreementClauseRequestSchema;
    output: typeof DeleteAgreementClauseResponseSchema;
  },
  /**
   * ReorderAgreementClauses reorders clauses within an agreement
   *
   * @generated from rpc cortado.v1.CortadoService.ReorderAgreementClauses
   */
  reorderAgreementClauses: {
    methodKind: "unary";
    input: typeof ReorderAgreementClausesRequestSchema;
    output: typeof ReorderAgreementClausesResponseSchema;
  },
  /**
   * GenerateAgreementClauses drafts client-portal agreement clauses with AI.
   * Pure generation - nothing is persisted.
   *
   * @generated from rpc cortado.v1.CortadoService.GenerateAgreementClauses
   */
  generateAgreementClauses: {
    methodKind: "unary";
    input: typeof GenerateAgreementClausesRequestSchema;
    output: typeof GenerateAgreementClausesResponseSchema;
  },
  /**
   * ListUnavailableDates lists unavailable dates for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.ListUnavailableDates
   */
  listUnavailableDates: {
    methodKind: "unary";
    input: typeof ListUnavailableDatesRequestSchema;
    output: typeof ListUnavailableDatesResponseSchema;
  },
  /**
   * CreateUnavailableDate marks a date as unavailable for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.CreateUnavailableDate
   */
  createUnavailableDate: {
    methodKind: "unary";
    input: typeof CreateUnavailableDateRequestSchema;
    output: typeof CreateUnavailableDateResponseSchema;
  },
  /**
   * UpdateUnavailableDate updates an unavailable date entry
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateUnavailableDate
   */
  updateUnavailableDate: {
    methodKind: "unary";
    input: typeof UpdateUnavailableDateRequestSchema;
    output: typeof UpdateUnavailableDateResponseSchema;
  },
  /**
   * DeleteUnavailableDate removes an unavailable date entry
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteUnavailableDate
   */
  deleteUnavailableDate: {
    methodKind: "unary";
    input: typeof DeleteUnavailableDateRequestSchema;
    output: typeof DeleteUnavailableDateResponseSchema;
  },
  /**
   * ListOrganizationRoles lists all roles for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.ListOrganizationRoles
   */
  listOrganizationRoles: {
    methodKind: "unary";
    input: typeof ListOrganizationRolesRequestSchema;
    output: typeof ListOrganizationRolesResponseSchema;
  },
  /**
   * GetOrganizationRole retrieves a single role by ID
   *
   * @generated from rpc cortado.v1.CortadoService.GetOrganizationRole
   */
  getOrganizationRole: {
    methodKind: "unary";
    input: typeof GetOrganizationRoleRequestSchema;
    output: typeof GetOrganizationRoleResponseSchema;
  },
  /**
   * CreateOrganizationRole creates a new role for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.CreateOrganizationRole
   */
  createOrganizationRole: {
    methodKind: "unary";
    input: typeof CreateOrganizationRoleRequestSchema;
    output: typeof CreateOrganizationRoleResponseSchema;
  },
  /**
   * UpdateOrganizationRole updates an existing role
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateOrganizationRole
   */
  updateOrganizationRole: {
    methodKind: "unary";
    input: typeof UpdateOrganizationRoleRequestSchema;
    output: typeof UpdateOrganizationRoleResponseSchema;
  },
  /**
   * DeleteOrganizationRole deletes a role (cannot delete Admin role)
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteOrganizationRole
   */
  deleteOrganizationRole: {
    methodKind: "unary";
    input: typeof DeleteOrganizationRoleRequestSchema;
    output: typeof DeleteOrganizationRoleResponseSchema;
  },
  /**
   * ListPermissions lists all available permissions
   *
   * @generated from rpc cortado.v1.CortadoService.ListPermissions
   */
  listPermissions: {
    methodKind: "unary";
    input: typeof ListPermissionsRequestSchema;
    output: typeof ListPermissionsResponseSchema;
  },
  /**
   * ListOrganizationEventTypes lists all event types for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.ListOrganizationEventTypes
   */
  listOrganizationEventTypes: {
    methodKind: "unary";
    input: typeof ListOrganizationEventTypesRequestSchema;
    output: typeof ListOrganizationEventTypesResponseSchema;
  },
  /**
   * CreateOrganizationEventType creates a new event type for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.CreateOrganizationEventType
   */
  createOrganizationEventType: {
    methodKind: "unary";
    input: typeof CreateOrganizationEventTypeRequestSchema;
    output: typeof CreateOrganizationEventTypeResponseSchema;
  },
  /**
   * UpdateOrganizationEventType updates an existing event type
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateOrganizationEventType
   */
  updateOrganizationEventType: {
    methodKind: "unary";
    input: typeof UpdateOrganizationEventTypeRequestSchema;
    output: typeof UpdateOrganizationEventTypeResponseSchema;
  },
  /**
   * ArchiveOrganizationEventType archives an event type (soft delete)
   *
   * @generated from rpc cortado.v1.CortadoService.ArchiveOrganizationEventType
   */
  archiveOrganizationEventType: {
    methodKind: "unary";
    input: typeof ArchiveOrganizationEventTypeRequestSchema;
    output: typeof ArchiveOrganizationEventTypeResponseSchema;
  },
  /**
   * ReorderOrganizationEventTypes reorders the display order of an organization's event types
   *
   * @generated from rpc cortado.v1.CortadoService.ReorderOrganizationEventTypes
   */
  reorderOrganizationEventTypes: {
    methodKind: "unary";
    input: typeof ReorderOrganizationEventTypesRequestSchema;
    output: typeof ReorderOrganizationEventTypesResponseSchema;
  },
  /**
   * GetSystemSettings retrieves all system enum settings
   *
   * @generated from rpc cortado.v1.CortadoService.GetSystemSettings
   */
  getSystemSettings: {
    methodKind: "unary";
    input: typeof GetSystemSettingsRequestSchema;
    output: typeof GetSystemSettingsResponseSchema;
  },
  /**
   * GetDashboardTasks retrieves tasks for the dashboard with enriched data
   *
   * @generated from rpc cortado.v1.CortadoService.GetDashboardTasks
   */
  getDashboardTasks: {
    methodKind: "unary";
    input: typeof GetDashboardTasksRequestSchema;
    output: typeof GetDashboardTasksResponseSchema;
  },
  /**
   * GetDashboardUpcomingEvents retrieves upcoming events for the dashboard with enriched data
   *
   * @generated from rpc cortado.v1.CortadoService.GetDashboardUpcomingEvents
   */
  getDashboardUpcomingEvents: {
    methodKind: "unary";
    input: typeof GetDashboardUpcomingEventsRequestSchema;
    output: typeof GetDashboardUpcomingEventsResponseSchema;
  },
  /**
   * GetDashboardBookings retrieves bookings for the dashboard with enriched data
   *
   * @generated from rpc cortado.v1.CortadoService.GetDashboardBookings
   */
  getDashboardBookings: {
    methodKind: "unary";
    input: typeof GetDashboardBookingsRequestSchema;
    output: typeof GetDashboardBookingsResponseSchema;
  },
  /**
   * GetDashboardOverduePaymentSchedules retrieves overdue payment schedules for the dashboard
   *
   * @generated from rpc cortado.v1.CortadoService.GetDashboardOverduePaymentSchedules
   */
  getDashboardOverduePaymentSchedules: {
    methodKind: "unary";
    input: typeof GetDashboardOverduePaymentSchedulesRequestSchema;
    output: typeof GetDashboardOverduePaymentSchedulesResponseSchema;
  },
  /**
   * GetDashboardUpcomingPaymentSchedules retrieves upcoming payment schedules for the dashboard
   *
   * @generated from rpc cortado.v1.CortadoService.GetDashboardUpcomingPaymentSchedules
   */
  getDashboardUpcomingPaymentSchedules: {
    methodKind: "unary";
    input: typeof GetDashboardUpcomingPaymentSchedulesRequestSchema;
    output: typeof GetDashboardUpcomingPaymentSchedulesResponseSchema;
  },
  /**
   * GetDashboardSummary aggregates the events/tasks/leads/payment-schedule widgets on the
   * dashboard home page into a single round trip. All windows/filters are client-supplied
   * (mirroring the individual ListEvents/ListTasks/ListInquiries/GetDashboardOverduePaymentSchedules/
   * GetDashboardUpcomingPaymentSchedules requests they replace) so the server never has to guess
   * the caller's local timezone.
   *
   * @generated from rpc cortado.v1.CortadoService.GetDashboardSummary
   */
  getDashboardSummary: {
    methodKind: "unary";
    input: typeof GetDashboardSummaryRequestSchema;
    output: typeof GetDashboardSummaryResponseSchema;
  },
  /**
   * ListActivities retrieves the activity feed for the dashboard
   *
   * @generated from rpc cortado.v1.CortadoService.ListActivities
   */
  listActivities: {
    methodKind: "unary";
    input: typeof ListActivitiesRequestSchema;
    output: typeof ListActivitiesResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.CortadoService.GetJob
   */
  getJob: {
    methodKind: "unary";
    input: typeof GetJobRequestSchema;
    output: typeof GetJobResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.CortadoService.ListJobs
   */
  listJobs: {
    methodKind: "unary";
    input: typeof ListJobsRequestSchema;
    output: typeof ListJobsResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.CortadoService.GetPipelineSummary
   */
  getPipelineSummary: {
    methodKind: "unary";
    input: typeof GetPipelineSummaryRequestSchema;
    output: typeof GetPipelineSummaryResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.CortadoService.UpdateJob
   */
  updateJob: {
    methodKind: "unary";
    input: typeof UpdateJobRequestSchema;
    output: typeof UpdateJobResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.CortadoService.ListJobActivity
   */
  listJobActivity: {
    methodKind: "unary";
    input: typeof ListJobActivityRequestSchema;
    output: typeof ListJobActivityResponseSchema;
  },
  /**
   * ListJobEvents returns exactly the events JobLite.event_count counts.
   *
   * @generated from rpc cortado.v1.CortadoService.ListJobEvents
   */
  listJobEvents: {
    methodKind: "unary";
    input: typeof ListJobEventsRequestSchema;
    output: typeof ListJobEventsResponseSchema;
  },
  /**
   * ListUnreadAnnouncements retrieves broadcast announcements the current user has not read.
   *
   * @generated from rpc cortado.v1.CortadoService.ListUnreadAnnouncements
   */
  listUnreadAnnouncements: {
    methodKind: "unary";
    input: typeof ListUnreadAnnouncementsRequestSchema;
    output: typeof ListUnreadAnnouncementsResponseSchema;
  },
  /**
   * MarkAnnouncementRead marks one broadcast announcement read for the current user.
   *
   * @generated from rpc cortado.v1.CortadoService.MarkAnnouncementRead
   */
  markAnnouncementRead: {
    methodKind: "unary";
    input: typeof MarkAnnouncementReadRequestSchema;
    output: typeof MarkAnnouncementReadResponseSchema;
  },
  /**
   * ListContacts lists all contacts for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.ListContacts
   */
  listContacts: {
    methodKind: "unary";
    input: typeof ListContactsRequestSchema;
    output: typeof ListContactsResponseSchema;
  },
  /**
   * CreateContact creates a new contact
   *
   * @generated from rpc cortado.v1.CortadoService.CreateContact
   */
  createContact: {
    methodKind: "unary";
    input: typeof CreateContactRequestSchema;
    output: typeof CreateContactResponseSchema;
  },
  /**
   * GetContact retrieves a contact by ID
   *
   * @generated from rpc cortado.v1.CortadoService.GetContact
   */
  getContact: {
    methodKind: "unary";
    input: typeof GetContactRequestSchema;
    output: typeof GetContactResponseSchema;
  },
  /**
   * UpdateContact updates a contact
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateContact
   */
  updateContact: {
    methodKind: "unary";
    input: typeof UpdateContactRequestSchema;
    output: typeof UpdateContactResponseSchema;
  },
  /**
   * DeleteContact deletes a contact
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteContact
   */
  deleteContact: {
    methodKind: "unary";
    input: typeof DeleteContactRequestSchema;
    output: typeof DeleteContactResponseSchema;
  },
  /**
   * ArchiveContact hides a contact from active lists while preserving history
   *
   * @generated from rpc cortado.v1.CortadoService.ArchiveContact
   */
  archiveContact: {
    methodKind: "unary";
    input: typeof ArchiveContactRequestSchema;
    output: typeof ArchiveContactResponseSchema;
  },
  /**
   * UnarchiveContact restores an archived contact
   *
   * @generated from rpc cortado.v1.CortadoService.UnarchiveContact
   */
  unarchiveContact: {
    methodKind: "unary";
    input: typeof UnarchiveContactRequestSchema;
    output: typeof UnarchiveContactResponseSchema;
  },
  /**
   * GetContactByEmail retrieves a contact by email within an organization.
   * Matches any of a contact's addresses, not only the primary one.
   *
   * @generated from rpc cortado.v1.CortadoService.GetContactByEmail
   */
  getContactByEmail: {
    methodKind: "unary";
    input: typeof GetContactByEmailRequestSchema;
    output: typeof GetContactByEmailResponseSchema;
  },
  /**
   * AddContactEmail adds another address to a contact. AlreadyExists when the
   * address already belongs to a contact in the organization.
   *
   * @generated from rpc cortado.v1.CortadoService.AddContactEmail
   */
  addContactEmail: {
    methodKind: "unary";
    input: typeof AddContactEmailRequestSchema;
    output: typeof AddContactEmailResponseSchema;
  },
  /**
   * RemoveContactEmail removes one of a contact's addresses. Removing the
   * primary promotes the oldest remaining address.
   *
   * @generated from rpc cortado.v1.CortadoService.RemoveContactEmail
   */
  removeContactEmail: {
    methodKind: "unary";
    input: typeof RemoveContactEmailRequestSchema;
    output: typeof RemoveContactEmailResponseSchema;
  },
  /**
   * SetPrimaryContactEmail makes one of a contact's addresses its primary
   * (Contact.email).
   *
   * @generated from rpc cortado.v1.CortadoService.SetPrimaryContactEmail
   */
  setPrimaryContactEmail: {
    methodKind: "unary";
    input: typeof SetPrimaryContactEmailRequestSchema;
    output: typeof SetPrimaryContactEmailResponseSchema;
  },
  /**
   * ListCompanies lists all companies for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.ListCompanies
   */
  listCompanies: {
    methodKind: "unary";
    input: typeof ListCompaniesRequestSchema;
    output: typeof ListCompaniesResponseSchema;
  },
  /**
   * CreateCompany creates a new company
   *
   * @generated from rpc cortado.v1.CortadoService.CreateCompany
   */
  createCompany: {
    methodKind: "unary";
    input: typeof CreateCompanyRequestSchema;
    output: typeof CreateCompanyResponseSchema;
  },
  /**
   * GetCompany retrieves a company by ID
   *
   * @generated from rpc cortado.v1.CortadoService.GetCompany
   */
  getCompany: {
    methodKind: "unary";
    input: typeof GetCompanyRequestSchema;
    output: typeof GetCompanyResponseSchema;
  },
  /**
   * UpdateCompany updates a company
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateCompany
   */
  updateCompany: {
    methodKind: "unary";
    input: typeof UpdateCompanyRequestSchema;
    output: typeof UpdateCompanyResponseSchema;
  },
  /**
   * DeleteCompany deletes a company
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteCompany
   */
  deleteCompany: {
    methodKind: "unary";
    input: typeof DeleteCompanyRequestSchema;
    output: typeof DeleteCompanyResponseSchema;
  },
  /**
   * ArchiveCompany hides a company from active lists while preserving history
   *
   * @generated from rpc cortado.v1.CortadoService.ArchiveCompany
   */
  archiveCompany: {
    methodKind: "unary";
    input: typeof ArchiveCompanyRequestSchema;
    output: typeof ArchiveCompanyResponseSchema;
  },
  /**
   * UnarchiveCompany restores an archived company
   *
   * @generated from rpc cortado.v1.CortadoService.UnarchiveCompany
   */
  unarchiveCompany: {
    methodKind: "unary";
    input: typeof UnarchiveCompanyRequestSchema;
    output: typeof UnarchiveCompanyResponseSchema;
  },
  /**
   * AddContactToCompany adds a contact to a company with optional title
   *
   * @generated from rpc cortado.v1.CortadoService.AddContactToCompany
   */
  addContactToCompany: {
    methodKind: "unary";
    input: typeof AddContactToCompanyRequestSchema;
    output: typeof AddContactToCompanyResponseSchema;
  },
  /**
   * RemoveContactFromCompany removes a contact from a company
   *
   * @generated from rpc cortado.v1.CortadoService.RemoveContactFromCompany
   */
  removeContactFromCompany: {
    methodKind: "unary";
    input: typeof RemoveContactFromCompanyRequestSchema;
    output: typeof RemoveContactFromCompanyResponseSchema;
  },
  /**
   * CreateInquiry creates a new inquiry
   *
   * @generated from rpc cortado.v1.CortadoService.CreateInquiry
   */
  createInquiry: {
    methodKind: "unary";
    input: typeof CreateInquiryRequestSchema;
    output: typeof CreateInquiryResponseSchema;
  },
  /**
   * GetInquiry retrieves an inquiry by ID
   *
   * @generated from rpc cortado.v1.CortadoService.GetInquiry
   */
  getInquiry: {
    methodKind: "unary";
    input: typeof GetInquiryRequestSchema;
    output: typeof GetInquiryResponseSchema;
  },
  /**
   * GetInquiryOverlaps retrieves leads and events that overlap with an inquiry's date/time
   *
   * @generated from rpc cortado.v1.CortadoService.GetInquiryOverlaps
   */
  getInquiryOverlaps: {
    methodKind: "unary";
    input: typeof GetInquiryOverlapsRequestSchema;
    output: typeof GetInquiryOverlapsResponseSchema;
  },
  /**
   * CreateInquiryEvent creates a new event for an inquiry
   *
   * @generated from rpc cortado.v1.CortadoService.CreateInquiryEvent
   */
  createInquiryEvent: {
    methodKind: "unary";
    input: typeof CreateInquiryEventRequestSchema;
    output: typeof CreateInquiryEventResponseSchema;
  },
  /**
   * UpdateInquiryEvent updates an inquiry event
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateInquiryEvent
   */
  updateInquiryEvent: {
    methodKind: "unary";
    input: typeof UpdateInquiryEventRequestSchema;
    output: typeof UpdateInquiryEventResponseSchema;
  },
  /**
   * DeleteInquiryEvent deletes an inquiry event
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteInquiryEvent
   */
  deleteInquiryEvent: {
    methodKind: "unary";
    input: typeof DeleteInquiryEventRequestSchema;
    output: typeof DeleteInquiryEventResponseSchema;
  },
  /**
   * ListInquiryEvents lists all events for an inquiry
   *
   * @generated from rpc cortado.v1.CortadoService.ListInquiryEvents
   */
  listInquiryEvents: {
    methodKind: "unary";
    input: typeof ListInquiryEventsRequestSchema;
    output: typeof ListInquiryEventsResponseSchema;
  },
  /**
   * UpdateInquiry updates an inquiry
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateInquiry
   */
  updateInquiry: {
    methodKind: "unary";
    input: typeof UpdateInquiryRequestSchema;
    output: typeof UpdateInquiryResponseSchema;
  },
  /**
   * ListOrganizationInquiries lists all inquiries for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.ListOrganizationInquiries
   */
  listOrganizationInquiries: {
    methodKind: "unary";
    input: typeof ListOrganizationInquiriesRequestSchema;
    output: typeof ListOrganizationInquiriesResponseSchema;
  },
  /**
   * ListInquiries lists inquiries with comprehensive filtering support
   *
   * @generated from rpc cortado.v1.CortadoService.ListInquiries
   */
  listInquiries: {
    methodKind: "unary";
    input: typeof ListInquiriesRequestSchema;
    output: typeof ListInquiriesResponseSchema;
  },
  /**
   * GeneratePortalLink generates a shareable portal link with JWT token for an inquiry
   *
   * @generated from rpc cortado.v1.CortadoService.GeneratePortalLink
   */
  generatePortalLink: {
    methodKind: "unary";
    input: typeof GeneratePortalLinkRequestSchema;
    output: typeof GeneratePortalLinkResponseSchema;
  },
  /**
   * GenerateInvoicePortalLink generates a shareable portal link with JWT token for an invoice
   * Supports both inquiry-scoped tokens (if booking has inquiry) and booking-scoped tokens
   *
   * @generated from rpc cortado.v1.CortadoService.GenerateInvoicePortalLink
   */
  generateInvoicePortalLink: {
    methodKind: "unary";
    input: typeof GenerateInvoicePortalLinkRequestSchema;
    output: typeof GenerateInvoicePortalLinkResponseSchema;
  },
  /**
   * GetPublicInquiry retrieves public inquiry data for customer-facing portal
   *
   * @generated from rpc cortado.v1.CortadoService.GetPublicInquiry
   */
  getPublicInquiry: {
    methodKind: "unary";
    input: typeof GetPublicInquiryRequestSchema;
    output: typeof GetPublicInquiryResponseSchema;
  },
  /**
   * GetPublicQuote retrieves full quote details for customer-facing portal
   *
   * @generated from rpc cortado.v1.CortadoService.GetPublicQuote
   */
  getPublicQuote: {
    methodKind: "unary";
    input: typeof GetPublicQuoteRequestSchema;
    output: typeof GetPublicQuoteResponseSchema;
  },
  /**
   * PreviewPublicQuote recomputes a quote's totals with the customer's requested
   * add-on selections applied. Fully server-side; never persisted.
   *
   * @generated from rpc cortado.v1.CortadoService.PreviewPublicQuote
   */
  previewPublicQuote: {
    methodKind: "unary";
    input: typeof PreviewPublicQuoteRequestSchema;
    output: typeof PreviewPublicQuoteResponseSchema;
  },
  /**
   * GeneratePublicQuotePdf returns a cached or newly rendered quote PDF.
   *
   * @generated from rpc cortado.v1.CortadoService.GeneratePublicQuotePdf
   */
  generatePublicQuotePdf: {
    methodKind: "unary";
    input: typeof GeneratePublicQuotePdfRequestSchema;
    output: typeof GeneratePublicQuotePdfResponseSchema;
  },
  /**
   * AcceptPublicQuote accepts a quote and creates booking + invoice
   *
   * @generated from rpc cortado.v1.CortadoService.AcceptPublicQuote
   */
  acceptPublicQuote: {
    methodKind: "unary";
    input: typeof AcceptPublicQuoteRequestSchema;
    output: typeof AcceptPublicQuoteResponseSchema;
  },
  /**
   * RejectPublicQuote declines a quote on behalf of the customer.
   * Idempotent: rejecting an already-rejected quote returns success.
   * Portal tokens are optional and used only for attribution (matches AcceptPublicQuote).
   *
   * @generated from rpc cortado.v1.CortadoService.RejectPublicQuote
   */
  rejectPublicQuote: {
    methodKind: "unary";
    input: typeof RejectPublicQuoteRequestSchema;
    output: typeof RejectPublicQuoteResponseSchema;
  },
  /**
   * MarkPublicQuoteViewed marks a quote as viewed by the customer
   *
   * @generated from rpc cortado.v1.CortadoService.MarkPublicQuoteViewed
   */
  markPublicQuoteViewed: {
    methodKind: "unary";
    input: typeof MarkPublicQuoteViewedRequestSchema;
    output: typeof MarkPublicQuoteViewedResponseSchema;
  },
  /**
   * GetPublicBooking retrieves public booking data for customer-facing portal
   *
   * @generated from rpc cortado.v1.CortadoService.GetPublicBooking
   */
  getPublicBooking: {
    methodKind: "unary";
    input: typeof GetPublicBookingRequestSchema;
    output: typeof GetPublicBookingResponseSchema;
  },
  /**
   * SubmitPublicBookingQuestionnaire writes customer answers onto the booking's
   * questionnaire snapshot. Portal tokens are optional and used only for
   * attribution (matches GetPublicBooking). Does not read the event-type template.
   *
   * @generated from rpc cortado.v1.CortadoService.SubmitPublicBookingQuestionnaire
   */
  submitPublicBookingQuestionnaire: {
    methodKind: "unary";
    input: typeof SubmitPublicBookingQuestionnaireRequestSchema;
    output: typeof SubmitPublicBookingQuestionnaireResponseSchema;
  },
  /**
   * UploadPublicBookingQuestionnaireFile stores one file for a file-upload
   * question as an attachment on the booking. It does not change the
   * questionnaire; submit the returned attachment ID as the item's answer.
   * Portal tokens are optional and used only for attribution.
   *
   * @generated from rpc cortado.v1.CortadoService.UploadPublicBookingQuestionnaireFile
   */
  uploadPublicBookingQuestionnaireFile: {
    methodKind: "unary";
    input: typeof UploadPublicBookingQuestionnaireFileRequestSchema;
    output: typeof UploadPublicBookingQuestionnaireFileResponseSchema;
  },
  /**
   * GetPublicInvoice retrieves public invoice data for customer-facing portal
   *
   * @generated from rpc cortado.v1.CortadoService.GetPublicInvoice
   */
  getPublicInvoice: {
    methodKind: "unary";
    input: typeof GetPublicInvoiceRequestSchema;
    output: typeof GetPublicInvoiceResponseSchema;
  },
  /**
   * GeneratePublicInvoicePdf returns a cached or newly rendered invoice PDF.
   *
   * @generated from rpc cortado.v1.CortadoService.GeneratePublicInvoicePdf
   */
  generatePublicInvoicePdf: {
    methodKind: "unary";
    input: typeof GeneratePublicInvoicePdfRequestSchema;
    output: typeof GeneratePublicInvoicePdfResponseSchema;
  },
  /**
   * GeneratePublicPaymentReceiptPdf returns a cached or newly rendered receipt PDF
   * for a payment schedule that has at least one completed payment.
   *
   * @generated from rpc cortado.v1.CortadoService.GeneratePublicPaymentReceiptPdf
   */
  generatePublicPaymentReceiptPdf: {
    methodKind: "unary";
    input: typeof GeneratePublicPaymentReceiptPdfRequestSchema;
    output: typeof GeneratePublicPaymentReceiptPdfResponseSchema;
  },
  /**
   * UpdatePublicInvoiceTip updates the customer tip for an invoice
   *
   * @generated from rpc cortado.v1.CortadoService.UpdatePublicInvoiceTip
   */
  updatePublicInvoiceTip: {
    methodKind: "unary";
    input: typeof UpdatePublicInvoiceTipRequestSchema;
    output: typeof UpdatePublicInvoiceTipResponseSchema;
  },
  /**
   * CreatePublicPaymentIntent is a dead endpoint that always returns Unimplemented.
   * Use CreatePublicCheckoutSession (Stripe Embedded Checkout) instead.
   * Kept in the proto so old clients fail loudly instead of breaking at decode time.
   *
   * @generated from rpc cortado.v1.CortadoService.CreatePublicPaymentIntent
   * @deprecated
   */
  createPublicPaymentIntent: {
    methodKind: "unary";
    input: typeof CreatePublicPaymentIntentRequestSchema;
    output: typeof CreatePublicPaymentIntentResponseSchema;
  },
  /**
   * CreatePublicCheckoutSession creates a Stripe Checkout Session for a payment schedule item
   *
   * @generated from rpc cortado.v1.CortadoService.CreatePublicCheckoutSession
   */
  createPublicCheckoutSession: {
    methodKind: "unary";
    input: typeof CreatePublicCheckoutSessionRequestSchema;
    output: typeof CreatePublicCheckoutSessionResponseSchema;
  },
  /**
   * CreatePublicResidualTipCheckoutSession creates a tip-only Stripe Checkout Session to
   * collect outstanding tip after the invoice base is fully paid (CPRO-652 H2b).
   *
   * @generated from rpc cortado.v1.CortadoService.CreatePublicResidualTipCheckoutSession
   */
  createPublicResidualTipCheckoutSession: {
    methodKind: "unary";
    input: typeof CreatePublicResidualTipCheckoutSessionRequestSchema;
    output: typeof CreatePublicResidualTipCheckoutSessionResponseSchema;
  },
  /**
   * GetPublicCheckoutSessionStatus retrieves the status of a Stripe Checkout Session
   *
   * @generated from rpc cortado.v1.CortadoService.GetPublicCheckoutSessionStatus
   */
  getPublicCheckoutSessionStatus: {
    methodKind: "unary";
    input: typeof GetPublicCheckoutSessionStatusRequestSchema;
    output: typeof GetPublicCheckoutSessionStatusResponseSchema;
  },
  /**
   * GeneratePublicPortalLink generates a new shareable link from portal (requires token auth)
   *
   * @generated from rpc cortado.v1.CortadoService.GeneratePublicPortalLink
   */
  generatePublicPortalLink: {
    methodKind: "unary";
    input: typeof GeneratePublicPortalLinkRequestSchema;
    output: typeof GeneratePublicPortalLinkResponseSchema;
  },
  /**
   * SharePublicInquiryByEmail sends inquiry links via email
   *
   * @generated from rpc cortado.v1.CortadoService.SharePublicInquiryByEmail
   */
  sharePublicInquiryByEmail: {
    methodKind: "unary";
    input: typeof SharePublicInquiryByEmailRequestSchema;
    output: typeof SharePublicInquiryByEmailResponseSchema;
  },
  /**
   * SharePublicInvoiceByEmail sends invoice links via email
   *
   * @generated from rpc cortado.v1.CortadoService.SharePublicInvoiceByEmail
   */
  sharePublicInvoiceByEmail: {
    methodKind: "unary";
    input: typeof SharePublicInvoiceByEmailRequestSchema;
    output: typeof SharePublicInvoiceByEmailResponseSchema;
  },
  /**
   * ConvertToPayInFull converts multiple payment schedules to a single "pay in full" schedule
   * Only allowed when invoice has multiple schedules and no payments have been made
   *
   * @generated from rpc cortado.v1.CortadoService.ConvertToPayInFull
   */
  convertToPayInFull: {
    methodKind: "unary";
    input: typeof ConvertToPayInFullRequestSchema;
    output: typeof ConvertToPayInFullResponseSchema;
  },
  /**
   * ResolvePortalLink exchanges an opaque short code for a portal token and
   * canonical resource path. Public only through the portal API mount.
   *
   * @generated from rpc cortado.v1.CortadoService.ResolvePortalLink
   */
  resolvePortalLink: {
    methodKind: "unary";
    input: typeof ResolvePortalLinkRequestSchema;
    output: typeof ResolvePortalLinkResponseSchema;
  },
  /**
   * GetInquiryOrgInfo returns org info for a given inquiry token — public endpoint, no auth required, works with expired tokens
   *
   * @generated from rpc cortado.v1.CortadoService.GetInquiryOrgInfo
   */
  getInquiryOrgInfo: {
    methodKind: "unary";
    input: typeof GetInquiryOrgInfoRequestSchema;
    output: typeof GetInquiryOrgInfoResponseSchema;
  },
  /**
   * ResendPortalLink reissues the caller's portal token (preserving its JTI) and emails a fresh link to the original recipient.
   * Public endpoint — accepts expired tokens. Returns success-shaped responses for invalid tokens to avoid enumeration.
   *
   * @generated from rpc cortado.v1.CortadoService.ResendPortalLink
   */
  resendPortalLink: {
    methodKind: "unary";
    input: typeof ResendPortalLinkRequestSchema;
    output: typeof ResendPortalLinkResponseSchema;
  },
  /**
   * ListEvents lists events with filtering and pagination
   *
   * @generated from rpc cortado.v1.CortadoService.ListEvents
   */
  listEvents: {
    methodKind: "unary";
    input: typeof ListEventsRequestSchema;
    output: typeof ListEventsResponseSchema;
  },
  /**
   * ListTasks lists tasks with filtering and pagination
   *
   * @generated from rpc cortado.v1.CortadoService.ListTasks
   */
  listTasks: {
    methodKind: "unary";
    input: typeof ListTasksRequestSchema;
    output: typeof ListTasksResponseSchema;
  },
  /**
   * GetBooking retrieves a booking by ID
   *
   * @generated from rpc cortado.v1.CortadoService.GetBooking
   */
  getBooking: {
    methodKind: "unary";
    input: typeof GetBookingRequestSchema;
    output: typeof GetBookingResponseSchema;
  },
  /**
   * UpdateBooking updates a booking
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateBooking
   */
  updateBooking: {
    methodKind: "unary";
    input: typeof UpdateBookingRequestSchema;
    output: typeof UpdateBookingResponseSchema;
  },
  /**
   * UpdateBookingQuestionnaire replaces a booking's questionnaire with the
   * given items, in order. Staff author the questionnaire directly - it does
   * not depend on org/event-type templates. Answers are server-owned: the
   * caller's answer content is ignored, and any existing answer is carried
   * over only when its item survives unchanged in type (and, for choice
   * items, its answered options still exist). An empty items list clears the
   * booking's questionnaire.
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateBookingQuestionnaire
   */
  updateBookingQuestionnaire: {
    methodKind: "unary";
    input: typeof UpdateBookingQuestionnaireRequestSchema;
    output: typeof UpdateBookingQuestionnaireResponseSchema;
  },
  /**
   * CreateBooking creates a new booking directly (without requiring an inquiry)
   *
   * @generated from rpc cortado.v1.CortadoService.CreateBooking
   */
  createBooking: {
    methodKind: "unary";
    input: typeof CreateBookingRequestSchema;
    output: typeof CreateBookingResponseSchema;
  },
  /**
   * MoveInquiryToEvents creates a booking and events from an accepted inquiry
   * Used when an inquiry is manually accepted without going through quote acceptance
   *
   * @generated from rpc cortado.v1.CortadoService.MoveInquiryToEvents
   */
  moveInquiryToEvents: {
    methodKind: "unary";
    input: typeof MoveInquiryToEventsRequestSchema;
    output: typeof MoveInquiryToEventsResponseSchema;
  },
  /**
   * AcceptQuoteAsAdmin accepts a quote as an admin, creating a booking + events + invoice
   *
   * @generated from rpc cortado.v1.CortadoService.AcceptQuoteAsAdmin
   */
  acceptQuoteAsAdmin: {
    methodKind: "unary";
    input: typeof AcceptQuoteAsAdminRequestSchema;
    output: typeof AcceptQuoteAsAdminResponseSchema;
  },
  /**
   * GetEvent retrieves an event by ID with full enrichment
   *
   * @generated from rpc cortado.v1.CortadoService.GetEvent
   */
  getEvent: {
    methodKind: "unary";
    input: typeof GetEventRequestSchema;
    output: typeof GetEventResponseSchema;
  },
  /**
   * GetEventDetail is an aggregate endpoint returning the event plus its
   * booking and (when the booking came from an inquiry) the inquiry, in one
   * round-trip, to eliminate the event-detail page request waterfall.
   *
   * @generated from rpc cortado.v1.CortadoService.GetEventDetail
   */
  getEventDetail: {
    methodKind: "unary";
    input: typeof GetEventDetailRequestSchema;
    output: typeof GetEventDetailResponseSchema;
  },
  /**
   * CreateEvent creates a new event within a booking
   *
   * @generated from rpc cortado.v1.CortadoService.CreateEvent
   */
  createEvent: {
    methodKind: "unary";
    input: typeof CreateEventRequestSchema;
    output: typeof CreateEventResponseSchema;
  },
  /**
   * UpdateEvent updates an event
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateEvent
   */
  updateEvent: {
    methodKind: "unary";
    input: typeof UpdateEventRequestSchema;
    output: typeof UpdateEventResponseSchema;
  },
  /**
   * ArchiveEvent soft-deletes an event
   *
   * @generated from rpc cortado.v1.CortadoService.ArchiveEvent
   */
  archiveEvent: {
    methodKind: "unary";
    input: typeof ArchiveEventRequestSchema;
    output: typeof ArchiveEventResponseSchema;
  },
  /**
   * UnarchiveEvent restores an archived event
   *
   * @generated from rpc cortado.v1.CortadoService.UnarchiveEvent
   */
  unarchiveEvent: {
    methodKind: "unary";
    input: typeof UnarchiveEventRequestSchema;
    output: typeof UnarchiveEventResponseSchema;
  },
  /**
   * ArchiveInquiry soft-deletes an inquiry (lead), optionally cascading to its booking's events
   *
   * @generated from rpc cortado.v1.CortadoService.ArchiveInquiry
   */
  archiveInquiry: {
    methodKind: "unary";
    input: typeof ArchiveInquiryRequestSchema;
    output: typeof ArchiveInquiryResponseSchema;
  },
  /**
   * UnarchiveInquiry restores an archived inquiry (lead)
   *
   * @generated from rpc cortado.v1.CortadoService.UnarchiveInquiry
   */
  unarchiveInquiry: {
    methodKind: "unary";
    input: typeof UnarchiveInquiryRequestSchema;
    output: typeof UnarchiveInquiryResponseSchema;
  },
  /**
   * Lead referrals: send a lead to another organization by its referral code.
   * GetLeadReferralSettings returns the organization's opt-in and code.
   *
   * @generated from rpc cortado.v1.CortadoService.GetLeadReferralSettings
   */
  getLeadReferralSettings: {
    methodKind: "unary";
    input: typeof GetLeadReferralSettingsRequestSchema;
    output: typeof GetLeadReferralSettingsResponseSchema;
  },
  /**
   * UpdateLeadReferralSettings turns receiving referrals on or off.
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateLeadReferralSettings
   */
  updateLeadReferralSettings: {
    methodKind: "unary";
    input: typeof UpdateLeadReferralSettingsRequestSchema;
    output: typeof UpdateLeadReferralSettingsResponseSchema;
  },
  /**
   * RegenerateLeadReferralCode replaces the organization's code.
   *
   * @generated from rpc cortado.v1.CortadoService.RegenerateLeadReferralCode
   */
  regenerateLeadReferralCode: {
    methodKind: "unary";
    input: typeof RegenerateLeadReferralCodeRequestSchema;
    output: typeof RegenerateLeadReferralCodeResponseSchema;
  },
  /**
   * LookupLeadReferralCode returns the name of the organization holding a code.
   *
   * @generated from rpc cortado.v1.CortadoService.LookupLeadReferralCode
   */
  lookupLeadReferralCode: {
    methodKind: "unary";
    input: typeof LookupLeadReferralCodeRequestSchema;
    output: typeof LookupLeadReferralCodeResponseSchema;
  },
  /**
   * ListLeadReferralPartners lists saved codes.
   *
   * @generated from rpc cortado.v1.CortadoService.ListLeadReferralPartners
   */
  listLeadReferralPartners: {
    methodKind: "unary";
    input: typeof ListLeadReferralPartnersRequestSchema;
    output: typeof ListLeadReferralPartnersResponseSchema;
  },
  /**
   * CreateLeadReferralPartner saves a code.
   *
   * @generated from rpc cortado.v1.CortadoService.CreateLeadReferralPartner
   */
  createLeadReferralPartner: {
    methodKind: "unary";
    input: typeof CreateLeadReferralPartnerRequestSchema;
    output: typeof CreateLeadReferralPartnerResponseSchema;
  },
  /**
   * DeleteLeadReferralPartner removes a saved code.
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteLeadReferralPartner
   */
  deleteLeadReferralPartner: {
    methodKind: "unary";
    input: typeof DeleteLeadReferralPartnerRequestSchema;
    output: typeof DeleteLeadReferralPartnerResponseSchema;
  },
  /**
   * SendLeadReferral refers a lead to another organization.
   *
   * @generated from rpc cortado.v1.CortadoService.SendLeadReferral
   */
  sendLeadReferral: {
    methodKind: "unary";
    input: typeof SendLeadReferralRequestSchema;
    output: typeof SendLeadReferralResponseSchema;
  },
  /**
   * ListLeadReferrals lists referrals the organization sent.
   *
   * @generated from rpc cortado.v1.CortadoService.ListLeadReferrals
   */
  listLeadReferrals: {
    methodKind: "unary";
    input: typeof ListLeadReferralsRequestSchema;
    output: typeof ListLeadReferralsResponseSchema;
  },
  /**
   * ListIncomingLeadReferrals lists referrals waiting on the organization.
   *
   * @generated from rpc cortado.v1.CortadoService.ListIncomingLeadReferrals
   */
  listIncomingLeadReferrals: {
    methodKind: "unary";
    input: typeof ListIncomingLeadReferralsRequestSchema;
    output: typeof ListIncomingLeadReferralsResponseSchema;
  },
  /**
   * AcceptLeadReferral copies the referred lead into the organization.
   *
   * @generated from rpc cortado.v1.CortadoService.AcceptLeadReferral
   */
  acceptLeadReferral: {
    methodKind: "unary";
    input: typeof AcceptLeadReferralRequestSchema;
    output: typeof AcceptLeadReferralResponseSchema;
  },
  /**
   * RejectLeadReferral declines a referral.
   *
   * @generated from rpc cortado.v1.CortadoService.RejectLeadReferral
   */
  rejectLeadReferral: {
    methodKind: "unary";
    input: typeof RejectLeadReferralRequestSchema;
    output: typeof RejectLeadReferralResponseSchema;
  },
  /**
   * WithdrawLeadReferral takes back a pending referral the organization sent.
   *
   * @generated from rpc cortado.v1.CortadoService.WithdrawLeadReferral
   */
  withdrawLeadReferral: {
    methodKind: "unary";
    input: typeof WithdrawLeadReferralRequestSchema;
    output: typeof WithdrawLeadReferralResponseSchema;
  },
  /**
   * SyncEventCalendar triggers a Google Calendar sync for an event
   *
   * @generated from rpc cortado.v1.CortadoService.SyncEventCalendar
   */
  syncEventCalendar: {
    methodKind: "unary";
    input: typeof SyncEventCalendarRequestSchema;
    output: typeof SyncEventCalendarResponseSchema;
  },
  /**
   * GetEventDriveTime calculates drive time from org address to event location
   *
   * @generated from rpc cortado.v1.CortadoService.GetEventDriveTime
   */
  getEventDriveTime: {
    methodKind: "unary";
    input: typeof GetEventDriveTimeRequestSchema;
    output: typeof GetEventDriveTimeResponseSchema;
  },
  /**
   * GetInquiryDriveTime calculates drive time from org address to an inquiry's location
   *
   * @generated from rpc cortado.v1.CortadoService.GetInquiryDriveTime
   */
  getInquiryDriveTime: {
    methodKind: "unary";
    input: typeof GetInquiryDriveTimeRequestSchema;
    output: typeof GetInquiryDriveTimeResponseSchema;
  },
  /**
   * ListEventAddons lists the add-ons the customer accepted on the quote that
   * booked the event.
   *
   * @generated from rpc cortado.v1.CortadoService.ListEventAddons
   */
  listEventAddons: {
    methodKind: "unary";
    input: typeof ListEventAddonsRequestSchema;
    output: typeof ListEventAddonsResponseSchema;
  },
  /**
   * PreviewEventInventory computes the event's packing list from its current
   * inputs (org inventory settings, guests, length, accepted add-ons). Nothing
   * is saved.
   *
   * @generated from rpc cortado.v1.CortadoService.PreviewEventInventory
   */
  previewEventInventory: {
    methodKind: "unary";
    input: typeof PreviewEventInventoryRequestSchema;
    output: typeof PreviewEventInventoryResponseSchema;
  },
  /**
   * PreviewEventTimeline computes the event's run of show from its current
   * inputs (org time settings, drive time, cart count). Nothing is saved.
   *
   * @generated from rpc cortado.v1.CortadoService.PreviewEventTimeline
   */
  previewEventTimeline: {
    methodKind: "unary";
    input: typeof PreviewEventTimelineRequestSchema;
    output: typeof PreviewEventTimelineResponseSchema;
  },
  /**
   * GetEventPackingList returns the event's saved packing list and whether
   * its inputs changed since it was made. Generates the list on first view.
   *
   * @generated from rpc cortado.v1.CortadoService.GetEventPackingList
   */
  getEventPackingList: {
    methodKind: "unary";
    input: typeof GetEventPackingListRequestSchema;
    output: typeof GetEventPackingListResponseSchema;
  },
  /**
   * RegenerateEventPackingList rebuilds the computed and add-on rows from the
   * event's current inputs, resetting their overrides and packed marks.
   *
   * @generated from rpc cortado.v1.CortadoService.RegenerateEventPackingList
   */
  regenerateEventPackingList: {
    methodKind: "unary";
    input: typeof RegenerateEventPackingListRequestSchema;
    output: typeof RegenerateEventPackingListResponseSchema;
  },
  /**
   * SetEventPackingItemPacked marks a packing row packed or unpacked.
   *
   * @generated from rpc cortado.v1.CortadoService.SetEventPackingItemPacked
   */
  setEventPackingItemPacked: {
    methodKind: "unary";
    input: typeof SetEventPackingItemPackedRequestSchema;
    output: typeof SetEventPackingItemPackedResponseSchema;
  },
  /**
   * SetEventPackingItemQuantity overrides (or clears) a row's quantity.
   *
   * @generated from rpc cortado.v1.CortadoService.SetEventPackingItemQuantity
   */
  setEventPackingItemQuantity: {
    methodKind: "unary";
    input: typeof SetEventPackingItemQuantityRequestSchema;
    output: typeof SetEventPackingItemQuantityResponseSchema;
  },
  /**
   * AddEventPackingItem adds a manual row to the event's packing list.
   *
   * @generated from rpc cortado.v1.CortadoService.AddEventPackingItem
   */
  addEventPackingItem: {
    methodKind: "unary";
    input: typeof AddEventPackingItemRequestSchema;
    output: typeof AddEventPackingItemResponseSchema;
  },
  /**
   * DeleteEventPackingItem removes a manual row from the event's packing list.
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteEventPackingItem
   */
  deleteEventPackingItem: {
    methodKind: "unary";
    input: typeof DeleteEventPackingItemRequestSchema;
    output: typeof DeleteEventPackingItemResponseSchema;
  },
  /**
   * GetEventTimeline returns the event's saved run-of-show timeline and what
   * changed since it was generated, generating it on first read.
   *
   * @generated from rpc cortado.v1.CortadoService.GetEventTimeline
   */
  getEventTimeline: {
    methodKind: "unary";
    input: typeof GetEventTimelineRequestSchema;
    output: typeof GetEventTimelineResponseSchema;
  },
  /**
   * UpdateEventTimelineBlocks replaces the event's timeline blocks with an
   * edited list and marks the timeline customized.
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateEventTimelineBlocks
   */
  updateEventTimelineBlocks: {
    methodKind: "unary";
    input: typeof UpdateEventTimelineBlocksRequestSchema;
    output: typeof UpdateEventTimelineBlocksResponseSchema;
  },
  /**
   * RegenerateEventTimeline recalculates the event's timeline from its
   * current inputs, discarding edits.
   *
   * @generated from rpc cortado.v1.CortadoService.RegenerateEventTimeline
   */
  regenerateEventTimeline: {
    methodKind: "unary";
    input: typeof RegenerateEventTimelineRequestSchema;
    output: typeof RegenerateEventTimelineResponseSchema;
  },
  /**
   * ResolveLocationTimezone returns the IANA timezone for a given postal
   * address by geocoding it. Used by the timezone picker's "Use location
   * timezone" link to recover the auto-detected zone after a manual override.
   *
   * @generated from rpc cortado.v1.CortadoService.ResolveLocationTimezone
   */
  resolveLocationTimezone: {
    methodKind: "unary";
    input: typeof ResolveLocationTimezoneRequestSchema;
    output: typeof ResolveLocationTimezoneResponseSchema;
  },
  /**
   * ListUserSchedulings lists user schedulings with optional filtering
   *
   * @generated from rpc cortado.v1.CortadoService.ListUserSchedulings
   */
  listUserSchedulings: {
    methodKind: "unary";
    input: typeof ListUserSchedulingsRequestSchema;
    output: typeof ListUserSchedulingsResponseSchema;
  },
  /**
   * GetUserScheduling retrieves a single user scheduling by ID
   *
   * @generated from rpc cortado.v1.CortadoService.GetUserScheduling
   */
  getUserScheduling: {
    methodKind: "unary";
    input: typeof GetUserSchedulingRequestSchema;
    output: typeof GetUserSchedulingResponseSchema;
  },
  /**
   * CreateUserScheduling creates a new user scheduling
   *
   * @generated from rpc cortado.v1.CortadoService.CreateUserScheduling
   */
  createUserScheduling: {
    methodKind: "unary";
    input: typeof CreateUserSchedulingRequestSchema;
    output: typeof CreateUserSchedulingResponseSchema;
  },
  /**
   * UpdateUserScheduling updates an existing user scheduling
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateUserScheduling
   */
  updateUserScheduling: {
    methodKind: "unary";
    input: typeof UpdateUserSchedulingRequestSchema;
    output: typeof UpdateUserSchedulingResponseSchema;
  },
  /**
   * DeleteUserScheduling deletes a user scheduling
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteUserScheduling
   */
  deleteUserScheduling: {
    methodKind: "unary";
    input: typeof DeleteUserSchedulingRequestSchema;
    output: typeof DeleteUserSchedulingResponseSchema;
  },
  /**
   * ListEventStaffAvailability lists every org member with whether they can
   * work the event: unavailable when assigned to another event that overlaps
   * the on-site window, or when the window touches an org blackout date.
   *
   * @generated from rpc cortado.v1.CortadoService.ListEventStaffAvailability
   */
  listEventStaffAvailability: {
    methodKind: "unary";
    input: typeof ListEventStaffAvailabilityRequestSchema;
    output: typeof ListEventStaffAvailabilityResponseSchema;
  },
  /**
   * ListItems lists all items for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.ListItems
   */
  listItems: {
    methodKind: "unary";
    input: typeof ListItemsRequestSchema;
    output: typeof ListItemsResponseSchema;
  },
  /**
   * CreateItem creates a new item
   *
   * @generated from rpc cortado.v1.CortadoService.CreateItem
   */
  createItem: {
    methodKind: "unary";
    input: typeof CreateItemRequestSchema;
    output: typeof CreateItemResponseSchema;
  },
  /**
   * GetItem retrieves an item by ID
   *
   * @generated from rpc cortado.v1.CortadoService.GetItem
   */
  getItem: {
    methodKind: "unary";
    input: typeof GetItemRequestSchema;
    output: typeof GetItemResponseSchema;
  },
  /**
   * UpdateItem updates an item
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateItem
   */
  updateItem: {
    methodKind: "unary";
    input: typeof UpdateItemRequestSchema;
    output: typeof UpdateItemResponseSchema;
  },
  /**
   * DeleteItem deletes an item
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteItem
   */
  deleteItem: {
    methodKind: "unary";
    input: typeof DeleteItemRequestSchema;
    output: typeof DeleteItemResponseSchema;
  },
  /**
   * ReorderFormItems reorders the display order of items on the inquiry form
   *
   * @generated from rpc cortado.v1.CortadoService.ReorderFormItems
   */
  reorderFormItems: {
    methodKind: "unary";
    input: typeof ReorderFormItemsRequestSchema;
    output: typeof ReorderFormItemsResponseSchema;
  },
  /**
   * GetTransportationItem gets the organization's mileage configuration.
   *
   * @generated from rpc cortado.v1.CortadoService.GetTransportationItem
   */
  getTransportationItem: {
    methodKind: "unary";
    input: typeof GetTransportationItemRequestSchema;
    output: typeof GetTransportationItemResponseSchema;
  },
  /**
   * UpsertTransportationItem creates or updates the organization's mileage configuration.
   *
   * @generated from rpc cortado.v1.CortadoService.UpsertTransportationItem
   */
  upsertTransportationItem: {
    methodKind: "unary";
    input: typeof UpsertTransportationItemRequestSchema;
    output: typeof UpsertTransportationItemResponseSchema;
  },
  /**
   * UploadItemImage adds a gallery image to a catalog item (JPEG/PNG/WebP, <= 10 MB, max 10 per item)
   *
   * @generated from rpc cortado.v1.CortadoService.UploadItemImage
   */
  uploadItemImage: {
    methodKind: "unary";
    input: typeof UploadItemImageRequestSchema;
    output: typeof UploadItemImageResponseSchema;
  },
  /**
   * ListItemImages lists a catalog item's gallery images ordered by sort_order
   *
   * @generated from rpc cortado.v1.CortadoService.ListItemImages
   */
  listItemImages: {
    methodKind: "unary";
    input: typeof ListItemImagesRequestSchema;
    output: typeof ListItemImagesResponseSchema;
  },
  /**
   * UpdateItemImage updates an image's alt text and/or marks it as the cover image
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateItemImage
   */
  updateItemImage: {
    methodKind: "unary";
    input: typeof UpdateItemImageRequestSchema;
    output: typeof UpdateItemImageResponseSchema;
  },
  /**
   * ReorderItemImages sets the display order of a catalog item's images
   *
   * @generated from rpc cortado.v1.CortadoService.ReorderItemImages
   */
  reorderItemImages: {
    methodKind: "unary";
    input: typeof ReorderItemImagesRequestSchema;
    output: typeof ReorderItemImagesResponseSchema;
  },
  /**
   * DeleteItemImage removes a gallery image and its stored file
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteItemImage
   */
  deleteItemImage: {
    methodKind: "unary";
    input: typeof DeleteItemImageRequestSchema;
    output: typeof DeleteItemImageResponseSchema;
  },
  /**
   * UploadOrganizationGalleryImage adds a photo to the organization's portal gallery (JPEG/PNG/WebP, <= 10 MB, max 30)
   *
   * @generated from rpc cortado.v1.CortadoService.UploadOrganizationGalleryImage
   */
  uploadOrganizationGalleryImage: {
    methodKind: "unary";
    input: typeof UploadOrganizationGalleryImageRequestSchema;
    output: typeof UploadOrganizationGalleryImageResponseSchema;
  },
  /**
   * ListOrganizationGalleryImages lists the organization's gallery photos ordered by sort_order
   *
   * @generated from rpc cortado.v1.CortadoService.ListOrganizationGalleryImages
   */
  listOrganizationGalleryImages: {
    methodKind: "unary";
    input: typeof ListOrganizationGalleryImagesRequestSchema;
    output: typeof ListOrganizationGalleryImagesResponseSchema;
  },
  /**
   * UpdateOrganizationGalleryImage updates a gallery photo's alt text
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateOrganizationGalleryImage
   */
  updateOrganizationGalleryImage: {
    methodKind: "unary";
    input: typeof UpdateOrganizationGalleryImageRequestSchema;
    output: typeof UpdateOrganizationGalleryImageResponseSchema;
  },
  /**
   * ReorderOrganizationGalleryImages sets the display order of the organization's gallery photos
   *
   * @generated from rpc cortado.v1.CortadoService.ReorderOrganizationGalleryImages
   */
  reorderOrganizationGalleryImages: {
    methodKind: "unary";
    input: typeof ReorderOrganizationGalleryImagesRequestSchema;
    output: typeof ReorderOrganizationGalleryImagesResponseSchema;
  },
  /**
   * DeleteOrganizationGalleryImage removes a gallery photo and its stored file
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteOrganizationGalleryImage
   */
  deleteOrganizationGalleryImage: {
    methodKind: "unary";
    input: typeof DeleteOrganizationGalleryImageRequestSchema;
    output: typeof DeleteOrganizationGalleryImageResponseSchema;
  },
  /**
   * CalculateTransportationMileage calculates driving mileage for selected event locations.
   *
   * @generated from rpc cortado.v1.CortadoService.CalculateTransportationMileage
   */
  calculateTransportationMileage: {
    methodKind: "unary";
    input: typeof CalculateTransportationMileageRequestSchema;
    output: typeof CalculateTransportationMileageResponseSchema;
  },
  /**
   * ListTaxRates lists all tax rates for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.ListTaxRates
   */
  listTaxRates: {
    methodKind: "unary";
    input: typeof ListTaxRatesRequestSchema;
    output: typeof ListTaxRatesResponseSchema;
  },
  /**
   * CreateTaxRate creates a new tax rate
   *
   * @generated from rpc cortado.v1.CortadoService.CreateTaxRate
   */
  createTaxRate: {
    methodKind: "unary";
    input: typeof CreateTaxRateRequestSchema;
    output: typeof CreateTaxRateResponseSchema;
  },
  /**
   * ArchiveTaxRate archives a tax rate (soft delete)
   *
   * @generated from rpc cortado.v1.CortadoService.ArchiveTaxRate
   */
  archiveTaxRate: {
    methodKind: "unary";
    input: typeof ArchiveTaxRateRequestSchema;
    output: typeof ArchiveTaxRateResponseSchema;
  },
  /**
   * UpdateTaxRate updates a tax rate
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateTaxRate
   */
  updateTaxRate: {
    methodKind: "unary";
    input: typeof UpdateTaxRateRequestSchema;
    output: typeof UpdateTaxRateResponseSchema;
  },
  /**
   * ListDiscounts lists all discounts for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.ListDiscounts
   */
  listDiscounts: {
    methodKind: "unary";
    input: typeof ListDiscountsRequestSchema;
    output: typeof ListDiscountsResponseSchema;
  },
  /**
   * CreateDiscount creates a new discount
   *
   * @generated from rpc cortado.v1.CortadoService.CreateDiscount
   */
  createDiscount: {
    methodKind: "unary";
    input: typeof CreateDiscountRequestSchema;
    output: typeof CreateDiscountResponseSchema;
  },
  /**
   * GetDiscount retrieves a discount by ID
   *
   * @generated from rpc cortado.v1.CortadoService.GetDiscount
   */
  getDiscount: {
    methodKind: "unary";
    input: typeof GetDiscountRequestSchema;
    output: typeof GetDiscountResponseSchema;
  },
  /**
   * UpdateDiscount updates a discount
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateDiscount
   */
  updateDiscount: {
    methodKind: "unary";
    input: typeof UpdateDiscountRequestSchema;
    output: typeof UpdateDiscountResponseSchema;
  },
  /**
   * ListQuoteTemplates lists all quote templates for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.ListQuoteTemplates
   */
  listQuoteTemplates: {
    methodKind: "unary";
    input: typeof ListQuoteTemplatesRequestSchema;
    output: typeof ListQuoteTemplatesResponseSchema;
  },
  /**
   * CreateQuoteTemplate creates a new quote template
   *
   * @generated from rpc cortado.v1.CortadoService.CreateQuoteTemplate
   */
  createQuoteTemplate: {
    methodKind: "unary";
    input: typeof CreateQuoteTemplateRequestSchema;
    output: typeof CreateQuoteTemplateResponseSchema;
  },
  /**
   * GetQuoteTemplate retrieves a quote template by ID
   *
   * @generated from rpc cortado.v1.CortadoService.GetQuoteTemplate
   */
  getQuoteTemplate: {
    methodKind: "unary";
    input: typeof GetQuoteTemplateRequestSchema;
    output: typeof GetQuoteTemplateResponseSchema;
  },
  /**
   * GetQuoteTemplateByEventType retrieves a quote template by event type for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.GetQuoteTemplateByEventType
   */
  getQuoteTemplateByEventType: {
    methodKind: "unary";
    input: typeof GetQuoteTemplateByEventTypeRequestSchema;
    output: typeof GetQuoteTemplateByEventTypeResponseSchema;
  },
  /**
   * UpdateQuoteTemplate updates a quote template
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateQuoteTemplate
   */
  updateQuoteTemplate: {
    methodKind: "unary";
    input: typeof UpdateQuoteTemplateRequestSchema;
    output: typeof UpdateQuoteTemplateResponseSchema;
  },
  /**
   * DeleteQuoteTemplate deletes a quote template
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteQuoteTemplate
   */
  deleteQuoteTemplate: {
    methodKind: "unary";
    input: typeof DeleteQuoteTemplateRequestSchema;
    output: typeof DeleteQuoteTemplateResponseSchema;
  },
  /**
   * GetQuotePreFill returns pre-filled quote data based on inquiry and template configuration
   *
   * @generated from rpc cortado.v1.CortadoService.GetQuotePreFill
   */
  getQuotePreFill: {
    methodKind: "unary";
    input: typeof GetQuotePreFillRequestSchema;
    output: typeof GetQuotePreFillResponseSchema;
  },
  /**
   * ListQuotes lists quotes with comprehensive filtering support
   *
   * @generated from rpc cortado.v1.CortadoService.ListQuotes
   */
  listQuotes: {
    methodKind: "unary";
    input: typeof ListQuotesRequestSchema;
    output: typeof ListQuotesResponseSchema;
  },
  /**
   * GetQuoteStats returns aggregate quote counts and totals for an organization,
   * grouped into the stat-card buckets used by the quotes list page. Replaces
   * fetching every quote client-side to compute stats.
   *
   * @generated from rpc cortado.v1.CortadoService.GetQuoteStats
   */
  getQuoteStats: {
    methodKind: "unary";
    input: typeof GetQuoteStatsRequestSchema;
    output: typeof GetQuoteStatsResponseSchema;
  },
  /**
   * ListContactQuoteInteractions lists public quote token interactions for a contact
   *
   * @generated from rpc cortado.v1.CortadoService.ListContactQuoteInteractions
   */
  listContactQuoteInteractions: {
    methodKind: "unary";
    input: typeof ListContactQuoteInteractionsRequestSchema;
    output: typeof ListContactQuoteInteractionsResponseSchema;
  },
  /**
   * ListPortalVisitorActivity lists recipient-intent and browser-attributed
   * portal opens for one supported organization resource.
   *
   * @generated from rpc cortado.v1.CortadoService.ListPortalVisitorActivity
   */
  listPortalVisitorActivity: {
    methodKind: "unary";
    input: typeof ListPortalVisitorActivityRequestSchema;
    output: typeof ListPortalVisitorActivityResponseSchema;
  },
  /**
   * CreateQuote creates a new quote
   *
   * @generated from rpc cortado.v1.CortadoService.CreateQuote
   */
  createQuote: {
    methodKind: "unary";
    input: typeof CreateQuoteRequestSchema;
    output: typeof CreateQuoteResponseSchema;
  },
  /**
   * GetQuote retrieves a quote by ID with full enrichment
   *
   * @generated from rpc cortado.v1.CortadoService.GetQuote
   */
  getQuote: {
    methodKind: "unary";
    input: typeof GetQuoteRequestSchema;
    output: typeof GetQuoteResponseSchema;
  },
  /**
   * GetQuoteDetail is an aggregate endpoint returning the quote plus its
   * inquiry, contact, booking (when the inquiry converted), and the invoice
   * created from it (if any), in one round-trip, to eliminate the
   * quote-detail page request waterfall.
   *
   * @generated from rpc cortado.v1.CortadoService.GetQuoteDetail
   */
  getQuoteDetail: {
    methodKind: "unary";
    input: typeof GetQuoteDetailRequestSchema;
    output: typeof GetQuoteDetailResponseSchema;
  },
  /**
   * UpdateQuote updates a quote
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateQuote
   */
  updateQuote: {
    methodKind: "unary";
    input: typeof UpdateQuoteRequestSchema;
    output: typeof UpdateQuoteResponseSchema;
  },
  /**
   * DeleteQuote deletes a quote
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteQuote
   */
  deleteQuote: {
    methodKind: "unary";
    input: typeof DeleteQuoteRequestSchema;
    output: typeof DeleteQuoteResponseSchema;
  },
  /**
   * SendQuote sends a quote email to the customer and updates status to SENT
   *
   * @generated from rpc cortado.v1.CortadoService.SendQuote
   */
  sendQuote: {
    methodKind: "unary";
    input: typeof SendQuoteRequestSchema;
    output: typeof SendQuoteResponseSchema;
  },
  /**
   * PreviewQuoteSendEmail renders the Quote Sent email for one quote with an
   * optional per-send override. Mints no portal token and writes no rows.
   *
   * @generated from rpc cortado.v1.CortadoService.PreviewQuoteSendEmail
   */
  previewQuoteSendEmail: {
    methodKind: "unary";
    input: typeof PreviewQuoteSendEmailRequestSchema;
    output: typeof PreviewQuoteSendEmailResponseSchema;
  },
  /**
   * DuplicateQuote creates a copy of an existing quote with all its data
   *
   * @generated from rpc cortado.v1.CortadoService.DuplicateQuote
   */
  duplicateQuote: {
    methodKind: "unary";
    input: typeof DuplicateQuoteRequestSchema;
    output: typeof DuplicateQuoteResponseSchema;
  },
  /**
   * ListQuoteItems lists all items for a quote
   *
   * @generated from rpc cortado.v1.CortadoService.ListQuoteItems
   */
  listQuoteItems: {
    methodKind: "unary";
    input: typeof ListQuoteItemsRequestSchema;
    output: typeof ListQuoteItemsResponseSchema;
  },
  /**
   * CreateQuoteItem creates a new quote item
   *
   * @generated from rpc cortado.v1.CortadoService.CreateQuoteItem
   */
  createQuoteItem: {
    methodKind: "unary";
    input: typeof CreateQuoteItemRequestSchema;
    output: typeof CreateQuoteItemResponseSchema;
  },
  /**
   * GetQuoteItem retrieves a quote item by ID
   *
   * @generated from rpc cortado.v1.CortadoService.GetQuoteItem
   */
  getQuoteItem: {
    methodKind: "unary";
    input: typeof GetQuoteItemRequestSchema;
    output: typeof GetQuoteItemResponseSchema;
  },
  /**
   * UpdateQuoteItem updates a quote item
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateQuoteItem
   */
  updateQuoteItem: {
    methodKind: "unary";
    input: typeof UpdateQuoteItemRequestSchema;
    output: typeof UpdateQuoteItemResponseSchema;
  },
  /**
   * DeleteQuoteItem deletes a quote item
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteQuoteItem
   */
  deleteQuoteItem: {
    methodKind: "unary";
    input: typeof DeleteQuoteItemRequestSchema;
    output: typeof DeleteQuoteItemResponseSchema;
  },
  /**
   * GetQuoteLitesByIds retrieves lightweight quotes by an array of IDs
   *
   * @generated from rpc cortado.v1.CortadoService.GetQuoteLitesByIds
   */
  getQuoteLitesByIds: {
    methodKind: "unary";
    input: typeof GetQuoteLitesByIdsRequestSchema;
    output: typeof GetQuoteLitesByIdsResponseSchema;
  },
  /**
   * GenerateQuotePdf returns a cached or newly rendered quote PDF.
   *
   * @generated from rpc cortado.v1.CortadoService.GenerateQuotePdf
   */
  generateQuotePdf: {
    methodKind: "unary";
    input: typeof GenerateQuotePdfRequestSchema;
    output: typeof GenerateQuotePdfResponseSchema;
  },
  /**
   * ListInvoices lists invoices with comprehensive filtering support
   *
   * @generated from rpc cortado.v1.CortadoService.ListInvoices
   */
  listInvoices: {
    methodKind: "unary";
    input: typeof ListInvoicesRequestSchema;
    output: typeof ListInvoicesResponseSchema;
  },
  /**
   * GetInvoiceStats returns aggregate invoice counts and totals for an organization,
   * grouped into the stat-card buckets used by the invoices list page. Replaces
   * fetching every invoice client-side to compute stats.
   *
   * @generated from rpc cortado.v1.CortadoService.GetInvoiceStats
   */
  getInvoiceStats: {
    methodKind: "unary";
    input: typeof GetInvoiceStatsRequestSchema;
    output: typeof GetInvoiceStatsResponseSchema;
  },
  /**
   * CreateInvoice creates a new invoice (typically from an accepted quote)
   *
   * @generated from rpc cortado.v1.CortadoService.CreateInvoice
   */
  createInvoice: {
    methodKind: "unary";
    input: typeof CreateInvoiceRequestSchema;
    output: typeof CreateInvoiceResponseSchema;
  },
  /**
   * GetInvoice retrieves an invoice by ID with full details
   *
   * @generated from rpc cortado.v1.CortadoService.GetInvoice
   */
  getInvoice: {
    methodKind: "unary";
    input: typeof GetInvoiceRequestSchema;
    output: typeof GetInvoiceResponseSchema;
  },
  /**
   * GetInvoiceDetail is an aggregate endpoint returning the invoice plus its
   * contact and booking (when set), in one round-trip, to eliminate the
   * invoice-detail page request waterfall.
   *
   * @generated from rpc cortado.v1.CortadoService.GetInvoiceDetail
   */
  getInvoiceDetail: {
    methodKind: "unary";
    input: typeof GetInvoiceDetailRequestSchema;
    output: typeof GetInvoiceDetailResponseSchema;
  },
  /**
   * UpdateInvoice updates an invoice (creates a new revision if not locked)
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateInvoice
   */
  updateInvoice: {
    methodKind: "unary";
    input: typeof UpdateInvoiceRequestSchema;
    output: typeof UpdateInvoiceResponseSchema;
  },
  /**
   * DeleteInvoice deletes an invoice
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteInvoice
   */
  deleteInvoice: {
    methodKind: "unary";
    input: typeof DeleteInvoiceRequestSchema;
    output: typeof DeleteInvoiceResponseSchema;
  },
  /**
   * GetInvoiceLitesByIds retrieves lightweight invoices by an array of IDs
   *
   * @generated from rpc cortado.v1.CortadoService.GetInvoiceLitesByIds
   */
  getInvoiceLitesByIds: {
    methodKind: "unary";
    input: typeof GetInvoiceLitesByIdsRequestSchema;
    output: typeof GetInvoiceLitesByIdsResponseSchema;
  },
  /**
   * GenerateInvoicePdf returns a cached or newly rendered invoice PDF.
   *
   * @generated from rpc cortado.v1.CortadoService.GenerateInvoicePdf
   */
  generateInvoicePdf: {
    methodKind: "unary";
    input: typeof GenerateInvoicePdfRequestSchema;
    output: typeof GenerateInvoicePdfResponseSchema;
  },
  /**
   * GeneratePaymentReceiptPdf returns a cached or newly rendered receipt PDF
   * for a payment schedule that has at least one completed payment.
   *
   * @generated from rpc cortado.v1.CortadoService.GeneratePaymentReceiptPdf
   */
  generatePaymentReceiptPdf: {
    methodKind: "unary";
    input: typeof GeneratePaymentReceiptPdfRequestSchema;
    output: typeof GeneratePaymentReceiptPdfResponseSchema;
  },
  /**
   * CreatePaymentSchedule creates a new payment schedule for an invoice
   *
   * @generated from rpc cortado.v1.CortadoService.CreatePaymentSchedule
   */
  createPaymentSchedule: {
    methodKind: "unary";
    input: typeof CreatePaymentScheduleRequestSchema;
    output: typeof CreatePaymentScheduleResponseSchema;
  },
  /**
   * UpdatePaymentSchedule updates a payment schedule (only if invoice not locked)
   *
   * @generated from rpc cortado.v1.CortadoService.UpdatePaymentSchedule
   */
  updatePaymentSchedule: {
    methodKind: "unary";
    input: typeof UpdatePaymentScheduleRequestSchema;
    output: typeof UpdatePaymentScheduleResponseSchema;
  },
  /**
   * DeletePaymentSchedule deletes a payment schedule (only if invoice not locked)
   *
   * @generated from rpc cortado.v1.CortadoService.DeletePaymentSchedule
   */
  deletePaymentSchedule: {
    methodKind: "unary";
    input: typeof DeletePaymentScheduleRequestSchema;
    output: typeof DeletePaymentScheduleResponseSchema;
  },
  /**
   * ReplacePaymentSchedules atomically replaces every payment schedule on an
   * invoice. Blocked if the invoice is locked, any schedule has recorded
   * payments, or an open checkout session exists for the invoice.
   *
   * @generated from rpc cortado.v1.CortadoService.ReplacePaymentSchedules
   */
  replacePaymentSchedules: {
    methodKind: "unary";
    input: typeof ReplacePaymentSchedulesRequestSchema;
    output: typeof ReplacePaymentSchedulesResponseSchema;
  },
  /**
   * CreatePaymentIntent is a dead endpoint that always returns Unimplemented.
   * Use CreatePublicCheckoutSession (Stripe Embedded Checkout) instead.
   *
   * @generated from rpc cortado.v1.CortadoService.CreatePaymentIntent
   * @deprecated
   */
  createPaymentIntent: {
    methodKind: "unary";
    input: typeof CreatePaymentIntentRequestSchema;
    output: typeof CreatePaymentIntentResponseSchema;
  },
  /**
   * GetPaymentIntent is a dead endpoint that always returns Unimplemented.
   * Payment status is read via GetPublicCheckoutSessionStatus / ListStripePayments.
   *
   * @generated from rpc cortado.v1.CortadoService.GetPaymentIntent
   * @deprecated
   */
  getPaymentIntent: {
    methodKind: "unary";
    input: typeof GetPaymentIntentRequestSchema;
    output: typeof GetPaymentIntentResponseSchema;
  },
  /**
   * UpdatePaymentIntentFromWebhook updates a payment intent from Stripe webhook
   *
   * @generated from rpc cortado.v1.CortadoService.UpdatePaymentIntentFromWebhook
   */
  updatePaymentIntentFromWebhook: {
    methodKind: "unary";
    input: typeof UpdatePaymentIntentFromWebhookRequestSchema;
    output: typeof UpdatePaymentIntentFromWebhookResponseSchema;
  },
  /**
   * ListStripePayments lists individual payment attempts/charges for a payment intent or invoice
   *
   * @generated from rpc cortado.v1.CortadoService.ListStripePayments
   */
  listStripePayments: {
    methodKind: "unary";
    input: typeof ListStripePaymentsRequestSchema;
    output: typeof ListStripePaymentsResponseSchema;
  },
  /**
   * GetStripePayment retrieves a single payment/charge by ID
   *
   * @generated from rpc cortado.v1.CortadoService.GetStripePayment
   */
  getStripePayment: {
    methodKind: "unary";
    input: typeof GetStripePaymentRequestSchema;
    output: typeof GetStripePaymentResponseSchema;
  },
  /**
   * RecordManualPayment records a payment made outside of Stripe (check, wire transfer, cash, ACH)
   *
   * @generated from rpc cortado.v1.CortadoService.RecordManualPayment
   */
  recordManualPayment: {
    methodKind: "unary";
    input: typeof RecordManualPaymentRequestSchema;
    output: typeof RecordManualPaymentResponseSchema;
  },
  /**
   * RecordBatchManualPayments records multiple manual payments atomically (all succeed or all fail)
   *
   * @generated from rpc cortado.v1.CortadoService.RecordBatchManualPayments
   */
  recordBatchManualPayments: {
    methodKind: "unary";
    input: typeof RecordBatchManualPaymentsRequestSchema;
    output: typeof RecordBatchManualPaymentsResponseSchema;
  },
  /**
   * ProcessStripeRefund initiates a refund through Stripe for an existing payment
   *
   * @generated from rpc cortado.v1.CortadoService.ProcessStripeRefund
   */
  processStripeRefund: {
    methodKind: "unary";
    input: typeof ProcessStripeRefundRequestSchema;
    output: typeof ProcessStripeRefundResponseSchema;
  },
  /**
   * VoidManualPayment voids a manual payment (admin correction)
   *
   * @generated from rpc cortado.v1.CortadoService.VoidManualPayment
   */
  voidManualPayment: {
    methodKind: "unary";
    input: typeof VoidManualPaymentRequestSchema;
    output: typeof VoidManualPaymentResponseSchema;
  },
  /**
   * ListInvoicePayments lists all payments (Stripe + manual) for an invoice
   *
   * @generated from rpc cortado.v1.CortadoService.ListInvoicePayments
   */
  listInvoicePayments: {
    methodKind: "unary";
    input: typeof ListInvoicePaymentsRequestSchema;
    output: typeof ListInvoicePaymentsResponseSchema;
  },
  /**
   * ExportInvoicePayments exports payments for an invoice as CSV
   *
   * @generated from rpc cortado.v1.CortadoService.ExportInvoicePayments
   */
  exportInvoicePayments: {
    methodKind: "unary";
    input: typeof ExportInvoicePaymentsRequestSchema;
    output: typeof ExportInvoicePaymentsResponseSchema;
  },
  /**
   * VoidInvoice cancels an invoice and releases payment schedules
   *
   * @generated from rpc cortado.v1.CortadoService.VoidInvoice
   */
  voidInvoice: {
    methodKind: "unary";
    input: typeof VoidInvoiceRequestSchema;
    output: typeof VoidInvoiceResponseSchema;
  },
  /**
   * MarkInvoiceAsPaid creates a manual payment for the full remaining balance
   *
   * @generated from rpc cortado.v1.CortadoService.MarkInvoiceAsPaid
   */
  markInvoiceAsPaid: {
    methodKind: "unary";
    input: typeof MarkInvoiceAsPaidRequestSchema;
    output: typeof MarkInvoiceAsPaidResponseSchema;
  },
  /**
   * SendInvoice sends an invoice email to the customer and updates status to SENT
   * For already-sent invoices, resends the email without changing status
   *
   * @generated from rpc cortado.v1.CortadoService.SendInvoice
   */
  sendInvoice: {
    methodKind: "unary";
    input: typeof SendInvoiceRequestSchema;
    output: typeof SendInvoiceResponseSchema;
  },
  /**
   * SendPaymentReminder sends a payment reminder email to the customer
   *
   * @generated from rpc cortado.v1.CortadoService.SendPaymentReminder
   */
  sendPaymentReminder: {
    methodKind: "unary";
    input: typeof SendPaymentReminderRequestSchema;
    output: typeof SendPaymentReminderResponseSchema;
  },
  /**
   * ListDisputes lists Stripe disputes (chargebacks) for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.ListDisputes
   */
  listDisputes: {
    methodKind: "unary";
    input: typeof ListDisputesRequestSchema;
    output: typeof ListDisputesResponseSchema;
  },
  /**
   * ListNotes lists notes with optional filters
   *
   * @generated from rpc cortado.v1.CortadoService.ListNotes
   */
  listNotes: {
    methodKind: "unary";
    input: typeof ListNotesRequestSchema;
    output: typeof ListNotesResponseSchema;
  },
  /**
   * CreateNote creates a new note
   *
   * @generated from rpc cortado.v1.CortadoService.CreateNote
   */
  createNote: {
    methodKind: "unary";
    input: typeof CreateNoteRequestSchema;
    output: typeof CreateNoteResponseSchema;
  },
  /**
   * GetNote retrieves a note by ID
   *
   * @generated from rpc cortado.v1.CortadoService.GetNote
   */
  getNote: {
    methodKind: "unary";
    input: typeof GetNoteRequestSchema;
    output: typeof GetNoteResponseSchema;
  },
  /**
   * UpdateNote updates a note
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateNote
   */
  updateNote: {
    methodKind: "unary";
    input: typeof UpdateNoteRequestSchema;
    output: typeof UpdateNoteResponseSchema;
  },
  /**
   * DeleteNote deletes a note
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteNote
   */
  deleteNote: {
    methodKind: "unary";
    input: typeof DeleteNoteRequestSchema;
    output: typeof DeleteNoteResponseSchema;
  },
  /**
   * CreateTask creates a new task
   *
   * @generated from rpc cortado.v1.CortadoService.CreateTask
   */
  createTask: {
    methodKind: "unary";
    input: typeof CreateTaskRequestSchema;
    output: typeof CreateTaskResponseSchema;
  },
  /**
   * GetTask retrieves a task by ID
   *
   * @generated from rpc cortado.v1.CortadoService.GetTask
   */
  getTask: {
    methodKind: "unary";
    input: typeof GetTaskRequestSchema;
    output: typeof GetTaskResponseSchema;
  },
  /**
   * UpdateTask updates a task
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateTask
   */
  updateTask: {
    methodKind: "unary";
    input: typeof UpdateTaskRequestSchema;
    output: typeof UpdateTaskResponseSchema;
  },
  /**
   * DeleteTask deletes a task
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteTask
   */
  deleteTask: {
    methodKind: "unary";
    input: typeof DeleteTaskRequestSchema;
    output: typeof DeleteTaskResponseSchema;
  },
  /**
   * ListAttachments lists attachments with optional filters
   *
   * @generated from rpc cortado.v1.CortadoService.ListAttachments
   */
  listAttachments: {
    methodKind: "unary";
    input: typeof ListAttachmentsRequestSchema;
    output: typeof ListAttachmentsResponseSchema;
  },
  /**
   * CreateAttachment uploads a new attachment
   *
   * @generated from rpc cortado.v1.CortadoService.CreateAttachment
   */
  createAttachment: {
    methodKind: "unary";
    input: typeof CreateAttachmentRequestSchema;
    output: typeof CreateAttachmentResponseSchema;
  },
  /**
   * GetAttachment retrieves an attachment by ID
   *
   * @generated from rpc cortado.v1.CortadoService.GetAttachment
   */
  getAttachment: {
    methodKind: "unary";
    input: typeof GetAttachmentRequestSchema;
    output: typeof GetAttachmentResponseSchema;
  },
  /**
   * UpdateAttachment updates an attachment (filename only)
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateAttachment
   */
  updateAttachment: {
    methodKind: "unary";
    input: typeof UpdateAttachmentRequestSchema;
    output: typeof UpdateAttachmentResponseSchema;
  },
  /**
   * DeleteAttachment deletes an attachment
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteAttachment
   */
  deleteAttachment: {
    methodKind: "unary";
    input: typeof DeleteAttachmentRequestSchema;
    output: typeof DeleteAttachmentResponseSchema;
  },
  /**
   * ListAttachmentFolders lists attachment library folders for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.ListAttachmentFolders
   */
  listAttachmentFolders: {
    methodKind: "unary";
    input: typeof ListAttachmentFoldersRequestSchema;
    output: typeof ListAttachmentFoldersResponseSchema;
  },
  /**
   * CreateAttachmentFolder creates a new attachment library folder
   *
   * @generated from rpc cortado.v1.CortadoService.CreateAttachmentFolder
   */
  createAttachmentFolder: {
    methodKind: "unary";
    input: typeof CreateAttachmentFolderRequestSchema;
    output: typeof CreateAttachmentFolderResponseSchema;
  },
  /**
   * RenameAttachmentFolder renames an attachment library folder
   *
   * @generated from rpc cortado.v1.CortadoService.RenameAttachmentFolder
   */
  renameAttachmentFolder: {
    methodKind: "unary";
    input: typeof RenameAttachmentFolderRequestSchema;
    output: typeof RenameAttachmentFolderResponseSchema;
  },
  /**
   * MoveAttachmentFolder moves an attachment library folder under a new parent
   *
   * @generated from rpc cortado.v1.CortadoService.MoveAttachmentFolder
   */
  moveAttachmentFolder: {
    methodKind: "unary";
    input: typeof MoveAttachmentFolderRequestSchema;
    output: typeof MoveAttachmentFolderResponseSchema;
  },
  /**
   * DeleteAttachmentFolder deletes an attachment library folder
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteAttachmentFolder
   */
  deleteAttachmentFolder: {
    methodKind: "unary";
    input: typeof DeleteAttachmentFolderRequestSchema;
    output: typeof DeleteAttachmentFolderResponseSchema;
  },
  /**
   * ListFeedback lists all feedback for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.ListFeedback
   */
  listFeedback: {
    methodKind: "unary";
    input: typeof ListFeedbackRequestSchema;
    output: typeof ListFeedbackResponseSchema;
  },
  /**
   * CreateFeedback creates a new feedback item
   *
   * @generated from rpc cortado.v1.CortadoService.CreateFeedback
   */
  createFeedback: {
    methodKind: "unary";
    input: typeof CreateFeedbackRequestSchema;
    output: typeof CreateFeedbackResponseSchema;
  },
  /**
   * UpdateFeedback updates a feedback item (only creator can update content)
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateFeedback
   */
  updateFeedback: {
    methodKind: "unary";
    input: typeof UpdateFeedbackRequestSchema;
    output: typeof UpdateFeedbackResponseSchema;
  },
  /**
   * DeleteFeedback deletes a feedback item (only creator can delete)
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteFeedback
   */
  deleteFeedback: {
    methodKind: "unary";
    input: typeof DeleteFeedbackRequestSchema;
    output: typeof DeleteFeedbackResponseSchema;
  },
  /**
   * UpvoteFeedback adds the current user's upvote to a feedback item
   *
   * @generated from rpc cortado.v1.CortadoService.UpvoteFeedback
   */
  upvoteFeedback: {
    methodKind: "unary";
    input: typeof UpvoteFeedbackRequestSchema;
    output: typeof UpvoteFeedbackResponseSchema;
  },
  /**
   * RemoveUpvote removes the current user's upvote from a feedback item
   *
   * @generated from rpc cortado.v1.CortadoService.RemoveUpvote
   */
  removeUpvote: {
    methodKind: "unary";
    input: typeof RemoveUpvoteRequestSchema;
    output: typeof RemoveUpvoteResponseSchema;
  },
  /**
   * ListEmailTemplates lists all email templates for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.ListEmailTemplates
   */
  listEmailTemplates: {
    methodKind: "unary";
    input: typeof ListEmailTemplatesRequestSchema;
    output: typeof ListEmailTemplatesResponseSchema;
  },
  /**
   * CreateEmailTemplate creates a new email template
   *
   * @generated from rpc cortado.v1.CortadoService.CreateEmailTemplate
   */
  createEmailTemplate: {
    methodKind: "unary";
    input: typeof CreateEmailTemplateRequestSchema;
    output: typeof CreateEmailTemplateResponseSchema;
  },
  /**
   * GetEmailTemplate retrieves an email template by ID
   *
   * @generated from rpc cortado.v1.CortadoService.GetEmailTemplate
   */
  getEmailTemplate: {
    methodKind: "unary";
    input: typeof GetEmailTemplateRequestSchema;
    output: typeof GetEmailTemplateResponseSchema;
  },
  /**
   * RenderEmailTemplate renders an email template with entity context
   *
   * @generated from rpc cortado.v1.CortadoService.RenderEmailTemplate
   */
  renderEmailTemplate: {
    methodKind: "unary";
    input: typeof RenderEmailTemplateRequestSchema;
    output: typeof RenderEmailTemplateResponseSchema;
  },
  /**
   * UpdateEmailTemplate updates an email template
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateEmailTemplate
   */
  updateEmailTemplate: {
    methodKind: "unary";
    input: typeof UpdateEmailTemplateRequestSchema;
    output: typeof UpdateEmailTemplateResponseSchema;
  },
  /**
   * DeleteEmailTemplate deletes an email template
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteEmailTemplate
   */
  deleteEmailTemplate: {
    methodKind: "unary";
    input: typeof DeleteEmailTemplateRequestSchema;
    output: typeof DeleteEmailTemplateResponseSchema;
  },
  /**
   * GetEmailTemplateCategories returns available template categories
   *
   * @generated from rpc cortado.v1.CortadoService.GetEmailTemplateCategories
   */
  getEmailTemplateCategories: {
    methodKind: "unary";
    input: typeof GetEmailTemplateCategoriesRequestSchema;
    output: typeof GetEmailTemplateCategoriesResponseSchema;
  },
  /**
   * GetGmailAuthURL returns the OAuth URL for connecting Gmail
   *
   * @generated from rpc cortado.v1.CortadoService.GetGmailAuthURL
   */
  getGmailAuthURL: {
    methodKind: "unary";
    input: typeof GetGmailAuthURLRequestSchema;
    output: typeof GetGmailAuthURLResponseSchema;
  },
  /**
   * IsGmailConnected checks if Gmail is connected and returns accounts
   *
   * @generated from rpc cortado.v1.CortadoService.IsGmailConnected
   */
  isGmailConnected: {
    methodKind: "unary";
    input: typeof IsGmailConnectedRequestSchema;
    output: typeof IsGmailConnectedResponseSchema;
  },
  /**
   * RecheckGmailAccountHealth probes one Gmail account and persists its current health
   *
   * @generated from rpc cortado.v1.CortadoService.RecheckGmailAccountHealth
   */
  recheckGmailAccountHealth: {
    methodKind: "unary";
    input: typeof RecheckGmailAccountHealthRequestSchema;
    output: typeof RecheckGmailAccountHealthResponseSchema;
  },
  /**
   * UpdateGmailAccount updates a Gmail account (e.g., set as default)
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateGmailAccount
   */
  updateGmailAccount: {
    methodKind: "unary";
    input: typeof UpdateGmailAccountRequestSchema;
    output: typeof UpdateGmailAccountResponseSchema;
  },
  /**
   * DeleteGmailAccount disconnects a Gmail account
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteGmailAccount
   */
  deleteGmailAccount: {
    methodKind: "unary";
    input: typeof DeleteGmailAccountRequestSchema;
    output: typeof DeleteGmailAccountResponseSchema;
  },
  /**
   * CheckEventsCalendarExists checks if the "Events" calendar exists in Google Calendar
   *
   * @generated from rpc cortado.v1.CortadoService.CheckEventsCalendarExists
   */
  checkEventsCalendarExists: {
    methodKind: "unary";
    input: typeof CheckEventsCalendarExistsRequestSchema;
    output: typeof CheckEventsCalendarExistsResponseSchema;
  },
  /**
   * ListGoogleCalendars lists all calendars in the connected Google accounts
   *
   * @generated from rpc cortado.v1.CortadoService.ListGoogleCalendars
   */
  listGoogleCalendars: {
    methodKind: "unary";
    input: typeof ListGoogleCalendarsRequestSchema;
    output: typeof ListGoogleCalendarsResponseSchema;
  },
  /**
   * SetGoogleCalendar sets the calendar to use for event syncing
   *
   * @generated from rpc cortado.v1.CortadoService.SetGoogleCalendar
   */
  setGoogleCalendar: {
    methodKind: "unary";
    input: typeof SetGoogleCalendarRequestSchema;
    output: typeof SetGoogleCalendarResponseSchema;
  },
  /**
   * PreviewCalendarDescription renders a (possibly unsaved) description
   * template against a real or synthetic event, without persisting anything
   *
   * @generated from rpc cortado.v1.CortadoService.PreviewCalendarDescription
   */
  previewCalendarDescription: {
    methodKind: "unary";
    input: typeof PreviewCalendarDescriptionRequestSchema;
    output: typeof PreviewCalendarDescriptionResponseSchema;
  },
  /**
   * ApplyCalendarDescriptionTemplate reports (or, unless dry_run, triggers a
   * resync for) events whose Google Calendar description the org's stored
   * template would affect
   *
   * @generated from rpc cortado.v1.CortadoService.ApplyCalendarDescriptionTemplate
   */
  applyCalendarDescriptionTemplate: {
    methodKind: "unary";
    input: typeof ApplyCalendarDescriptionTemplateRequestSchema;
    output: typeof ApplyCalendarDescriptionTemplateResponseSchema;
  },
  /**
   * GetStripeConnectionStatus checks if Stripe is connected and returns account details
   *
   * @generated from rpc cortado.v1.CortadoService.GetStripeConnectionStatus
   */
  getStripeConnectionStatus: {
    methodKind: "unary";
    input: typeof GetStripeConnectionStatusRequestSchema;
    output: typeof GetStripeConnectionStatusResponseSchema;
  },
  /**
   * GetStripeAccountLinkURL creates account link URL for Stripe onboarding
   *
   * @generated from rpc cortado.v1.CortadoService.GetStripeAccountLinkURL
   */
  getStripeAccountLinkURL: {
    methodKind: "unary";
    input: typeof GetStripeAccountLinkURLRequestSchema;
    output: typeof GetStripeAccountLinkURLResponseSchema;
  },
  /**
   * DisconnectStripeAccount removes Stripe connection from organization
   *
   * @generated from rpc cortado.v1.CortadoService.DisconnectStripeAccount
   */
  disconnectStripeAccount: {
    methodKind: "unary";
    input: typeof DisconnectStripeAccountRequestSchema;
    output: typeof DisconnectStripeAccountResponseSchema;
  },
  /**
   * ListFailedWebhooks retrieves failed Stripe webhooks for potential replay.
   * If organization_id is provided, filters by org (org admin). Otherwise returns all (global admin).
   *
   * @generated from rpc cortado.v1.CortadoService.ListFailedWebhooks
   */
  listFailedWebhooks: {
    methodKind: "unary";
    input: typeof ListFailedWebhooksRequestSchema;
    output: typeof ListFailedWebhooksResponseSchema;
  },
  /**
   * ListStaleWebhooks retrieves pending webhooks that appear stuck.
   * If organization_id is provided, filters by org (org admin). Otherwise returns all (global admin).
   *
   * @generated from rpc cortado.v1.CortadoService.ListStaleWebhooks
   */
  listStaleWebhooks: {
    methodKind: "unary";
    input: typeof ListStaleWebhooksRequestSchema;
    output: typeof ListStaleWebhooksResponseSchema;
  },
  /**
   * ListWebhooks retrieves all webhooks for an organization (org admin)
   *
   * @generated from rpc cortado.v1.CortadoService.ListWebhooks
   */
  listWebhooks: {
    methodKind: "unary";
    input: typeof ListWebhooksRequestSchema;
    output: typeof ListWebhooksResponseSchema;
  },
  /**
   * ReplayWebhook replays a single webhook by event ID.
   * If organization_id is provided, verifies webhook belongs to org (org admin). Otherwise requires global admin.
   *
   * @generated from rpc cortado.v1.CortadoService.ReplayWebhook
   */
  replayWebhook: {
    methodKind: "unary";
    input: typeof ReplayWebhookRequestSchema;
    output: typeof ReplayWebhookResponseSchema;
  },
  /**
   * ReplayFailedWebhooks replays all failed webhooks up to a limit.
   * If organization_id is provided, only replays org's webhooks (org admin). Otherwise replays all (global admin).
   *
   * @generated from rpc cortado.v1.CortadoService.ReplayFailedWebhooks
   */
  replayFailedWebhooks: {
    methodKind: "unary";
    input: typeof ReplayFailedWebhooksRequestSchema;
    output: typeof ReplayFailedWebhooksResponseSchema;
  },
  /**
   * ReplayStaleWebhooks replays all stale pending webhooks.
   * If organization_id is provided, only replays org's webhooks (org admin). Otherwise replays all (global admin).
   *
   * @generated from rpc cortado.v1.CortadoService.ReplayStaleWebhooks
   */
  replayStaleWebhooks: {
    methodKind: "unary";
    input: typeof ReplayStaleWebhooksRequestSchema;
    output: typeof ReplayStaleWebhooksResponseSchema;
  },
  /**
   * GetOrganizationSubscription retrieves the subscription status for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.GetOrganizationSubscription
   */
  getOrganizationSubscription: {
    methodKind: "unary";
    input: typeof GetOrganizationSubscriptionRequestSchema;
    output: typeof GetOrganizationSubscriptionResponseSchema;
  },
  /**
   * GetPaymentHistory retrieves payment history for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.GetPaymentHistory
   */
  getPaymentHistory: {
    methodKind: "unary";
    input: typeof GetPaymentHistoryRequestSchema;
    output: typeof GetPaymentHistoryResponseSchema;
  },
  /**
   * CreateCheckoutSession creates a Stripe Checkout Session for subscribing.
   *
   * @generated from rpc cortado.v1.CortadoService.CreateCheckoutSession
   */
  createCheckoutSession: {
    methodKind: "unary";
    input: typeof CreateCheckoutSessionRequestSchema;
    output: typeof CreateCheckoutSessionResponseSchema;
  },
  /**
   * ReconcileCheckoutSession performs organization-scoped lost-webhook
   * recovery for a locally claimed Stripe Checkout Session.
   *
   * @generated from rpc cortado.v1.CortadoService.ReconcileCheckoutSession
   */
  reconcileCheckoutSession: {
    methodKind: "unary";
    input: typeof ReconcileCheckoutSessionRequestSchema;
    output: typeof ReconcileCheckoutSessionResponseSchema;
  },
  /**
   * GetCustomerPortalURL returns the Stripe customer portal URL for managing a subscription.
   *
   * @generated from rpc cortado.v1.CortadoService.GetCustomerPortalURL
   */
  getCustomerPortalURL: {
    methodKind: "unary";
    input: typeof GetCustomerPortalURLRequestSchema;
    output: typeof GetCustomerPortalURLResponseSchema;
  },
  /**
   * GetSubscriptionProduct returns the eligible subscription product for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.GetSubscriptionProduct
   */
  getSubscriptionProduct: {
    methodKind: "unary";
    input: typeof GetSubscriptionProductRequestSchema;
    output: typeof GetSubscriptionProductResponseSchema;
  },
  /**
   * GetOrganizationBillingState retrieves the org billing/access state.
   *
   * @generated from rpc cortado.v1.CortadoService.GetOrganizationBillingState
   */
  getOrganizationBillingState: {
    methodKind: "unary";
    input: typeof GetOrganizationBillingStateRequestSchema;
    output: typeof GetOrganizationBillingStateResponseSchema;
  },
  /**
   * ListPlanOptions lists the purchasable plan+interval combinations for an organization.
   *
   * @generated from rpc cortado.v1.CortadoService.ListPlanOptions
   */
  listPlanOptions: {
    methodKind: "unary";
    input: typeof ListPlanOptionsRequestSchema;
    output: typeof ListPlanOptionsResponseSchema;
  },
  /**
   * PreviewPlanChange previews the effect of a plan/interval change before committing it.
   *
   * @generated from rpc cortado.v1.CortadoService.PreviewPlanChange
   */
  previewPlanChange: {
    methodKind: "unary";
    input: typeof PreviewPlanChangeRequestSchema;
    output: typeof PreviewPlanChangeResponseSchema;
  },
  /**
   * ChangeSubscriptionPlan changes an organization's plan and/or billing interval.
   *
   * @generated from rpc cortado.v1.CortadoService.ChangeSubscriptionPlan
   */
  changeSubscriptionPlan: {
    methodKind: "unary";
    input: typeof ChangeSubscriptionPlanRequestSchema;
    output: typeof ChangeSubscriptionPlanResponseSchema;
  },
  /**
   * CancelSubscription schedules cancellation at the end of the current paid period.
   *
   * @generated from rpc cortado.v1.CortadoService.CancelSubscription
   */
  cancelSubscription: {
    methodKind: "unary";
    input: typeof CancelSubscriptionRequestSchema;
    output: typeof CancelSubscriptionResponseSchema;
  },
  /**
   * ResumeSubscription reverses a scheduled cancellation before the paid term expires.
   *
   * @generated from rpc cortado.v1.CortadoService.ResumeSubscription
   */
  resumeSubscription: {
    methodKind: "unary";
    input: typeof ResumeSubscriptionRequestSchema;
    output: typeof ResumeSubscriptionResponseSchema;
  },
  /**
   * GetSeatUsage returns an organization's seat usage and billing breakdown.
   *
   * @generated from rpc cortado.v1.CortadoService.GetSeatUsage
   */
  getSeatUsage: {
    methodKind: "unary";
    input: typeof GetSeatUsageRequestSchema;
    output: typeof GetSeatUsageResponseSchema;
  },
  /**
   * GetNotificationDigest returns the organization's digest settings, timezone and recent sends.
   *
   * @generated from rpc cortado.v1.CortadoService.GetNotificationDigest
   */
  getNotificationDigest: {
    methodKind: "unary";
    input: typeof GetNotificationDigestRequestSchema;
    output: typeof GetNotificationDigestResponseSchema;
  },
  /**
   * UpdateNotificationDigest validates and saves the organization's digest settings.
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateNotificationDigest
   */
  updateNotificationDigest: {
    methodKind: "unary";
    input: typeof UpdateNotificationDigestRequestSchema;
    output: typeof UpdateNotificationDigestResponseSchema;
  },
  /**
   * SendTestNotificationDigest sends the digest to the calling user now.
   *
   * @generated from rpc cortado.v1.CortadoService.SendTestNotificationDigest
   */
  sendTestNotificationDigest: {
    methodKind: "unary";
    input: typeof SendTestNotificationDigestRequestSchema;
    output: typeof SendTestNotificationDigestResponseSchema;
  },
  /**
   * ListInAppNotifications retrieves in-app notifications for the current user
   *
   * @generated from rpc cortado.v1.CortadoService.ListInAppNotifications
   */
  listInAppNotifications: {
    methodKind: "unary";
    input: typeof ListInAppNotificationsRequestSchema;
    output: typeof ListInAppNotificationsResponseSchema;
  },
  /**
   * MarkNotificationsRead marks one or more notifications as read
   *
   * @generated from rpc cortado.v1.CortadoService.MarkNotificationsRead
   */
  markNotificationsRead: {
    methodKind: "unary";
    input: typeof MarkNotificationsReadRequestSchema;
    output: typeof MarkNotificationsReadResponseSchema;
  },
  /**
   * ArchiveNotifications archives one or more notifications
   *
   * @generated from rpc cortado.v1.CortadoService.ArchiveNotifications
   */
  archiveNotifications: {
    methodKind: "unary";
    input: typeof ArchiveNotificationsRequestSchema;
    output: typeof ArchiveNotificationsResponseSchema;
  },
  /**
   * GetUnreadNotificationCount returns the count of unread notifications for the current user
   *
   * @generated from rpc cortado.v1.CortadoService.GetUnreadNotificationCount
   */
  getUnreadNotificationCount: {
    methodKind: "unary";
    input: typeof GetUnreadNotificationCountRequestSchema;
    output: typeof GetUnreadNotificationCountResponseSchema;
  },
  /**
   * ListMyNotificationSettings returns the caller's own instant/off choice
   * for each notification type a user can set (mail notifications, CPRO-792)
   *
   * @generated from rpc cortado.v1.CortadoService.ListMyNotificationSettings
   */
  listMyNotificationSettings: {
    methodKind: "unary";
    input: typeof ListMyNotificationSettingsRequestSchema;
    output: typeof ListMyNotificationSettingsResponseSchema;
  },
  /**
   * UpdateMyNotificationSetting sets the caller's own choice for one type
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateMyNotificationSetting
   */
  updateMyNotificationSetting: {
    methodKind: "unary";
    input: typeof UpdateMyNotificationSettingRequestSchema;
    output: typeof UpdateMyNotificationSettingResponseSchema;
  },
  /**
   * GetRealtimeQueries seals the org-scoped Neon Realtime live queries the
   * caller may subscribe to (new leads, accepted quotes, payments).
   *
   * @generated from rpc cortado.v1.CortadoService.GetRealtimeQueries
   */
  getRealtimeQueries: {
    methodKind: "unary";
    input: typeof GetRealtimeQueriesRequestSchema;
    output: typeof GetRealtimeQueriesResponseSchema;
  },
  /**
   * ListPublicDomains retrieves custom public domains for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.ListPublicDomains
   */
  listPublicDomains: {
    methodKind: "unary";
    input: typeof ListPublicDomainsRequestSchema;
    output: typeof ListPublicDomainsResponseSchema;
  },
  /**
   * AddPublicDomain registers a custom form or portal domain for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.AddPublicDomain
   */
  addPublicDomain: {
    methodKind: "unary";
    input: typeof AddPublicDomainRequestSchema;
    output: typeof AddPublicDomainResponseSchema;
  },
  /**
   * VerifyPublicDomain refreshes DNS and provider verification status
   *
   * @generated from rpc cortado.v1.CortadoService.VerifyPublicDomain
   */
  verifyPublicDomain: {
    methodKind: "unary";
    input: typeof VerifyPublicDomainRequestSchema;
    output: typeof VerifyPublicDomainResponseSchema;
  },
  /**
   * DeletePublicDomain removes a custom public domain from an organization
   *
   * @generated from rpc cortado.v1.CortadoService.DeletePublicDomain
   */
  deletePublicDomain: {
    methodKind: "unary";
    input: typeof DeletePublicDomainRequestSchema;
    output: typeof DeletePublicDomainResponseSchema;
  },
  /**
   * CreateWorkflowDefinition creates a new automation workflow definition
   *
   * @generated from rpc cortado.v1.CortadoService.CreateWorkflowDefinition
   */
  createWorkflowDefinition: {
    methodKind: "unary";
    input: typeof CreateWorkflowDefinitionRequestSchema;
    output: typeof CreateWorkflowDefinitionResponseSchema;
  },
  /**
   * ValidateWorkflowDefinition runs the same save-time validation
   * Create/UpdateWorkflowDefinition apply (trigger, conditions, graph,
   * stop_conditions) without persisting anything, returning field-keyed
   * issues so the builder can route errors to the right control instead of
   * matching on English error text.
   *
   * @generated from rpc cortado.v1.CortadoService.ValidateWorkflowDefinition
   */
  validateWorkflowDefinition: {
    methodKind: "unary";
    input: typeof ValidateWorkflowDefinitionRequestSchema;
    output: typeof ValidateWorkflowDefinitionResponseSchema;
  },
  /**
   * GetWorkflowDefinition retrieves a workflow definition by ID
   *
   * @generated from rpc cortado.v1.CortadoService.GetWorkflowDefinition
   */
  getWorkflowDefinition: {
    methodKind: "unary";
    input: typeof GetWorkflowDefinitionRequestSchema;
    output: typeof GetWorkflowDefinitionResponseSchema;
  },
  /**
   * ListWorkflowDefinitions lists all workflow definitions for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.ListWorkflowDefinitions
   */
  listWorkflowDefinitions: {
    methodKind: "unary";
    input: typeof ListWorkflowDefinitionsRequestSchema;
    output: typeof ListWorkflowDefinitionsResponseSchema;
  },
  /**
   * UpdateWorkflowDefinition updates an existing workflow definition
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateWorkflowDefinition
   */
  updateWorkflowDefinition: {
    methodKind: "unary";
    input: typeof UpdateWorkflowDefinitionRequestSchema;
    output: typeof UpdateWorkflowDefinitionResponseSchema;
  },
  /**
   * DeleteWorkflowDefinition deletes a workflow definition
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteWorkflowDefinition
   */
  deleteWorkflowDefinition: {
    methodKind: "unary";
    input: typeof DeleteWorkflowDefinitionRequestSchema;
    output: typeof DeleteWorkflowDefinitionResponseSchema;
  },
  /**
   * ListWorkflowExecutions lists executions for a workflow definition
   *
   * @generated from rpc cortado.v1.CortadoService.ListWorkflowExecutions
   */
  listWorkflowExecutions: {
    methodKind: "unary";
    input: typeof ListWorkflowExecutionsRequestSchema;
    output: typeof ListWorkflowExecutionsResponseSchema;
  },
  /**
   * GetWorkflowExecution retrieves one execution and its debug detail.
   *
   * @generated from rpc cortado.v1.CortadoService.GetWorkflowExecution
   */
  getWorkflowExecution: {
    methodKind: "unary";
    input: typeof GetWorkflowExecutionRequestSchema;
    output: typeof GetWorkflowExecutionResponseSchema;
  },
  /**
   * GetWorkflowHealth returns a rolling-window count of failed workflow
   * executions for an organization, backing the "N automations failing" badge.
   *
   * @generated from rpc cortado.v1.CortadoService.GetWorkflowHealth
   */
  getWorkflowHealth: {
    methodKind: "unary";
    input: typeof GetWorkflowHealthRequestSchema;
    output: typeof GetWorkflowHealthResponseSchema;
  },
  /**
   * RetryWorkflowExecution retries a failed workflow execution.
   *
   * @generated from rpc cortado.v1.CortadoService.RetryWorkflowExecution
   */
  retryWorkflowExecution: {
    methodKind: "unary";
    input: typeof RetryWorkflowExecutionRequestSchema;
    output: typeof RetryWorkflowExecutionResponseSchema;
  },
  /**
   * CancelWorkflowExecution stops an in-flight (Pending/Running) workflow
   * execution. It cancels the Temporal run; the execution workflow records the
   * terminal Cancelled status. Terminal executions are rejected (FailedPrecondition).
   *
   * @generated from rpc cortado.v1.CortadoService.CancelWorkflowExecution
   */
  cancelWorkflowExecution: {
    methodKind: "unary";
    input: typeof CancelWorkflowExecutionRequestSchema;
    output: typeof CancelWorkflowExecutionResponseSchema;
  },
  /**
   * StartWorkflowExecution manually starts a workflow execution against a
   * specific entity, bypassing the definition's trigger conditions.
   *
   * @generated from rpc cortado.v1.CortadoService.StartWorkflowExecution
   */
  startWorkflowExecution: {
    methodKind: "unary";
    input: typeof StartWorkflowExecutionRequestSchema;
    output: typeof StartWorkflowExecutionResponseSchema;
  },
  /**
   * CloneWorkflowDefinition creates a copy of an existing workflow definition
   *
   * @generated from rpc cortado.v1.CortadoService.CloneWorkflowDefinition
   */
  cloneWorkflowDefinition: {
    methodKind: "unary";
    input: typeof CloneWorkflowDefinitionRequestSchema;
    output: typeof CloneWorkflowDefinitionResponseSchema;
  },
  /**
   * EvaluateWorkflowConditions evaluates a condition tree against the org's
   * most-recent inquiry and returns a step-by-step trace for the condition editor.
   *
   * @generated from rpc cortado.v1.CortadoService.EvaluateWorkflowConditions
   */
  evaluateWorkflowConditions: {
    methodKind: "unary";
    input: typeof EvaluateWorkflowConditionsRequestSchema;
    output: typeof EvaluateWorkflowConditionsResponseSchema;
  },
  /**
   * GetWorkflowAuthoringSchema returns the server-owned authoring vocabulary
   * for the workflow builder: selectable trigger events (with publisher
   * wiring status), per-entity condition fields, template variables, and
   * recipient paths, plus the node types the builder may add.
   *
   * @generated from rpc cortado.v1.CortadoService.GetWorkflowAuthoringSchema
   */
  getWorkflowAuthoringSchema: {
    methodKind: "unary";
    input: typeof GetWorkflowAuthoringSchemaRequestSchema;
    output: typeof GetWorkflowAuthoringSchemaResponseSchema;
  },
  /**
   * ListWorkflowTemplates lists the code-defined workflow template registry
   * with per-org installed flags. Replaces per-org seeded stock rows.
   *
   * @generated from rpc cortado.v1.CortadoService.ListWorkflowTemplates
   */
  listWorkflowTemplates: {
    methodKind: "unary";
    input: typeof ListWorkflowTemplatesRequestSchema;
    output: typeof ListWorkflowTemplatesResponseSchema;
  },
  /**
   * InstallWorkflowTemplate instantiates a registry template into a regular,
   * org-owned, disabled workflow definition (creating any referenced tenant
   * email templates that are missing).
   *
   * @generated from rpc cortado.v1.CortadoService.InstallWorkflowTemplate
   */
  installWorkflowTemplate: {
    methodKind: "unary";
    input: typeof InstallWorkflowTemplateRequestSchema;
    output: typeof InstallWorkflowTemplateResponseSchema;
  },
  /**
   * ListWebhookEndpoints lists an organization's webhook endpoints.
   *
   * @generated from rpc cortado.v1.CortadoService.ListWebhookEndpoints
   */
  listWebhookEndpoints: {
    methodKind: "unary";
    input: typeof ListWebhookEndpointsRequestSchema;
    output: typeof ListWebhookEndpointsResponseSchema;
  },
  /**
   * CreateWebhookEndpoint registers a new endpoint, optionally with custom
   * outbound headers, and returns its one-time signing secret.
   *
   * @generated from rpc cortado.v1.CortadoService.CreateWebhookEndpoint
   */
  createWebhookEndpoint: {
    methodKind: "unary";
    input: typeof CreateWebhookEndpointRequestSchema;
    output: typeof CreateWebhookEndpointResponseSchema;
  },
  /**
   * UpdateWebhookEndpoint edits an endpoint's name, description, URL,
   * enabled flag, or custom outbound headers.
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateWebhookEndpoint
   */
  updateWebhookEndpoint: {
    methodKind: "unary";
    input: typeof UpdateWebhookEndpointRequestSchema;
    output: typeof UpdateWebhookEndpointResponseSchema;
  },
  /**
   * DeleteWebhookEndpoint soft-deletes an endpoint. Rejected with
   * FailedPrecondition while any workflow definition references it.
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteWebhookEndpoint
   */
  deleteWebhookEndpoint: {
    methodKind: "unary";
    input: typeof DeleteWebhookEndpointRequestSchema;
    output: typeof DeleteWebhookEndpointResponseSchema;
  },
  /**
   * RotateWebhookEndpointSecret replaces the signing secret and returns the
   * new one exactly once.
   *
   * @generated from rpc cortado.v1.CortadoService.RotateWebhookEndpointSecret
   */
  rotateWebhookEndpointSecret: {
    methodKind: "unary";
    input: typeof RotateWebhookEndpointSecretRequestSchema;
    output: typeof RotateWebhookEndpointSecretResponseSchema;
  },
  /**
   * SendTestWebhookEndpoint delivers a signed `webhook.test` envelope to the
   * endpoint synchronously and reports the response.
   *
   * @generated from rpc cortado.v1.CortadoService.SendTestWebhookEndpoint
   */
  sendTestWebhookEndpoint: {
    methodKind: "unary";
    input: typeof SendTestWebhookEndpointRequestSchema;
    output: typeof SendTestWebhookEndpointResponseSchema;
  },
  /**
   * GetConnectInboxURL returns the hosted-auth URL that connects the caller's
   * own mailbox to the organization. Requires the EmailInbox entitlement.
   *
   * @generated from rpc cortado.v1.CortadoService.GetConnectInboxURL
   */
  getConnectInboxURL: {
    methodKind: "unary";
    input: typeof GetConnectInboxURLRequestSchema;
    output: typeof GetConnectInboxURLResponseSchema;
  },
  /**
   * CompleteConnectInbox finishes a connect with the code and state the
   * hosted-auth callback forwarded to the browser. The state must belong to
   * the signed-in caller and the requested organization.
   *
   * @generated from rpc cortado.v1.CortadoService.CompleteConnectInbox
   */
  completeConnectInbox: {
    methodKind: "unary";
    input: typeof CompleteConnectInboxRequestSchema;
    output: typeof CompleteConnectInboxResponseSchema;
  },
  /**
   * ListConnectedMailboxes lists the organization's connected mailboxes,
   * disconnected ones included.
   *
   * @generated from rpc cortado.v1.CortadoService.ListConnectedMailboxes
   */
  listConnectedMailboxes: {
    methodKind: "unary";
    input: typeof ListConnectedMailboxesRequestSchema;
    output: typeof ListConnectedMailboxesResponseSchema;
  },
  /**
   * DisconnectMailbox disconnects a connected mailbox and revokes its Nylas
   * grant. Callers may disconnect their own mailbox; disconnecting a
   * teammate's needs Settings Manage (owners and admins). Captured threads
   * stay. When the org default disconnects, the oldest other active mailbox
   * takes over.
   *
   * @generated from rpc cortado.v1.CortadoService.DisconnectMailbox
   */
  disconnectMailbox: {
    methodKind: "unary";
    input: typeof DisconnectMailboxRequestSchema;
    output: typeof DisconnectMailboxResponseSchema;
  },
  /**
   * SetDefaultConnectedMailbox makes an active mailbox the organization's
   * default for automated mail. Owners and admins only.
   *
   * @generated from rpc cortado.v1.CortadoService.SetDefaultConnectedMailbox
   */
  setDefaultConnectedMailbox: {
    methodKind: "unary";
    input: typeof SetDefaultConnectedMailboxRequestSchema;
    output: typeof SetDefaultConnectedMailboxResponseSchema;
  },
  /**
   * ListSendableMailboxes lists the organization's active connected
   * mailboxes for the "send from" picker, marking the ones the caller may
   * send as, and which one to preselect. Requires Manage Communications and
   * the EmailInbox entitlement.
   *
   * @generated from rpc cortado.v1.CortadoService.ListSendableMailboxes
   */
  listSendableMailboxes: {
    methodKind: "unary";
    input: typeof ListSendableMailboxesRequestSchema;
    output: typeof ListSendableMailboxesResponseSchema;
  },
  /**
   * GetAutomatedEmailSender reports the address automated email (New
   * Inquiry, Quote Sent, invoices, reminders, workflow emails) sends from
   * right now: the org default connected mailbox (Connected inbox add-on
   * only), else the org default Gmail, else Cortado's own address.
   *
   * @generated from rpc cortado.v1.CortadoService.GetAutomatedEmailSender
   */
  getAutomatedEmailSender: {
    methodKind: "unary";
    input: typeof GetAutomatedEmailSenderRequestSchema;
    output: typeof GetAutomatedEmailSenderResponseSchema;
  },
  /**
   * ListMailboxSendAccess lists the teammates a connected mailbox is shared
   * with, beyond its owner.
   *
   * @generated from rpc cortado.v1.CortadoService.ListMailboxSendAccess
   */
  listMailboxSendAccess: {
    methodKind: "unary";
    input: typeof ListMailboxSendAccessRequestSchema;
    output: typeof ListMailboxSendAccessResponseSchema;
  },
  /**
   * GrantMailboxSendAccess lets a teammate send as a connected mailbox. The
   * mailbox's owner may share it; sharing a teammate's needs Settings Manage
   * (owners and admins). Granting again changes nothing.
   *
   * @generated from rpc cortado.v1.CortadoService.GrantMailboxSendAccess
   */
  grantMailboxSendAccess: {
    methodKind: "unary";
    input: typeof GrantMailboxSendAccessRequestSchema;
    output: typeof GrantMailboxSendAccessResponseSchema;
  },
  /**
   * RevokeMailboxSendAccess stops a teammate sending as a connected mailbox.
   * The same people who may grant may revoke.
   *
   * @generated from rpc cortado.v1.CortadoService.RevokeMailboxSendAccess
   */
  revokeMailboxSendAccess: {
    methodKind: "unary";
    input: typeof RevokeMailboxSendAccessRequestSchema;
    output: typeof RevokeMailboxSendAccessResponseSchema;
  },
  /**
   * ListMailboxesNeedingReconnect lists the organization's connected
   * mailboxes that lost their connection, for the app-wide banner. Any member
   * may call it; it returns nothing when the organization lacks the
   * EmailInbox entitlement.
   *
   * @generated from rpc cortado.v1.CortadoService.ListMailboxesNeedingReconnect
   */
  listMailboxesNeedingReconnect: {
    methodKind: "unary";
    input: typeof ListMailboxesNeedingReconnectRequestSchema;
    output: typeof ListMailboxesNeedingReconnectResponseSchema;
  },
  /**
   * ListEmailCaptureExclusions lists the organization's "Never capture"
   * entries: org-wide ones and every mailbox's own. Requires Manage
   * Communications and the EmailInbox entitlement.
   *
   * @generated from rpc cortado.v1.CortadoService.ListEmailCaptureExclusions
   */
  listEmailCaptureExclusions: {
    methodKind: "unary";
    input: typeof ListEmailCaptureExclusionsRequestSchema;
    output: typeof ListEmailCaptureExclusionsResponseSchema;
  },
  /**
   * AddEmailCaptureExclusion stops capturing mail to or from an address or
   * domain. An org-wide entry needs Settings Manage (owners and admins); a
   * mailbox entry needs the mailbox's owner or Settings Manage. Adding an
   * entry that exists returns it. With wipe_thread_id set it also deletes
   * that conversation's captured messages.
   *
   * @generated from rpc cortado.v1.CortadoService.AddEmailCaptureExclusion
   */
  addEmailCaptureExclusion: {
    methodKind: "unary";
    input: typeof AddEmailCaptureExclusionRequestSchema;
    output: typeof AddEmailCaptureExclusionResponseSchema;
  },
  /**
   * RemoveEmailCaptureExclusion deletes a "Never capture" entry. The same
   * people who may add it may remove it. Mail is captured again from then on;
   * nothing missed meanwhile is fetched.
   *
   * @generated from rpc cortado.v1.CortadoService.RemoveEmailCaptureExclusion
   */
  removeEmailCaptureExclusion: {
    methodKind: "unary";
    input: typeof RemoveEmailCaptureExclusionRequestSchema;
    output: typeof RemoveEmailCaptureExclusionResponseSchema;
  },
  /**
   * ListEmailSenderSuggestions lists the organization's open "Not in
   * Cortado" suggestions: received mail from senders who are not contacts,
   * kept as metadata for 14 days. Also says whether the organization keeps
   * them. Requires Manage Communications and the EmailInbox entitlement.
   *
   * @generated from rpc cortado.v1.CortadoService.ListEmailSenderSuggestions
   */
  listEmailSenderSuggestions: {
    methodKind: "unary";
    input: typeof ListEmailSenderSuggestionsRequestSchema;
    output: typeof ListEmailSenderSuggestionsResponseSchema;
  },
  /**
   * ResolveEmailSenderSuggestion acts on a suggestion. LINK_CONTACT adds the
   * sender's address to contact_id (when it is not on it yet) and captures
   * the kept messages in full; it needs Manage Contacts too. IGNORE_SENDER
   * adds the sender to the never-capture list (org-wide for owners and
   * admins, else for the suggestion's mailbox when the caller owns it).
   * IGNORE_ONCE dismisses it.
   *
   * @generated from rpc cortado.v1.CortadoService.ResolveEmailSenderSuggestion
   */
  resolveEmailSenderSuggestion: {
    methodKind: "unary";
    input: typeof ResolveEmailSenderSuggestionRequestSchema;
    output: typeof ResolveEmailSenderSuggestionResponseSchema;
  },
  /**
   * SetEmailSenderSuggestionsEnabled turns "Suggest contacts from new
   * senders" on or off. Turning it off discards the open suggestions. Owners
   * and admins only.
   *
   * @generated from rpc cortado.v1.CortadoService.SetEmailSenderSuggestionsEnabled
   */
  setEmailSenderSuggestionsEnabled: {
    methodKind: "unary";
    input: typeof SetEmailSenderSuggestionsEnabledRequestSchema;
    output: typeof SetEmailSenderSuggestionsEnabledResponseSchema;
  },
  /**
   * GetEmailCaptureSettings reads the organization's capture settings.
   * Requires Manage Communications and the EmailInbox entitlement.
   *
   * @generated from rpc cortado.v1.CortadoService.GetEmailCaptureSettings
   */
  getEmailCaptureSettings: {
    methodKind: "unary";
    input: typeof GetEmailCaptureSettingsRequestSchema;
    output: typeof GetEmailCaptureSettingsResponseSchema;
  },
  /**
   * UpdateEmailCaptureSettings changes the organization's capture settings.
   * Also requires Settings Manage (owners and admins).
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateEmailCaptureSettings
   */
  updateEmailCaptureSettings: {
    methodKind: "unary";
    input: typeof UpdateEmailCaptureSettingsRequestSchema;
    output: typeof UpdateEmailCaptureSettingsResponseSchema;
  },
  /**
   * ListEmailSuppressions lists suppressed email addresses for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.ListEmailSuppressions
   */
  listEmailSuppressions: {
    methodKind: "unary";
    input: typeof ListEmailSuppressionsRequestSchema;
    output: typeof ListEmailSuppressionsResponseSchema;
  },
  /**
   * CreateEmailSuppression manually adds an email address to the suppression list (reason is forced to MANUAL)
   *
   * @generated from rpc cortado.v1.CortadoService.CreateEmailSuppression
   */
  createEmailSuppression: {
    methodKind: "unary";
    input: typeof CreateEmailSuppressionRequestSchema;
    output: typeof CreateEmailSuppressionResponseSchema;
  },
  /**
   * DeleteEmailSuppression removes an email address from the suppression list
   *
   * @generated from rpc cortado.v1.CortadoService.DeleteEmailSuppression
   */
  deleteEmailSuppression: {
    methodKind: "unary";
    input: typeof DeleteEmailSuppressionRequestSchema;
    output: typeof DeleteEmailSuppressionResponseSchema;
  },
  /**
   * ListApiKeys lists the organization's external API keys (active and revoked)
   *
   * @generated from rpc cortado.v1.CortadoService.ListApiKeys
   */
  listApiKeys: {
    methodKind: "unary";
    input: typeof ListApiKeysRequestSchema;
    output: typeof ListApiKeysResponseSchema;
  },
  /**
   * CreateApiKey issues a new external API key; the secret is returned exactly once
   *
   * @generated from rpc cortado.v1.CortadoService.CreateApiKey
   */
  createApiKey: {
    methodKind: "unary";
    input: typeof CreateApiKeyRequestSchema;
    output: typeof CreateApiKeyResponseSchema;
  },
  /**
   * RevokeApiKey permanently revokes an external API key
   *
   * @generated from rpc cortado.v1.CortadoService.RevokeApiKey
   */
  revokeApiKey: {
    methodKind: "unary";
    input: typeof RevokeApiKeyRequestSchema;
    output: typeof RevokeApiKeyResponseSchema;
  },
  /**
   * SendInquiryEmail sends an email to a customer linked to an inquiry.
   *
   * TENANT-ONLY. This method must never appear in publicMethodAllowlist in
   * backend/internal/api/router/router.go: the portal is a customer-
   * authenticated surface and email threads may carry internal correspondence.
   *
   * @generated from rpc cortado.v1.CortadoService.SendInquiryEmail
   */
  sendInquiryEmail: {
    methodKind: "unary";
    input: typeof SendInquiryEmailRequestSchema;
    output: typeof SendInquiryEmailResponseSchema;
  },
  /**
   * SendEmail sends an email to a customer linked to a supported parent entity
   *
   * @generated from rpc cortado.v1.CortadoService.SendEmail
   */
  sendEmail: {
    methodKind: "unary";
    input: typeof SendEmailRequestSchema;
    output: typeof SendEmailResponseSchema;
  },
  /**
   * ListInquiryEmails retrieves the email thread for an inquiry.
   *
   * TENANT-ONLY. This method must never appear in publicMethodAllowlist in
   * backend/internal/api/router/router.go: the portal is a customer-
   * authenticated surface and email threads may carry internal correspondence.
   *
   * @generated from rpc cortado.v1.CortadoService.ListInquiryEmails
   */
  listInquiryEmails: {
    methodKind: "unary";
    input: typeof ListInquiryEmailsRequestSchema;
    output: typeof ListInquiryEmailsResponseSchema;
  },
  /**
   * ListEmails retrieves a flat email history for a parent entity (inquiry, contact, booking).
   * Superseded by ListEmailThreadsByEntity, which covers the
   * same mail now that every tenant send is filed under a linked conversation.
   * Kept for one release window for orgs without the Connected inbox add-on.
   *
   * @generated from rpc cortado.v1.CortadoService.ListEmails
   * @deprecated
   */
  listEmails: {
    methodKind: "unary";
    input: typeof ListEmailsRequestSchema;
    output: typeof ListEmailsResponseSchema;
  },
  /**
   * ListEmailThreads retrieves email threads for the inbox view
   *
   * @generated from rpc cortado.v1.CortadoService.ListEmailThreads
   */
  listEmailThreads: {
    methodKind: "unary";
    input: typeof ListEmailThreadsRequestSchema;
    output: typeof ListEmailThreadsResponseSchema;
  },
  /**
   * ListEmailThreadsByEntity retrieves conversations linked to a CRM entity
   *
   * @generated from rpc cortado.v1.CortadoService.ListEmailThreadsByEntity
   */
  listEmailThreadsByEntity: {
    methodKind: "unary";
    input: typeof ListEmailThreadsByEntityRequestSchema;
    output: typeof ListEmailThreadsByEntityResponseSchema;
  },
  /**
   * MarkEmailThreadRead advances the current user's read position for a conversation
   *
   * @generated from rpc cortado.v1.CortadoService.MarkEmailThreadRead
   */
  markEmailThreadRead: {
    methodKind: "unary";
    input: typeof MarkEmailThreadReadRequestSchema;
    output: typeof MarkEmailThreadReadResponseSchema;
  },
  /**
   * GetEmailThread retrieves a single email thread by ID with all messages
   *
   * @generated from rpc cortado.v1.CortadoService.GetEmailThread
   */
  getEmailThread: {
    methodKind: "unary";
    input: typeof GetEmailThreadRequestSchema;
    output: typeof GetEmailThreadResponseSchema;
  },
  /**
   * SaveDraft saves or updates one of the current user's drafts — a reply draft
   * on a thread, or a compose draft that has no thread yet
   *
   * @generated from rpc cortado.v1.CortadoService.SaveDraft
   */
  saveDraft: {
    methodKind: "unary";
    input: typeof SaveDraftRequestSchema;
    output: typeof SaveDraftResponseSchema;
  },
  /**
   * DiscardDraft deletes one of the current user's drafts
   *
   * @generated from rpc cortado.v1.CortadoService.DiscardDraft
   */
  discardDraft: {
    methodKind: "unary";
    input: typeof DiscardDraftRequestSchema;
    output: typeof DiscardDraftResponseSchema;
  },
  /**
   * ListEmailDrafts lists the current user's drafts so an interrupted compose
   * can be resumed from any session
   *
   * @generated from rpc cortado.v1.CortadoService.ListEmailDrafts
   */
  listEmailDrafts: {
    methodKind: "unary";
    input: typeof ListEmailDraftsRequestSchema;
    output: typeof ListEmailDraftsResponseSchema;
  },
  /**
   * RetryEmailBodyFetch retries fetching the body for an email
   *
   * @generated from rpc cortado.v1.CortadoService.RetryEmailBodyFetch
   */
  retryEmailBodyFetch: {
    methodKind: "unary";
    input: typeof RetryEmailBodyFetchRequestSchema;
    output: typeof RetryEmailBodyFetchResponseSchema;
  },
  /**
   * GetEmailAttachmentDownloadUrl returns a short-lived URL that opens one
   * attachment on an email the caller can read. Files on captured mail stream
   * from the connected mailbox; Cortado never stores them.
   *
   * @generated from rpc cortado.v1.CortadoService.GetEmailAttachmentDownloadUrl
   */
  getEmailAttachmentDownloadUrl: {
    methodKind: "unary";
    input: typeof GetEmailAttachmentDownloadUrlRequestSchema;
    output: typeof GetEmailAttachmentDownloadUrlResponseSchema;
  },
  /**
   * RetryEmailSend restarts delivery for a queued or failed outbound email
   *
   * @generated from rpc cortado.v1.CortadoService.RetryEmailSend
   */
  retryEmailSend: {
    methodKind: "unary";
    input: typeof RetryEmailSendRequestSchema;
    output: typeof RetryEmailSendResponseSchema;
  },
  /**
   * UpdateEmailThread updates an email thread's properties (status, assignment, links)
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateEmailThread
   */
  updateEmailThread: {
    methodKind: "unary";
    input: typeof UpdateEmailThreadRequestSchema;
    output: typeof UpdateEmailThreadResponseSchema;
  },
  /**
   * LinkEmailThread attaches a conversation to any CRM entity via the
   * polymorphic email_thread_links table
   *
   * @generated from rpc cortado.v1.CortadoService.LinkEmailThread
   */
  linkEmailThread: {
    methodKind: "unary";
    input: typeof LinkEmailThreadRequestSchema;
    output: typeof LinkEmailThreadResponseSchema;
  },
  /**
   * UnlinkEmailThread detaches a conversation from one CRM entity
   *
   * @generated from rpc cortado.v1.CortadoService.UnlinkEmailThread
   */
  unlinkEmailThread: {
    methodKind: "unary";
    input: typeof UnlinkEmailThreadRequestSchema;
    output: typeof UnlinkEmailThreadResponseSchema;
  },
  /**
   * ListEmailThreadLinks lists every CRM entity a conversation is linked to
   *
   * @generated from rpc cortado.v1.CortadoService.ListEmailThreadLinks
   */
  listEmailThreadLinks: {
    methodKind: "unary";
    input: typeof ListEmailThreadLinksRequestSchema;
    output: typeof ListEmailThreadLinksResponseSchema;
  },
  /**
   * ListEmailThreadEntityCandidates lists the open leads and bookings of a
   * conversation's contact, for the "Which event is this about?" picker
   *
   * @generated from rpc cortado.v1.CortadoService.ListEmailThreadEntityCandidates
   */
  listEmailThreadEntityCandidates: {
    methodKind: "unary";
    input: typeof ListEmailThreadEntityCandidatesRequestSchema;
    output: typeof ListEmailThreadEntityCandidatesResponseSchema;
  },
  /**
   * ListEmailThreadAddressSuggestions lists addresses on a conversation that
   * a linked contact may also use: sent under that contact's name and on no
   * contact yet. Dismissed ones are left out for the caller.
   *
   * @generated from rpc cortado.v1.CortadoService.ListEmailThreadAddressSuggestions
   */
  listEmailThreadAddressSuggestions: {
    methodKind: "unary";
    input: typeof ListEmailThreadAddressSuggestionsRequestSchema;
    output: typeof ListEmailThreadAddressSuggestionsResponseSchema;
  },
  /**
   * AcceptEmailThreadAddressSuggestion adds a suggested address to the
   * contact, with source capture. NotFound when the conversation no longer
   * suggests it; needs Manage Contacts on the contact.
   *
   * @generated from rpc cortado.v1.CortadoService.AcceptEmailThreadAddressSuggestion
   */
  acceptEmailThreadAddressSuggestion: {
    methodKind: "unary";
    input: typeof AcceptEmailThreadAddressSuggestionRequestSchema;
    output: typeof AcceptEmailThreadAddressSuggestionResponseSchema;
  },
  /**
   * DismissEmailThreadAddressSuggestion hides a suggestion on a conversation
   * for the caller only.
   *
   * @generated from rpc cortado.v1.CortadoService.DismissEmailThreadAddressSuggestion
   */
  dismissEmailThreadAddressSuggestion: {
    methodKind: "unary";
    input: typeof DismissEmailThreadAddressSuggestionRequestSchema;
    output: typeof DismissEmailThreadAddressSuggestionResponseSchema;
  },
  /**
   * ReplyToThread sends a reply within an existing email thread
   *
   * @generated from rpc cortado.v1.CortadoService.ReplyToThread
   */
  replyToThread: {
    methodKind: "unary";
    input: typeof ReplyToThreadRequestSchema;
    output: typeof ReplyToThreadResponseSchema;
  },
  /**
   * ListSystemEmailTemplates returns all system email templates with their customization status
   *
   * @generated from rpc cortado.v1.CortadoService.ListSystemEmailTemplates
   */
  listSystemEmailTemplates: {
    methodKind: "unary";
    input: typeof ListSystemEmailTemplatesRequestSchema;
    output: typeof ListSystemEmailTemplatesResponseSchema;
  },
  /**
   * GetSystemEmailTemplate returns a specific system email template with its current customizations
   *
   * @generated from rpc cortado.v1.CortadoService.GetSystemEmailTemplate
   */
  getSystemEmailTemplate: {
    methodKind: "unary";
    input: typeof GetSystemEmailTemplateRequestSchema;
    output: typeof GetSystemEmailTemplateResponseSchema;
  },
  /**
   * UpdateSystemEmailTemplate updates the customizations for a system email template
   *
   * @generated from rpc cortado.v1.CortadoService.UpdateSystemEmailTemplate
   */
  updateSystemEmailTemplate: {
    methodKind: "unary";
    input: typeof UpdateSystemEmailTemplateRequestSchema;
    output: typeof UpdateSystemEmailTemplateResponseSchema;
  },
  /**
   * ResetSystemEmailTemplate removes all customizations and restores defaults
   *
   * @generated from rpc cortado.v1.CortadoService.ResetSystemEmailTemplate
   */
  resetSystemEmailTemplate: {
    methodKind: "unary";
    input: typeof ResetSystemEmailTemplateRequestSchema;
    output: typeof ResetSystemEmailTemplateResponseSchema;
  },
  /**
   * PreviewSystemEmailTemplate generates a preview with sample data
   *
   * @generated from rpc cortado.v1.CortadoService.PreviewSystemEmailTemplate
   */
  previewSystemEmailTemplate: {
    methodKind: "unary";
    input: typeof PreviewSystemEmailTemplateRequestSchema;
    output: typeof PreviewSystemEmailTemplateResponseSchema;
  },
  /**
   * GetReportingMetrics retrieves reporting metrics (close rate, leads count) for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.GetReportingMetrics
   */
  getReportingMetrics: {
    methodKind: "unary";
    input: typeof GetReportingMetricsRequestSchema;
    output: typeof GetReportingMetricsResponseSchema;
  },
  /**
   * GetSalesTaxReport retrieves a sales tax report grouped by tax rate for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.GetSalesTaxReport
   */
  getSalesTaxReport: {
    methodKind: "unary";
    input: typeof GetSalesTaxReportRequestSchema;
    output: typeof GetSalesTaxReportResponseSchema;
  },
  /**
   * SubmitWaitlist adds an entry to the waitlist (public, no auth required)
   *
   * @generated from rpc cortado.v1.CortadoService.SubmitWaitlist
   */
  submitWaitlist: {
    methodKind: "unary";
    input: typeof SubmitWaitlistRequestSchema;
    output: typeof SubmitWaitlistResponseSchema;
  },
  /**
   * GetPublicSignupEnabled returns whether public signup is enabled (public, no auth required)
   *
   * @generated from rpc cortado.v1.CortadoService.GetPublicSignupEnabled
   */
  getPublicSignupEnabled: {
    methodKind: "unary";
    input: typeof GetPublicSignupEnabledRequestSchema;
    output: typeof GetPublicSignupEnabledResponseSchema;
  },
  /**
   * AdminCreateUser creates a new app user by email (Supabase + DB)
   *
   * @generated from rpc cortado.v1.CortadoService.AdminCreateUser
   */
  adminCreateUser: {
    methodKind: "unary";
    input: typeof AdminCreateUserRequestSchema;
    output: typeof AdminCreateUserResponseSchema;
  },
  /**
   * AdminListUsers lists all app users in the system
   *
   * @generated from rpc cortado.v1.CortadoService.AdminListUsers
   */
  adminListUsers: {
    methodKind: "unary";
    input: typeof AdminListUsersRequestSchema;
    output: typeof AdminListUsersResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.CortadoService.AdminResendInvite
   */
  adminResendInvite: {
    methodKind: "unary";
    input: typeof AdminResendInviteRequestSchema;
    output: typeof AdminResendInviteResponseSchema;
  },
  /**
   * AdminArchiveUser archives a user account so it can no longer log in
   *
   * @generated from rpc cortado.v1.CortadoService.AdminArchiveUser
   */
  adminArchiveUser: {
    methodKind: "unary";
    input: typeof AdminArchiveUserRequestSchema;
    output: typeof AdminArchiveUserResponseSchema;
  },
  /**
   * AdminUnarchiveUser unarchives a previously archived user account
   *
   * @generated from rpc cortado.v1.CortadoService.AdminUnarchiveUser
   */
  adminUnarchiveUser: {
    methodKind: "unary";
    input: typeof AdminUnarchiveUserRequestSchema;
    output: typeof AdminUnarchiveUserResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.CortadoService.AdminListOrganizations
   */
  adminListOrganizations: {
    methodKind: "unary";
    input: typeof AdminListOrganizationsRequestSchema;
    output: typeof AdminListOrganizationsResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.CortadoService.AdminGetOrganizationFeatures
   */
  adminGetOrganizationFeatures: {
    methodKind: "unary";
    input: typeof AdminGetOrganizationFeaturesRequestSchema;
    output: typeof AdminGetOrganizationFeaturesResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.CortadoService.AdminEnableFeature
   */
  adminEnableFeature: {
    methodKind: "unary";
    input: typeof AdminEnableFeatureRequestSchema;
    output: typeof AdminEnableFeatureResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.CortadoService.AdminDisableFeature
   */
  adminDisableFeature: {
    methodKind: "unary";
    input: typeof AdminDisableFeatureRequestSchema;
    output: typeof AdminDisableFeatureResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.CortadoService.AdminDisableFeatureForAllOrgs
   */
  adminDisableFeatureForAllOrgs: {
    methodKind: "unary";
    input: typeof AdminDisableFeatureForAllOrgsRequestSchema;
    output: typeof AdminDisableFeatureForAllOrgsResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.CortadoService.AdminListFeatureCatalog
   */
  adminListFeatureCatalog: {
    methodKind: "unary";
    input: typeof AdminListFeatureCatalogRequestSchema;
    output: typeof AdminListFeatureCatalogResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.CortadoService.AdminGetOrganization
   */
  adminGetOrganization: {
    methodKind: "unary";
    input: typeof AdminGetOrganizationRequestSchema;
    output: typeof AdminGetOrganizationResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.CortadoService.AdminGetOrganizationStats
   */
  adminGetOrganizationStats: {
    methodKind: "unary";
    input: typeof AdminGetOrganizationStatsRequestSchema;
    output: typeof AdminGetOrganizationStatsResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.CortadoService.AdminGetSystemStats
   */
  adminGetSystemStats: {
    methodKind: "unary";
    input: typeof AdminGetSystemStatsRequestSchema;
    output: typeof AdminGetSystemStatsResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.CortadoService.AdminGetOrganizationLeaderboard
   */
  adminGetOrganizationLeaderboard: {
    methodKind: "unary";
    input: typeof AdminGetOrganizationLeaderboardRequestSchema;
    output: typeof AdminGetOrganizationLeaderboardResponseSchema;
  },
  /**
   * AdminUpdateFeedbackStage updates the stage of a feedback item (admin only)
   *
   * @generated from rpc cortado.v1.CortadoService.AdminUpdateFeedbackStage
   */
  adminUpdateFeedbackStage: {
    methodKind: "unary";
    input: typeof AdminUpdateFeedbackStageRequestSchema;
    output: typeof AdminUpdateFeedbackStageResponseSchema;
  },
  /**
   * GetOrganizationIntegration retrieves an integration for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.GetOrganizationIntegration
   */
  getOrganizationIntegration: {
    methodKind: "unary";
    input: typeof GetOrganizationIntegrationRequestSchema;
    output: typeof GetOrganizationIntegrationResponseSchema;
  },
  /**
   * UpsertOrganizationIntegration creates or updates an integration for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.UpsertOrganizationIntegration
   */
  upsertOrganizationIntegration: {
    methodKind: "unary";
    input: typeof UpsertOrganizationIntegrationRequestSchema;
    output: typeof UpsertOrganizationIntegrationResponseSchema;
  },
  /**
   * DisconnectOrganizationIntegration marks an integration as disconnected
   *
   * @generated from rpc cortado.v1.CortadoService.DisconnectOrganizationIntegration
   */
  disconnectOrganizationIntegration: {
    methodKind: "unary";
    input: typeof DisconnectOrganizationIntegrationRequestSchema;
    output: typeof DisconnectOrganizationIntegrationResponseSchema;
  },
  /**
   * ListSlackChannels returns the available Slack channels for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.ListSlackChannels
   */
  listSlackChannels: {
    methodKind: "unary";
    input: typeof ListSlackChannelsRequestSchema;
    output: typeof ListSlackChannelsResponseSchema;
  },
  /**
   * GetConnectedSlackChannels returns the Slack channel IDs connected for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.GetConnectedSlackChannels
   */
  getConnectedSlackChannels: {
    methodKind: "unary";
    input: typeof GetConnectedSlackChannelsRequestSchema;
    output: typeof GetConnectedSlackChannelsResponseSchema;
  },
  /**
   * SetConnectedSlackChannels updates the Slack channel IDs connected for an organization
   *
   * @generated from rpc cortado.v1.CortadoService.SetConnectedSlackChannels
   */
  setConnectedSlackChannels: {
    methodKind: "unary";
    input: typeof SetConnectedSlackChannelsRequestSchema;
    output: typeof SetConnectedSlackChannelsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_cortado_v1_cortado, 0);

